import './index.css';var ul = Object.defineProperty;
var dl = (i, e, t) => e in i ? ul(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var hs = (i, e, t) => dl(i, typeof e != "symbol" ? e + "" : e, t);
import { jsxs as ue, jsx as F, Fragment as hl } from "react/jsx-runtime";
import { DownloadLight as fl, CalendarLight as ml, ArrowAltLeft as gl, ArrowAltRight as pl, PlayFill as Tl, PauseFill as El, ZoomOutCustom as yl, ZoomLightCustom as xl, PinedFill as bi, PinLightLeft as _i, ViewHideLight as Ci, SettingLineLight as vl, FrameLight as Sl, FullLight as Al, EyeLight as Ll } from "@repo/go-icons";
import { LoaderIcon as ao } from "@repo/go-ui";
import { useRef as oe, useState as ie, useCallback as Y, useMemo as Te, useEffect as se, forwardRef as Rl, useLayoutEffect as lo } from "react";
import { useTranslation as ht, initReactI18next as Dl, I18nextProvider as Il } from "react-i18next";
import bl from "i18next";
import _l from "i18next-browser-languagedetector";
function co(i) {
  var e, t, s = "";
  if (typeof i == "string" || typeof i == "number") s += i;
  else if (typeof i == "object") if (Array.isArray(i)) {
    var n = i.length;
    for (e = 0; e < n; e++) i[e] && (t = co(i[e])) && (s && (s += " "), s += t);
  } else for (t in i) i[t] && (s && (s += " "), s += t);
  return s;
}
function ce() {
  for (var i, e, t = 0, s = "", n = arguments.length; t < n; t++) (i = arguments[t]) && (e = co(i)) && (s && (s += " "), s += e);
  return s;
}
function Zs(i) {
  return typeof i == "number" && Number.isFinite(i) ? i : 0;
}
function Mn(i, e = 0) {
  return i + Zs(e);
}
function kn(i, e = 0) {
  return i - Zs(e);
}
function Je(i, e = 0) {
  return new Date(Mn(i, e));
}
function rs(i, e = 0) {
  const t = Je(i, e);
  return `${Ce(t.getHours())}:${Ce(
    t.getMinutes()
  )}:${Ce(t.getSeconds())}`;
}
function Cl(i, e = 0) {
  const t = Je(i, e);
  return `${Ce(t.getDate())}.${Ce(t.getMonth() + 1)}.${t.getFullYear()}`;
}
function wl(i, e = 0) {
  return `${Cl(i, e)} ${rs(i, e)}`;
}
function Ce(i) {
  return String(i).padStart(2, "0");
}
const Ml = 500;
function kl({
  displayTimeOffsetMs: i,
  title: e
}) {
  const t = oe(!1), [s, n] = ie(!1), [r, o] = ie(null), a = Y(() => {
    o(null);
  }, []), l = Y(
    (c) => {
      if (!t.current) {
        t.current = !0, n(!0), o(null);
        try {
          Fl({
            displayTimeOffsetMs: i,
            part: c,
            title: e
          });
        } catch (u) {
          t.current = !1, n(!1), o(u instanceof Error ? u : new Error("Failed to download DVR export"));
          return;
        }
        setTimeout(() => {
          t.current = !1, n(!1);
        }, Ml);
      }
    },
    [i, e]
  );
  return {
    clearDownloadError: a,
    downloadError: r,
    downloading: s,
    downloadPart: l
  };
}
function Fl({
  displayTimeOffsetMs: i,
  part: e,
  title: t
}) {
  const s = document.createElement("a");
  s.href = e.url, s.download = Pl({
    displayTimeOffsetMs: i,
    fromMs: e.fromMs,
    title: t,
    toMs: e.toMs
  }), s.rel = "noopener noreferrer", document.body.appendChild(s), s.click(), s.remove();
}
function Pl({
  displayTimeOffsetMs: i,
  fromMs: e,
  title: t,
  toMs: s
}) {
  return `${Ol(t)}_${wi(
    e,
    i
  )}_${wi(s, i)}.mp4`;
}
function Ol(i) {
  return i.replace(/[<>:"/\\|?*]/g, "_").replace(/\s+/g, " ").trim() || "video";
}
function wi(i, e) {
  const t = Je(i, e);
  return `${t.getFullYear()}-${Ce(
    t.getMonth() + 1
  )}-${Ce(t.getDate())}_${Nl(i, e).replace(
    /:/g,
    "-"
  )}`;
}
function Nl(i, e) {
  return rs(i, e);
}
const Ul = "HlsDvrExportButton-module__root__CDKPo", Bl = "HlsDvrExportButton-module__iconButton__zENqO", $l = "HlsDvrExportButton-module__partButton__7FXhU", Gl = "HlsDvrExportButton-module__partsMenu__2-dLi", fs = {
  root: Ul,
  iconButton: Bl,
  partButton: $l,
  partsMenu: Gl
};
function Hl({ displayTimeOffsetMs: i, exportState: e, title: t }) {
  const { t: s } = ht("hlsFlussonicVideoPlayer"), n = oe(null), [r, o] = ie(!1), a = e.status === "multiple" && r, { clearDownloadError: l, downloadError: c, downloading: u, downloadPart: d } = kl({
    displayTimeOffsetMs: i,
    title: t
  }), h = u || e.status === "loading" || e.status === "empty", m = Te(() => c != null ? s("download.error") : u ? s("download.starting") : Kl(e, s), [c, u, e, s]), f = Y(
    (p) => {
      o(!1), ms(n.current), d(p);
    },
    [d]
  ), g = Y(() => {
    if (l(), ms(n.current), e.status === "single") {
      f(e.part);
      return;
    }
    e.status === "multiple" && o((p) => !p);
  }, [l, e, f]);
  return se(() => {
    if (!a)
      return;
    const p = (E) => {
      var y;
      (y = n.current) != null && y.contains(E.target) || (o(!1), ms(n.current));
    };
    return document.addEventListener("pointerdown", p), () => {
      document.removeEventListener("pointerdown", p);
    };
  }, [a]), e.status === "hidden" ? null : /* @__PURE__ */ ue(
    "div",
    {
      className: fs.root,
      "data-carousel-drag-disabled": !0,
      onKeyDown: (p) => {
        p.key === "Escape" && (o(!1), ms(n.current));
      },
      ref: n,
      children: [
        /* @__PURE__ */ F(
          "button",
          {
            "aria-label": m,
            className: fs.iconButton,
            disabled: h,
            onClick: g,
            title: m,
            type: "button",
            children: u ? /* @__PURE__ */ F(ao, { size: "s" }) : /* @__PURE__ */ F(fl, {})
          }
        ),
        a && /* @__PURE__ */ F("div", { className: fs.partsMenu, role: "menu", children: e.parts.map((p) => /* @__PURE__ */ F(
          "button",
          {
            className: fs.partButton,
            disabled: u,
            onClick: () => f(p),
            role: "menuitem",
            type: "button",
            children: Vl(p, i)
          },
          `${p.fromMs}:${p.toMs}`
        )) })
      ]
    }
  );
}
function Kl(i, e) {
  switch (i.status) {
    case "loading":
      return e("download.checking");
    case "empty":
      switch (i.reason) {
        case "archive-error":
          return e("download.archiveError");
        case "no-archive":
          return e("download.noArchive");
        case "no-track":
          return e("download.noTrack");
        default:
          return e("download.interval");
      }
    case "multiple":
      return e("download.multiple");
    case "single":
      return i.complete ? e("download.interval") : e("download.availableFragment");
    default:
      return e("download.interval");
  }
}
function Vl(i, e) {
  return `${Mi(i.fromMs, e)} - ${Mi(
    i.toMs,
    e
  )}`;
}
function Mi(i, e) {
  return rs(i, e);
}
function ms(i) {
  const e = document.activeElement;
  e instanceof HTMLElement && (i != null && i.contains(e)) && e.blur();
}
const Wl = "HlsDvrTimeline-module__root__JPs2F", Yl = "HlsDvrTimeline-module__controlsRow__v2emc", ql = "HlsDvrTimeline-module__trackColumn__4B7u9", zl = "HlsDvrTimeline-module__labelsRow__07PyX", jl = "HlsDvrTimeline-module__liveButton__1kKlU", Xl = "HlsDvrTimeline-module__liveButtonActive__egOPv", Ql = "HlsDvrTimeline-module__timelineButton__4OrxO", Zl = "HlsDvrTimeline-module__timeLabel__OYCxm", Jl = "HlsDvrTimeline-module__timelineButtonSeekable__Jzt1a", ec = "HlsDvrTimeline-module__timelineButtonDragging__xTI3j", tc = "HlsDvrTimeline-module__trackBase__D58cR", sc = "HlsDvrTimeline-module__trackBaseDragging__X8X05", nc = "HlsDvrTimeline-module__archiveSegment__nBzPC", ic = "HlsDvrTimeline-module__progressBar__Y3uFE", rc = "HlsDvrTimeline-module__progressBarDragging__qM6-Z", oc = "HlsDvrTimeline-module__timelineHandle__OuF5i", ac = "HlsDvrTimeline-module__timelineHandleSeekable__L4H-u", lc = "HlsDvrTimeline-module__timelineHandleDragging__39V2q", cc = "HlsDvrTimeline-module__timeTooltip__-cshr", uc = "HlsDvrTimeline-module__timeTooltipImage__fTx1I", dc = "HlsDvrTimeline-module__timeTooltipVideo__8z9QA", hc = "HlsDvrTimeline-module__timeTooltipPlaceholder__jD6CQ", fc = "HlsDvrTimeline-module__timeTooltipLabel__mbs-Z", mc = "HlsDvrTimeline-module__tick__kWlkB", gc = "HlsDvrTimeline-module__tickMark__fOxpo", pc = "HlsDvrTimeline-module__tickMarkMajor__4ynqx", Tc = "HlsDvrTimeline-module__tickLabel__-ONjl", le = {
  root: Wl,
  controlsRow: Yl,
  trackColumn: ql,
  labelsRow: zl,
  liveButton: jl,
  liveButtonActive: Xl,
  timelineButton: Ql,
  timeLabel: Zl,
  timelineButtonSeekable: Jl,
  timelineButtonDragging: ec,
  trackBase: tc,
  trackBaseDragging: sc,
  archiveSegment: nc,
  progressBar: ic,
  progressBarDragging: rc,
  timelineHandle: oc,
  timelineHandleSeekable: ac,
  timelineHandleDragging: lc,
  timeTooltip: cc,
  timeTooltipImage: uc,
  timeTooltipVideo: dc,
  timeTooltipPlaceholder: hc,
  timeTooltipLabel: fc,
  tick: mc,
  tickMark: gc,
  tickMarkMajor: pc,
  tickLabel: Tc
};
function Fn(i, e) {
  return rs(i, e);
}
function Ec(i, e) {
  const t = Je(i, e);
  return `${Ce(t.getDate())}.${Ce(
    t.getMonth() + 1
  )}.${String(t.getFullYear()).slice(-2)} ${Fn(i, e)}`;
}
const yc = 4, xc = 36e5, vc = 5 * 6e4, ki = 5 * 6e4, Sc = 12, Fi = 0.75;
function Pi({
  clientX: i,
  element: e,
  fullBounds: t,
  startBounds: s,
  startClientX: n
}) {
  const r = e.getBoundingClientRect(), o = s.endMs - s.startMs;
  if (r.width <= 0 || o <= 0)
    return s;
  const l = -((i - n) / r.width) * o;
  return ts(
    {
      startMs: s.startMs + l,
      endMs: s.endMs + l
    },
    t
  );
}
function Ac({
  clientX: i,
  element: e,
  handleVisible: t,
  progressPercent: s
}) {
  if (!t)
    return !1;
  const n = e.getBoundingClientRect(), r = n.left + n.width * (s / 100);
  return Math.abs(i - r) <= Sc;
}
function Lc({
  clientX: i,
  element: e,
  fullBounds: t,
  visibleBounds: s,
  zoomIn: n
}) {
  const r = t.endMs - t.startMs, o = s.endMs - s.startMs;
  if (r <= 0 || o <= 0)
    return null;
  const a = Math.min(vc, r), l = At(
    n ? o * Fi : o / Fi,
    a,
    r
  );
  if (l >= r)
    return t;
  const c = fo({
    clientX: i,
    element: e
  }), d = s.startMs + o * c - l * c;
  return ts(
    {
      startMs: d,
      endMs: d + l
    },
    t
  );
}
function Rc({
  fullBounds: i,
  previousFullBounds: e,
  visibleBounds: t
}) {
  if (t == null)
    return null;
  if (e != null && i.endMs > e.endMs && Cc({
    bounds: t,
    fullBounds: e
  })) {
    const s = t.endMs - t.startMs;
    return ts(
      {
        startMs: i.endMs - s,
        endMs: i.endMs
      },
      i
    );
  }
  return ts(t, i);
}
function Pn({
  bounds: i,
  fullBounds: e,
  mode: t
}) {
  return t !== "live" || i == null || i.endMs < e.endMs ? null : i.startMs <= e.startMs ? {
    mode: "full"
  } : {
    mode: "window",
    windowMs: i.endMs - i.startMs
  };
}
function Oi({ fullBounds: i, timeMs: e }) {
  return e >= i.endMs - 1;
}
function Dc({
  archiveRanges: i,
  fullBounds: e
}) {
  const t = i.reduce((s, n) => !s || n.toMs > s.toMs ? n : s, null);
  return t ? Math.max(t.fromMs, t.toMs - 1e3) : Math.max(e.startMs, e.endMs - 1e3);
}
function uo({
  fullBounds: i,
  mode: e,
  state: t
}) {
  if (e !== "live" || t == null)
    return null;
  if (t.mode === "full")
    return t;
  const s = i.endMs - i.startMs;
  return s <= 0 ? null : t.windowMs >= s ? {
    mode: "full"
  } : {
    mode: "window",
    windowMs: At(t.windowMs, 1, s)
  };
}
function ho({
  fullBounds: i,
  liveFollowState: e
}) {
  if (e.mode === "full")
    return i;
  const t = i.endMs - i.startMs, s = At(e.windowMs, 1, Math.max(t, 1));
  return {
    startMs: i.endMs - s,
    endMs: i.endMs
  };
}
function ts(i, e) {
  const t = e.endMs - e.startMs, s = i.endMs - i.startMs;
  if (t <= 0 || s <= 0)
    return null;
  if (s >= t)
    return e;
  const n = Math.min(s, t), r = At(i.startMs, e.startMs, e.endMs - n);
  return {
    startMs: r,
    endMs: r + n
  };
}
function Ic({ fullBounds: i, mode: e }) {
  const t = i.endMs - i.startMs;
  return e !== "live" || t <= ki ? i : {
    startMs: i.endMs - ki,
    endMs: i.endMs
  };
}
function zt({
  bounds: i,
  clientX: e,
  element: t
}) {
  const s = fo({
    clientX: e,
    element: t
  });
  return Math.round(i.startMs + (i.endMs - i.startMs) * s);
}
function bc({ bounds: i, ranges: e }) {
  const t = i.endMs - i.startMs;
  return t <= 0 ? [] : e.map((s) => {
    const n = At(s.fromMs, i.startMs, i.endMs), r = At(s.toMs, i.startMs, i.endMs);
    return r <= n ? null : {
      fromMs: n,
      toMs: r,
      leftPercent: (n - i.startMs) / t * 100,
      widthPercent: (r - n) / t * 100
    };
  }).filter((s) => s !== null);
}
function _c({
  mode: i,
  currentTimeMs: e,
  playbackStartTimeMs: t,
  durationSec: s,
  windowEndMs: n,
  windowStartMs: r
}) {
  var l;
  if (r != null && n != null && n > r)
    return {
      startMs: r,
      endMs: n
    };
  if (i === "live") {
    const c = Date.now();
    return {
      startMs: c - xc,
      endMs: c
    };
  }
  const o = Math.max(s * 1e3, 1), a = (l = t != null ? t : e) != null ? l : Date.now() - o;
  return {
    startMs: a,
    endMs: a + o
  };
}
function Cc({ bounds: i, fullBounds: e }) {
  return i.endMs >= e.endMs - 1;
}
function fo({ clientX: i, element: e }) {
  const t = e.getBoundingClientRect();
  return t.width <= 0 ? 0 : At((i - t.left) / t.width, 0, 1);
}
function At(i, e, t) {
  return Number.isFinite(i) ? Math.min(Math.max(i, e), t) : e;
}
function wc({
  displayTimeOffsetMs: i,
  media: e,
  percent: t,
  thumbnailAvailable: s,
  timeMs: n,
  onMediaError: r,
  onMediaLoad: o
}) {
  const { t: a } = ht("hlsFlussonicVideoPlayer"), l = Ec(n, i);
  return /* @__PURE__ */ ue(
    "span",
    {
      className: le.timeTooltip,
      style: {
        "--timeline-tooltip-percent": `${t}%`
      },
      children: [
        e ? e.type === "video" ? /* @__PURE__ */ F(
          "video",
          {
            autoPlay: !0,
            className: le.timeTooltipVideo,
            muted: !0,
            onError: () => r(e),
            onLoadedData: () => o(e),
            playsInline: !0,
            src: e.url
          }
        ) : /* @__PURE__ */ F(
          "img",
          {
            alt: l,
            className: le.timeTooltipImage,
            onError: () => r(e),
            onLoad: () => o(e),
            src: e.url
          }
        ) : /* @__PURE__ */ F("span", { className: le.timeTooltipPlaceholder, children: s === !1 ? a("errors.noArchive") : l }),
        /* @__PURE__ */ F("span", { className: le.timeTooltipLabel, children: l })
      ]
    }
  );
}
const Mc = 180, kc = 64, Fc = 128, Pc = 28, Ni = 6, Oc = 8, Nt = 1440 * 6e4, Nc = [
  6e4,
  5 * 6e4,
  15 * 6e4,
  30 * 6e4,
  60 * 6e4,
  120 * 6e4,
  360 * 6e4,
  720 * 6e4,
  Nt,
  7 * Nt,
  30 * Nt
];
function Uc({
  bounds: i,
  displayTimeOffsetMs: e,
  widthPx: t
}) {
  const s = i.endMs - i.startMs;
  if (s <= 0)
    return [];
  const n = Bc({
    durationMs: s,
    widthPx: t
  }), r = Zs(e), o = n * 2, a = kn(
    Math.ceil(Mn(i.startMs, r) / n) * n,
    r
  ), l = [];
  let c = -1 / 0;
  for (let u = a; u < i.endMs; u += n) {
    if (u <= i.startMs)
      continue;
    const h = Mn(u, r) % o === 0, m = (u - i.startMs) / s * 100, f = h ? $c({
      displayTimeOffsetMs: r,
      durationMs: s,
      lastLabelRightPx: c,
      leftPercent: m,
      tickMs: u,
      widthPx: t
    }) : "";
    if (f) {
      const g = go({
        durationMs: s,
        label: f
      });
      c = mo({
        leftPercent: m,
        widthPx: t
      }) + g / 2;
    }
    l.push({
      label: f,
      leftPercent: m,
      major: h,
      timeMs: u
    });
  }
  return l;
}
function Bc({ durationMs: i, widthPx: e }) {
  var n;
  const t = e == null ? 10 : Math.max(2, Math.floor(e / Pc)), s = i / t;
  return (n = Nc.find((r) => r >= s)) != null ? n : 30 * Nt;
}
function $c({
  displayTimeOffsetMs: i,
  durationMs: e,
  lastLabelRightPx: t,
  leftPercent: s,
  tickMs: n,
  widthPx: r
}) {
  const o = Kc(n, e, i);
  if (r == null)
    return o;
  if (r < Mc)
    return "";
  const a = go({
    durationMs: e,
    label: o
  }), l = mo({
    leftPercent: s,
    widthPx: r
  }), c = l - a / 2, u = l + a / 2;
  return c < Ni || u > r - Ni || c < t + Oc ? "" : o;
}
function mo({ leftPercent: i, widthPx: e }) {
  return (e != null ? e : 0) * i / 100;
}
function go({ durationMs: i, label: e }) {
  return Math.max(Gc(e), Hc(i));
}
function Gc(i) {
  return i.length * 7;
}
function Hc(i) {
  return i >= Nt ? Fc : kc;
}
function Kc(i, e, t) {
  const s = Je(i, t);
  return e >= Nt ? `${Ce(s.getDate())}.${Ce(
    s.getMonth() + 1
  )}.${String(s.getFullYear()).slice(-2)} ${Ce(
    s.getHours()
  )}:${Ce(s.getMinutes())}` : `${Ce(s.getHours())}:${Ce(s.getMinutes())}`;
}
function Vc({ bounds: i, displayTimeOffsetMs: e, widthPx: t }) {
  const s = Uc({
    bounds: i,
    displayTimeOffsetMs: e,
    widthPx: t
  });
  return /* @__PURE__ */ F(hl, { children: s.map((n) => /* @__PURE__ */ ue(
    "span",
    {
      className: le.tick,
      style: {
        "--timeline-tick-left-percent": `${n.leftPercent}%`
      },
      children: [
        /* @__PURE__ */ F("span", { className: ce(le.tickMark, n.major && le.tickMarkMajor) }),
        n.label && /* @__PURE__ */ F("span", { className: le.tickLabel, children: n.label })
      ]
    },
    n.timeMs
  )) });
}
const Ui = 12, Wc = Rl(function({
  archiveSegments: e,
  archiveSegmentHeight: t,
  bounds: s,
  displayTimeOffsetMs: n,
  handleSize: r,
  handleVisible: o,
  isInteracting: a,
  isSeeking: l,
  progressPercent: c,
  progressVisible: u,
  previewPercent: d,
  seekable: h,
  thumbnailAvailable: m,
  timelineWidthPx: f,
  tooltipMedia: g,
  tooltipTimeMs: p,
  trackHeight: E,
  trackLabel: y,
  onPointerCancel: v,
  onPointerDown: S,
  onPointerEnter: x,
  onPointerLeave: R,
  onPointerMove: L,
  onPointerUp: _,
  onThumbnailMediaError: A,
  onThumbnailMediaLoad: I
}, w) {
  const $ = {
    "--timeline-track-height": `${E}px`,
    "--timeline-track-top": `${Ui - E / 2}px`
  }, M = {
    "--timeline-archive-height": `${t}px`,
    "--timeline-archive-top": `${Ui - t / 2}px`
  };
  return /* @__PURE__ */ ue(
    "button",
    {
      "aria-label": y,
      className: ce(
        le.timelineButton,
        h && le.timelineButtonSeekable,
        a && le.timelineButtonDragging
      ),
      disabled: !h,
      onPointerCancel: v,
      onPointerDown: S,
      onPointerEnter: x,
      onPointerLeave: R,
      onPointerMove: L,
      onPointerUp: _,
      ref: w,
      type: "button",
      children: [
        /* @__PURE__ */ F("span", { className: ce(le.trackBase, a && le.trackBaseDragging), style: $ }),
        e.map((U) => /* @__PURE__ */ F(
          "span",
          {
            className: le.archiveSegment,
            style: {
              ...M,
              "--timeline-left-percent": `${U.leftPercent}%`,
              "--timeline-width-percent": `${U.widthPercent}%`
            }
          },
          `${U.fromMs}:${U.toMs}`
        )),
        u && /* @__PURE__ */ F(
          "span",
          {
            className: ce(le.progressBar, l && le.progressBarDragging),
            style: {
              ...$,
              "--timeline-progress-percent": `${c}%`
            }
          }
        ),
        o && /* @__PURE__ */ F(
          "span",
          {
            className: ce(
              le.timelineHandle,
              h && le.timelineHandleSeekable,
              l && le.timelineHandleDragging
            ),
            style: {
              "--timeline-handle-size": `${r}px`,
              "--timeline-progress-percent": `${c}%`
            }
          }
        ),
        p != null && /* @__PURE__ */ F(
          wc,
          {
            displayTimeOffsetMs: n,
            media: g,
            onMediaError: A,
            onMediaLoad: I,
            percent: d,
            thumbnailAvailable: m,
            timeMs: p
          }
        ),
        /* @__PURE__ */ F(Vc, { bounds: s, displayTimeOffsetMs: n, widthPx: f })
      ]
    }
  );
});
function po(i) {
  const [e, t] = ie(null);
  return se(() => {
    const s = i.current;
    if (!s)
      return;
    const n = () => {
      t(Math.round(s.getBoundingClientRect().width));
    };
    if (n(), typeof ResizeObserver == "undefined")
      return window.addEventListener("resize", n), () => {
        window.removeEventListener("resize", n);
      };
    const r = new ResizeObserver((o) => {
      const a = o[0], l = a == null ? void 0 : a.contentRect.width;
      t(Math.round(l != null ? l : s.getBoundingClientRect().width));
    });
    return r.observe(s), () => {
      r.disconnect();
    };
  }, [i]), e;
}
function Yc({
  applyViewportState: i,
  applyVisibleBounds: e,
  archiveRanges: t,
  boundsRef: s,
  fullBounds: n,
  gestureState: r,
  handleVisible: o,
  liveAvailable: a,
  mode: l,
  onLive: c,
  onSeek: u,
  progressPercent: d,
  seekable: h,
  setDragPreviewTimeMs: m,
  setGestureState: f,
  setHoverPreviewTimeMs: g,
  viewportLocked: p
}) {
  const E = Y(() => s.current, [s]), y = Y(
    (A) => {
      A.preventDefault(), A.stopPropagation(), h && (g(null), A.currentTarget.setPointerCapture(A.pointerId), f({
        kind: "pending",
        pointerId: A.pointerId,
        startBounds: E(),
        startClientX: A.clientX,
        startedOnHandle: Ac({
          clientX: A.clientX,
          element: A.currentTarget,
          handleVisible: o,
          progressPercent: d
        })
      }));
    },
    [E, o, d, h, f, g]
  ), v = Y(
    (A, I) => {
      const w = A.clientX - I.startClientX;
      if (!(Math.abs(w) < yc)) {
        if (I.startedOnHandle || p) {
          f({
            kind: "seek",
            pointerId: I.pointerId
          }), m(
            zt({
              bounds: I.startBounds,
              clientX: A.clientX,
              element: A.currentTarget
            })
          );
          return;
        }
        f({
          kind: "pan",
          pointerId: I.pointerId,
          startBounds: I.startBounds,
          startClientX: I.startClientX
        }), e(
          Pi({
            clientX: A.clientX,
            element: A.currentTarget,
            fullBounds: n,
            startBounds: I.startBounds,
            startClientX: I.startClientX
          }),
          !1
        );
      }
    },
    [e, n, m, f, p]
  ), S = Y(
    (A) => {
      if (r == null) {
        h && g(
          zt({
            bounds: E(),
            clientX: A.clientX,
            element: A.currentTarget
          })
        );
        return;
      }
      if (!(!h || A.pointerId !== r.pointerId)) {
        if (A.preventDefault(), A.stopPropagation(), r.kind === "pending") {
          v(A, r);
          return;
        }
        if (r.kind === "seek") {
          m(
            zt({
              bounds: E(),
              clientX: A.clientX,
              element: A.currentTarget
            })
          );
          return;
        }
        p || e(
          Pi({
            clientX: A.clientX,
            element: A.currentTarget,
            fullBounds: n,
            startBounds: r.startBounds,
            startClientX: r.startClientX
          }),
          !1
        );
      }
    },
    [
      e,
      n,
      r,
      E,
      v,
      h,
      m,
      g,
      p
    ]
  ), x = Y(
    (A) => {
      if (!h || r == null || A.pointerId !== r.pointerId)
        return;
      if (A.preventDefault(), A.stopPropagation(), A.currentTarget.hasPointerCapture(A.pointerId) && A.currentTarget.releasePointerCapture(A.pointerId), r.kind === "pan") {
        const M = E(), U = Pn({
          bounds: M,
          fullBounds: n,
          mode: l
        });
        f(null), g(null), i({
          liveFollowState: U,
          visibleBounds: U == null ? M : null
        });
        return;
      }
      const I = zt({
        bounds: r.kind === "pending" ? r.startBounds : E(),
        clientX: A.clientX,
        element: A.currentTarget
      });
      if (f(null), m(null), g(null), r.kind === "seek" && !p && a && Oi({
        fullBounds: n,
        timeMs: I
      })) {
        const M = Pn({
          bounds: E(),
          fullBounds: n,
          mode: "live"
        });
        i({
          liveFollowState: M,
          visibleBounds: null
        }), c();
        return;
      }
      const w = !a && Oi({
        fullBounds: n,
        timeMs: I
      }) ? Dc({
        archiveRanges: t,
        fullBounds: n
      }) : I, $ = E();
      p || i({
        liveFollowState: null,
        visibleBounds: $
      }), u(w);
    },
    [
      i,
      t,
      n,
      r,
      E,
      a,
      l,
      c,
      u,
      h,
      m,
      f,
      g,
      p
    ]
  ), R = Y(
    (A) => {
      r != null && A.pointerId !== r.pointerId || (A.currentTarget.hasPointerCapture(A.pointerId) && A.currentTarget.releasePointerCapture(A.pointerId), f(null), m(null), g(null));
    },
    [r, m, f, g]
  ), L = Y(
    (A) => {
      !h || r != null || g(
        zt({
          bounds: E(),
          clientX: A.clientX,
          element: A.currentTarget
        })
      );
    },
    [r, E, h, g]
  ), _ = Y(() => {
    r == null && g(null);
  }, [r, g]);
  return {
    handlePointerCancel: R,
    handlePointerDown: y,
    handlePointerEnter: L,
    handlePointerLeave: _,
    handlePointerMove: S,
    handlePointerUp: x
  };
}
function qc({
  fullBounds: i,
  isInteracting: e,
  mode: t,
  onTimelineViewportChange: s,
  timelineViewport: n
}) {
  const r = oe(null), o = oe(null), [a, l] = ie(null), [c, u] = ie(null), d = Te(
    () => Ic({
      fullBounds: i,
      mode: t
    }),
    [i, t]
  ), h = Te(
    () => c != null ? ho({
      fullBounds: i,
      liveFollowState: c
    }) : null,
    [i, c]
  ), m = Te(
    () => {
      var S;
      return (S = h != null ? h : a) != null ? S : d;
    },
    [d, h, a]
  ), f = oe(m), g = Te(() => Bi(n), [n]);
  se(() => {
    f.current = m;
  }, [m]);
  const p = Y(
    ({
      liveFollowState: S,
      visibleBounds: x
    }) => {
      const R = jc({
        liveFollowState: S,
        visibleBounds: x
      });
      o.current = Bi(R), s == null || s(R);
    },
    [s]
  ), E = Y(
    ({
      liveFollowState: S,
      visibleBounds: x
    }, R = !0) => {
      u(S), l(x), f.current = Xc({
        defaultBounds: d,
        fullBounds: i,
        liveFollowState: S,
        visibleBounds: x
      }), R && p({
        liveFollowState: S,
        visibleBounds: x
      });
    },
    [d, i, p]
  ), y = Y(
    (S, x = !0) => {
      const R = Pn({
        bounds: S,
        fullBounds: i,
        mode: t
      });
      if (R != null) {
        E(
          {
            liveFollowState: R,
            visibleBounds: null
          },
          x
        );
        return;
      }
      E(
        {
          liveFollowState: null,
          visibleBounds: S
        },
        x
      );
    },
    [E, i, t]
  ), v = Y(() => {
    E({
      liveFollowState: null,
      visibleBounds: null
    });
  }, [E]);
  return se(() => {
    if (e)
      return;
    const S = r.current;
    u(
      (x) => uo({
        fullBounds: i,
        mode: t,
        state: x
      })
    ), l(
      (x) => Rc({
        fullBounds: i,
        previousFullBounds: S,
        visibleBounds: x
      })
    ), r.current = i;
  }, [i, e, t]), se(() => {
    if (n == null || g == null || e || o.current === g)
      return;
    const S = zc({
      fullBounds: i,
      mode: t,
      viewport: n
    });
    E(S, !1), o.current = g;
  }, [E, i, e, t, n, g]), {
    applyViewportState: E,
    applyVisibleBounds: y,
    bounds: m,
    boundsRef: f,
    reportTimelineViewport: p,
    resetViewport: v
  };
}
function zc({
  fullBounds: i,
  mode: e,
  viewport: t
}) {
  return t.mode === "auto" ? {
    liveFollowState: null,
    visibleBounds: null
  } : t.mode === "live-follow" ? {
    liveFollowState: uo({
      fullBounds: i,
      mode: e,
      state: t.windowMs == null ? { mode: "full" } : { mode: "window", windowMs: t.windowMs }
    }),
    visibleBounds: null
  } : {
    liveFollowState: null,
    visibleBounds: ts(
      {
        startMs: t.startMs,
        endMs: t.endMs
      },
      i
    )
  };
}
function jc({
  liveFollowState: i,
  visibleBounds: e
}) {
  return (i == null ? void 0 : i.mode) === "full" ? {
    mode: "live-follow",
    windowMs: null
  } : (i == null ? void 0 : i.mode) === "window" ? {
    mode: "live-follow",
    windowMs: i.windowMs
  } : e ? {
    mode: "fixed",
    startMs: Math.round(e.startMs),
    endMs: Math.round(e.endMs)
  } : {
    mode: "auto"
  };
}
function Xc({
  defaultBounds: i,
  fullBounds: e,
  liveFollowState: t,
  visibleBounds: s
}) {
  return t != null ? ho({
    fullBounds: e,
    liveFollowState: t
  }) : s != null ? s : i;
}
function Bi(i) {
  var e;
  return i == null ? null : i.mode === "fixed" ? `${i.mode}:${Math.round(i.startMs)}:${Math.round(i.endMs)}` : i.mode === "live-follow" ? `${i.mode}:${(e = i.windowMs) != null ? e : "full"}` : i.mode;
}
function Qc({
  archiveRanges: i,
  liveAvailable: e,
  mode: t,
  currentTimeMs: s,
  displayTimeOffsetMs: n,
  playbackStartTimeMs: r,
  durationSec: o,
  seekable: a,
  thumbnailAvailable: l,
  thumbnailMedia: c = [],
  thumbnailTimeMs: u,
  timelineViewport: d,
  timelineZoomCommand: h,
  viewportLocked: m = !1,
  windowEndMs: f,
  windowStartMs: g,
  onPreviewTimeChange: p,
  onThumbnailMediaError: E,
  onThumbnailMediaLoad: y,
  onTimelineViewportChange: v,
  onSeek: S,
  onLive: x
}) {
  var mt, Ye;
  const { t: R } = ht("hlsFlussonicVideoPlayer"), L = oe(null), _ = oe(null), A = po(L), [I, w] = ie(null), [$, M] = ie(null), [U, N] = ie(null), q = g != null && f != null && f > g ? null : s, B = Te(
    () => _c({
      mode: t,
      currentTimeMs: q,
      playbackStartTimeMs: r,
      durationSec: o,
      windowEndMs: f,
      windowStartMs: g
    }),
    [o, q, t, r, f, g]
  ), O = I != null, P = (U == null ? void 0 : U.kind) === "pan", W = O || P, { applyViewportState: K, applyVisibleBounds: J, bounds: j, boundsRef: z, resetViewport: ne } = qc({
    fullBounds: B,
    isInteracting: W,
    mode: t,
    onTimelineViewportChange: v,
    timelineViewport: d
  }), he = (mt = I != null ? I : s) != null ? mt : t === "live" ? Date.now() : j.startMs, Fe = t === "live" && e && he > j.endMs, we = O || he >= j.startMs && (he <= j.endMs || Fe), tt = O || he > j.startMs, st = eu(he, j), ft = $i(st, j), Et = bc({
    bounds: j,
    ranges: i
  }), Pe = I != null ? I : $, nt = Pe == null ? 0 : $i(Pe, j), it = u != null ? u : Pe, [rt, te] = ie(() => ({
    mediaKey: "",
    urls: []
  })), Ge = Te(
    () => c.filter(
      (pe, Oe, _e) => _e.findIndex((ot) => ot.url === pe.url) === Oe
    ),
    [c]
  ), Ne = Te(
    () => Ge.map((pe) => pe.url).join(`
`),
    [Ge]
  ), It = rt.mediaKey === Ne ? rt.urls : [], bt = (Ye = Ge.find((pe) => !It.includes(pe.url))) != null ? Ye : null, _t = Y(
    (pe) => {
      E == null || E(pe), te((Oe) => ({
        mediaKey: Ne,
        urls: Jc({
          currentFailedUrls: Oe.mediaKey === Ne ? Oe.urls : [],
          failedUrl: pe.url
        })
      }));
    },
    [E, Ne]
  ), sn = Y(
    (pe) => {
      y == null || y(pe);
    },
    [y]
  );
  se(() => {
    p == null || p(Pe);
  }, [I, $, p, Pe]);
  const nn = () => {
    m || !e || (ne(), x());
  }, Ct = Y(
    (pe, Oe) => {
      const _e = L.current;
      if (!_e)
        return;
      const ot = _e.getBoundingClientRect();
      ot.width <= 0 || J(
        Lc({
          clientX: Oe != null ? Oe : ot.left + ot.width * Zc(st, j),
          element: _e,
          fullBounds: B,
          visibleBounds: j,
          zoomIn: pe
        })
      );
    },
    [J, j, B, st]
  );
  se(() => {
    const pe = L.current;
    if (!pe)
      return;
    const Oe = (_e) => {
      m || !a || _e.deltaY === 0 || (_e.preventDefault(), _e.stopPropagation(), Ct(_e.deltaY < 0, _e.clientX));
    };
    return pe.addEventListener("wheel", Oe, {
      passive: !1
    }), () => {
      pe.removeEventListener("wheel", Oe);
    };
  }, [Ct, a, m]), se(() => {
    h == null || _.current === h.revision || (_.current = h.revision, !(m || !a) && Ct(h.direction === "in"));
  }, [Ct, a, h, m]);
  const {
    handlePointerCancel: He,
    handlePointerDown: rn,
    handlePointerEnter: ls,
    handlePointerLeave: cs,
    handlePointerMove: Wt,
    handlePointerUp: on
  } = Yc({
    applyViewportState: K,
    applyVisibleBounds: J,
    archiveRanges: i,
    boundsRef: z,
    fullBounds: B,
    gestureState: U,
    handleVisible: we,
    liveAvailable: e,
    mode: t,
    onLive: x,
    onSeek: S,
    progressPercent: ft,
    seekable: a,
    setDragPreviewTimeMs: w,
    setGestureState: N,
    setHoverPreviewTimeMs: M,
    viewportLocked: m
  }), us = O ? 12 : 10, Yt = O ? 8 : 6, an = O ? 20 : 18;
  return /* @__PURE__ */ F("div", { className: le.root, "data-carousel-drag-disabled": !0, children: /* @__PURE__ */ ue("div", { className: le.controlsRow, children: [
    e && /* @__PURE__ */ F(
      "button",
      {
        "aria-pressed": t === "live",
        className: ce(le.liveButton, t === "live" && le.liveButtonActive),
        onClick: nn,
        type: "button",
        children: "Live"
      }
    ),
    /* @__PURE__ */ ue("div", { className: le.trackColumn, children: [
      /* @__PURE__ */ ue("div", { className: le.labelsRow, children: [
        /* @__PURE__ */ F("span", { className: le.timeLabel, children: Fn(j.startMs, n) }),
        /* @__PURE__ */ F("span", { className: le.timeLabel, children: Fn(j.endMs, n) })
      ] }),
      /* @__PURE__ */ F(
        Wc,
        {
          archiveSegmentHeight: Yt,
          archiveSegments: Et,
          bounds: j,
          displayTimeOffsetMs: n,
          handleSize: an,
          handleVisible: we,
          isInteracting: W,
          isSeeking: O,
          onPointerCancel: He,
          onPointerDown: rn,
          onPointerEnter: ls,
          onPointerLeave: cs,
          onPointerMove: Wt,
          onPointerUp: on,
          onThumbnailMediaError: _t,
          onThumbnailMediaLoad: sn,
          previewPercent: nt,
          progressPercent: ft,
          progressVisible: tt,
          ref: L,
          seekable: a,
          thumbnailAvailable: l,
          timelineWidthPx: A,
          tooltipMedia: bt,
          tooltipTimeMs: it,
          trackHeight: us,
          trackLabel: R("timeline.seek")
        }
      )
    ] })
  ] }) });
}
function $i(i, e) {
  return (i - e.startMs) / (e.endMs - e.startMs) * 100;
}
function Zc(i, e) {
  const t = e.endMs - e.startMs;
  return t <= 0 ? 0.5 : Math.min(Math.max((i - e.startMs) / t, 0), 1);
}
function Jc({
  currentFailedUrls: i,
  failedUrl: e
}) {
  return i.includes(e) ? i : [...i, e];
}
function eu(i, e) {
  return Number.isFinite(i) ? Math.min(Math.max(i, e.startMs), e.endMs) : e.startMs;
}
const On = [1, 2, 4, 8, 16], Gi = /* @__PURE__ */ Symbol.for("constructDateFrom");
function Us(i, e) {
  return typeof i == "function" ? i(e) : i && typeof i == "object" && Gi in i ? i[Gi](e) : i instanceof Date ? new i.constructor(e) : new Date(e);
}
function Rt(i, e) {
  return Us(e || i, i);
}
function To(i, e, t) {
  const s = Rt(i, t == null ? void 0 : t.in);
  return isNaN(e) ? Us(i, NaN) : (s.setDate(s.getDate() + e), s);
}
function Eo(i, e, t) {
  const s = Rt(i, t == null ? void 0 : t.in);
  if (isNaN(e)) return Us(i, NaN);
  if (!e)
    return s;
  const n = s.getDate(), r = Us(i, s.getTime());
  r.setMonth(s.getMonth() + e + 1, 0);
  const o = r.getDate();
  return n >= o ? r : (s.setFullYear(
    r.getFullYear(),
    r.getMonth(),
    n
  ), s);
}
function tu(i, e) {
  const t = e == null ? void 0 : e.weekStartsOn, s = Rt(i, e == null ? void 0 : e.in), n = s.getDay(), r = (n < t ? 7 : 0) + n - t;
  return s.setDate(s.getDate() - r), s.setHours(0, 0, 0, 0), s;
}
function Hi(i, e) {
  const t = Rt(i, e == null ? void 0 : e.in);
  return t.setHours(0, 0, 0, 0), t;
}
function su(i, e) {
  const t = Rt(i, e == null ? void 0 : e.in), s = t.getMonth();
  return t.setFullYear(t.getFullYear(), s + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function yo(i, e) {
  const t = Rt(i, e == null ? void 0 : e.in);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function nu(i, e) {
  const t = e == null ? void 0 : e.weekStartsOn, s = Rt(i, e == null ? void 0 : e.in), n = s.getDay(), r = (n < t ? -7 : 0) + 6 - (n - t);
  return s.setDate(s.getDate() + r), s.setHours(23, 59, 59, 999), s;
}
function iu(i, e, t) {
  return Eo(i, -1, t);
}
const Ki = 1;
function ru(i, e) {
  const t = /* @__PURE__ */ new Map(), s = Zs(e);
  return i.forEach((n) => {
    if (!lu(n))
      return;
    let r = Hi(Je(n.fromMs, s)).getTime();
    const o = Hi(
      Je(Math.max(n.fromMs, n.toMs - 1), s)
    ).getTime();
    for (; r <= o; ) {
      const a = To(new Date(r), 1).getTime(), l = kn(r, s), c = kn(a, s), u = Math.max(n.fromMs, l), d = Math.min(n.toMs, c);
      if (d > u) {
        const h = Bs(l, s), m = t.get(h);
        m ? (m.firstArchiveTimeMs = Math.min(m.firstArchiveTimeMs, u), m.lastArchiveTimeMs = Math.max(m.lastArchiveTimeMs, d)) : t.set(h, {
          dayEndMs: c,
          dayKey: h,
          dayStartMs: l,
          firstArchiveTimeMs: u,
          lastArchiveTimeMs: d
        });
      }
      r = a;
    }
  }), Array.from(t.values()).sort((n, r) => n.dayStartMs - r.dayStartMs);
}
function ou({
  archiveDaysByKey: i,
  monthMs: e
}) {
  var c;
  const t = new Date(e), s = yo(t).getTime(), n = su(t).getTime(), r = tu(new Date(s), {
    weekStartsOn: Ki
  }).getTime(), o = nu(new Date(n), {
    weekStartsOn: Ki
  }).getTime(), a = [];
  let l = r;
  for (; l <= o; ) {
    const u = Bs(l);
    a.push({
      archiveDay: (c = i.get(u)) != null ? c : null,
      dayKey: u,
      dayStartMs: l,
      inMonth: l >= s && l <= n
    }), l = To(new Date(l), 1).getTime();
  }
  return a;
}
function Bs(i, e) {
  const t = Je(i, e);
  return `${t.getFullYear()}-${Vi(t.getMonth() + 1)}-${Vi(t.getDate())}`;
}
function au(i, e) {
  return yo(Je(i, e)).getTime();
}
function lu(i) {
  return Number.isFinite(i.fromMs) && Number.isFinite(i.toMs) && i.toMs > i.fromMs;
}
function Vi(i) {
  return String(i).padStart(2, "0");
}
const cu = "HlsDvrCalendar-module__root__shV81", uu = "HlsDvrCalendar-module__trigger__1xDjL", du = "HlsDvrCalendar-module__triggerOpen__UCSOM", hu = "HlsDvrCalendar-module__navButton__tLlxU", fu = "HlsDvrCalendar-module__dayButton__kdktU", mu = "HlsDvrCalendar-module__popover__lbfGu", gu = "HlsDvrCalendar-module__header__QQbK7", pu = "HlsDvrCalendar-module__monthLabel__sfOOS", Tu = "HlsDvrCalendar-module__weekdays__eeNlv", Eu = "HlsDvrCalendar-module__grid__aFqU8", yu = "HlsDvrCalendar-module__weekday__5m30g", xu = "HlsDvrCalendar-module__dayAvailable__SFTfj", vu = "HlsDvrCalendar-module__daySelected__8QNYi", Su = "HlsDvrCalendar-module__dayToday__wVPfR", Au = "HlsDvrCalendar-module__dayOutOfMonth__lU2cY", Lu = "HlsDvrCalendar-module__archiveMarker__WJtIH", Ru = "HlsDvrCalendar-module__archiveMarkerSelected__ViIfz", Du = "HlsDvrCalendar-module__status__dce4V", Iu = "HlsDvrCalendar-module__statusError__704-L", bu = "HlsDvrCalendar-module__legend__DKeWv", _u = "HlsDvrCalendar-module__legendMarker__xCfIm", fe = {
  root: cu,
  trigger: uu,
  triggerOpen: du,
  navButton: hu,
  dayButton: fu,
  popover: mu,
  header: gu,
  monthLabel: pu,
  weekdays: Tu,
  grid: Eu,
  weekday: yu,
  dayAvailable: xu,
  daySelected: vu,
  dayToday: Su,
  dayOutOfMonth: Au,
  archiveMarker: Lu,
  archiveMarkerSelected: Ru,
  status: Du,
  statusError: Iu,
  legend: bu,
  legendMarker: _u
}, Cu = ku();
function wu({
  archiveRanges: i,
  archiveRangesError: e = null,
  archiveRangesLoading: t = !1,
  currentTimeMs: s,
  disabled: n = !1,
  displayTimeOffsetMs: r,
  onDaySelect: o
}) {
  var H, q;
  const { t: a } = ht("hlsFlussonicVideoPlayer"), l = oe(null), c = oe(null), [u, d] = ie(!1), [h, m] = ie({ x: 0, y: 0 }), f = Te(
    () => ru(i, r),
    [i, r]
  ), g = Te(() => new Map(f.map((B) => [B.dayKey, B])), [f]), p = (q = s != null ? s : (H = f[f.length - 1]) == null ? void 0 : H.firstArchiveTimeMs) != null ? q : Date.now(), E = au(p, r), [y, v] = ie(() => E), S = u && !n, x = s == null ? null : Bs(s, r), R = Bs(Date.now(), r), L = Te(
    () => ou({
      archiveDaysByKey: g,
      monthMs: y
    }),
    [g, y]
  ), _ = f.length > 0, A = t && !_, I = !t && e != null && !_, w = !t && e == null && !_, $ = Y(() => {
    const B = l.current, O = c.current, P = B == null ? void 0 : B.closest("[data-hls-video-player-root]");
    if (!B || !O || !(P instanceof HTMLElement)) {
      m({ x: 0, y: 0 });
      return;
    }
    const W = 8, K = P.getBoundingClientRect(), J = O.style.transform;
    O.style.transform = "none";
    const j = O.getBoundingClientRect();
    O.style.transform = J;
    let z = 0, ne = 0;
    j.left < K.left + W && (z += K.left + W - j.left), j.right + z > K.right - W && (z -= j.right + z - (K.right - W)), j.top < K.top + W && (ne += K.top + W - j.top), m({
      x: Math.round(z),
      y: Math.round(ne)
    });
  }, []);
  se(() => {
    if (!S)
      return;
    const B = (P) => {
      var K;
      const W = P.target;
      W instanceof Node && ((K = l.current) != null && K.contains(W)) || d(!1);
    }, O = (P) => {
      P.key === "Escape" && d(!1);
    };
    return document.addEventListener("pointerdown", B), document.addEventListener("keydown", O), () => {
      document.removeEventListener("pointerdown", B), document.removeEventListener("keydown", O);
    };
  }, [S]), lo(() => {
    if (!S) {
      m({ x: 0, y: 0 });
      return;
    }
    return $(), window.addEventListener("resize", $), window.addEventListener("scroll", $, !0), () => {
      window.removeEventListener("resize", $), window.removeEventListener("scroll", $, !0);
    };
  }, [S, $, y]);
  const M = () => {
    if (S) {
      d(!1), Yi(l.current);
      return;
    }
    v(E), d(!0);
  }, U = (B) => {
    o(B), d(!1), Yi(l.current);
  }, N = ln(p, r);
  return /* @__PURE__ */ ue("div", { className: fe.root, ref: l, children: [
    /* @__PURE__ */ F(
      "button",
      {
        "aria-expanded": S,
        "aria-haspopup": "dialog",
        "aria-label": `${a("calendar.open")}: ${N}`,
        className: ce(fe.trigger, S && fe.triggerOpen),
        disabled: n,
        onClick: M,
        title: N,
        type: "button",
        children: /* @__PURE__ */ F(ml, {})
      }
    ),
    S && /* @__PURE__ */ ue(
      "div",
      {
        "aria-label": a("calendar.title"),
        className: fe.popover,
        ref: c,
        role: "dialog",
        style: Pu(h),
        children: [
          /* @__PURE__ */ ue("div", { className: fe.header, children: [
            /* @__PURE__ */ F(
              "button",
              {
                className: fe.navButton,
                onClick: () => v((B) => iu(new Date(B)).getTime()),
                title: a("calendar.previousMonth"),
                type: "button",
                children: /* @__PURE__ */ F(gl, {})
              }
            ),
            /* @__PURE__ */ F("div", { className: fe.monthLabel, children: Mu(y) }),
            /* @__PURE__ */ F(
              "button",
              {
                className: fe.navButton,
                onClick: () => v((B) => Eo(new Date(B), 1).getTime()),
                title: a("calendar.nextMonth"),
                type: "button",
                children: /* @__PURE__ */ F(pl, {})
              }
            )
          ] }),
          A && /* @__PURE__ */ F("div", { className: fe.status, children: a("calendar.loading") }),
          I && /* @__PURE__ */ F("div", { className: ce(fe.status, fe.statusError), children: a("calendar.error") }),
          w && /* @__PURE__ */ F("div", { className: fe.status, children: a("calendar.empty") }),
          /* @__PURE__ */ F("div", { "aria-hidden": !0, className: fe.weekdays, children: Cu.map((B) => /* @__PURE__ */ F("span", { className: fe.weekday, children: B }, B)) }),
          /* @__PURE__ */ F("div", { className: fe.grid, children: L.map((B) => {
            const O = B.archiveDay, P = O != null, W = B.dayKey === x, K = B.dayKey === R, J = P ? `${a("calendar.openDay")}: ${ln(B.dayStartMs)}` : ln(B.dayStartMs);
            return /* @__PURE__ */ ue(
              "button",
              {
                "aria-label": J,
                className: ce(
                  fe.dayButton,
                  P && fe.dayAvailable,
                  !B.inMonth && fe.dayOutOfMonth,
                  W && fe.daySelected,
                  K && fe.dayToday
                ),
                disabled: !P,
                onClick: () => {
                  O && U(O);
                },
                title: J,
                type: "button",
                children: [
                  new Date(B.dayStartMs).getDate(),
                  P && /* @__PURE__ */ F("span", { className: ce(fe.archiveMarker, W && fe.archiveMarkerSelected) })
                ]
              },
              B.dayKey
            );
          }) }),
          /* @__PURE__ */ ue("div", { className: fe.legend, children: [
            /* @__PURE__ */ F("span", { className: fe.legendMarker }),
            /* @__PURE__ */ F("span", { children: a("calendar.recordedDay") })
          ] })
        ]
      }
    )
  ] });
}
function ln(i, e) {
  const t = Je(i, e);
  return `${Wi(t.getDate())}.${Wi(t.getMonth() + 1)}.${t.getFullYear()}`;
}
function Mu(i) {
  return new Intl.DateTimeFormat(void 0, {
    month: "long",
    year: "numeric"
  }).format(new Date(i));
}
function ku() {
  const i = new Date(2024, 0, 1);
  return Array.from(
    { length: 7 },
    (e, t) => new Intl.DateTimeFormat(void 0, {
      weekday: "short"
    }).format(Fu(i, t))
  );
}
function Fu(i, e) {
  const t = new Date(i);
  return t.setDate(i.getDate() + e), t;
}
function Wi(i) {
  return String(i).padStart(2, "0");
}
function Yi(i) {
  const e = document.activeElement;
  e instanceof HTMLElement && (i != null && i.contains(e)) && e.blur();
}
function Pu(i) {
  if (!(i.x === 0 && i.y === 0))
    return {
      transform: `translate(${i.x}px, ${i.y}px)`
    };
}
const Ou = "HlsPlayerControls-module__controlsRow__BPR2L", Nu = "HlsPlayerControls-module__iconButton__yJk33", Uu = "HlsPlayerControls-module__iconButtonActive__25rms", Bu = "HlsPlayerControls-module__dropdownTrigger__2Vlx3", $u = "HlsPlayerControls-module__option__VOWE6", Gu = "HlsPlayerControls-module__playbackTime__4gega", Hu = "HlsPlayerControls-module__timelineZoomControls__8B07O", Ku = "HlsPlayerControls-module__controlsSpacer__S-d8M", Vu = "HlsPlayerControls-module__secondaryControl__9rUvz", Wu = "HlsPlayerControls-module__secondaryControlCompact__bCou3", Yu = "HlsPlayerControls-module__dropdown__VRnvj", qu = "HlsPlayerControls-module__dropdownTriggerOpen__TZ0LY", zu = "HlsPlayerControls-module__playbackRateTrigger__tBYIh", ju = "HlsPlayerControls-module__triggerText__LQ0o9", Xu = "HlsPlayerControls-module__menu__mch9T", Qu = "HlsPlayerControls-module__playbackRateMenu__C-BM-", Zu = "HlsPlayerControls-module__optionSelected__lEn3i", Ju = "HlsPlayerControls-module__playbackRateOption__lq7MP", ed = "HlsPlayerControls-module__settingsDropdown__ivbzE", td = "HlsPlayerControls-module__settingsDropdownCompact__XduZX", sd = "HlsPlayerControls-module__settingsTriggerOpen__WcWdQ", nd = "HlsPlayerControls-module__settingsMenu__DbJ7b", id = "HlsPlayerControls-module__settingsSection__T44l9", rd = "HlsPlayerControls-module__settingsSectionTitle__q-x4s", od = "HlsPlayerControls-module__settingsOptionsGrid__GabGj", ad = "HlsPlayerControls-module__settingsOption__GB0eL", ld = "HlsPlayerControls-module__settingsActionButton__Xz7ic", V = {
  controlsRow: Ou,
  iconButton: Nu,
  iconButtonActive: Uu,
  dropdownTrigger: Bu,
  option: $u,
  playbackTime: Gu,
  timelineZoomControls: Hu,
  controlsSpacer: Ku,
  secondaryControl: Vu,
  secondaryControlCompact: Wu,
  dropdown: Yu,
  dropdownTriggerOpen: qu,
  playbackRateTrigger: zu,
  triggerText: ju,
  menu: Xu,
  playbackRateMenu: Qu,
  optionSelected: Zu,
  playbackRateOption: Ju,
  settingsDropdown: ed,
  settingsDropdownCompact: td,
  settingsTriggerOpen: sd,
  settingsMenu: nd,
  settingsSection: id,
  settingsSectionTitle: rd,
  settingsOptionsGrid: od,
  settingsOption: ad,
  settingsActionButton: ld
};
function cd({
  archiveCalendarDisabled: i = !1,
  archiveRanges: e,
  archiveRangesError: t = null,
  archiveRangesLoading: s = !1,
  controlsMode: n,
  currentTimeMs: r,
  displayTimeOffsetMs: o,
  fullscreen: a,
  paused: l,
  playbackRate: c,
  playbackRateDisabled: u = !1,
  selectedVideoTrackId: d,
  timelineZoomDisabled: h = !1,
  videoTracks: m,
  onHideControls: f,
  onArchiveCalendarDaySelect: g,
  onFullscreenToggle: p,
  onPlaybackRateChange: E,
  onPlayToggle: y,
  onPinToggle: v,
  onTimelineZoomIn: S,
  onTimelineZoomOut: x,
  onVideoTrackChange: R
}) {
  var nt, it, rt;
  const { t: L } = ht("hlsFlussonicVideoPlayer"), _ = oe(null), A = oe(null), I = oe(null), w = oe(null), [$, M] = ie(null), U = n === "pinned", N = (it = (nt = m.find((te) => te.id === d)) != null ? nt : m[0]) != null ? it : null, H = po(_), q = H != null && H <= 460, B = m.length === 0, O = $ === "playback-rate", P = $ === "quality", W = $ === "settings", K = L("playbackRate"), J = L("videoQuality"), j = L("settings"), z = L("timeline.zoomIn"), ne = L("timeline.zoomOut"), he = L(U ? "controls.unpinPanel" : "controls.pinPanel"), Fe = L("controls.hidePanel");
  se(() => {
    if (!$)
      return;
    const te = (Ge) => {
      var It, bt, _t;
      const Ne = Ge.target;
      Ne instanceof Node && ((It = A.current) != null && It.contains(Ne) || (bt = I.current) != null && bt.contains(Ne) || (_t = w.current) != null && _t.contains(Ne) || M(null));
    };
    return document.addEventListener("pointerdown", te), () => {
      document.removeEventListener("pointerdown", te);
    };
  }, [$]);
  const we = (te) => {
    M((Ge) => Ge === te ? null : te);
  }, tt = (te) => {
    E(te), M(null), jt(A.current), jt(w.current);
  }, st = (te) => {
    R(te), M(null), jt(I.current), jt(w.current);
  }, ft = () => {
    v(), M(null), jt(w.current);
  }, Et = () => {
    M(null), f();
  }, Pe = (te) => {
    te.key === "Escape" && M(null);
  };
  return /* @__PURE__ */ ue("div", { className: V.controlsRow, ref: _, children: [
    /* @__PURE__ */ F(
      "button",
      {
        className: V.iconButton,
        onClick: y,
        title: L(l ? "play" : "pause"),
        type: "button",
        children: l ? /* @__PURE__ */ F(Tl, {}) : /* @__PURE__ */ F(El, {})
      }
    ),
    /* @__PURE__ */ F("span", { className: V.playbackTime, children: ud(r, o) }),
    /* @__PURE__ */ ue("div", { className: V.timelineZoomControls, children: [
      /* @__PURE__ */ F(
        "button",
        {
          "aria-label": ne,
          className: V.iconButton,
          disabled: h,
          onClick: x,
          title: ne,
          type: "button",
          children: /* @__PURE__ */ F(yl, {})
        }
      ),
      /* @__PURE__ */ F(
        "button",
        {
          "aria-label": z,
          className: V.iconButton,
          disabled: h,
          onClick: S,
          title: z,
          type: "button",
          children: /* @__PURE__ */ F(xl, {})
        }
      )
    ] }),
    /* @__PURE__ */ F("span", { className: V.controlsSpacer }),
    /* @__PURE__ */ F(
      wu,
      {
        archiveRanges: e,
        archiveRangesError: t,
        archiveRangesLoading: s,
        currentTimeMs: r,
        disabled: i,
        displayTimeOffsetMs: o,
        onDaySelect: g
      }
    ),
    /* @__PURE__ */ F("div", { className: ce(V.secondaryControl, q && V.secondaryControlCompact), children: /* @__PURE__ */ ue("div", { className: V.dropdown, ref: A, children: [
      /* @__PURE__ */ F(
        "button",
        {
          "aria-expanded": O,
          "aria-haspopup": "listbox",
          className: ce(
            V.dropdownTrigger,
            V.playbackRateTrigger,
            O && V.dropdownTriggerOpen
          ),
          disabled: u,
          onClick: () => we("playback-rate"),
          onKeyDown: Pe,
          title: K,
          type: "button",
          children: /* @__PURE__ */ F("span", { className: V.triggerText, children: cn(c) })
        }
      ),
      O && /* @__PURE__ */ F("div", { className: ce(V.menu, V.playbackRateMenu), role: "listbox", children: On.map((te) => /* @__PURE__ */ F(
        "button",
        {
          "aria-selected": te === c,
          className: ce(
            V.option,
            V.playbackRateOption,
            te === c && V.optionSelected
          ),
          onClick: () => tt(te),
          role: "option",
          type: "button",
          children: cn(te)
        },
        te
      )) })
    ] }) }),
    /* @__PURE__ */ F("div", { className: ce(V.secondaryControl, q && V.secondaryControlCompact), children: /* @__PURE__ */ ue("div", { className: V.dropdown, ref: I, children: [
      /* @__PURE__ */ F(
        "button",
        {
          "aria-expanded": P,
          "aria-haspopup": "listbox",
          className: ce(V.dropdownTrigger, P && V.dropdownTriggerOpen),
          disabled: B,
          onClick: () => we("quality"),
          onKeyDown: Pe,
          title: J,
          type: "button",
          children: /* @__PURE__ */ F("span", { className: V.triggerText, children: (rt = N == null ? void 0 : N.label) != null ? rt : "" })
        }
      ),
      P && /* @__PURE__ */ F("div", { className: V.menu, role: "listbox", children: m.map((te) => /* @__PURE__ */ F(
        "button",
        {
          "aria-selected": te.id === (N == null ? void 0 : N.id),
          className: ce(V.option, te.id === (N == null ? void 0 : N.id) && V.optionSelected),
          onClick: () => st(te.id),
          role: "option",
          type: "button",
          children: te.label
        },
        te.id
      )) })
    ] }) }),
    /* @__PURE__ */ F("div", { className: ce(V.secondaryControl, q && V.secondaryControlCompact), children: /* @__PURE__ */ F(
      "button",
      {
        className: ce(V.iconButton, U && V.iconButtonActive),
        onClick: ft,
        title: he,
        type: "button",
        children: U ? /* @__PURE__ */ F(bi, {}) : /* @__PURE__ */ F(_i, {})
      }
    ) }),
    /* @__PURE__ */ F("div", { className: ce(V.secondaryControl, q && V.secondaryControlCompact), children: /* @__PURE__ */ F("button", { className: V.iconButton, onClick: Et, title: Fe, type: "button", children: /* @__PURE__ */ F(Ci, {}) }) }),
    /* @__PURE__ */ ue(
      "div",
      {
        className: ce(V.settingsDropdown, q && V.settingsDropdownCompact),
        ref: w,
        children: [
          /* @__PURE__ */ F(
            "button",
            {
              "aria-expanded": W,
              "aria-haspopup": "dialog",
              className: ce(V.iconButton, W && V.settingsTriggerOpen),
              onClick: () => we("settings"),
              onKeyDown: Pe,
              title: j,
              type: "button",
              children: /* @__PURE__ */ F(vl, {})
            }
          ),
          W && /* @__PURE__ */ ue("div", { "aria-label": j, className: V.settingsMenu, role: "dialog", children: [
            /* @__PURE__ */ ue("div", { className: V.settingsSection, children: [
              /* @__PURE__ */ F("div", { className: V.settingsSectionTitle, children: K }),
              /* @__PURE__ */ F("div", { className: V.settingsOptionsGrid, children: On.map((te) => /* @__PURE__ */ F(
                "button",
                {
                  "aria-pressed": te === c,
                  className: ce(
                    V.option,
                    V.settingsOption,
                    te === c && V.optionSelected
                  ),
                  disabled: u,
                  onClick: () => tt(te),
                  type: "button",
                  children: cn(te)
                },
                te
              )) })
            ] }),
            !B && /* @__PURE__ */ ue("div", { className: V.settingsSection, children: [
              /* @__PURE__ */ F("div", { className: V.settingsSectionTitle, children: J }),
              m.map((te) => /* @__PURE__ */ F(
                "button",
                {
                  "aria-pressed": te.id === (N == null ? void 0 : N.id),
                  className: ce(
                    V.option,
                    V.settingsOption,
                    te.id === (N == null ? void 0 : N.id) && V.optionSelected
                  ),
                  onClick: () => st(te.id),
                  type: "button",
                  children: te.label
                },
                te.id
              ))
            ] }),
            /* @__PURE__ */ ue("div", { className: V.settingsSection, children: [
              /* @__PURE__ */ ue(
                "button",
                {
                  className: ce(V.option, V.settingsActionButton, U && V.optionSelected),
                  onClick: ft,
                  type: "button",
                  children: [
                    U ? /* @__PURE__ */ F(bi, {}) : /* @__PURE__ */ F(_i, {}),
                    /* @__PURE__ */ F("span", { children: he })
                  ]
                }
              ),
              /* @__PURE__ */ ue(
                "button",
                {
                  className: ce(V.option, V.settingsActionButton),
                  onClick: Et,
                  type: "button",
                  children: [
                    /* @__PURE__ */ F(Ci, {}),
                    /* @__PURE__ */ F("span", { children: Fe })
                  ]
                }
              )
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ F(
      "button",
      {
        className: V.iconButton,
        onClick: p,
        title: L(a ? "fullscreen.exit" : "fullscreen.enter"),
        type: "button",
        children: a ? /* @__PURE__ */ F(Sl, {}) : /* @__PURE__ */ F(Al, {})
      }
    )
  ] });
}
function ud(i, e) {
  return i == null ? "--:--:--" : rs(i, e);
}
function cn(i) {
  return `${i}x`;
}
function jt(i) {
  const e = document.activeElement;
  e instanceof HTMLElement && (i != null && i.contains(e)) && e.blur();
}
const dd = "PlayerPlaceholder-module__placeholder__ogwUS", hd = "PlayerPlaceholder-module__title__zbLHY", fd = "PlayerPlaceholder-module__meta__3DTgL", Jt = {
  placeholder: dd,
  title: hd,
  meta: fd
};
function md() {
  const { t: i } = ht("hlsFlussonicVideoPlayer");
  return /* @__PURE__ */ F("div", { className: Jt.placeholder, children: i("errors.liveUnavailable") });
}
function gd({ displayTimeOffsetMs: i, timeMs: e }) {
  const { t } = ht("hlsFlussonicVideoPlayer");
  return /* @__PURE__ */ ue("div", { className: Jt.placeholder, children: [
    /* @__PURE__ */ F("div", { className: Jt.title, children: t("errors.noArchive") }),
    /* @__PURE__ */ F("div", { className: Jt.meta, children: wl(e, i) })
  ] });
}
function pd() {
  const { t: i } = ht("hlsFlussonicVideoPlayer");
  return /* @__PURE__ */ F("div", { className: Jt.placeholder, children: i("errors.streamUnavailable") });
}
const Td = "HlsVideoPlayer-module__root__aoyuI", Ed = "HlsVideoPlayer-module__video__iuTuw", yd = "HlsVideoPlayer-module__loadingOverlay__oakam", xd = "HlsVideoPlayer-module__controlsOverlay__8uzhw", vd = "HlsVideoPlayer-module__controlsOverlayVisible__16rws", Sd = "HlsVideoPlayer-module__errorOverlay__fR5B-", Ad = "HlsVideoPlayer-module__errorOverlayMessage__s-lQH", Ld = "HlsVideoPlayer-module__restoreControlsButton__mtGip", Rd = "HlsVideoPlayer-module__cameraNameBadge__Jr6QX", at = {
  root: Td,
  video: Ed,
  loadingOverlay: yd,
  controlsOverlay: xd,
  controlsOverlayVisible: vd,
  errorOverlay: Sd,
  errorOverlayMessage: Ad,
  restoreControlsButton: Ld,
  cameraNameBadge: Rd
};
function Dt(i) {
  const e = new URL(i), t = Pd(e.pathname);
  return {
    origin: e.origin,
    streamName: t.replace(/^\/+/, ""),
    streamPath: t,
    searchParams: new URLSearchParams(e.search)
  };
}
function Dd({
  config: i,
  playbackMode: e,
  playbackStartTimeMs: t,
  playlistDurationSec: s,
  videoTrackId: n
}) {
  const r = Tt(
    i,
    Fd({
      playbackMode: e,
      playbackStartTimeMs: t,
      playlistDurationSec: s
    })
  );
  return n && r.searchParams.set("filter.tracks", n), r.toString();
}
function Id({
  config: i,
  playbackStartTimeMs: e,
  playlistDurationSec: t
}) {
  const s = Tt(
    i,
    `archive-${Math.floor(e / 1e3)}-${t}.json`
  );
  return s.searchParams.delete("filter.tracks"), s.searchParams.delete("tracks"), s.toString();
}
function bd({
  authToken: i,
  config: e,
  fromMs: t,
  toMs: s,
  videoTrackId: n
}) {
  const r = Math.floor(t / 1e3), o = Math.ceil(s / 1e3), a = o - r, l = n.trim();
  if (!Number.isFinite(r) || !Number.isFinite(o) || r < 0 || a <= 0)
    throw new RangeError("Invalid Flussonic DVR export interval");
  if (!l)
    throw new RangeError("Invalid Flussonic DVR export video track");
  const c = Tt(e, `archive-${r}-${a}.mp4`);
  return c.searchParams.delete("tracks"), c.searchParams.set("filter.tracks", l), xo(c, i), c.toString();
}
function _d(i) {
  return Tt(i, "recording_status.json").toString();
}
function Cd(i) {
  return Tt(i, "media_info.json").toString();
}
function wd(i) {
  return Tt(i, "info.json").toString();
}
function Md({
  config: i,
  closedAtGteMs: e,
  openedAtLteMs: t,
  resolutionSec: s
}) {
  const n = Tt(i, "ranges.json");
  return n.searchParams.set("closed_at_gte", qi(e)), n.searchParams.set("opened_at_lte", qi(t)), s != null && n.searchParams.set("resolution", String(s)), n.toString();
}
function kd({
  authToken: i,
  config: e,
  timeMs: t
}) {
  const s = Tt(e, `${Math.floor(t / 1e3)}-preview.jpg`);
  return xo(s, i), s.toString();
}
function Tt(i, e) {
  const t = e.replace(/^\/+/, ""), s = i.streamPath === "/" ? "" : i.streamPath, n = new URL(`${i.origin}${s}/${t}`);
  return i.searchParams.forEach((r, o) => {
    n.searchParams.append(o, r);
  }), n;
}
function xo(i, e) {
  !e || i.searchParams.has("token") || i.searchParams.set("token", e);
}
function Fd({
  playbackMode: i,
  playbackStartTimeMs: e,
  playlistDurationSec: t
}) {
  return i === "archive" && e != null ? `index-${Math.floor(e / 1e3)}-${t}.fmp4.m3u8` : "index.m3u8";
}
function Pd(i) {
  const e = i.replace(/\/+$/, "");
  return e.endsWith("/embed.html") || e.endsWith("/index.m3u8") ? e.slice(0, -11) || "/" : e.endsWith("/mpegts") ? e.slice(0, -7) || "/" : e || "/";
}
function qi(i) {
  return String(Math.floor(i / 1e3));
}
function Od({ elementRef: i }) {
  const [e, t] = ie(!1);
  se(() => {
    const n = () => {
      t(document.fullscreenElement === i.current);
    };
    return document.addEventListener("fullscreenchange", n), () => {
      document.removeEventListener("fullscreenchange", n);
    };
  }, [i]);
  const s = Y(() => {
    const n = i.current;
    if (n) {
      if (document.fullscreenElement === n) {
        document.exitFullscreen().catch(() => {
        });
        return;
      }
      n.requestFullscreen().catch(() => {
      });
    }
  }, [i]);
  return {
    fullscreen: e,
    toggleFullscreen: s
  };
}
function os(i, e) {
  return i.some((t) => e >= t.fromMs && e <= t.toMs);
}
function Nd({
  archiveRanges: i,
  fromMs: e,
  toMs: t
}) {
  const s = Bd({ fromMs: e, toMs: t });
  if (s == null)
    return {
      requestedInterval: s,
      status: "empty"
    };
  const n = Hd(
    i.map((r) => $d(s, r)).filter((r) => r !== null)
  );
  if (n.length === 0)
    return {
      requestedInterval: s,
      status: "empty"
    };
  if (n.length === 1) {
    const [r] = n;
    return {
      complete: Gd(r, s),
      part: r,
      requestedInterval: s,
      status: "single"
    };
  }
  return {
    complete: !1,
    parts: n,
    requestedInterval: s,
    status: "multiple"
  };
}
function Ud(i) {
  const e = Nn(i).map(Kd).filter((t) => t !== null).sort((t, s) => t.fromMs - s.fromMs);
  return Yd(e);
}
function Nn(i) {
  return i == null ? [] : Array.isArray(i) ? qd(i) || ji(i) ? [i] : i.flatMap(Nn) : typeof i == "object" ? ji(i) ? [i] : Object.values(i).flatMap(Nn) : [];
}
function Bd({ fromMs: i, toMs: e }) {
  const t = Math.min(i, e), s = Math.max(i, e);
  return !Number.isFinite(t) || !Number.isFinite(s) || t >= s ? null : {
    fromMs: t,
    toMs: s
  };
}
function $d(i, e) {
  const t = Math.max(i.fromMs, e.fromMs), s = Math.min(i.toMs, e.toMs);
  return t >= s ? null : {
    fromMs: t,
    toMs: s
  };
}
function Gd(i, e) {
  return i.fromMs === e.fromMs && i.toMs === e.toMs;
}
function Hd(i) {
  return i.slice().sort((e, t) => e.fromMs - t.fromMs).reduce((e, t) => {
    const s = e[e.length - 1];
    return !s || t.fromMs > s.toMs ? (e.push({ ...t }), e) : (s.toMs = Math.max(s.toMs, t.toMs), e);
  }, []);
}
function Kd(i) {
  var n, r, o, a, l;
  if (Array.isArray(i)) {
    const c = gs(i[0]), u = gs(i[1]);
    return zi(c, u);
  }
  if (!vo(i))
    return null;
  const e = i, t = gs((r = (n = e.from) != null ? n : e.start) != null ? r : e.opened_at), s = (l = gs((a = (o = e.to) != null ? o : e.end) != null ? a : e.closed_at)) != null ? l : Vd(t, e.duration);
  return zi(t, s);
}
function Vd(i, e) {
  if (i == null)
    return null;
  const t = Wd(e);
  return t == null ? null : i + t;
}
function Wd(i) {
  const e = Number(i);
  return !Number.isFinite(e) || e < 0 ? null : e > 1e5 ? Math.round(e) : e * 1e3;
}
function gs(i) {
  const e = Number(i);
  return !Number.isFinite(e) || e <= 0 ? null : e > 1e11 ? Math.round(e) : Math.round(e * 1e3);
}
function zi(i, e) {
  return i == null || e == null || e < i ? null : { fromMs: i, toMs: e };
}
function Yd(i) {
  return i.reduce((e, t) => {
    const s = e[e.length - 1];
    return !s || t.fromMs > s.toMs ? (e.push({ ...t }), e) : (s.toMs = Math.max(s.toMs, t.toMs), e);
  }, []);
}
function ji(i) {
  return vo(i) ? ("from" in i || "start" in i || "opened_at" in i) && ("to" in i || "end" in i || "closed_at" in i || "duration" in i) : !1;
}
function qd(i) {
  return i.length >= 2 && Number.isFinite(Number(i[0])) && Number.isFinite(Number(i[1]));
}
function vo(i) {
  return typeof i == "object" && i !== null;
}
function zd(i) {
  var e;
  return !(i != null && i.dvrEnabled) || i.fromMs == null || i.toMs != null && i.toMs <= i.fromMs ? null : {
    startMs: i.fromMs,
    endMs: (e = i.toMs) != null ? e : Date.now()
  };
}
function jd({
  archiveRanges: i,
  dvrWindow: e
}) {
  const t = i.reduce((s, n) => !s || n.toMs > s.toMs ? n : s, null);
  return t ? Math.max(t.fromMs, t.toMs - 1e3) : e ? Math.max(e.startMs, e.endMs - 1e3) : null;
}
function Xd({
  dvrWindow: i,
  liveAvailable: e,
  liveEdgeMs: t
}) {
  return i ? !e || t == null ? i : {
    startMs: i.startMs,
    endMs: Math.max(i.endMs, t)
  } : null;
}
class Qd extends Error {
  constructor({ status: t, statusText: s, url: n }) {
    super(`Flussonic request failed: ${t} ${s}`);
    hs(this, "status");
    hs(this, "statusText");
    hs(this, "url");
    this.name = "FlussonicRequestError", this.status = t, this.statusText = s, this.url = n;
  }
}
async function Zd({
  sourceUrl: i,
  signal: e
}) {
  const t = Dt(i), s = await as({
    signal: e,
    url: _d(t)
  });
  return ih(s, t.streamName);
}
async function Jd({
  closedAtGteMs: i,
  openedAtLteMs: e,
  resolutionSec: t,
  signal: s,
  sourceUrl: n
}) {
  const r = Dt(n), o = await as({
    signal: s,
    url: Md({
      closedAtGteMs: i,
      config: r,
      openedAtLteMs: e,
      resolutionSec: t
    })
  });
  return Ud(o);
}
async function eh({
  playbackMode: i,
  playbackStartTimeMs: e = null,
  playlistDurationSec: t = null,
  signal: s,
  sourceUrl: n
}) {
  return i === "archive" && e != null && t != null && Number.isFinite(e) && Number.isFinite(t) && t > 0 ? sh({
    playbackStartTimeMs: e,
    playlistDurationSec: t,
    signal: s,
    sourceUrl: n
  }) : th({
    signal: s,
    sourceUrl: n
  });
}
async function th({ signal: i, sourceUrl: e }) {
  const t = Dt(e), s = await as({
    signal: i,
    url: Cd(t)
  });
  return Un(s);
}
async function sh({
  playbackStartTimeMs: i,
  playlistDurationSec: e,
  signal: t,
  sourceUrl: s
}) {
  const n = Dt(s), r = await as({
    signal: t,
    url: Id({
      config: n,
      playbackStartTimeMs: i,
      playlistDurationSec: e
    })
  });
  return uh(r);
}
async function nh({ signal: i, sourceUrl: e }) {
  const t = Dt(e), s = await as({
    signal: i,
    url: wd(t)
  });
  return hh(s);
}
async function as({ signal: i, url: e }) {
  const t = await fetch(e, { signal: i });
  if (!t.ok)
    throw new Qd({
      status: t.status,
      statusText: t.statusText,
      url: e
    });
  return t.json();
}
function ih(i, e) {
  const t = rh(i, e), s = Ie(t), n = $s(xe(s, ["from", "start", "opened_at", "begin"])), r = $s(xe(s, ["to", "end", "closed_at", "until"])), o = So(xe(s, ["duration", "depth"])), a = r != null ? r : ah(n, o);
  return {
    dvrEnabled: oh(t),
    fromMs: n,
    toMs: a,
    durationMs: o,
    raw: i
  };
}
function rh(i, e) {
  if (ps(i))
    return i;
  const t = Ie(i);
  if (!t)
    return i;
  if (ps(t[e]))
    return t[e];
  const s = e.split("/").pop();
  if (s && ps(t[s]))
    return t[s];
  const n = Object.values(t).find(ps);
  return n != null ? n : i;
}
function ps(i) {
  const e = Ie(i);
  return e != null && xe(e, [
    "from",
    "start",
    "opened_at",
    "begin",
    "to",
    "end",
    "closed_at",
    "until",
    "duration",
    "depth"
  ]) != null;
}
function oh(i) {
  if (typeof i == "boolean")
    return i;
  const e = Ie(i);
  if (!e)
    return !1;
  const t = xe(e, ["recording", "recording_enabled", "dvr", "dvr_enabled", "enabled"]);
  return typeof t == "boolean" ? t : typeof t == "string" ? ["true", "1", "active", "enabled", "recording"].includes(t.toLowerCase()) : typeof t == "number" ? t > 0 : $s(xe(e, ["from", "start", "opened_at", "begin"])) != null || So(xe(e, ["duration", "depth"])) != null;
}
function ah(i, e) {
  return i == null || e == null ? null : i + e;
}
function So(i) {
  const e = Number(i);
  return !Number.isFinite(e) || e < 0 ? null : e > 1e5 ? Math.round(e) : e * 1e3;
}
function $s(i) {
  const e = Number(i);
  return !Number.isFinite(e) || e <= 0 ? null : e > 1e11 ? Math.round(e) : Math.round(e * 1e3);
}
function xe(i, e) {
  if (i) {
    for (const t of e)
      if (i[t] != null)
        return i[t];
  }
}
function Ie(i) {
  return typeof i == "object" && i !== null ? i : null;
}
const lh = ["active", "alive", "online", "publishing", "running", "started"], ch = ["closed", "failed", "inactive", "no_input", "offline", "stopped", "waiting"];
function Un(i) {
  return gh(i).map(ph).filter((t) => t != null).sort(Ao);
}
function uh(i) {
  const e = Ie(i), t = e == null ? void 0 : e.periods;
  return Array.isArray(t) ? dh(
    t.flatMap((s) => {
      var r;
      const n = Ie(s);
      return Un((r = n == null ? void 0 : n.media_info) != null ? r : s);
    })
  ).sort(Ao) : Un(i);
}
function dh(i) {
  const e = /* @__PURE__ */ new Map();
  return i.forEach((t) => {
    e.has(t.id) || e.set(t.id, t);
  }), Array.from(e.values());
}
function hh(i) {
  const e = fh(i), t = Ie(e == null ? void 0 : e.stats), s = $t(xe(t != null ? t : e, ["status", "state"])), n = $s(
    xe(t != null ? t : e, ["last_dts_at", "lastDtsAt", "last_dts", "lastDts"])
  );
  return {
    authToken: $t(xe(e, ["auth_token", "authToken", "token"])),
    lastDtsAtMs: n,
    liveAvailable: mh({
      lastDtsAtMs: n,
      stats: t != null ? t : e,
      status: s
    }),
    raw: i,
    status: s
  };
}
function fh(i) {
  var n;
  const e = Ie(i);
  if (!e)
    return null;
  if (Ie(e.stats))
    return e;
  const s = Object.values(e).find((r) => {
    const o = Ie(r);
    return o != null && Ie(o.stats) != null;
  });
  return (n = Ie(s)) != null ? n : e;
}
function mh({
  lastDtsAtMs: i,
  stats: e,
  status: t
}) {
  const s = xe(e, ["live", "online", "alive", "running", "source_alive", "sourceAlive"]);
  if (typeof s == "boolean")
    return s;
  const n = t == null ? void 0 : t.toLowerCase();
  if (n) {
    if (lh.includes(n))
      return !0;
    if (ch.includes(n))
      return !1;
  }
  return i != null && Date.now() - i < 3e4 ? !0 : null;
}
function gh(i) {
  var r;
  const e = Ie(i), t = (r = Ie(e == null ? void 0 : e.media_info)) != null ? r : e, s = t == null ? void 0 : t.tracks;
  if (Array.isArray(s))
    return s;
  const n = Ie(s);
  return n ? Object.entries(n).map(([o, a]) => {
    const l = Ie(a);
    return l ? { id: o, ...l } : a;
  }) : [];
}
function ph(i) {
  const e = Ie(i);
  if (!e || !Th(e))
    return null;
  const t = Eh(e);
  if (!t)
    return null;
  const s = Qt(xe(e, ["width", "w"])), n = Qt(xe(e, ["height", "h"])), r = Qt(xe(e, ["bitrate", "bit_rate", "bps"])), o = Qt(xe(e, ["fps", "framerate"])), a = $t(xe(e, ["codec", "codec_name"]));
  return {
    id: t,
    label: yh({ height: n, id: t }),
    bitrate: r,
    codec: a,
    fps: o,
    height: n,
    raw: i,
    width: s
  };
}
function Th(i) {
  const e = $t(xe(i, ["id", "track_id", "trackId", "name"])), t = $t(xe(i, ["content", "type", "media_type", "kind"]));
  return (e == null ? void 0 : e.startsWith("v")) || (t == null ? void 0 : t.toLowerCase()) === "video" || Qt(xe(i, ["width", "height"])) != null;
}
function Eh(i) {
  const e = $t(xe(i, ["id", "track_id", "trackId", "name"]));
  return e && e.startsWith("v") ? e : null;
}
function yh({ height: i, id: e }) {
  return i != null ? `${i}p` : e;
}
function Ao(i, e) {
  return Xi(i.height, e.height) || Xi(i.bitrate, e.bitrate) || i.id.localeCompare(e.id);
}
function Xi(i, e) {
  return i == null && e == null ? 0 : i == null ? -1 : e == null ? 1 : i - e;
}
function Qt(i) {
  const e = Number(i);
  return Number.isFinite(e) ? e : null;
}
function $t(i) {
  return typeof i == "string" && i.trim() !== "" ? i.trim() : null;
}
function Js({
  enabled: i = !0,
  initialData: e,
  loadingStrategy: t = "always",
  load: s,
  preserveDataOnError: n = !1,
  refreshIntervalMs: r = null,
  resetOnLoadChange: o = !0
}) {
  const a = oe(e), l = oe(!1), [c, u] = ie(e), [d, h] = ie(null), [m, f] = ie(!1), [g, p] = ie(0), E = Y(() => {
    p((y) => y + 1);
  }, []);
  return se(() => {
    o && (a.current = e, l.current = !1, u(e), h(null));
  }, [e, s, o]), se(() => {
    if (!i) {
      a.current = e, l.current = !1, u(e), h(null), f(!1);
      return;
    }
    const y = new AbortController();
    let v = !0;
    const S = t === "always" || !l.current;
    return f(S), h(null), s(y.signal).then((x) => {
      v && (a.current = x, l.current = !0, u(x), f(!1));
    }).catch((x) => {
      !v || xh(x) || (h(vh(x)), (!n || !l.current) && (a.current = e, l.current = !1, u(e)), f(!1));
    }), () => {
      v = !1, y.abort();
    };
  }, [i, e, s, t, n, g]), se(() => {
    if (!i || r == null || !Number.isFinite(r) || r <= 0)
      return;
    const y = setInterval(E, r);
    return () => {
      clearInterval(y);
    };
  }, [i, r, E]), {
    data: c,
    error: d,
    loading: m,
    reload: E
  };
}
function xh(i) {
  return i instanceof DOMException && i.name === "AbortError";
}
function vh(i) {
  return i instanceof Error ? i : new Error(String(i));
}
const Sh = 720, Qi = [];
function Ah({
  sourceUrl: i,
  windowEndMs: e,
  windowStartMs: t
}) {
  const s = t != null && e != null && e > t, n = Y(
    (r) => t == null || e == null || e <= t ? Promise.resolve(Qi) : Jd({
      closedAtGteMs: t,
      openedAtLteMs: e,
      resolutionSec: Lh(t, e),
      signal: r,
      sourceUrl: i
    }),
    [i, e, t]
  );
  return Js({
    enabled: s,
    initialData: Qi,
    load: n,
    resetOnLoadChange: !1
  });
}
function Lh(i, e) {
  const t = Math.max((e - i) / 1e3, 1);
  return Math.max(Math.floor(t / Sh), 1);
}
const Rh = 1e4;
function Dh(i, e = {}) {
  var n;
  const t = (n = e.refreshIntervalMs) != null ? n : Rh, s = Y(
    (r) => Zd({
      signal: r,
      sourceUrl: i
    }),
    [i]
  );
  return Js({
    initialData: null,
    load: s,
    loadingStrategy: "initial",
    preserveDataOnError: !0,
    refreshIntervalMs: t
  });
}
const Ih = 1e4;
function bh(i, e = {}) {
  var n;
  const t = (n = e.refreshIntervalMs) != null ? n : Ih, s = Y(
    (r) => nh({
      signal: r,
      sourceUrl: i
    }),
    [i]
  );
  return Js({
    initialData: null,
    load: s,
    loadingStrategy: "initial",
    preserveDataOnError: !0,
    refreshIntervalMs: t
  });
}
const _h = [];
function Ch({
  enabled: i = !0,
  playbackMode: e,
  playbackStartTimeMs: t = null,
  playlistDurationSec: s = null,
  sourceUrl: n
}) {
  const r = oe({
    playbackMode: e,
    playbackStartTimeMs: t,
    playlistDurationSec: s
  }), o = wh({
    playbackMode: e,
    playbackStartTimeMs: t,
    playlistDurationSec: s
  }), a = oe(o), l = Y(
    (d) => {
      const h = r.current;
      return eh({
        playbackMode: h.playbackMode,
        playbackStartTimeMs: h.playbackStartTimeMs,
        playlistDurationSec: h.playlistDurationSec,
        signal: d,
        sourceUrl: n
      });
    },
    [n]
  );
  se(() => {
    r.current = {
      playbackMode: e,
      playbackStartTimeMs: t,
      playlistDurationSec: s
    };
  }, [e, t, s]);
  const c = Js({
    enabled: i,
    initialData: _h,
    load: l,
    loadingStrategy: "initial",
    preserveDataOnError: !0
  }), { reload: u } = c;
  return se(() => {
    if (!i) {
      a.current = o;
      return;
    }
    a.current !== o && (a.current = o, u());
  }, [o, i, u]), c;
}
function wh({
  playbackMode: i,
  playbackStartTimeMs: e,
  playlistDurationSec: t
}) {
  return i !== "archive" || e == null || t == null || !Number.isFinite(e) || !Number.isFinite(t) || t <= 0 ? null : `${Math.floor(e / 1e3)}:${t}`;
}
function Mh({
  liveEdgeMs: i,
  playbackMode: e,
  playbackStartTimeMs: t,
  playlistDurationSec: s,
  sourceUrl: n
}) {
  var y, v, S, x, R, L, _, A, I;
  const r = bh(n), o = (v = (y = r.data) == null ? void 0 : y.liveAvailable) != null ? v : null, a = (x = (S = r.data) == null ? void 0 : S.authToken) != null ? x : null, l = o !== !1, c = o === !1 ? null : (L = (R = r.data) == null ? void 0 : R.lastDtsAtMs) != null ? L : null, u = Dh(n), d = Te(() => zd(u.data), [u.data]), h = Te(
    () => Xd({
      dvrWindow: d,
      liveAvailable: l,
      liveEdgeMs: i
    }),
    [d, l, i]
  ), m = Ah({
    sourceUrl: n,
    windowEndMs: (_ = d == null ? void 0 : d.endMs) != null ? _ : null,
    windowStartMs: (A = d == null ? void 0 : d.startMs) != null ? A : null
  }), f = m.loading || u.loading || u.data == null && u.error == null, g = Ch({
    enabled: kh({
      archiveRanges: m.data,
      archiveRangesError: m.error,
      archiveRangesLoading: f,
      playbackMode: e,
      playbackStartTimeMs: t
    }),
    playbackMode: e,
    playbackStartTimeMs: t,
    playlistDurationSec: s,
    sourceUrl: n
  }), p = ((I = r.data) == null ? void 0 : I.liveAvailable) === !1 && u.data != null && d == null, E = h != null;
  return {
    archiveRanges: {
      ...m,
      loading: f
    },
    canSeekArchive: E,
    dvrWindow: d,
    liveAvailable: l,
    recordingStatus: u,
    streamLiveAvailable: o,
    streamAuthToken: a,
    streamLiveEdgeMs: c,
    streamStatus: r,
    streamUnavailable: p,
    timelineWindow: h,
    videoTracks: g
  };
}
function kh({
  archiveRanges: i,
  archiveRangesError: e,
  archiveRangesLoading: t,
  playbackMode: s,
  playbackStartTimeMs: n
}) {
  return s !== "archive" ? !0 : n == null || !Number.isFinite(n) ? !1 : t || e != null ? !0 : os(i, n);
}
function Fh({
  archiveRanges: i,
  archiveRangesError: e,
  archiveRangesLoading: t,
  authToken: s,
  config: n,
  playbackBounds: r,
  videoTrackId: o
}) {
  return Te(
    () => Ph({
      archiveRanges: i,
      archiveRangesError: e,
      archiveRangesLoading: t,
      authToken: s,
      config: n,
      playbackBounds: r,
      videoTrackId: o
    }),
    [i, e, t, s, n, r, o]
  );
}
function Ph({
  archiveRanges: i,
  archiveRangesError: e,
  archiveRangesLoading: t,
  authToken: s,
  config: n,
  playbackBounds: r,
  videoTrackId: o
}) {
  if ((r == null ? void 0 : r.locked) !== !0)
    return {
      status: "hidden"
    };
  const a = {
    fromMs: r.startMs,
    toMs: r.endMs
  };
  if (!o)
    return {
      reason: "no-track",
      requestedInterval: a,
      status: "empty"
    };
  if (t)
    return {
      requestedInterval: a,
      status: "loading"
    };
  if (e != null)
    return {
      reason: "archive-error",
      requestedInterval: a,
      status: "empty"
    };
  const l = Nd({
    archiveRanges: i,
    fromMs: r.startMs,
    toMs: r.endMs
  });
  return l.status === "empty" ? {
    reason: "no-archive",
    requestedInterval: l.requestedInterval,
    status: "empty"
  } : l.status === "single" ? {
    complete: l.complete,
    part: Zi({
      authToken: s,
      config: n,
      part: l.part,
      videoTrackId: o
    }),
    requestedInterval: l.requestedInterval,
    status: "single"
  } : {
    complete: !1,
    parts: l.parts.map(
      (c) => Zi({
        authToken: s,
        config: n,
        part: c,
        videoTrackId: o
      })
    ),
    requestedInterval: l.requestedInterval,
    status: "multiple"
  };
}
function Zi({
  authToken: i,
  config: e,
  part: t,
  videoTrackId: s
}) {
  return {
    ...t,
    url: bd({
      authToken: i,
      config: e,
      fromMs: t.fromMs,
      toMs: t.toMs,
      videoTrackId: s
    })
  };
}
function Oh({
  liveAvailable: i,
  streamLiveEdgeMs: e
}) {
  const t = oe(null);
  return se(() => {
    if (!i || e == null) {
      t.current = null;
      return;
    }
    t.current = {
      capturedAtMs: Date.now(),
      liveEdgeMs: e
    };
  }, [i, e]), {
    getLivePlaybackTimeMs: Y(() => {
      const n = t.current;
      return !i || n == null ? Date.now() : n.liveEdgeMs + (Date.now() - n.capturedAtMs);
    }, [i])
  };
}
function Nh(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
var Lo = { exports: {} };
(function(i, e) {
  (function(t) {
    var s = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, n = /^(?=([^\/?#]*))\1([^]*)$/, r = /(?:\/|^)\.(?=\/)/g, o = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, a = {
      // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
      // E.g
      // With opts.alwaysNormalize = false (default, spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
      // With opts.alwaysNormalize = true (not spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
      buildAbsoluteURL: function(l, c, u) {
        if (u = u || {}, l = l.trim(), c = c.trim(), !c) {
          if (!u.alwaysNormalize)
            return l;
          var d = a.parseURL(l);
          if (!d)
            throw new Error("Error trying to parse base URL.");
          return d.path = a.normalizePath(
            d.path
          ), a.buildURLFromParts(d);
        }
        var h = a.parseURL(c);
        if (!h)
          throw new Error("Error trying to parse relative URL.");
        if (h.scheme)
          return u.alwaysNormalize ? (h.path = a.normalizePath(h.path), a.buildURLFromParts(h)) : c;
        var m = a.parseURL(l);
        if (!m)
          throw new Error("Error trying to parse base URL.");
        if (!m.netLoc && m.path && m.path[0] !== "/") {
          var f = n.exec(m.path);
          m.netLoc = f[1], m.path = f[2];
        }
        m.netLoc && !m.path && (m.path = "/");
        var g = {
          // 2c) Otherwise, the embedded URL inherits the scheme of
          // the base URL.
          scheme: m.scheme,
          netLoc: h.netLoc,
          path: null,
          params: h.params,
          query: h.query,
          fragment: h.fragment
        };
        if (!h.netLoc && (g.netLoc = m.netLoc, h.path[0] !== "/"))
          if (!h.path)
            g.path = m.path, h.params || (g.params = m.params, h.query || (g.query = m.query));
          else {
            var p = m.path, E = p.substring(0, p.lastIndexOf("/") + 1) + h.path;
            g.path = a.normalizePath(E);
          }
        return g.path === null && (g.path = u.alwaysNormalize ? a.normalizePath(h.path) : h.path), a.buildURLFromParts(g);
      },
      parseURL: function(l) {
        var c = s.exec(l);
        return c ? {
          scheme: c[1] || "",
          netLoc: c[2] || "",
          path: c[3] || "",
          params: c[4] || "",
          query: c[5] || "",
          fragment: c[6] || ""
        } : null;
      },
      normalizePath: function(l) {
        for (l = l.split("").reverse().join("").replace(r, ""); l.length !== (l = l.replace(o, "")).length; )
          ;
        return l.split("").reverse().join("");
      },
      buildURLFromParts: function(l) {
        return l.scheme + l.netLoc + l.path + l.params + l.query + l.fragment;
      }
    };
    i.exports = a;
  })();
})(Lo);
var ti = Lo.exports;
function Ji(i, e) {
  var t = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(i);
    e && (s = s.filter(function(n) {
      return Object.getOwnPropertyDescriptor(i, n).enumerable;
    })), t.push.apply(t, s);
  }
  return t;
}
function Re(i) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ji(Object(t), !0).forEach(function(s) {
      $h(i, s, t[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(t)) : Ji(Object(t)).forEach(function(s) {
      Object.defineProperty(i, s, Object.getOwnPropertyDescriptor(t, s));
    });
  }
  return i;
}
function Uh(i, e) {
  if (typeof i != "object" || !i) return i;
  var t = i[Symbol.toPrimitive];
  if (t !== void 0) {
    var s = t.call(i, e);
    if (typeof s != "object") return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(i);
}
function Bh(i) {
  var e = Uh(i, "string");
  return typeof e == "symbol" ? e : String(e);
}
function $h(i, e, t) {
  return e = Bh(e), e in i ? Object.defineProperty(i, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[e] = t, i;
}
function ve() {
  return ve = Object.assign ? Object.assign.bind() : function(i) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (i[s] = t[s]);
    }
    return i;
  }, ve.apply(this, arguments);
}
const G = Number.isFinite || function(i) {
  return typeof i == "number" && isFinite(i);
}, Gh = Number.isSafeInteger || function(i) {
  return typeof i == "number" && Math.abs(i) <= Hh;
}, Hh = Number.MAX_SAFE_INTEGER || 9007199254740991;
let T = /* @__PURE__ */ (function(i) {
  return i.MEDIA_ATTACHING = "hlsMediaAttaching", i.MEDIA_ATTACHED = "hlsMediaAttached", i.MEDIA_DETACHING = "hlsMediaDetaching", i.MEDIA_DETACHED = "hlsMediaDetached", i.BUFFER_RESET = "hlsBufferReset", i.BUFFER_CODECS = "hlsBufferCodecs", i.BUFFER_CREATED = "hlsBufferCreated", i.BUFFER_APPENDING = "hlsBufferAppending", i.BUFFER_APPENDED = "hlsBufferAppended", i.BUFFER_EOS = "hlsBufferEos", i.BUFFER_FLUSHING = "hlsBufferFlushing", i.BUFFER_FLUSHED = "hlsBufferFlushed", i.MANIFEST_LOADING = "hlsManifestLoading", i.MANIFEST_LOADED = "hlsManifestLoaded", i.MANIFEST_PARSED = "hlsManifestParsed", i.LEVEL_SWITCHING = "hlsLevelSwitching", i.LEVEL_SWITCHED = "hlsLevelSwitched", i.LEVEL_LOADING = "hlsLevelLoading", i.LEVEL_LOADED = "hlsLevelLoaded", i.LEVEL_UPDATED = "hlsLevelUpdated", i.LEVEL_PTS_UPDATED = "hlsLevelPtsUpdated", i.LEVELS_UPDATED = "hlsLevelsUpdated", i.AUDIO_TRACKS_UPDATED = "hlsAudioTracksUpdated", i.AUDIO_TRACK_SWITCHING = "hlsAudioTrackSwitching", i.AUDIO_TRACK_SWITCHED = "hlsAudioTrackSwitched", i.AUDIO_TRACK_LOADING = "hlsAudioTrackLoading", i.AUDIO_TRACK_LOADED = "hlsAudioTrackLoaded", i.SUBTITLE_TRACKS_UPDATED = "hlsSubtitleTracksUpdated", i.SUBTITLE_TRACKS_CLEARED = "hlsSubtitleTracksCleared", i.SUBTITLE_TRACK_SWITCH = "hlsSubtitleTrackSwitch", i.SUBTITLE_TRACK_LOADING = "hlsSubtitleTrackLoading", i.SUBTITLE_TRACK_LOADED = "hlsSubtitleTrackLoaded", i.SUBTITLE_FRAG_PROCESSED = "hlsSubtitleFragProcessed", i.CUES_PARSED = "hlsCuesParsed", i.NON_NATIVE_TEXT_TRACKS_FOUND = "hlsNonNativeTextTracksFound", i.INIT_PTS_FOUND = "hlsInitPtsFound", i.FRAG_LOADING = "hlsFragLoading", i.FRAG_LOAD_EMERGENCY_ABORTED = "hlsFragLoadEmergencyAborted", i.FRAG_LOADED = "hlsFragLoaded", i.FRAG_DECRYPTED = "hlsFragDecrypted", i.FRAG_PARSING_INIT_SEGMENT = "hlsFragParsingInitSegment", i.FRAG_PARSING_USERDATA = "hlsFragParsingUserdata", i.FRAG_PARSING_METADATA = "hlsFragParsingMetadata", i.FRAG_PARSED = "hlsFragParsed", i.FRAG_BUFFERED = "hlsFragBuffered", i.FRAG_CHANGED = "hlsFragChanged", i.FPS_DROP = "hlsFpsDrop", i.FPS_DROP_LEVEL_CAPPING = "hlsFpsDropLevelCapping", i.MAX_AUTO_LEVEL_UPDATED = "hlsMaxAutoLevelUpdated", i.ERROR = "hlsError", i.DESTROYING = "hlsDestroying", i.KEY_LOADING = "hlsKeyLoading", i.KEY_LOADED = "hlsKeyLoaded", i.LIVE_BACK_BUFFER_REACHED = "hlsLiveBackBufferReached", i.BACK_BUFFER_REACHED = "hlsBackBufferReached", i.STEERING_MANIFEST_LOADED = "hlsSteeringManifestLoaded", i;
})({}), Z = /* @__PURE__ */ (function(i) {
  return i.NETWORK_ERROR = "networkError", i.MEDIA_ERROR = "mediaError", i.KEY_SYSTEM_ERROR = "keySystemError", i.MUX_ERROR = "muxError", i.OTHER_ERROR = "otherError", i;
})({}), C = /* @__PURE__ */ (function(i) {
  return i.KEY_SYSTEM_NO_KEYS = "keySystemNoKeys", i.KEY_SYSTEM_NO_ACCESS = "keySystemNoAccess", i.KEY_SYSTEM_NO_SESSION = "keySystemNoSession", i.KEY_SYSTEM_NO_CONFIGURED_LICENSE = "keySystemNoConfiguredLicense", i.KEY_SYSTEM_LICENSE_REQUEST_FAILED = "keySystemLicenseRequestFailed", i.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED = "keySystemServerCertificateRequestFailed", i.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED = "keySystemServerCertificateUpdateFailed", i.KEY_SYSTEM_SESSION_UPDATE_FAILED = "keySystemSessionUpdateFailed", i.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED = "keySystemStatusOutputRestricted", i.KEY_SYSTEM_STATUS_INTERNAL_ERROR = "keySystemStatusInternalError", i.MANIFEST_LOAD_ERROR = "manifestLoadError", i.MANIFEST_LOAD_TIMEOUT = "manifestLoadTimeOut", i.MANIFEST_PARSING_ERROR = "manifestParsingError", i.MANIFEST_INCOMPATIBLE_CODECS_ERROR = "manifestIncompatibleCodecsError", i.LEVEL_EMPTY_ERROR = "levelEmptyError", i.LEVEL_LOAD_ERROR = "levelLoadError", i.LEVEL_LOAD_TIMEOUT = "levelLoadTimeOut", i.LEVEL_PARSING_ERROR = "levelParsingError", i.LEVEL_SWITCH_ERROR = "levelSwitchError", i.AUDIO_TRACK_LOAD_ERROR = "audioTrackLoadError", i.AUDIO_TRACK_LOAD_TIMEOUT = "audioTrackLoadTimeOut", i.SUBTITLE_LOAD_ERROR = "subtitleTrackLoadError", i.SUBTITLE_TRACK_LOAD_TIMEOUT = "subtitleTrackLoadTimeOut", i.FRAG_LOAD_ERROR = "fragLoadError", i.FRAG_LOAD_TIMEOUT = "fragLoadTimeOut", i.FRAG_DECRYPT_ERROR = "fragDecryptError", i.FRAG_PARSING_ERROR = "fragParsingError", i.FRAG_GAP = "fragGap", i.REMUX_ALLOC_ERROR = "remuxAllocError", i.KEY_LOAD_ERROR = "keyLoadError", i.KEY_LOAD_TIMEOUT = "keyLoadTimeOut", i.BUFFER_ADD_CODEC_ERROR = "bufferAddCodecError", i.BUFFER_INCOMPATIBLE_CODECS_ERROR = "bufferIncompatibleCodecsError", i.BUFFER_APPEND_ERROR = "bufferAppendError", i.BUFFER_APPENDING_ERROR = "bufferAppendingError", i.BUFFER_STALLED_ERROR = "bufferStalledError", i.BUFFER_FULL_ERROR = "bufferFullError", i.BUFFER_SEEK_OVER_HOLE = "bufferSeekOverHole", i.BUFFER_NUDGE_ON_STALL = "bufferNudgeOnStall", i.INTERNAL_EXCEPTION = "internalException", i.INTERNAL_ABORTED = "aborted", i.UNKNOWN = "unknown", i;
})({});
const xt = function() {
}, Bn = {
  trace: xt,
  debug: xt,
  log: xt,
  warn: xt,
  info: xt,
  error: xt
};
let es = Bn;
function Kh(i) {
  const e = self.console[i];
  return e ? e.bind(self.console, `[${i}] >`) : xt;
}
function Vh(i, ...e) {
  e.forEach(function(t) {
    es[t] = i[t] ? i[t].bind(i) : Kh(t);
  });
}
function Wh(i, e) {
  if (typeof console == "object" && i === !0 || typeof i == "object") {
    Vh(
      i,
      // Remove out from list here to hard-disable a log-level
      // 'trace',
      "debug",
      "log",
      "info",
      "warn",
      "error"
    );
    try {
      es.log(`Debug logs enabled for "${e}" in hls.js version 1.5.13`);
    } catch {
      es = Bn;
    }
  } else
    es = Bn;
}
const D = es, Yh = /^(\d+)x(\d+)$/, er = /(.+?)=(".*?"|.*?)(?:,|$)/g;
class ge {
  constructor(e) {
    typeof e == "string" && (e = ge.parseAttrList(e)), ve(this, e);
  }
  get clientAttrs() {
    return Object.keys(this).filter((e) => e.substring(0, 2) === "X-");
  }
  decimalInteger(e) {
    const t = parseInt(this[e], 10);
    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
  }
  hexadecimalInteger(e) {
    if (this[e]) {
      let t = (this[e] || "0x").slice(2);
      t = (t.length & 1 ? "0" : "") + t;
      const s = new Uint8Array(t.length / 2);
      for (let n = 0; n < t.length / 2; n++)
        s[n] = parseInt(t.slice(n * 2, n * 2 + 2), 16);
      return s;
    } else
      return null;
  }
  hexadecimalIntegerAsNumber(e) {
    const t = parseInt(this[e], 16);
    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
  }
  decimalFloatingPoint(e) {
    return parseFloat(this[e]);
  }
  optionalFloat(e, t) {
    const s = this[e];
    return s ? parseFloat(s) : t;
  }
  enumeratedString(e) {
    return this[e];
  }
  bool(e) {
    return this[e] === "YES";
  }
  decimalResolution(e) {
    const t = Yh.exec(this[e]);
    if (t !== null)
      return {
        width: parseInt(t[1], 10),
        height: parseInt(t[2], 10)
      };
  }
  static parseAttrList(e) {
    let t;
    const s = {};
    for (er.lastIndex = 0; (t = er.exec(e)) !== null; ) {
      let r = t[2];
      r.indexOf('"') === 0 && r.lastIndexOf('"') === r.length - 1 && (r = r.slice(1, -1));
      const o = t[1].trim();
      s[o] = r;
    }
    return s;
  }
}
function qh(i) {
  return i !== "ID" && i !== "CLASS" && i !== "START-DATE" && i !== "DURATION" && i !== "END-DATE" && i !== "END-ON-NEXT";
}
function zh(i) {
  return i === "SCTE35-OUT" || i === "SCTE35-IN";
}
class Ro {
  constructor(e, t) {
    if (this.attr = void 0, this._startDate = void 0, this._endDate = void 0, this._badValueForSameId = void 0, t) {
      const s = t.attr;
      for (const n in s)
        if (Object.prototype.hasOwnProperty.call(e, n) && e[n] !== s[n]) {
          D.warn(`DATERANGE tag attribute: "${n}" does not match for tags with ID: "${e.ID}"`), this._badValueForSameId = n;
          break;
        }
      e = ve(new ge({}), s, e);
    }
    if (this.attr = e, this._startDate = new Date(e["START-DATE"]), "END-DATE" in this.attr) {
      const s = new Date(this.attr["END-DATE"]);
      G(s.getTime()) && (this._endDate = s);
    }
  }
  get id() {
    return this.attr.ID;
  }
  get class() {
    return this.attr.CLASS;
  }
  get startDate() {
    return this._startDate;
  }
  get endDate() {
    if (this._endDate)
      return this._endDate;
    const e = this.duration;
    return e !== null ? new Date(this._startDate.getTime() + e * 1e3) : null;
  }
  get duration() {
    if ("DURATION" in this.attr) {
      const e = this.attr.decimalFloatingPoint("DURATION");
      if (G(e))
        return e;
    } else if (this._endDate)
      return (this._endDate.getTime() - this._startDate.getTime()) / 1e3;
    return null;
  }
  get plannedDuration() {
    return "PLANNED-DURATION" in this.attr ? this.attr.decimalFloatingPoint("PLANNED-DURATION") : null;
  }
  get endOnNext() {
    return this.attr.bool("END-ON-NEXT");
  }
  get isValid() {
    return !!this.id && !this._badValueForSameId && G(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class);
  }
}
class en {
  constructor() {
    this.aborted = !1, this.loaded = 0, this.retry = 0, this.total = 0, this.chunkCount = 0, this.bwEstimate = 0, this.loading = {
      start: 0,
      first: 0,
      end: 0
    }, this.parsing = {
      start: 0,
      end: 0
    }, this.buffering = {
      start: 0,
      first: 0,
      end: 0
    };
  }
}
var ae = {
  AUDIO: "audio",
  VIDEO: "video",
  AUDIOVIDEO: "audiovideo"
};
class Do {
  constructor(e) {
    this._byteRange = null, this._url = null, this.baseurl = void 0, this.relurl = void 0, this.elementaryStreams = {
      [ae.AUDIO]: null,
      [ae.VIDEO]: null,
      [ae.AUDIOVIDEO]: null
    }, this.baseurl = e;
  }
  // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
  setByteRange(e, t) {
    const s = e.split("@", 2);
    let n;
    s.length === 1 ? n = (t == null ? void 0 : t.byteRangeEndOffset) || 0 : n = parseInt(s[1]), this._byteRange = [n, parseInt(s[0]) + n];
  }
  get byteRange() {
    return this._byteRange ? this._byteRange : [];
  }
  get byteRangeStartOffset() {
    return this.byteRange[0];
  }
  get byteRangeEndOffset() {
    return this.byteRange[1];
  }
  get url() {
    return !this._url && this.baseurl && this.relurl && (this._url = ti.buildAbsoluteURL(this.baseurl, this.relurl, {
      alwaysNormalize: !0
    })), this._url || "";
  }
  set url(e) {
    this._url = e;
  }
}
class un extends Do {
  constructor(e, t) {
    super(t), this._decryptdata = null, this.rawProgramDateTime = null, this.programDateTime = null, this.tagList = [], this.duration = 0, this.sn = 0, this.levelkeys = void 0, this.type = void 0, this.loader = null, this.keyLoader = null, this.level = -1, this.cc = 0, this.startPTS = void 0, this.endPTS = void 0, this.startDTS = void 0, this.endDTS = void 0, this.start = 0, this.deltaPTS = void 0, this.maxStartPTS = void 0, this.minEndPTS = void 0, this.stats = new en(), this.data = void 0, this.bitrateTest = !1, this.title = null, this.initSegment = null, this.endList = void 0, this.gap = void 0, this.urlId = 0, this.type = e;
  }
  get decryptdata() {
    const {
      levelkeys: e
    } = this;
    if (!e && !this._decryptdata)
      return null;
    if (!this._decryptdata && this.levelkeys && !this.levelkeys.NONE) {
      const t = this.levelkeys.identity;
      if (t)
        this._decryptdata = t.getDecryptData(this.sn);
      else {
        const s = Object.keys(this.levelkeys);
        if (s.length === 1)
          return this._decryptdata = this.levelkeys[s[0]].getDecryptData(this.sn);
      }
    }
    return this._decryptdata;
  }
  get end() {
    return this.start + this.duration;
  }
  get endProgramDateTime() {
    if (this.programDateTime === null || !G(this.programDateTime))
      return null;
    const e = G(this.duration) ? this.duration : 0;
    return this.programDateTime + e * 1e3;
  }
  get encrypted() {
    var e;
    if ((e = this._decryptdata) != null && e.encrypted)
      return !0;
    if (this.levelkeys) {
      const t = Object.keys(this.levelkeys), s = t.length;
      if (s > 1 || s === 1 && this.levelkeys[t[0]].encrypted)
        return !0;
    }
    return !1;
  }
  setKeyFormat(e) {
    if (this.levelkeys) {
      const t = this.levelkeys[e];
      t && !this._decryptdata && (this._decryptdata = t.getDecryptData(this.sn));
    }
  }
  abortRequests() {
    var e, t;
    (e = this.loader) == null || e.abort(), (t = this.keyLoader) == null || t.abort();
  }
  setElementaryStreamInfo(e, t, s, n, r, o = !1) {
    const {
      elementaryStreams: a
    } = this, l = a[e];
    if (!l) {
      a[e] = {
        startPTS: t,
        endPTS: s,
        startDTS: n,
        endDTS: r,
        partial: o
      };
      return;
    }
    l.startPTS = Math.min(l.startPTS, t), l.endPTS = Math.max(l.endPTS, s), l.startDTS = Math.min(l.startDTS, n), l.endDTS = Math.max(l.endDTS, r);
  }
  clearElementaryStreamInfo() {
    const {
      elementaryStreams: e
    } = this;
    e[ae.AUDIO] = null, e[ae.VIDEO] = null, e[ae.AUDIOVIDEO] = null;
  }
}
class jh extends Do {
  constructor(e, t, s, n, r) {
    super(s), this.fragOffset = 0, this.duration = 0, this.gap = !1, this.independent = !1, this.relurl = void 0, this.fragment = void 0, this.index = void 0, this.stats = new en(), this.duration = e.decimalFloatingPoint("DURATION"), this.gap = e.bool("GAP"), this.independent = e.bool("INDEPENDENT"), this.relurl = e.enumeratedString("URI"), this.fragment = t, this.index = n;
    const o = e.enumeratedString("BYTERANGE");
    o && this.setByteRange(o, r), r && (this.fragOffset = r.fragOffset + r.duration);
  }
  get start() {
    return this.fragment.start + this.fragOffset;
  }
  get end() {
    return this.start + this.duration;
  }
  get loaded() {
    const {
      elementaryStreams: e
    } = this;
    return !!(e.audio || e.video || e.audiovideo);
  }
}
const Xh = 10;
class Qh {
  constructor(e) {
    this.PTSKnown = !1, this.alignedSliding = !1, this.averagetargetduration = void 0, this.endCC = 0, this.endSN = 0, this.fragments = void 0, this.fragmentHint = void 0, this.partList = null, this.dateRanges = void 0, this.live = !0, this.ageHeader = 0, this.advancedDateTime = void 0, this.updated = !0, this.advanced = !0, this.availabilityDelay = void 0, this.misses = 0, this.startCC = 0, this.startSN = 0, this.startTimeOffset = null, this.targetduration = 0, this.totalduration = 0, this.type = null, this.url = void 0, this.m3u8 = "", this.version = null, this.canBlockReload = !1, this.canSkipUntil = 0, this.canSkipDateRanges = !1, this.skippedSegments = 0, this.recentlyRemovedDateranges = void 0, this.partHoldBack = 0, this.holdBack = 0, this.partTarget = 0, this.preloadHint = void 0, this.renditionReports = void 0, this.tuneInGoal = 0, this.deltaUpdateFailed = void 0, this.driftStartTime = 0, this.driftEndTime = 0, this.driftStart = 0, this.driftEnd = 0, this.encryptedFragments = void 0, this.playlistParsingError = null, this.variableList = null, this.hasVariableRefs = !1, this.fragments = [], this.encryptedFragments = [], this.dateRanges = {}, this.url = e;
  }
  reloaded(e) {
    if (!e) {
      this.advanced = !0, this.updated = !0;
      return;
    }
    const t = this.lastPartSn - e.lastPartSn, s = this.lastPartIndex - e.lastPartIndex;
    this.updated = this.endSN !== e.endSN || !!s || !!t || !this.live, this.advanced = this.endSN > e.endSN || t > 0 || t === 0 && s > 0, this.updated || this.advanced ? this.misses = Math.floor(e.misses * 0.6) : this.misses = e.misses + 1, this.availabilityDelay = e.availabilityDelay;
  }
  get hasProgramDateTime() {
    return this.fragments.length ? G(this.fragments[this.fragments.length - 1].programDateTime) : !1;
  }
  get levelTargetDuration() {
    return this.averagetargetduration || this.targetduration || Xh;
  }
  get drift() {
    const e = this.driftEndTime - this.driftStartTime;
    return e > 0 ? (this.driftEnd - this.driftStart) * 1e3 / e : 1;
  }
  get edge() {
    return this.partEnd || this.fragmentEnd;
  }
  get partEnd() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].end : this.fragmentEnd;
  }
  get fragmentEnd() {
    var e;
    return (e = this.fragments) != null && e.length ? this.fragments[this.fragments.length - 1].end : 0;
  }
  get age() {
    return this.advancedDateTime ? Math.max(Date.now() - this.advancedDateTime, 0) / 1e3 : 0;
  }
  get lastPartIndex() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].index : -1;
  }
  get lastPartSn() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].fragment.sn : this.endSN;
  }
}
function si(i) {
  return Uint8Array.from(atob(i), (e) => e.charCodeAt(0));
}
function Zh(i) {
  const e = $n(i).subarray(0, 16), t = new Uint8Array(16);
  return t.set(e, 16 - e.length), t;
}
function Jh(i) {
  const e = function(s, n, r) {
    const o = s[n];
    s[n] = s[r], s[r] = o;
  };
  e(i, 0, 3), e(i, 1, 2), e(i, 4, 5), e(i, 6, 7);
}
function ef(i) {
  const e = i.split(":");
  let t = null;
  if (e[0] === "data" && e.length === 2) {
    const s = e[1].split(";"), n = s[s.length - 1].split(",");
    if (n.length === 2) {
      const r = n[0] === "base64", o = n[1];
      r ? (s.splice(-1, 1), t = si(o)) : t = Zh(o);
    }
  }
  return t;
}
function $n(i) {
  return Uint8Array.from(unescape(encodeURIComponent(i)), (e) => e.charCodeAt(0));
}
const Gt = typeof self != "undefined" ? self : void 0;
var me = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.fps",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "com.widevine.alpha"
}, ke = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.streamingkeydelivery",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function tr(i) {
  switch (i) {
    case ke.FAIRPLAY:
      return me.FAIRPLAY;
    case ke.PLAYREADY:
      return me.PLAYREADY;
    case ke.WIDEVINE:
      return me.WIDEVINE;
    case ke.CLEARKEY:
      return me.CLEARKEY;
  }
}
var Io = {
  WIDEVINE: "edef8ba979d64acea3c827dcd51d21ed"
};
function tf(i) {
  if (i === Io.WIDEVINE)
    return me.WIDEVINE;
}
function sr(i) {
  switch (i) {
    case me.FAIRPLAY:
      return ke.FAIRPLAY;
    case me.PLAYREADY:
      return ke.PLAYREADY;
    case me.WIDEVINE:
      return ke.WIDEVINE;
    case me.CLEARKEY:
      return ke.CLEARKEY;
  }
}
function dn(i) {
  const {
    drmSystems: e,
    widevineLicenseUrl: t
  } = i, s = e ? [me.FAIRPLAY, me.WIDEVINE, me.PLAYREADY, me.CLEARKEY].filter((n) => !!e[n]) : [];
  return !s[me.WIDEVINE] && t && s.push(me.WIDEVINE), s;
}
const bo = (function(i) {
  return Gt != null && (i = Gt.navigator) != null && i.requestMediaKeySystemAccess ? self.navigator.requestMediaKeySystemAccess.bind(self.navigator) : null;
})();
function sf(i, e, t, s) {
  let n;
  switch (i) {
    case me.FAIRPLAY:
      n = ["cenc", "sinf"];
      break;
    case me.WIDEVINE:
    case me.PLAYREADY:
      n = ["cenc"];
      break;
    case me.CLEARKEY:
      n = ["cenc", "keyids"];
      break;
    default:
      throw new Error(`Unknown key-system: ${i}`);
  }
  return nf(n, e, t, s);
}
function nf(i, e, t, s) {
  return [{
    initDataTypes: i,
    persistentState: s.persistentState || "optional",
    distinctiveIdentifier: s.distinctiveIdentifier || "optional",
    sessionTypes: s.sessionTypes || [s.sessionType || "temporary"],
    audioCapabilities: e.map((r) => ({
      contentType: `audio/mp4; codecs="${r}"`,
      robustness: s.audioRobustness || "",
      encryptionScheme: s.audioEncryptionScheme || null
    })),
    videoCapabilities: t.map((r) => ({
      contentType: `video/mp4; codecs="${r}"`,
      robustness: s.videoRobustness || "",
      encryptionScheme: s.videoEncryptionScheme || null
    }))
  }];
}
function St(i, e, t) {
  return Uint8Array.prototype.slice ? i.slice(e, t) : new Uint8Array(Array.prototype.slice.call(i, e, t));
}
const ni = (i, e) => e + 10 <= i.length && i[e] === 73 && i[e + 1] === 68 && i[e + 2] === 51 && i[e + 3] < 255 && i[e + 4] < 255 && i[e + 6] < 128 && i[e + 7] < 128 && i[e + 8] < 128 && i[e + 9] < 128, _o = (i, e) => e + 10 <= i.length && i[e] === 51 && i[e + 1] === 68 && i[e + 2] === 73 && i[e + 3] < 255 && i[e + 4] < 255 && i[e + 6] < 128 && i[e + 7] < 128 && i[e + 8] < 128 && i[e + 9] < 128, ss = (i, e) => {
  const t = e;
  let s = 0;
  for (; ni(i, e); ) {
    s += 10;
    const n = tn(i, e + 6);
    s += n, _o(i, e + 10) && (s += 10), e += s;
  }
  if (s > 0)
    return i.subarray(t, t + s);
}, tn = (i, e) => {
  let t = 0;
  return t = (i[e] & 127) << 21, t |= (i[e + 1] & 127) << 14, t |= (i[e + 2] & 127) << 7, t |= i[e + 3] & 127, t;
}, rf = (i, e) => ni(i, e) && tn(i, e + 6) + 10 <= i.length - e, ii = (i) => {
  const e = wo(i);
  for (let t = 0; t < e.length; t++) {
    const s = e[t];
    if (Co(s))
      return df(s);
  }
}, Co = (i) => i && i.key === "PRIV" && i.info === "com.apple.streaming.transportStreamTimestamp", of = (i) => {
  const e = String.fromCharCode(i[0], i[1], i[2], i[3]), t = tn(i, 4), s = 10;
  return {
    type: e,
    size: t,
    data: i.subarray(s, s + t)
  };
}, wo = (i) => {
  let e = 0;
  const t = [];
  for (; ni(i, e); ) {
    const s = tn(i, e + 6);
    e += 10;
    const n = e + s;
    for (; e + 8 < n; ) {
      const r = of(i.subarray(e)), o = af(r);
      o && t.push(o), e += r.size + 10;
    }
    _o(i, e) && (e += 10);
  }
  return t;
}, af = (i) => i.type === "PRIV" ? lf(i) : i.type[0] === "W" ? uf(i) : cf(i), lf = (i) => {
  if (i.size < 2)
    return;
  const e = Ze(i.data, !0), t = new Uint8Array(i.data.subarray(e.length + 1));
  return {
    key: i.type,
    info: e,
    data: t.buffer
  };
}, cf = (i) => {
  if (i.size < 2)
    return;
  if (i.type === "TXXX") {
    let t = 1;
    const s = Ze(i.data.subarray(t), !0);
    t += s.length + 1;
    const n = Ze(i.data.subarray(t));
    return {
      key: i.type,
      info: s,
      data: n
    };
  }
  const e = Ze(i.data.subarray(1));
  return {
    key: i.type,
    data: e
  };
}, uf = (i) => {
  if (i.type === "WXXX") {
    if (i.size < 2)
      return;
    let t = 1;
    const s = Ze(i.data.subarray(t), !0);
    t += s.length + 1;
    const n = Ze(i.data.subarray(t));
    return {
      key: i.type,
      info: s,
      data: n
    };
  }
  const e = Ze(i.data);
  return {
    key: i.type,
    data: e
  };
}, df = (i) => {
  if (i.data.byteLength === 8) {
    const e = new Uint8Array(i.data), t = e[3] & 1;
    let s = (e[4] << 23) + (e[5] << 15) + (e[6] << 7) + e[7];
    return s /= 45, t && (s += 4772185884e-2), Math.round(s);
  }
}, Ze = (i, e = !1) => {
  const t = hf();
  if (t) {
    const c = t.decode(i);
    if (e) {
      const u = c.indexOf("\0");
      return u !== -1 ? c.substring(0, u) : c;
    }
    return c.replace(/\0/g, "");
  }
  const s = i.length;
  let n, r, o, a = "", l = 0;
  for (; l < s; ) {
    if (n = i[l++], n === 0 && e)
      return a;
    if (n === 0 || n === 3)
      continue;
    switch (n >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        a += String.fromCharCode(n);
        break;
      case 12:
      case 13:
        r = i[l++], a += String.fromCharCode((n & 31) << 6 | r & 63);
        break;
      case 14:
        r = i[l++], o = i[l++], a += String.fromCharCode((n & 15) << 12 | (r & 63) << 6 | (o & 63) << 0);
        break;
    }
  }
  return a;
};
let hn;
function hf() {
  if (!navigator.userAgent.includes("PlayStation 4"))
    return !hn && typeof self.TextDecoder != "undefined" && (hn = new self.TextDecoder("utf-8")), hn;
}
const ze = {
  hexDump: function(i) {
    let e = "";
    for (let t = 0; t < i.length; t++) {
      let s = i[t].toString(16);
      s.length < 2 && (s = "0" + s), e += s;
    }
    return e;
  }
}, Gs = Math.pow(2, 32) - 1, ff = [].push, Mo = {
  video: 1,
  audio: 2,
  id3: 3,
  text: 4
};
function Se(i) {
  return String.fromCharCode.apply(null, i);
}
function ko(i, e) {
  const t = i[e] << 8 | i[e + 1];
  return t < 0 ? 65536 + t : t;
}
function X(i, e) {
  const t = Fo(i, e);
  return t < 0 ? 4294967296 + t : t;
}
function nr(i, e) {
  let t = X(i, e);
  return t *= Math.pow(2, 32), t += X(i, e + 4), t;
}
function Fo(i, e) {
  return i[e] << 24 | i[e + 1] << 16 | i[e + 2] << 8 | i[e + 3];
}
function fn(i, e, t) {
  i[e] = t >> 24, i[e + 1] = t >> 16 & 255, i[e + 2] = t >> 8 & 255, i[e + 3] = t & 255;
}
function mf(i) {
  const e = i.byteLength;
  for (let t = 0; t < e; ) {
    const s = X(i, t);
    if (s > 8 && i[t + 4] === 109 && i[t + 5] === 111 && i[t + 6] === 111 && i[t + 7] === 102)
      return !0;
    t = s > 1 ? t + s : e;
  }
  return !1;
}
function ee(i, e) {
  const t = [];
  if (!e.length)
    return t;
  const s = i.byteLength;
  for (let n = 0; n < s; ) {
    const r = X(i, n), o = Se(i.subarray(n + 4, n + 8)), a = r > 1 ? n + r : s;
    if (o === e[0])
      if (e.length === 1)
        t.push(i.subarray(n + 8, a));
      else {
        const l = ee(i.subarray(n + 8, a), e.slice(1));
        l.length && ff.apply(t, l);
      }
    n = a;
  }
  return t;
}
function gf(i) {
  const e = [], t = i[0];
  let s = 8;
  const n = X(i, s);
  s += 4;
  let r = 0, o = 0;
  t === 0 ? (r = X(i, s), o = X(i, s + 4), s += 8) : (r = nr(i, s), o = nr(i, s + 8), s += 16), s += 2;
  let a = i.length + o;
  const l = ko(i, s);
  s += 2;
  for (let c = 0; c < l; c++) {
    let u = s;
    const d = X(i, u);
    u += 4;
    const h = d & 2147483647;
    if ((d & 2147483648) >>> 31 === 1)
      return D.warn("SIDX has hierarchical references (not supported)"), null;
    const f = X(i, u);
    u += 4, e.push({
      referenceSize: h,
      subsegmentDuration: f,
      // unscaled
      info: {
        duration: f / n,
        start: a,
        end: a + h - 1
      }
    }), a += h, u += 4, s = u;
  }
  return {
    earliestPresentationTime: r,
    timescale: n,
    version: t,
    referencesCount: l,
    references: e
  };
}
function Po(i) {
  const e = [], t = ee(i, ["moov", "trak"]);
  for (let n = 0; n < t.length; n++) {
    const r = t[n], o = ee(r, ["tkhd"])[0];
    if (o) {
      let a = o[0];
      const l = X(o, a === 0 ? 12 : 20), c = ee(r, ["mdia", "mdhd"])[0];
      if (c) {
        a = c[0];
        const u = X(c, a === 0 ? 12 : 20), d = ee(r, ["mdia", "hdlr"])[0];
        if (d) {
          const h = Se(d.subarray(8, 12)), m = {
            soun: ae.AUDIO,
            vide: ae.VIDEO
          }[h];
          if (m) {
            const f = ee(r, ["mdia", "minf", "stbl", "stsd"])[0], g = pf(f);
            e[l] = {
              timescale: u,
              type: m
            }, e[m] = Re({
              timescale: u,
              id: l
            }, g);
          }
        }
      }
    }
  }
  return ee(i, ["moov", "mvex", "trex"]).forEach((n) => {
    const r = X(n, 4), o = e[r];
    o && (o.default = {
      duration: X(n, 12),
      flags: X(n, 20)
    });
  }), e;
}
function pf(i) {
  const e = i.subarray(8), t = e.subarray(86), s = Se(e.subarray(4, 8));
  let n = s;
  const r = s === "enca" || s === "encv";
  if (r) {
    const a = ee(e, [s])[0].subarray(s === "enca" ? 28 : 78);
    ee(a, ["sinf"]).forEach((c) => {
      const u = ee(c, ["schm"])[0];
      if (u) {
        const d = Se(u.subarray(4, 8));
        if (d === "cbcs" || d === "cenc") {
          const h = ee(c, ["frma"])[0];
          h && (n = Se(h));
        }
      }
    });
  }
  switch (n) {
    case "avc1":
    case "avc2":
    case "avc3":
    case "avc4": {
      const o = ee(t, ["avcC"])[0];
      n += "." + Ts(o[1]) + Ts(o[2]) + Ts(o[3]);
      break;
    }
    case "mp4a": {
      const o = ee(e, [s])[0], a = ee(o.subarray(28), ["esds"])[0];
      if (a && a.length > 12) {
        let l = 4;
        if (a[l++] !== 3)
          break;
        l = mn(a, l), l += 2;
        const c = a[l++];
        if (c & 128 && (l += 2), c & 64 && (l += a[l++]), a[l++] !== 4)
          break;
        l = mn(a, l);
        const u = a[l++];
        if (u === 64)
          n += "." + Ts(u);
        else
          break;
        if (l += 12, a[l++] !== 5)
          break;
        l = mn(a, l);
        const d = a[l++];
        let h = (d & 248) >> 3;
        h === 31 && (h += 1 + ((d & 7) << 3) + ((a[l] & 224) >> 5)), n += "." + h;
      }
      break;
    }
    case "hvc1":
    case "hev1": {
      const o = ee(t, ["hvcC"])[0], a = o[1], l = ["", "A", "B", "C"][a >> 6], c = a & 31, u = X(o, 2), d = (a & 32) >> 5 ? "H" : "L", h = o[12], m = o.subarray(6, 12);
      n += "." + l + c, n += "." + u.toString(16).toUpperCase(), n += "." + d + h;
      let f = "";
      for (let g = m.length; g--; ) {
        const p = m[g];
        (p || f) && (f = "." + p.toString(16).toUpperCase() + f);
      }
      n += f;
      break;
    }
    case "dvh1":
    case "dvhe": {
      const o = ee(t, ["dvcC"])[0], a = o[2] >> 1 & 127, l = o[2] << 5 & 32 | o[3] >> 3 & 31;
      n += "." + qe(a) + "." + qe(l);
      break;
    }
    case "vp09": {
      const o = ee(t, ["vpcC"])[0], a = o[4], l = o[5], c = o[6] >> 4 & 15;
      n += "." + qe(a) + "." + qe(l) + "." + qe(c);
      break;
    }
    case "av01": {
      const o = ee(t, ["av1C"])[0], a = o[1] >>> 5, l = o[1] & 31, c = o[2] >>> 7 ? "H" : "M", u = (o[2] & 64) >> 6, d = (o[2] & 32) >> 5, h = a === 2 && u ? d ? 12 : 10 : u ? 10 : 8, m = (o[2] & 16) >> 4, f = (o[2] & 8) >> 3, g = (o[2] & 4) >> 2, p = o[2] & 3;
      n += "." + a + "." + qe(l) + c + "." + qe(h) + "." + m + "." + f + g + p + "." + qe(1) + "." + qe(1) + "." + qe(1) + "." + 0;
      break;
    }
  }
  return {
    codec: n,
    encrypted: r
  };
}
function mn(i, e) {
  const t = e + 5;
  for (; i[e++] & 128 && e < t; )
    ;
  return e;
}
function Ts(i) {
  return ("0" + i.toString(16).toUpperCase()).slice(-2);
}
function qe(i) {
  return (i < 10 ? "0" : "") + i;
}
function Tf(i, e) {
  if (!i || !e)
    return i;
  const t = e.keyId;
  return t && e.isCommonEncryption && ee(i, ["moov", "trak"]).forEach((n) => {
    const o = ee(n, ["mdia", "minf", "stbl", "stsd"])[0].subarray(8);
    let a = ee(o, ["enca"]);
    const l = a.length > 0;
    l || (a = ee(o, ["encv"])), a.forEach((c) => {
      const u = l ? c.subarray(28) : c.subarray(78);
      ee(u, ["sinf"]).forEach((h) => {
        const m = Oo(h);
        if (m) {
          const f = m.subarray(8, 24);
          f.some((g) => g !== 0) || (D.log(`[eme] Patching keyId in 'enc${l ? "a" : "v"}>sinf>>tenc' box: ${ze.hexDump(f)} -> ${ze.hexDump(t)}`), m.set(t, 8));
        }
      });
    });
  }), i;
}
function Oo(i) {
  const e = ee(i, ["schm"])[0];
  if (e) {
    const t = Se(e.subarray(4, 8));
    if (t === "cbcs" || t === "cenc")
      return ee(i, ["schi", "tenc"])[0];
  }
  return D.error("[eme] missing 'schm' box"), null;
}
function Ef(i, e) {
  return ee(e, ["moof", "traf"]).reduce((t, s) => {
    const n = ee(s, ["tfdt"])[0], r = n[0], o = ee(s, ["tfhd"]).reduce((a, l) => {
      const c = X(l, 4), u = i[c];
      if (u) {
        let d = X(n, 4);
        if (r === 1) {
          if (d === Gs)
            return D.warn("[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time"), a;
          d *= Gs + 1, d += X(n, 8);
        }
        const h = u.timescale || 9e4, m = d / h;
        if (G(m) && (a === null || m < a))
          return m;
      }
      return a;
    }, null);
    return o !== null && G(o) && (t === null || o < t) ? o : t;
  }, null);
}
function yf(i, e) {
  let t = 0, s = 0, n = 0;
  const r = ee(i, ["moof", "traf"]);
  for (let o = 0; o < r.length; o++) {
    const a = r[o], l = ee(a, ["tfhd"])[0], c = X(l, 4), u = e[c];
    if (!u)
      continue;
    const d = u.default, h = X(l, 0) | (d == null ? void 0 : d.flags);
    let m = d == null ? void 0 : d.duration;
    h & 8 && (h & 2 ? m = X(l, 12) : m = X(l, 8));
    const f = u.timescale || 9e4, g = ee(a, ["trun"]);
    for (let p = 0; p < g.length; p++) {
      if (t = xf(g[p]), !t && m) {
        const E = X(g[p], 4);
        t = m * E;
      }
      u.type === ae.VIDEO ? s += t / f : u.type === ae.AUDIO && (n += t / f);
    }
  }
  if (s === 0 && n === 0) {
    let o = 1 / 0, a = 0, l = 0;
    const c = ee(i, ["sidx"]);
    for (let u = 0; u < c.length; u++) {
      const d = gf(c[u]);
      if (d != null && d.references) {
        o = Math.min(o, d.earliestPresentationTime / d.timescale);
        const h = d.references.reduce((m, f) => m + f.info.duration || 0, 0);
        a = Math.max(a, h + d.earliestPresentationTime / d.timescale), l = a - o;
      }
    }
    if (l && G(l))
      return l;
  }
  return s || n;
}
function xf(i) {
  const e = X(i, 0);
  let t = 8;
  e & 1 && (t += 4), e & 4 && (t += 4);
  let s = 0;
  const n = X(i, 4);
  for (let r = 0; r < n; r++) {
    if (e & 256) {
      const o = X(i, t);
      s += o, t += 4;
    }
    e & 512 && (t += 4), e & 1024 && (t += 4), e & 2048 && (t += 4);
  }
  return s;
}
function vf(i, e, t) {
  ee(e, ["moof", "traf"]).forEach((s) => {
    ee(s, ["tfhd"]).forEach((n) => {
      const r = X(n, 4), o = i[r];
      if (!o)
        return;
      const a = o.timescale || 9e4;
      ee(s, ["tfdt"]).forEach((l) => {
        const c = l[0], u = t * a;
        if (u) {
          let d = X(l, 4);
          if (c === 0)
            d -= u, d = Math.max(d, 0), fn(l, 4, d);
          else {
            d *= Math.pow(2, 32), d += X(l, 8), d -= u, d = Math.max(d, 0);
            const h = Math.floor(d / (Gs + 1)), m = Math.floor(d % (Gs + 1));
            fn(l, 4, h), fn(l, 8, m);
          }
        }
      });
    });
  });
}
function Sf(i) {
  const e = {
    valid: null,
    remainder: null
  }, t = ee(i, ["moof"]);
  if (t.length < 2)
    return e.remainder = i, e;
  const s = t[t.length - 1];
  return e.valid = St(i, 0, s.byteOffset - 8), e.remainder = St(i, s.byteOffset - 8), e;
}
function $e(i, e) {
  const t = new Uint8Array(i.length + e.length);
  return t.set(i), t.set(e, i.length), t;
}
function ir(i, e) {
  const t = [], s = e.samples, n = e.timescale, r = e.id;
  let o = !1;
  return ee(s, ["moof"]).map((l) => {
    const c = l.byteOffset - 8;
    ee(l, ["traf"]).map((d) => {
      const h = ee(d, ["tfdt"]).map((m) => {
        const f = m[0];
        let g = X(m, 4);
        return f === 1 && (g *= Math.pow(2, 32), g += X(m, 8)), g / n;
      })[0];
      return h !== void 0 && (i = h), ee(d, ["tfhd"]).map((m) => {
        const f = X(m, 4), g = X(m, 0) & 16777215, p = (g & 1) !== 0, E = (g & 2) !== 0, y = (g & 8) !== 0;
        let v = 0;
        const S = (g & 16) !== 0;
        let x = 0;
        const R = (g & 32) !== 0;
        let L = 8;
        f === r && (p && (L += 8), E && (L += 4), y && (v = X(m, L), L += 4), S && (x = X(m, L), L += 4), R && (L += 4), e.type === "video" && (o = Af(e.codec)), ee(d, ["trun"]).map((_) => {
          const A = _[0], I = X(_, 0) & 16777215, w = (I & 1) !== 0;
          let $ = 0;
          const M = (I & 4) !== 0, U = (I & 256) !== 0;
          let N = 0;
          const H = (I & 512) !== 0;
          let q = 0;
          const B = (I & 1024) !== 0, O = (I & 2048) !== 0;
          let P = 0;
          const W = X(_, 4);
          let K = 8;
          w && ($ = X(_, K), K += 4), M && (K += 4);
          let J = $ + c;
          for (let j = 0; j < W; j++) {
            if (U ? (N = X(_, K), K += 4) : N = v, H ? (q = X(_, K), K += 4) : q = x, B && (K += 4), O && (A === 0 ? P = X(_, K) : P = Fo(_, K), K += 4), e.type === ae.VIDEO) {
              let z = 0;
              for (; z < q; ) {
                const ne = X(s, J);
                if (J += 4, Lf(o, s[J])) {
                  const he = s.subarray(J, J + ne);
                  No(he, o ? 2 : 1, i + P / n, t);
                }
                J += ne, z += ne + 4;
              }
            }
            i += N / n;
          }
        }));
      });
    });
  }), t;
}
function Af(i) {
  if (!i)
    return !1;
  const e = i.indexOf("."), t = e < 0 ? i : i.substring(0, e);
  return t === "hvc1" || t === "hev1" || // Dolby Vision
  t === "dvh1" || t === "dvhe";
}
function Lf(i, e) {
  if (i) {
    const t = e >> 1 & 63;
    return t === 39 || t === 40;
  } else
    return (e & 31) === 6;
}
function No(i, e, t, s) {
  const n = Uo(i);
  let r = 0;
  r += e;
  let o = 0, a = 0, l = 0;
  for (; r < n.length; ) {
    o = 0;
    do {
      if (r >= n.length)
        break;
      l = n[r++], o += l;
    } while (l === 255);
    a = 0;
    do {
      if (r >= n.length)
        break;
      l = n[r++], a += l;
    } while (l === 255);
    const c = n.length - r;
    let u = r;
    if (a < c)
      r += a;
    else if (a > c) {
      D.error(`Malformed SEI payload. ${a} is too small, only ${c} bytes left to parse.`);
      break;
    }
    if (o === 4) {
      if (n[u++] === 181) {
        const h = ko(n, u);
        if (u += 2, h === 49) {
          const m = X(n, u);
          if (u += 4, m === 1195456820) {
            const f = n[u++];
            if (f === 3) {
              const g = n[u++], p = 31 & g, E = 64 & g, y = E ? 2 + p * 3 : 0, v = new Uint8Array(y);
              if (E) {
                v[0] = g;
                for (let S = 1; S < y; S++)
                  v[S] = n[u++];
              }
              s.push({
                type: f,
                payloadType: o,
                pts: t,
                bytes: v
              });
            }
          }
        }
      }
    } else if (o === 5 && a > 16) {
      const d = [];
      for (let f = 0; f < 16; f++) {
        const g = n[u++].toString(16);
        d.push(g.length == 1 ? "0" + g : g), (f === 3 || f === 5 || f === 7 || f === 9) && d.push("-");
      }
      const h = a - 16, m = new Uint8Array(h);
      for (let f = 0; f < h; f++)
        m[f] = n[u++];
      s.push({
        payloadType: o,
        pts: t,
        uuid: d.join(""),
        userData: Ze(m),
        userDataBytes: m
      });
    }
  }
}
function Uo(i) {
  const e = i.byteLength, t = [];
  let s = 1;
  for (; s < e - 2; )
    i[s] === 0 && i[s + 1] === 0 && i[s + 2] === 3 ? (t.push(s + 2), s += 2) : s++;
  if (t.length === 0)
    return i;
  const n = e - t.length, r = new Uint8Array(n);
  let o = 0;
  for (s = 0; s < n; o++, s++)
    o === t[0] && (o++, t.shift()), r[s] = i[o];
  return r;
}
function Rf(i) {
  const e = i[0];
  let t = "", s = "", n = 0, r = 0, o = 0, a = 0, l = 0, c = 0;
  if (e === 0) {
    for (; Se(i.subarray(c, c + 1)) !== "\0"; )
      t += Se(i.subarray(c, c + 1)), c += 1;
    for (t += Se(i.subarray(c, c + 1)), c += 1; Se(i.subarray(c, c + 1)) !== "\0"; )
      s += Se(i.subarray(c, c + 1)), c += 1;
    s += Se(i.subarray(c, c + 1)), c += 1, n = X(i, 12), r = X(i, 16), a = X(i, 20), l = X(i, 24), c = 28;
  } else if (e === 1) {
    c += 4, n = X(i, c), c += 4;
    const d = X(i, c);
    c += 4;
    const h = X(i, c);
    for (c += 4, o = 2 ** 32 * d + h, Gh(o) || (o = Number.MAX_SAFE_INTEGER, D.warn("Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box")), a = X(i, c), c += 4, l = X(i, c), c += 4; Se(i.subarray(c, c + 1)) !== "\0"; )
      t += Se(i.subarray(c, c + 1)), c += 1;
    for (t += Se(i.subarray(c, c + 1)), c += 1; Se(i.subarray(c, c + 1)) !== "\0"; )
      s += Se(i.subarray(c, c + 1)), c += 1;
    s += Se(i.subarray(c, c + 1)), c += 1;
  }
  const u = i.subarray(c, i.byteLength);
  return {
    schemeIdUri: t,
    value: s,
    timeScale: n,
    presentationTime: o,
    presentationTimeDelta: r,
    eventDuration: a,
    id: l,
    payload: u
  };
}
function Df(i, ...e) {
  const t = e.length;
  let s = 8, n = t;
  for (; n--; )
    s += e[n].byteLength;
  const r = new Uint8Array(s);
  for (r[0] = s >> 24 & 255, r[1] = s >> 16 & 255, r[2] = s >> 8 & 255, r[3] = s & 255, r.set(i, 4), n = 0, s = 8; n < t; n++)
    r.set(e[n], s), s += e[n].byteLength;
  return r;
}
function If(i, e, t) {
  if (i.byteLength !== 16)
    throw new RangeError("Invalid system id");
  let s, n;
  s = 0, n = new Uint8Array();
  let r;
  s > 0 ? (r = new Uint8Array(4), e.length > 0 && new DataView(r.buffer).setUint32(0, e.length, !1)) : r = new Uint8Array();
  const o = new Uint8Array(4);
  return t && t.byteLength > 0 && new DataView(o.buffer).setUint32(0, t.byteLength, !1), Df(
    [112, 115, 115, 104],
    new Uint8Array([
      s,
      0,
      0,
      0
      // Flags
    ]),
    i,
    // 16 bytes
    r,
    n,
    o,
    t || new Uint8Array()
  );
}
function bf(i) {
  if (!(i instanceof ArrayBuffer) || i.byteLength < 32)
    return null;
  const e = {
    version: 0,
    systemId: "",
    kids: null,
    data: null
  }, t = new DataView(i), s = t.getUint32(0);
  if (i.byteLength !== s && s > 44 || t.getUint32(4) !== 1886614376 || (e.version = t.getUint32(8) >>> 24, e.version > 1))
    return null;
  e.systemId = ze.hexDump(new Uint8Array(i, 12, 16));
  const r = t.getUint32(28);
  if (e.version === 0) {
    if (s - 32 < r)
      return null;
    e.data = new Uint8Array(i, 32, r);
  } else if (e.version === 1) {
    e.kids = [];
    for (let o = 0; o < r; o++)
      e.kids.push(new Uint8Array(i, 32 + o * 16, 16));
  }
  return e;
}
let Es = {};
class ns {
  static clearKeyUriToKeyIdMap() {
    Es = {};
  }
  constructor(e, t, s, n = [1], r = null) {
    this.uri = void 0, this.method = void 0, this.keyFormat = void 0, this.keyFormatVersions = void 0, this.encrypted = void 0, this.isCommonEncryption = void 0, this.iv = null, this.key = null, this.keyId = null, this.pssh = null, this.method = e, this.uri = t, this.keyFormat = s, this.keyFormatVersions = n, this.iv = r, this.encrypted = e ? e !== "NONE" : !1, this.isCommonEncryption = this.encrypted && e !== "AES-128";
  }
  isSupported() {
    if (this.method) {
      if (this.method === "AES-128" || this.method === "NONE")
        return !0;
      if (this.keyFormat === "identity")
        return this.method === "SAMPLE-AES";
      switch (this.keyFormat) {
        case ke.FAIRPLAY:
        case ke.WIDEVINE:
        case ke.PLAYREADY:
        case ke.CLEARKEY:
          return ["ISO-23001-7", "SAMPLE-AES", "SAMPLE-AES-CENC", "SAMPLE-AES-CTR"].indexOf(this.method) !== -1;
      }
    }
    return !1;
  }
  getDecryptData(e) {
    if (!this.encrypted || !this.uri)
      return null;
    if (this.method === "AES-128" && this.uri && !this.iv) {
      typeof e != "number" && (this.method === "AES-128" && !this.iv && D.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`), e = 0);
      const s = _f(e);
      return new ns(this.method, this.uri, "identity", this.keyFormatVersions, s);
    }
    const t = ef(this.uri);
    if (t)
      switch (this.keyFormat) {
        case ke.WIDEVINE:
          this.pssh = t, t.length >= 22 && (this.keyId = t.subarray(t.length - 22, t.length - 6));
          break;
        case ke.PLAYREADY: {
          const s = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]);
          this.pssh = If(s, null, t);
          const n = new Uint16Array(t.buffer, t.byteOffset, t.byteLength / 2), r = String.fromCharCode.apply(null, Array.from(n)), o = r.substring(r.indexOf("<"), r.length), c = new DOMParser().parseFromString(o, "text/xml").getElementsByTagName("KID")[0];
          if (c) {
            const u = c.childNodes[0] ? c.childNodes[0].nodeValue : c.getAttribute("VALUE");
            if (u) {
              const d = si(u).subarray(0, 16);
              Jh(d), this.keyId = d;
            }
          }
          break;
        }
        default: {
          let s = t.subarray(0, 16);
          if (s.length !== 16) {
            const n = new Uint8Array(16);
            n.set(s, 16 - s.length), s = n;
          }
          this.keyId = s;
          break;
        }
      }
    if (!this.keyId || this.keyId.byteLength !== 16) {
      let s = Es[this.uri];
      if (!s) {
        const n = Object.keys(Es).length % Number.MAX_SAFE_INTEGER;
        s = new Uint8Array(16), new DataView(s.buffer, 12, 4).setUint32(0, n), Es[this.uri] = s;
      }
      this.keyId = s;
    }
    return this;
  }
}
function _f(i) {
  const e = new Uint8Array(16);
  for (let t = 12; t < 16; t++)
    e[t] = i >> 8 * (15 - t) & 255;
  return e;
}
const Bo = /\{\$([a-zA-Z0-9-_]+)\}/g;
function rr(i) {
  return Bo.test(i);
}
function Me(i, e, t) {
  if (i.variableList !== null || i.hasVariableRefs)
    for (let s = t.length; s--; ) {
      const n = t[s], r = e[n];
      r && (e[n] = Gn(i, r));
    }
}
function Gn(i, e) {
  if (i.variableList !== null || i.hasVariableRefs) {
    const t = i.variableList;
    return e.replace(Bo, (s) => {
      const n = s.substring(2, s.length - 1), r = t == null ? void 0 : t[n];
      return r === void 0 ? (i.playlistParsingError || (i.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${n}"`)), s) : r;
    });
  }
  return e;
}
function or(i, e, t) {
  let s = i.variableList;
  s || (i.variableList = s = {});
  let n, r;
  if ("QUERYPARAM" in e) {
    n = e.QUERYPARAM;
    try {
      const o = new self.URL(t).searchParams;
      if (o.has(n))
        r = o.get(n);
      else
        throw new Error(`"${n}" does not match any query parameter in URI: "${t}"`);
    } catch (o) {
      i.playlistParsingError || (i.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${o.message}`));
    }
  } else
    n = e.NAME, r = e.VALUE;
  n in s ? i.playlistParsingError || (i.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${n}"`)) : s[n] = r || "";
}
function Cf(i, e, t) {
  const s = e.IMPORT;
  if (t && s in t) {
    let n = i.variableList;
    n || (i.variableList = n = {}), n[s] = t[s];
  } else
    i.playlistParsingError || (i.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${s}"`));
}
function Lt(i = !0) {
  return typeof self == "undefined" ? void 0 : (i || !self.MediaSource) && self.ManagedMediaSource || self.MediaSource || self.WebKitMediaSource;
}
function wf(i) {
  return typeof self != "undefined" && i === self.ManagedMediaSource;
}
const Hs = {
  audio: {
    a3ds: 1,
    "ac-3": 0.95,
    "ac-4": 1,
    alac: 0.9,
    alaw: 1,
    dra1: 1,
    "dts+": 1,
    "dts-": 1,
    dtsc: 1,
    dtse: 1,
    dtsh: 1,
    "ec-3": 0.9,
    enca: 1,
    fLaC: 0.9,
    // MP4-RA listed codec entry for FLAC
    flac: 0.9,
    // legacy browser codec name for FLAC
    FLAC: 0.9,
    // some manifests may list "FLAC" with Apple's tools
    g719: 1,
    g726: 1,
    m4ae: 1,
    mha1: 1,
    mha2: 1,
    mhm1: 1,
    mhm2: 1,
    mlpa: 1,
    mp4a: 1,
    "raw ": 1,
    Opus: 1,
    opus: 1,
    // browsers expect this to be lowercase despite MP4RA says 'Opus'
    samr: 1,
    sawb: 1,
    sawp: 1,
    sevc: 1,
    sqcp: 1,
    ssmv: 1,
    twos: 1,
    ulaw: 1
  },
  video: {
    avc1: 1,
    avc2: 1,
    avc3: 1,
    avc4: 1,
    avcp: 1,
    av01: 0.8,
    drac: 1,
    dva1: 1,
    dvav: 1,
    dvh1: 0.7,
    dvhe: 0.7,
    encv: 1,
    hev1: 0.75,
    hvc1: 0.75,
    mjp2: 1,
    mp4v: 1,
    mvc1: 1,
    mvc2: 1,
    mvc3: 1,
    mvc4: 1,
    resv: 1,
    rv60: 1,
    s263: 1,
    svc1: 1,
    svc2: 1,
    "vc-1": 1,
    vp08: 1,
    vp09: 0.9
  },
  text: {
    stpp: 1,
    wvtt: 1
  }
};
function Mf(i, e) {
  const t = Hs[e];
  return !!t && !!t[i.slice(0, 4)];
}
function gn(i, e, t = !0) {
  return !i.split(",").some((s) => !$o(s, e, t));
}
function $o(i, e, t = !0) {
  var s;
  const n = Lt(t);
  return (s = n == null ? void 0 : n.isTypeSupported(is(i, e))) != null ? s : !1;
}
function is(i, e) {
  return `${e}/mp4;codecs="${i}"`;
}
function ar(i) {
  if (i) {
    const e = i.substring(0, 4);
    return Hs.video[e];
  }
  return 2;
}
function Ks(i) {
  return i.split(",").reduce((e, t) => {
    const s = Hs.video[t];
    return s ? (s * 2 + e) / (e ? 3 : 2) : (Hs.audio[t] + e) / (e ? 2 : 1);
  }, 0);
}
const pn = {};
function kf(i, e = !0) {
  if (pn[i])
    return pn[i];
  const t = {
    flac: ["flac", "fLaC", "FLAC"],
    opus: ["opus", "Opus"]
  }[i];
  for (let s = 0; s < t.length; s++)
    if ($o(t[s], "audio", e))
      return pn[i] = t[s], t[s];
  return i;
}
const Ff = /flac|opus/i;
function Vs(i, e = !0) {
  return i.replace(Ff, (t) => kf(t.toLowerCase(), e));
}
function lr(i, e) {
  return i && i !== "mp4a" ? i : e && e.split(",")[0];
}
function Pf(i) {
  const e = i.split(",");
  for (let t = 0; t < e.length; t++) {
    const s = e[t].split(".");
    if (s.length > 2) {
      let n = s.shift() + ".";
      n += parseInt(s.shift()).toString(16), n += ("000" + parseInt(s.shift()).toString(16)).slice(-4), e[t] = n;
    }
  }
  return e.join(",");
}
const cr = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g, ur = /#EXT-X-MEDIA:(.*)/g, Of = /^#EXT(?:INF|-X-TARGETDURATION):/m, dr = new RegExp([
  /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
  // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
  /(?!#) *(\S[^\r\n]*)/.source,
  // segment URI, group 3 => the URI (note newline is not eaten)
  /#EXT-X-BYTERANGE:*(.+)/.source,
  // next segment's byterange, group 4 => range spec (x@y)
  /#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
  // next segment's program date/time group 5 => the datetime spec
  /#.*/.source
  // All other non-segment oriented tags will match with all groups empty
].join("|"), "g"), Nf = new RegExp([/#(EXTM3U)/.source, /#EXT-X-(DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source, /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source, /#EXT-X-(DISCONTINUITY|ENDLIST|GAP|INDEPENDENT-SEGMENTS)/.source, /(#)([^:]*):(.*)/.source, /(#)(.*)(?:.*)\r?\n?/.source].join("|"));
class Xe {
  static findGroup(e, t) {
    for (let s = 0; s < e.length; s++) {
      const n = e[s];
      if (n.id === t)
        return n;
    }
  }
  static resolve(e, t) {
    return ti.buildAbsoluteURL(t, e, {
      alwaysNormalize: !0
    });
  }
  static isMediaPlaylist(e) {
    return Of.test(e);
  }
  static parseMasterPlaylist(e, t) {
    const s = rr(e), n = {
      contentSteering: null,
      levels: [],
      playlistParsingError: null,
      sessionData: null,
      sessionKeys: null,
      startTimeOffset: null,
      variableList: null,
      hasVariableRefs: s
    }, r = [];
    cr.lastIndex = 0;
    let o;
    for (; (o = cr.exec(e)) != null; )
      if (o[1]) {
        var a;
        const c = new ge(o[1]);
        Me(n, c, ["CODECS", "SUPPLEMENTAL-CODECS", "ALLOWED-CPC", "PATHWAY-ID", "STABLE-VARIANT-ID", "AUDIO", "VIDEO", "SUBTITLES", "CLOSED-CAPTIONS", "NAME"]);
        const u = Gn(n, o[2]), d = {
          attrs: c,
          bitrate: c.decimalInteger("BANDWIDTH") || c.decimalInteger("AVERAGE-BANDWIDTH"),
          name: c.NAME,
          url: Xe.resolve(u, t)
        }, h = c.decimalResolution("RESOLUTION");
        h && (d.width = h.width, d.height = h.height), Uf(c.CODECS, d), (a = d.unknownCodecs) != null && a.length || r.push(d), n.levels.push(d);
      } else if (o[3]) {
        const c = o[3], u = o[4];
        switch (c) {
          case "SESSION-DATA": {
            const d = new ge(u);
            Me(n, d, ["DATA-ID", "LANGUAGE", "VALUE", "URI"]);
            const h = d["DATA-ID"];
            h && (n.sessionData === null && (n.sessionData = {}), n.sessionData[h] = d);
            break;
          }
          case "SESSION-KEY": {
            const d = hr(u, t, n);
            d.encrypted && d.isSupported() ? (n.sessionKeys === null && (n.sessionKeys = []), n.sessionKeys.push(d)) : D.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${u}"`);
            break;
          }
          case "DEFINE": {
            {
              const d = new ge(u);
              Me(n, d, ["NAME", "VALUE", "QUERYPARAM"]), or(n, d, t);
            }
            break;
          }
          case "CONTENT-STEERING": {
            const d = new ge(u);
            Me(n, d, ["SERVER-URI", "PATHWAY-ID"]), n.contentSteering = {
              uri: Xe.resolve(d["SERVER-URI"], t),
              pathwayId: d["PATHWAY-ID"] || "."
            };
            break;
          }
          case "START": {
            n.startTimeOffset = fr(u);
            break;
          }
        }
      }
    const l = r.length > 0 && r.length < n.levels.length;
    return n.levels = l ? r : n.levels, n.levels.length === 0 && (n.playlistParsingError = new Error("no levels found in manifest")), n;
  }
  static parseMasterPlaylistMedia(e, t, s) {
    let n;
    const r = {}, o = s.levels, a = {
      AUDIO: o.map((c) => ({
        id: c.attrs.AUDIO,
        audioCodec: c.audioCodec
      })),
      SUBTITLES: o.map((c) => ({
        id: c.attrs.SUBTITLES,
        textCodec: c.textCodec
      })),
      "CLOSED-CAPTIONS": []
    };
    let l = 0;
    for (ur.lastIndex = 0; (n = ur.exec(e)) !== null; ) {
      const c = new ge(n[1]), u = c.TYPE;
      if (u) {
        const d = a[u], h = r[u] || [];
        r[u] = h, Me(s, c, ["URI", "GROUP-ID", "LANGUAGE", "ASSOC-LANGUAGE", "STABLE-RENDITION-ID", "NAME", "INSTREAM-ID", "CHARACTERISTICS", "CHANNELS"]);
        const m = c.LANGUAGE, f = c["ASSOC-LANGUAGE"], g = c.CHANNELS, p = c.CHARACTERISTICS, E = c["INSTREAM-ID"], y = {
          attrs: c,
          bitrate: 0,
          id: l++,
          groupId: c["GROUP-ID"] || "",
          name: c.NAME || m || "",
          type: u,
          default: c.bool("DEFAULT"),
          autoselect: c.bool("AUTOSELECT"),
          forced: c.bool("FORCED"),
          lang: m,
          url: c.URI ? Xe.resolve(c.URI, t) : ""
        };
        if (f && (y.assocLang = f), g && (y.channels = g), p && (y.characteristics = p), E && (y.instreamId = E), d != null && d.length) {
          const v = Xe.findGroup(d, y.groupId) || d[0];
          mr(y, v, "audioCodec"), mr(y, v, "textCodec");
        }
        h.push(y);
      }
    }
    return r;
  }
  static parseLevelPlaylist(e, t, s, n, r, o) {
    const a = new Qh(t), l = a.fragments;
    let c = null, u = 0, d = 0, h = 0, m = 0, f = null, g = new un(n, t), p, E, y, v = -1, S = !1, x = null;
    for (dr.lastIndex = 0, a.m3u8 = e, a.hasVariableRefs = rr(e); (p = dr.exec(e)) !== null; ) {
      S && (S = !1, g = new un(n, t), g.start = h, g.sn = u, g.cc = m, g.level = s, c && (g.initSegment = c, g.rawProgramDateTime = c.rawProgramDateTime, c.rawProgramDateTime = null, x && (g.setByteRange(x), x = null)));
      const A = p[1];
      if (A) {
        g.duration = parseFloat(A);
        const I = (" " + p[2]).slice(1);
        g.title = I || null, g.tagList.push(I ? ["INF", A, I] : ["INF", A]);
      } else if (p[3]) {
        if (G(g.duration)) {
          g.start = h, y && Tr(g, y, a), g.sn = u, g.level = s, g.cc = m, l.push(g);
          const I = (" " + p[3]).slice(1);
          g.relurl = Gn(a, I), gr(g, f), f = g, h += g.duration, u++, d = 0, S = !0;
        }
      } else if (p[4]) {
        const I = (" " + p[4]).slice(1);
        f ? g.setByteRange(I, f) : g.setByteRange(I);
      } else if (p[5])
        g.rawProgramDateTime = (" " + p[5]).slice(1), g.tagList.push(["PROGRAM-DATE-TIME", g.rawProgramDateTime]), v === -1 && (v = l.length);
      else {
        if (p = p[0].match(Nf), !p) {
          D.warn("No matches on slow regex match for level playlist!");
          continue;
        }
        for (E = 1; E < p.length && typeof p[E] == "undefined"; E++)
          ;
        const I = (" " + p[E]).slice(1), w = (" " + p[E + 1]).slice(1), $ = p[E + 2] ? (" " + p[E + 2]).slice(1) : "";
        switch (I) {
          case "PLAYLIST-TYPE":
            a.type = w.toUpperCase();
            break;
          case "MEDIA-SEQUENCE":
            u = a.startSN = parseInt(w);
            break;
          case "SKIP": {
            const M = new ge(w);
            Me(a, M, ["RECENTLY-REMOVED-DATERANGES"]);
            const U = M.decimalInteger("SKIPPED-SEGMENTS");
            if (G(U)) {
              a.skippedSegments = U;
              for (let H = U; H--; )
                l.unshift(null);
              u += U;
            }
            const N = M.enumeratedString("RECENTLY-REMOVED-DATERANGES");
            N && (a.recentlyRemovedDateranges = N.split("	"));
            break;
          }
          case "TARGETDURATION":
            a.targetduration = Math.max(parseInt(w), 1);
            break;
          case "VERSION":
            a.version = parseInt(w);
            break;
          case "INDEPENDENT-SEGMENTS":
          case "EXTM3U":
            break;
          case "ENDLIST":
            a.live = !1;
            break;
          case "#":
            (w || $) && g.tagList.push($ ? [w, $] : [w]);
            break;
          case "DISCONTINUITY":
            m++, g.tagList.push(["DIS"]);
            break;
          case "GAP":
            g.gap = !0, g.tagList.push([I]);
            break;
          case "BITRATE":
            g.tagList.push([I, w]);
            break;
          case "DATERANGE": {
            const M = new ge(w);
            Me(a, M, ["ID", "CLASS", "START-DATE", "END-DATE", "SCTE35-CMD", "SCTE35-OUT", "SCTE35-IN"]), Me(a, M, M.clientAttrs);
            const U = new Ro(M, a.dateRanges[M.ID]);
            U.isValid || a.skippedSegments ? a.dateRanges[U.id] = U : D.warn(`Ignoring invalid DATERANGE tag: "${w}"`), g.tagList.push(["EXT-X-DATERANGE", w]);
            break;
          }
          case "DEFINE": {
            {
              const M = new ge(w);
              Me(a, M, ["NAME", "VALUE", "IMPORT", "QUERYPARAM"]), "IMPORT" in M ? Cf(a, M, o) : or(a, M, t);
            }
            break;
          }
          case "DISCONTINUITY-SEQUENCE":
            m = parseInt(w);
            break;
          case "KEY": {
            const M = hr(w, t, a);
            if (M.isSupported()) {
              if (M.method === "NONE") {
                y = void 0;
                break;
              }
              y || (y = {}), y[M.keyFormat] && (y = ve({}, y)), y[M.keyFormat] = M;
            } else
              D.warn(`[Keys] Ignoring invalid EXT-X-KEY tag: "${w}"`);
            break;
          }
          case "START":
            a.startTimeOffset = fr(w);
            break;
          case "MAP": {
            const M = new ge(w);
            if (Me(a, M, ["BYTERANGE", "URI"]), g.duration) {
              const U = new un(n, t);
              pr(U, M, s, y), c = U, g.initSegment = c, c.rawProgramDateTime && !g.rawProgramDateTime && (g.rawProgramDateTime = c.rawProgramDateTime);
            } else {
              const U = g.byteRangeEndOffset;
              if (U) {
                const N = g.byteRangeStartOffset;
                x = `${U - N}@${N}`;
              } else
                x = null;
              pr(g, M, s, y), c = g, S = !0;
            }
            break;
          }
          case "SERVER-CONTROL": {
            const M = new ge(w);
            a.canBlockReload = M.bool("CAN-BLOCK-RELOAD"), a.canSkipUntil = M.optionalFloat("CAN-SKIP-UNTIL", 0), a.canSkipDateRanges = a.canSkipUntil > 0 && M.bool("CAN-SKIP-DATERANGES"), a.partHoldBack = M.optionalFloat("PART-HOLD-BACK", 0), a.holdBack = M.optionalFloat("HOLD-BACK", 0);
            break;
          }
          case "PART-INF": {
            const M = new ge(w);
            a.partTarget = M.decimalFloatingPoint("PART-TARGET");
            break;
          }
          case "PART": {
            let M = a.partList;
            M || (M = a.partList = []);
            const U = d > 0 ? M[M.length - 1] : void 0, N = d++, H = new ge(w);
            Me(a, H, ["BYTERANGE", "URI"]);
            const q = new jh(H, g, t, N, U);
            M.push(q), g.duration += q.duration;
            break;
          }
          case "PRELOAD-HINT": {
            const M = new ge(w);
            Me(a, M, ["URI"]), a.preloadHint = M;
            break;
          }
          case "RENDITION-REPORT": {
            const M = new ge(w);
            Me(a, M, ["URI"]), a.renditionReports = a.renditionReports || [], a.renditionReports.push(M);
            break;
          }
          default:
            D.warn(`line parsed but not handled: ${p}`);
            break;
        }
      }
    }
    f && !f.relurl ? (l.pop(), h -= f.duration, a.partList && (a.fragmentHint = f)) : a.partList && (gr(g, f), g.cc = m, a.fragmentHint = g, y && Tr(g, y, a));
    const R = l.length, L = l[0], _ = l[R - 1];
    if (h += a.skippedSegments * a.targetduration, h > 0 && R && _) {
      a.averagetargetduration = h / R;
      const A = _.sn;
      a.endSN = A !== "initSegment" ? A : 0, a.live || (_.endList = !0), L && (a.startCC = L.cc);
    } else
      a.endSN = 0, a.startCC = 0;
    return a.fragmentHint && (h += a.fragmentHint.duration), a.totalduration = h, a.endCC = m, v > 0 && Bf(l, v), a;
  }
}
function hr(i, e, t) {
  var s, n;
  const r = new ge(i);
  Me(t, r, ["KEYFORMAT", "KEYFORMATVERSIONS", "URI", "IV", "URI"]);
  const o = (s = r.METHOD) != null ? s : "", a = r.URI, l = r.hexadecimalInteger("IV"), c = r.KEYFORMATVERSIONS, u = (n = r.KEYFORMAT) != null ? n : "identity";
  a && r.IV && !l && D.error(`Invalid IV: ${r.IV}`);
  const d = a ? Xe.resolve(a, e) : "", h = (c || "1").split("/").map(Number).filter(Number.isFinite);
  return new ns(o, d, u, h, l);
}
function fr(i) {
  const t = new ge(i).decimalFloatingPoint("TIME-OFFSET");
  return G(t) ? t : null;
}
function Uf(i, e) {
  let t = (i || "").split(/[ ,]+/).filter((s) => s);
  ["video", "audio", "text"].forEach((s) => {
    const n = t.filter((r) => Mf(r, s));
    n.length && (e[`${s}Codec`] = n.join(","), t = t.filter((r) => n.indexOf(r) === -1));
  }), e.unknownCodecs = t;
}
function mr(i, e, t) {
  const s = e[t];
  s && (i[t] = s);
}
function Bf(i, e) {
  let t = i[e];
  for (let s = e; s--; ) {
    const n = i[s];
    if (!n)
      return;
    n.programDateTime = t.programDateTime - n.duration * 1e3, t = n;
  }
}
function gr(i, e) {
  i.rawProgramDateTime ? i.programDateTime = Date.parse(i.rawProgramDateTime) : e != null && e.programDateTime && (i.programDateTime = e.endProgramDateTime), G(i.programDateTime) || (i.programDateTime = null, i.rawProgramDateTime = null);
}
function pr(i, e, t, s) {
  i.relurl = e.URI, e.BYTERANGE && i.setByteRange(e.BYTERANGE), i.level = t, i.sn = "initSegment", s && (i.levelkeys = s), i.initSegment = null;
}
function Tr(i, e, t) {
  i.levelkeys = e;
  const {
    encryptedFragments: s
  } = t;
  (!s.length || s[s.length - 1].levelkeys !== e) && Object.keys(e).some((n) => e[n].isCommonEncryption) && s.push(i);
}
var re = {
  MANIFEST: "manifest",
  LEVEL: "level",
  AUDIO_TRACK: "audioTrack",
  SUBTITLE_TRACK: "subtitleTrack"
}, Q = {
  MAIN: "main",
  AUDIO: "audio",
  SUBTITLE: "subtitle"
};
function Er(i) {
  const {
    type: e
  } = i;
  switch (e) {
    case re.AUDIO_TRACK:
      return Q.AUDIO;
    case re.SUBTITLE_TRACK:
      return Q.SUBTITLE;
    default:
      return Q.MAIN;
  }
}
function Tn(i, e) {
  let t = i.url;
  return (t === void 0 || t.indexOf("data:") === 0) && (t = e.url), t;
}
class $f {
  constructor(e) {
    this.hls = void 0, this.loaders = /* @__PURE__ */ Object.create(null), this.variableList = null, this.hls = e, this.registerListeners();
  }
  startLoad(e) {
  }
  stopLoad() {
    this.destroyInternalLoaders();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.LEVEL_LOADING, this.onLevelLoading, this), e.on(T.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.on(T.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.LEVEL_LOADING, this.onLevelLoading, this), e.off(T.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.off(T.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }
  /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */
  createInternalLoader(e) {
    const t = this.hls.config, s = t.pLoader, n = t.loader, r = s || n, o = new r(t);
    return this.loaders[e.type] = o, o;
  }
  getInternalLoader(e) {
    return this.loaders[e.type];
  }
  resetInternalLoader(e) {
    this.loaders[e] && delete this.loaders[e];
  }
  /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */
  destroyInternalLoaders() {
    for (const e in this.loaders) {
      const t = this.loaders[e];
      t && t.destroy(), this.resetInternalLoader(e);
    }
  }
  destroy() {
    this.variableList = null, this.unregisterListeners(), this.destroyInternalLoaders();
  }
  onManifestLoading(e, t) {
    const {
      url: s
    } = t;
    this.variableList = null, this.load({
      id: null,
      level: 0,
      responseType: "text",
      type: re.MANIFEST,
      url: s,
      deliveryDirectives: null
    });
  }
  onLevelLoading(e, t) {
    const {
      id: s,
      level: n,
      pathwayId: r,
      url: o,
      deliveryDirectives: a
    } = t;
    this.load({
      id: s,
      level: n,
      pathwayId: r,
      responseType: "text",
      type: re.LEVEL,
      url: o,
      deliveryDirectives: a
    });
  }
  onAudioTrackLoading(e, t) {
    const {
      id: s,
      groupId: n,
      url: r,
      deliveryDirectives: o
    } = t;
    this.load({
      id: s,
      groupId: n,
      level: null,
      responseType: "text",
      type: re.AUDIO_TRACK,
      url: r,
      deliveryDirectives: o
    });
  }
  onSubtitleTrackLoading(e, t) {
    const {
      id: s,
      groupId: n,
      url: r,
      deliveryDirectives: o
    } = t;
    this.load({
      id: s,
      groupId: n,
      level: null,
      responseType: "text",
      type: re.SUBTITLE_TRACK,
      url: r,
      deliveryDirectives: o
    });
  }
  load(e) {
    var t;
    const s = this.hls.config;
    let n = this.getInternalLoader(e);
    if (n) {
      const c = n.context;
      if (c && c.url === e.url && c.level === e.level) {
        D.trace("[playlist-loader]: playlist request ongoing");
        return;
      }
      D.log(`[playlist-loader]: aborting previous loader for type: ${e.type}`), n.abort();
    }
    let r;
    if (e.type === re.MANIFEST ? r = s.manifestLoadPolicy.default : r = ve({}, s.playlistLoadPolicy.default, {
      timeoutRetry: null,
      errorRetry: null
    }), n = this.createInternalLoader(e), G((t = e.deliveryDirectives) == null ? void 0 : t.part)) {
      let c;
      if (e.type === re.LEVEL && e.level !== null ? c = this.hls.levels[e.level].details : e.type === re.AUDIO_TRACK && e.id !== null ? c = this.hls.audioTracks[e.id].details : e.type === re.SUBTITLE_TRACK && e.id !== null && (c = this.hls.subtitleTracks[e.id].details), c) {
        const u = c.partTarget, d = c.targetduration;
        if (u && d) {
          const h = Math.max(u * 3, d * 0.8) * 1e3;
          r = ve({}, r, {
            maxTimeToFirstByteMs: Math.min(h, r.maxTimeToFirstByteMs),
            maxLoadTimeMs: Math.min(h, r.maxTimeToFirstByteMs)
          });
        }
      }
    }
    const o = r.errorRetry || r.timeoutRetry || {}, a = {
      loadPolicy: r,
      timeout: r.maxLoadTimeMs,
      maxRetry: o.maxNumRetry || 0,
      retryDelay: o.retryDelayMs || 0,
      maxRetryDelay: o.maxRetryDelayMs || 0
    }, l = {
      onSuccess: (c, u, d, h) => {
        const m = this.getInternalLoader(d);
        this.resetInternalLoader(d.type);
        const f = c.data;
        if (f.indexOf("#EXTM3U") !== 0) {
          this.handleManifestParsingError(c, d, new Error("no EXTM3U delimiter"), h || null, u);
          return;
        }
        u.parsing.start = performance.now(), Xe.isMediaPlaylist(f) ? this.handleTrackOrLevelPlaylist(c, u, d, h || null, m) : this.handleMasterPlaylist(c, u, d, h);
      },
      onError: (c, u, d, h) => {
        this.handleNetworkError(u, d, !1, c, h);
      },
      onTimeout: (c, u, d) => {
        this.handleNetworkError(u, d, !0, void 0, c);
      }
    };
    n.load(e, a, l);
  }
  handleMasterPlaylist(e, t, s, n) {
    const r = this.hls, o = e.data, a = Tn(e, s), l = Xe.parseMasterPlaylist(o, a);
    if (l.playlistParsingError) {
      this.handleManifestParsingError(e, s, l.playlistParsingError, n, t);
      return;
    }
    const {
      contentSteering: c,
      levels: u,
      sessionData: d,
      sessionKeys: h,
      startTimeOffset: m,
      variableList: f
    } = l;
    this.variableList = f;
    const {
      AUDIO: g = [],
      SUBTITLES: p,
      "CLOSED-CAPTIONS": E
    } = Xe.parseMasterPlaylistMedia(o, a, l);
    g.length && !g.some((v) => !v.url) && u[0].audioCodec && !u[0].attrs.AUDIO && (D.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one"), g.unshift({
      type: "main",
      name: "main",
      groupId: "main",
      default: !1,
      autoselect: !1,
      forced: !1,
      id: -1,
      attrs: new ge({}),
      bitrate: 0,
      url: ""
    })), r.trigger(T.MANIFEST_LOADED, {
      levels: u,
      audioTracks: g,
      subtitles: p,
      captions: E,
      contentSteering: c,
      url: a,
      stats: t,
      networkDetails: n,
      sessionData: d,
      sessionKeys: h,
      startTimeOffset: m,
      variableList: f
    });
  }
  handleTrackOrLevelPlaylist(e, t, s, n, r) {
    const o = this.hls, {
      id: a,
      level: l,
      type: c
    } = s, u = Tn(e, s), d = 0, h = G(l) ? l : G(a) ? a : 0, m = Er(s), f = Xe.parseLevelPlaylist(e.data, u, h, m, d, this.variableList);
    if (c === re.MANIFEST) {
      const g = {
        attrs: new ge({}),
        bitrate: 0,
        details: f,
        name: "",
        url: u
      };
      o.trigger(T.MANIFEST_LOADED, {
        levels: [g],
        audioTracks: [],
        url: u,
        stats: t,
        networkDetails: n,
        sessionData: null,
        sessionKeys: null,
        contentSteering: null,
        startTimeOffset: null,
        variableList: null
      });
    }
    t.parsing.end = performance.now(), s.levelDetails = f, this.handlePlaylistLoaded(f, e, t, s, n, r);
  }
  handleManifestParsingError(e, t, s, n, r) {
    this.hls.trigger(T.ERROR, {
      type: Z.NETWORK_ERROR,
      details: C.MANIFEST_PARSING_ERROR,
      fatal: t.type === re.MANIFEST,
      url: e.url,
      err: s,
      error: s,
      reason: s.message,
      response: e,
      context: t,
      networkDetails: n,
      stats: r
    });
  }
  handleNetworkError(e, t, s = !1, n, r) {
    let o = `A network ${s ? "timeout" : "error" + (n ? " (status " + n.code + ")" : "")} occurred while loading ${e.type}`;
    e.type === re.LEVEL ? o += `: ${e.level} id: ${e.id}` : (e.type === re.AUDIO_TRACK || e.type === re.SUBTITLE_TRACK) && (o += ` id: ${e.id} group-id: "${e.groupId}"`);
    const a = new Error(o);
    D.warn(`[playlist-loader]: ${o}`);
    let l = C.UNKNOWN, c = !1;
    const u = this.getInternalLoader(e);
    switch (e.type) {
      case re.MANIFEST:
        l = s ? C.MANIFEST_LOAD_TIMEOUT : C.MANIFEST_LOAD_ERROR, c = !0;
        break;
      case re.LEVEL:
        l = s ? C.LEVEL_LOAD_TIMEOUT : C.LEVEL_LOAD_ERROR, c = !1;
        break;
      case re.AUDIO_TRACK:
        l = s ? C.AUDIO_TRACK_LOAD_TIMEOUT : C.AUDIO_TRACK_LOAD_ERROR, c = !1;
        break;
      case re.SUBTITLE_TRACK:
        l = s ? C.SUBTITLE_TRACK_LOAD_TIMEOUT : C.SUBTITLE_LOAD_ERROR, c = !1;
        break;
    }
    u && this.resetInternalLoader(e.type);
    const d = {
      type: Z.NETWORK_ERROR,
      details: l,
      fatal: c,
      url: e.url,
      loader: u,
      context: e,
      error: a,
      networkDetails: t,
      stats: r
    };
    if (n) {
      const h = (t == null ? void 0 : t.url) || e.url;
      d.response = Re({
        url: h,
        data: void 0
      }, n);
    }
    this.hls.trigger(T.ERROR, d);
  }
  handlePlaylistLoaded(e, t, s, n, r, o) {
    const a = this.hls, {
      type: l,
      level: c,
      id: u,
      groupId: d,
      deliveryDirectives: h
    } = n, m = Tn(t, n), f = Er(n), g = typeof n.level == "number" && f === Q.MAIN ? c : void 0;
    if (!e.fragments.length) {
      const E = new Error("No Segments found in Playlist");
      a.trigger(T.ERROR, {
        type: Z.NETWORK_ERROR,
        details: C.LEVEL_EMPTY_ERROR,
        fatal: !1,
        url: m,
        error: E,
        reason: E.message,
        response: t,
        context: n,
        level: g,
        parent: f,
        networkDetails: r,
        stats: s
      });
      return;
    }
    e.targetduration || (e.playlistParsingError = new Error("Missing Target Duration"));
    const p = e.playlistParsingError;
    if (p) {
      a.trigger(T.ERROR, {
        type: Z.NETWORK_ERROR,
        details: C.LEVEL_PARSING_ERROR,
        fatal: !1,
        url: m,
        error: p,
        reason: p.message,
        response: t,
        context: n,
        level: g,
        parent: f,
        networkDetails: r,
        stats: s
      });
      return;
    }
    switch (e.live && o && (o.getCacheAge && (e.ageHeader = o.getCacheAge() || 0), (!o.getCacheAge || isNaN(e.ageHeader)) && (e.ageHeader = 0)), l) {
      case re.MANIFEST:
      case re.LEVEL:
        a.trigger(T.LEVEL_LOADED, {
          details: e,
          level: g || 0,
          id: u || 0,
          stats: s,
          networkDetails: r,
          deliveryDirectives: h
        });
        break;
      case re.AUDIO_TRACK:
        a.trigger(T.AUDIO_TRACK_LOADED, {
          details: e,
          id: u || 0,
          groupId: d || "",
          stats: s,
          networkDetails: r,
          deliveryDirectives: h
        });
        break;
      case re.SUBTITLE_TRACK:
        a.trigger(T.SUBTITLE_TRACK_LOADED, {
          details: e,
          id: u || 0,
          groupId: d || "",
          stats: s,
          networkDetails: r,
          deliveryDirectives: h
        });
        break;
    }
  }
}
function Go(i, e) {
  let t;
  try {
    t = new Event("addtrack");
  } catch {
    t = document.createEvent("Event"), t.initEvent("addtrack", !1, !1);
  }
  t.track = i, e.dispatchEvent(t);
}
function Ho(i, e) {
  const t = i.mode;
  if (t === "disabled" && (i.mode = "hidden"), i.cues && !i.cues.getCueById(e.id))
    try {
      if (i.addCue(e), !i.cues.getCueById(e.id))
        throw new Error(`addCue is failed for: ${e}`);
    } catch (s) {
      D.debug(`[texttrack-utils]: ${s}`);
      try {
        const n = new self.TextTrackCue(e.startTime, e.endTime, e.text);
        n.id = e.id, i.addCue(n);
      } catch (n) {
        D.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${n}`);
      }
    }
  t === "disabled" && (i.mode = t);
}
function Ot(i) {
  const e = i.mode;
  if (e === "disabled" && (i.mode = "hidden"), i.cues)
    for (let t = i.cues.length; t--; )
      i.removeCue(i.cues[t]);
  e === "disabled" && (i.mode = e);
}
function Hn(i, e, t, s) {
  const n = i.mode;
  if (n === "disabled" && (i.mode = "hidden"), i.cues && i.cues.length > 0) {
    const r = Hf(i.cues, e, t);
    for (let o = 0; o < r.length; o++)
      (!s || s(r[o])) && i.removeCue(r[o]);
  }
  n === "disabled" && (i.mode = n);
}
function Gf(i, e) {
  if (e < i[0].startTime)
    return 0;
  const t = i.length - 1;
  if (e > i[t].endTime)
    return -1;
  let s = 0, n = t;
  for (; s <= n; ) {
    const r = Math.floor((n + s) / 2);
    if (e < i[r].startTime)
      n = r - 1;
    else if (e > i[r].startTime && s < t)
      s = r + 1;
    else
      return r;
  }
  return i[s].startTime - e < e - i[n].startTime ? s : n;
}
function Hf(i, e, t) {
  const s = [], n = Gf(i, e);
  if (n > -1)
    for (let r = n, o = i.length; r < o; r++) {
      const a = i[r];
      if (a.startTime >= e && a.endTime <= t)
        s.push(a);
      else if (a.startTime > t)
        return s;
    }
  return s;
}
function _s(i) {
  const e = [];
  for (let t = 0; t < i.length; t++) {
    const s = i[t];
    (s.kind === "subtitles" || s.kind === "captions") && s.label && e.push(i[t]);
  }
  return e;
}
var We = {
  audioId3: "org.id3",
  dateRange: "com.apple.quicktime.HLS",
  emsg: "https://aomedia.org/emsg/ID3"
};
const Kf = 0.25;
function Kn() {
  if (typeof self != "undefined")
    return self.VTTCue || self.TextTrackCue;
}
function yr(i, e, t, s, n) {
  let r = new i(e, t, "");
  try {
    r.value = s, n && (r.type = n);
  } catch {
    r = new i(e, t, JSON.stringify(n ? Re({
      type: n
    }, s) : s));
  }
  return r;
}
const ys = (() => {
  const i = Kn();
  try {
    i && new i(0, Number.POSITIVE_INFINITY, "");
  } catch {
    return Number.MAX_VALUE;
  }
  return Number.POSITIVE_INFINITY;
})();
function En(i, e) {
  return i.getTime() / 1e3 - e;
}
function Vf(i) {
  return Uint8Array.from(i.replace(/^0x/, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")).buffer;
}
class Wf {
  constructor(e) {
    this.hls = void 0, this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = e, this._registerListeners();
  }
  destroy() {
    this._unregisterListeners(), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.on(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(T.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.off(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(T.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  // Add ID3 metatadata text track.
  onMediaAttached(e, t) {
    this.media = t.media;
  }
  onMediaDetaching() {
    this.id3Track && (Ot(this.id3Track), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {});
  }
  onManifestLoading() {
    this.dateRangeCuesAppended = {};
  }
  createTrack(e) {
    const t = this.getID3Track(e.textTracks);
    return t.mode = "hidden", t;
  }
  getID3Track(e) {
    if (this.media) {
      for (let t = 0; t < e.length; t++) {
        const s = e[t];
        if (s.kind === "metadata" && s.label === "id3")
          return Go(s, this.media), s;
      }
      return this.media.addTextTrack("metadata", "id3");
    }
  }
  onFragParsingMetadata(e, t) {
    if (!this.media)
      return;
    const {
      hls: {
        config: {
          enableEmsgMetadataCues: s,
          enableID3MetadataCues: n
        }
      }
    } = this;
    if (!s && !n)
      return;
    const {
      samples: r
    } = t;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const o = Kn();
    if (o)
      for (let a = 0; a < r.length; a++) {
        const l = r[a].type;
        if (l === We.emsg && !s || !n)
          continue;
        const c = wo(r[a].data);
        if (c) {
          const u = r[a].pts;
          let d = u + r[a].duration;
          d > ys && (d = ys), d - u <= 0 && (d = u + Kf);
          for (let m = 0; m < c.length; m++) {
            const f = c[m];
            if (!Co(f)) {
              this.updateId3CueEnds(u, l);
              const g = yr(o, u, d, f, l);
              g && this.id3Track.addCue(g);
            }
          }
        }
      }
  }
  updateId3CueEnds(e, t) {
    var s;
    const n = (s = this.id3Track) == null ? void 0 : s.cues;
    if (n)
      for (let r = n.length; r--; ) {
        const o = n[r];
        o.type === t && o.startTime < e && o.endTime === ys && (o.endTime = e);
      }
  }
  onBufferFlushing(e, {
    startOffset: t,
    endOffset: s,
    type: n
  }) {
    const {
      id3Track: r,
      hls: o
    } = this;
    if (!o)
      return;
    const {
      config: {
        enableEmsgMetadataCues: a,
        enableID3MetadataCues: l
      }
    } = o;
    if (r && (a || l)) {
      let c;
      n === "audio" ? c = (u) => u.type === We.audioId3 && l : n === "video" ? c = (u) => u.type === We.emsg && a : c = (u) => u.type === We.audioId3 && l || u.type === We.emsg && a, Hn(r, t, s, c);
    }
  }
  onLevelUpdated(e, {
    details: t
  }) {
    if (!this.media || !t.hasProgramDateTime || !this.hls.config.enableDateRangeMetadataCues)
      return;
    const {
      dateRangeCuesAppended: s,
      id3Track: n
    } = this, {
      dateRanges: r
    } = t, o = Object.keys(r);
    if (n) {
      const u = Object.keys(s).filter((d) => !o.includes(d));
      for (let d = u.length; d--; ) {
        const h = u[d];
        Object.keys(s[h].cues).forEach((m) => {
          n.removeCue(s[h].cues[m]);
        }), delete s[h];
      }
    }
    const a = t.fragments[t.fragments.length - 1];
    if (o.length === 0 || !G(a == null ? void 0 : a.programDateTime))
      return;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const l = a.programDateTime / 1e3 - a.start, c = Kn();
    for (let u = 0; u < o.length; u++) {
      const d = o[u], h = r[d], m = En(h.startDate, l), f = s[d], g = (f == null ? void 0 : f.cues) || {};
      let p = (f == null ? void 0 : f.durationKnown) || !1, E = ys;
      const y = h.endDate;
      if (y)
        E = En(y, l), p = !0;
      else if (h.endOnNext && !p) {
        const S = o.reduce((x, R) => {
          if (R !== h.id) {
            const L = r[R];
            if (L.class === h.class && L.startDate > h.startDate && (!x || h.startDate < x.startDate))
              return L;
          }
          return x;
        }, null);
        S && (E = En(S.startDate, l), p = !0);
      }
      const v = Object.keys(h.attr);
      for (let S = 0; S < v.length; S++) {
        const x = v[S];
        if (!qh(x))
          continue;
        const R = g[x];
        if (R)
          p && !f.durationKnown && (R.endTime = E);
        else if (c) {
          let L = h.attr[x];
          zh(x) && (L = Vf(L));
          const _ = yr(c, m, E, {
            key: x,
            data: L
          }, We.dateRange);
          _ && (_.id = d, this.id3Track.addCue(_), g[x] = _);
        }
      }
      s[d] = {
        cues: g,
        dateRange: h,
        durationKnown: p
      };
    }
  }
}
class Yf {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = null, this.levelDetails = null, this.currentTime = 0, this.stallCount = 0, this._latency = null, this.timeupdateHandler = () => this.timeupdate(), this.hls = e, this.config = e.config, this.registerListeners();
  }
  get latency() {
    return this._latency || 0;
  }
  get maxLatency() {
    const {
      config: e,
      levelDetails: t
    } = this;
    return e.liveMaxLatencyDuration !== void 0 ? e.liveMaxLatencyDuration : t ? e.liveMaxLatencyDurationCount * t.targetduration : 0;
  }
  get targetLatency() {
    const {
      levelDetails: e
    } = this;
    if (e === null)
      return null;
    const {
      holdBack: t,
      partHoldBack: s,
      targetduration: n
    } = e, {
      liveSyncDuration: r,
      liveSyncDurationCount: o,
      lowLatencyMode: a
    } = this.config, l = this.hls.userConfig;
    let c = a && s || t;
    (l.liveSyncDuration || l.liveSyncDurationCount || c === 0) && (c = r !== void 0 ? r : o * n);
    const u = n;
    return c + Math.min(this.stallCount * 1, u);
  }
  get liveSyncPosition() {
    const e = this.estimateLiveEdge(), t = this.targetLatency, s = this.levelDetails;
    if (e === null || t === null || s === null)
      return null;
    const n = s.edge, r = e - t - this.edgeStalled, o = n - s.totalduration, a = n - (this.config.lowLatencyMode && s.partTarget || s.targetduration);
    return Math.min(Math.max(o, r), a);
  }
  get drift() {
    const {
      levelDetails: e
    } = this;
    return e === null ? 1 : e.drift;
  }
  get edgeStalled() {
    const {
      levelDetails: e
    } = this;
    if (e === null)
      return 0;
    const t = (this.config.lowLatencyMode && e.partTarget || e.targetduration) * 3;
    return Math.max(e.age - t, 0);
  }
  get forwardBufferLength() {
    const {
      media: e,
      levelDetails: t
    } = this;
    if (!e || !t)
      return 0;
    const s = e.buffered.length;
    return (s ? e.buffered.end(s - 1) : t.edge) - this.currentTime;
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetaching(), this.levelDetails = null, this.hls = this.timeupdateHandler = null;
  }
  registerListeners() {
    this.hls.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), this.hls.on(T.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(T.LEVEL_UPDATED, this.onLevelUpdated, this), this.hls.on(T.ERROR, this.onError, this);
  }
  unregisterListeners() {
    this.hls.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), this.hls.off(T.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.off(T.LEVEL_UPDATED, this.onLevelUpdated, this), this.hls.off(T.ERROR, this.onError, this);
  }
  onMediaAttached(e, t) {
    this.media = t.media, this.media.addEventListener("timeupdate", this.timeupdateHandler);
  }
  onMediaDetaching() {
    this.media && (this.media.removeEventListener("timeupdate", this.timeupdateHandler), this.media = null);
  }
  onManifestLoading() {
    this.levelDetails = null, this._latency = null, this.stallCount = 0;
  }
  onLevelUpdated(e, {
    details: t
  }) {
    this.levelDetails = t, t.advanced && this.timeupdate(), !t.live && this.media && this.media.removeEventListener("timeupdate", this.timeupdateHandler);
  }
  onError(e, t) {
    var s;
    t.details === C.BUFFER_STALLED_ERROR && (this.stallCount++, (s = this.levelDetails) != null && s.live && D.warn("[playback-rate-controller]: Stall detected, adjusting target latency"));
  }
  timeupdate() {
    const {
      media: e,
      levelDetails: t
    } = this;
    if (!e || !t)
      return;
    this.currentTime = e.currentTime;
    const s = this.computeLatency();
    if (s === null)
      return;
    this._latency = s;
    const {
      lowLatencyMode: n,
      maxLiveSyncPlaybackRate: r
    } = this.config;
    if (!n || r === 1 || !t.live)
      return;
    const o = this.targetLatency;
    if (o === null)
      return;
    const a = s - o, l = Math.min(this.maxLatency, o + t.targetduration);
    if (a < l && a > 0.05 && this.forwardBufferLength > 1) {
      const u = Math.min(2, Math.max(1, r)), d = Math.round(2 / (1 + Math.exp(-0.75 * a - this.edgeStalled)) * 20) / 20;
      e.playbackRate = Math.min(u, Math.max(1, d));
    } else e.playbackRate !== 1 && e.playbackRate !== 0 && (e.playbackRate = 1);
  }
  estimateLiveEdge() {
    const {
      levelDetails: e
    } = this;
    return e === null ? null : e.edge + e.age;
  }
  computeLatency() {
    const e = this.estimateLiveEdge();
    return e === null ? null : e - this.currentTime;
  }
}
const Vn = ["NONE", "TYPE-0", "TYPE-1", null];
function qf(i) {
  return Vn.indexOf(i) > -1;
}
const Ws = ["SDR", "PQ", "HLG"];
function zf(i) {
  return !!i && Ws.indexOf(i) > -1;
}
var Cs = {
  No: "",
  Yes: "YES",
  v2: "v2"
};
function xr(i) {
  const {
    canSkipUntil: e,
    canSkipDateRanges: t,
    age: s
  } = i, n = s < e / 2;
  return e && n ? t ? Cs.v2 : Cs.Yes : Cs.No;
}
class vr {
  constructor(e, t, s) {
    this.msn = void 0, this.part = void 0, this.skip = void 0, this.msn = e, this.part = t, this.skip = s;
  }
  addDirectives(e) {
    const t = new self.URL(e);
    return this.msn !== void 0 && t.searchParams.set("_HLS_msn", this.msn.toString()), this.part !== void 0 && t.searchParams.set("_HLS_part", this.part.toString()), this.skip && t.searchParams.set("_HLS_skip", this.skip), t.href;
  }
}
class Ht {
  constructor(e) {
    this._attrs = void 0, this.audioCodec = void 0, this.bitrate = void 0, this.codecSet = void 0, this.url = void 0, this.frameRate = void 0, this.height = void 0, this.id = void 0, this.name = void 0, this.videoCodec = void 0, this.width = void 0, this.details = void 0, this.fragmentError = 0, this.loadError = 0, this.loaded = void 0, this.realBitrate = 0, this.supportedPromise = void 0, this.supportedResult = void 0, this._avgBitrate = 0, this._audioGroups = void 0, this._subtitleGroups = void 0, this._urlId = 0, this.url = [e.url], this._attrs = [e.attrs], this.bitrate = e.bitrate, e.details && (this.details = e.details), this.id = e.id || 0, this.name = e.name, this.width = e.width || 0, this.height = e.height || 0, this.frameRate = e.attrs.optionalFloat("FRAME-RATE", 0), this._avgBitrate = e.attrs.decimalInteger("AVERAGE-BANDWIDTH"), this.audioCodec = e.audioCodec, this.videoCodec = e.videoCodec, this.codecSet = [e.videoCodec, e.audioCodec].filter((t) => !!t).map((t) => t.substring(0, 4)).join(","), this.addGroupId("audio", e.attrs.AUDIO), this.addGroupId("text", e.attrs.SUBTITLES);
  }
  get maxBitrate() {
    return Math.max(this.realBitrate, this.bitrate);
  }
  get averageBitrate() {
    return this._avgBitrate || this.realBitrate || this.bitrate;
  }
  get attrs() {
    return this._attrs[0];
  }
  get codecs() {
    return this.attrs.CODECS || "";
  }
  get pathwayId() {
    return this.attrs["PATHWAY-ID"] || ".";
  }
  get videoRange() {
    return this.attrs["VIDEO-RANGE"] || "SDR";
  }
  get score() {
    return this.attrs.optionalFloat("SCORE", 0);
  }
  get uri() {
    return this.url[0] || "";
  }
  hasAudioGroup(e) {
    return Sr(this._audioGroups, e);
  }
  hasSubtitleGroup(e) {
    return Sr(this._subtitleGroups, e);
  }
  get audioGroups() {
    return this._audioGroups;
  }
  get subtitleGroups() {
    return this._subtitleGroups;
  }
  addGroupId(e, t) {
    if (t) {
      if (e === "audio") {
        let s = this._audioGroups;
        s || (s = this._audioGroups = []), s.indexOf(t) === -1 && s.push(t);
      } else if (e === "text") {
        let s = this._subtitleGroups;
        s || (s = this._subtitleGroups = []), s.indexOf(t) === -1 && s.push(t);
      }
    }
  }
  // Deprecated methods (retained for backwards compatibility)
  get urlId() {
    return 0;
  }
  set urlId(e) {
  }
  get audioGroupIds() {
    return this.audioGroups ? [this.audioGroupId] : void 0;
  }
  get textGroupIds() {
    return this.subtitleGroups ? [this.textGroupId] : void 0;
  }
  get audioGroupId() {
    var e;
    return (e = this.audioGroups) == null ? void 0 : e[0];
  }
  get textGroupId() {
    var e;
    return (e = this.subtitleGroups) == null ? void 0 : e[0];
  }
  addFallback() {
  }
}
function Sr(i, e) {
  return !e || !i ? !1 : i.indexOf(e) !== -1;
}
function yn(i, e) {
  const t = e.startPTS;
  if (G(t)) {
    let s = 0, n;
    e.sn > i.sn ? (s = t - i.start, n = i) : (s = i.start - t, n = e), n.duration !== s && (n.duration = s);
  } else e.sn > i.sn ? i.cc === e.cc && i.minEndPTS ? e.start = i.start + (i.minEndPTS - i.start) : e.start = i.start + i.duration : e.start = Math.max(i.start - e.duration, 0);
}
function Ko(i, e, t, s, n, r) {
  s - t <= 0 && (D.warn("Fragment should have a positive duration", e), s = t + e.duration, r = n + e.duration);
  let a = t, l = s;
  const c = e.startPTS, u = e.endPTS;
  if (G(c)) {
    const p = Math.abs(c - t);
    G(e.deltaPTS) ? e.deltaPTS = Math.max(p, e.deltaPTS) : e.deltaPTS = p, a = Math.max(t, c), t = Math.min(t, c), n = Math.min(n, e.startDTS), l = Math.min(s, u), s = Math.max(s, u), r = Math.max(r, e.endDTS);
  }
  const d = t - e.start;
  e.start !== 0 && (e.start = t), e.duration = s - e.start, e.startPTS = t, e.maxStartPTS = a, e.startDTS = n, e.endPTS = s, e.minEndPTS = l, e.endDTS = r;
  const h = e.sn;
  if (!i || h < i.startSN || h > i.endSN)
    return 0;
  let m;
  const f = h - i.startSN, g = i.fragments;
  for (g[f] = e, m = f; m > 0; m--)
    yn(g[m], g[m - 1]);
  for (m = f; m < g.length - 1; m++)
    yn(g[m], g[m + 1]);
  return i.fragmentHint && yn(g[g.length - 1], i.fragmentHint), i.PTSKnown = i.alignedSliding = !0, d;
}
function jf(i, e) {
  let t = null;
  const s = i.fragments;
  for (let l = s.length - 1; l >= 0; l--) {
    const c = s[l].initSegment;
    if (c) {
      t = c;
      break;
    }
  }
  i.fragmentHint && delete i.fragmentHint.endPTS;
  let n = 0, r;
  if (Zf(i, e, (l, c) => {
    l.relurl && (n = l.cc - c.cc), G(l.startPTS) && G(l.endPTS) && (c.start = c.startPTS = l.startPTS, c.startDTS = l.startDTS, c.maxStartPTS = l.maxStartPTS, c.endPTS = l.endPTS, c.endDTS = l.endDTS, c.minEndPTS = l.minEndPTS, c.duration = l.endPTS - l.startPTS, c.duration && (r = c), e.PTSKnown = e.alignedSliding = !0), c.elementaryStreams = l.elementaryStreams, c.loader = l.loader, c.stats = l.stats, l.initSegment && (c.initSegment = l.initSegment, t = l.initSegment);
  }), t && (e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments).forEach((c) => {
    var u;
    c && (!c.initSegment || c.initSegment.relurl === ((u = t) == null ? void 0 : u.relurl)) && (c.initSegment = t);
  }), e.skippedSegments)
    if (e.deltaUpdateFailed = e.fragments.some((l) => !l), e.deltaUpdateFailed) {
      D.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");
      for (let l = e.skippedSegments; l--; )
        e.fragments.shift();
      e.startSN = e.fragments[0].sn, e.startCC = e.fragments[0].cc;
    } else e.canSkipDateRanges && (e.dateRanges = Xf(i.dateRanges, e.dateRanges, e.recentlyRemovedDateranges));
  const o = e.fragments;
  if (n) {
    D.warn("discontinuity sliding from playlist, take drift into account");
    for (let l = 0; l < o.length; l++)
      o[l].cc += n;
  }
  e.skippedSegments && (e.startCC = e.fragments[0].cc), Qf(i.partList, e.partList, (l, c) => {
    c.elementaryStreams = l.elementaryStreams, c.stats = l.stats;
  }), r ? Ko(e, r, r.startPTS, r.endPTS, r.startDTS, r.endDTS) : Vo(i, e), o.length && (e.totalduration = e.edge - o[0].start), e.driftStartTime = i.driftStartTime, e.driftStart = i.driftStart;
  const a = e.advancedDateTime;
  if (e.advanced && a) {
    const l = e.edge;
    e.driftStart || (e.driftStartTime = a, e.driftStart = l), e.driftEndTime = a, e.driftEnd = l;
  } else
    e.driftEndTime = i.driftEndTime, e.driftEnd = i.driftEnd, e.advancedDateTime = i.advancedDateTime;
}
function Xf(i, e, t) {
  const s = ve({}, i);
  return t && t.forEach((n) => {
    delete s[n];
  }), Object.keys(e).forEach((n) => {
    const r = new Ro(e[n].attr, s[n]);
    r.isValid ? s[n] = r : D.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${JSON.stringify(e[n].attr)}"`);
  }), s;
}
function Qf(i, e, t) {
  if (i && e) {
    let s = 0;
    for (let n = 0, r = i.length; n <= r; n++) {
      const o = i[n], a = e[n + s];
      o && a && o.index === a.index && o.fragment.sn === a.fragment.sn ? t(o, a) : s--;
    }
  }
}
function Zf(i, e, t) {
  const s = e.skippedSegments, n = Math.max(i.startSN, e.startSN) - e.startSN, r = (i.fragmentHint ? 1 : 0) + (s ? e.endSN : Math.min(i.endSN, e.endSN)) - e.startSN, o = e.startSN - i.startSN, a = e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments, l = i.fragmentHint ? i.fragments.concat(i.fragmentHint) : i.fragments;
  for (let c = n; c <= r; c++) {
    const u = l[o + c];
    let d = a[c];
    s && !d && c < s && (d = e.fragments[c] = u), u && d && t(u, d);
  }
}
function Vo(i, e) {
  const t = e.startSN + e.skippedSegments - i.startSN, s = i.fragments;
  t < 0 || t >= s.length || Wn(e, s[t].start);
}
function Wn(i, e) {
  if (e) {
    const t = i.fragments;
    for (let s = i.skippedSegments; s < t.length; s++)
      t[s].start += e;
    i.fragmentHint && (i.fragmentHint.start += e);
  }
}
function Jf(i, e = 1 / 0) {
  let t = 1e3 * i.targetduration;
  if (i.updated) {
    const s = i.fragments;
    if (s.length && t * 4 > e) {
      const r = s[s.length - 1].duration * 1e3;
      r < t && (t = r);
    }
  } else
    t /= 2;
  return Math.round(t);
}
function em(i, e, t) {
  if (!(i != null && i.details))
    return null;
  const s = i.details;
  let n = s.fragments[e - s.startSN];
  return n || (n = s.fragmentHint, n && n.sn === e) ? n : e < s.startSN && t && t.sn === e ? t : null;
}
function Ar(i, e, t) {
  var s;
  return i != null && i.details ? Wo((s = i.details) == null ? void 0 : s.partList, e, t) : null;
}
function Wo(i, e, t) {
  if (i)
    for (let s = i.length; s--; ) {
      const n = i[s];
      if (n.index === t && n.fragment.sn === e)
        return n;
    }
  return null;
}
function Yo(i) {
  i.forEach((e, t) => {
    const {
      details: s
    } = e;
    s != null && s.fragments && s.fragments.forEach((n) => {
      n.level = t;
    });
  });
}
function Ys(i) {
  switch (i.details) {
    case C.FRAG_LOAD_TIMEOUT:
    case C.KEY_LOAD_TIMEOUT:
    case C.LEVEL_LOAD_TIMEOUT:
    case C.MANIFEST_LOAD_TIMEOUT:
      return !0;
  }
  return !1;
}
function Lr(i, e) {
  const t = Ys(e);
  return i.default[`${t ? "timeout" : "error"}Retry`];
}
function ri(i, e) {
  const t = i.backoff === "linear" ? 1 : Math.pow(2, e);
  return Math.min(t * i.retryDelayMs, i.maxRetryDelayMs);
}
function Rr(i) {
  return Re(Re({}, i), {
    errorRetry: null,
    timeoutRetry: null
  });
}
function qs(i, e, t, s) {
  if (!i)
    return !1;
  const n = s == null ? void 0 : s.code, r = e < i.maxNumRetry && (tm(n) || !!t);
  return i.shouldRetry ? i.shouldRetry(i, e, t, s, r) : r;
}
function tm(i) {
  return i === 0 && navigator.onLine === !1 || !!i && (i < 400 || i > 499);
}
const qo = {
  /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */
  search: function(i, e) {
    let t = 0, s = i.length - 1, n = null, r = null;
    for (; t <= s; ) {
      n = (t + s) / 2 | 0, r = i[n];
      const o = e(r);
      if (o > 0)
        t = n + 1;
      else if (o < 0)
        s = n - 1;
      else
        return r;
    }
    return null;
  }
};
function sm(i, e, t) {
  if (e === null || !Array.isArray(i) || !i.length || !G(e))
    return null;
  const s = i[0].programDateTime;
  if (e < (s || 0))
    return null;
  const n = i[i.length - 1].endProgramDateTime;
  if (e >= (n || 0))
    return null;
  t = t || 0;
  for (let r = 0; r < i.length; ++r) {
    const o = i[r];
    if (im(e, t, o))
      return o;
  }
  return null;
}
function zs(i, e, t = 0, s = 0, n = 5e-3) {
  let r = null;
  if (i) {
    r = e[i.sn - e[0].sn + 1] || null;
    const a = i.endDTS - t;
    a > 0 && a < 15e-7 && (t += 15e-7);
  } else t === 0 && e[0].start === 0 && (r = e[0]);
  if (r && ((!i || i.level === r.level) && Yn(t, s, r) === 0 || nm(r, i, Math.min(n, s))))
    return r;
  const o = qo.search(e, Yn.bind(null, t, s));
  return o && (o !== i || !r) ? o : r;
}
function nm(i, e, t) {
  if (e && e.start === 0 && e.level < i.level && (e.endPTS || 0) > 0) {
    const s = e.tagList.reduce((n, r) => (r[0] === "INF" && (n += parseFloat(r[1])), n), t);
    return i.start <= s;
  }
  return !1;
}
function Yn(i = 0, e = 0, t) {
  if (t.start <= i && t.start + t.duration > i)
    return 0;
  const s = Math.min(e, t.duration + (t.deltaPTS ? t.deltaPTS : 0));
  return t.start + t.duration - s <= i ? 1 : t.start - s > i && t.start ? -1 : 0;
}
function im(i, e, t) {
  const s = Math.min(e, t.duration + (t.deltaPTS ? t.deltaPTS : 0)) * 1e3;
  return (t.endProgramDateTime || 0) - s > i;
}
function rm(i, e) {
  return qo.search(i, (t) => t.cc < e ? 1 : t.cc > e ? -1 : 0);
}
var De = {
  DoNothing: 0,
  SendAlternateToPenaltyBox: 2,
  RemoveAlternatePermanently: 3,
  RetryRequest: 5
}, Ke = {
  None: 0,
  MoveAllAlternatesMatchingHost: 1,
  MoveAllAlternatesMatchingHDCP: 2
};
class om {
  constructor(e) {
    this.hls = void 0, this.playlistError = 0, this.penalizedRenditions = {}, this.log = void 0, this.warn = void 0, this.error = void 0, this.hls = e, this.log = D.log.bind(D, "[info]:"), this.warn = D.warn.bind(D, "[warning]:"), this.error = D.error.bind(D, "[error]:"), this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(T.ERROR, this.onError, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(T.ERROR, this.onError, this), e.off(T.ERROR, this.onErrorOut, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.LEVEL_UPDATED, this.onLevelUpdated, this));
  }
  destroy() {
    this.unregisterListeners(), this.hls = null, this.penalizedRenditions = {};
  }
  startLoad(e) {
  }
  stopLoad() {
    this.playlistError = 0;
  }
  getVariantLevelIndex(e) {
    return (e == null ? void 0 : e.type) === Q.MAIN ? e.level : this.hls.loadLevel;
  }
  onManifestLoading() {
    this.playlistError = 0, this.penalizedRenditions = {};
  }
  onLevelUpdated() {
    this.playlistError = 0;
  }
  onError(e, t) {
    var s, n;
    if (t.fatal)
      return;
    const r = this.hls, o = t.context;
    switch (t.details) {
      case C.FRAG_LOAD_ERROR:
      case C.FRAG_LOAD_TIMEOUT:
      case C.KEY_LOAD_ERROR:
      case C.KEY_LOAD_TIMEOUT:
        t.errorAction = this.getFragRetryOrSwitchAction(t);
        return;
      case C.FRAG_PARSING_ERROR:
        if ((s = t.frag) != null && s.gap) {
          t.errorAction = {
            action: De.DoNothing,
            flags: Ke.None
          };
          return;
        }
      // falls through
      case C.FRAG_GAP:
      case C.FRAG_DECRYPT_ERROR: {
        t.errorAction = this.getFragRetryOrSwitchAction(t), t.errorAction.action = De.SendAlternateToPenaltyBox;
        return;
      }
      case C.LEVEL_EMPTY_ERROR:
      case C.LEVEL_PARSING_ERROR:
        {
          var a, l;
          const c = t.parent === Q.MAIN ? t.level : r.loadLevel;
          t.details === C.LEVEL_EMPTY_ERROR && ((a = t.context) != null && (l = a.levelDetails) != null && l.live) ? t.errorAction = this.getPlaylistRetryOrSwitchAction(t, c) : (t.levelRetry = !1, t.errorAction = this.getLevelSwitchAction(t, c));
        }
        return;
      case C.LEVEL_LOAD_ERROR:
      case C.LEVEL_LOAD_TIMEOUT:
        typeof (o == null ? void 0 : o.level) == "number" && (t.errorAction = this.getPlaylistRetryOrSwitchAction(t, o.level));
        return;
      case C.AUDIO_TRACK_LOAD_ERROR:
      case C.AUDIO_TRACK_LOAD_TIMEOUT:
      case C.SUBTITLE_LOAD_ERROR:
      case C.SUBTITLE_TRACK_LOAD_TIMEOUT:
        if (o) {
          const c = r.levels[r.loadLevel];
          if (c && (o.type === re.AUDIO_TRACK && c.hasAudioGroup(o.groupId) || o.type === re.SUBTITLE_TRACK && c.hasSubtitleGroup(o.groupId))) {
            t.errorAction = this.getPlaylistRetryOrSwitchAction(t, r.loadLevel), t.errorAction.action = De.SendAlternateToPenaltyBox, t.errorAction.flags = Ke.MoveAllAlternatesMatchingHost;
            return;
          }
        }
        return;
      case C.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
        {
          const c = r.levels[r.loadLevel], u = c == null ? void 0 : c.attrs["HDCP-LEVEL"];
          u ? t.errorAction = {
            action: De.SendAlternateToPenaltyBox,
            flags: Ke.MoveAllAlternatesMatchingHDCP,
            hdcpLevel: u
          } : this.keySystemError(t);
        }
        return;
      case C.BUFFER_ADD_CODEC_ERROR:
      case C.REMUX_ALLOC_ERROR:
      case C.BUFFER_APPEND_ERROR:
        t.errorAction = this.getLevelSwitchAction(t, (n = t.level) != null ? n : r.loadLevel);
        return;
      case C.INTERNAL_EXCEPTION:
      case C.BUFFER_APPENDING_ERROR:
      case C.BUFFER_FULL_ERROR:
      case C.LEVEL_SWITCH_ERROR:
      case C.BUFFER_STALLED_ERROR:
      case C.BUFFER_SEEK_OVER_HOLE:
      case C.BUFFER_NUDGE_ON_STALL:
        t.errorAction = {
          action: De.DoNothing,
          flags: Ke.None
        };
        return;
    }
    t.type === Z.KEY_SYSTEM_ERROR && this.keySystemError(t);
  }
  keySystemError(e) {
    const t = this.getVariantLevelIndex(e.frag);
    e.levelRetry = !1, e.errorAction = this.getLevelSwitchAction(e, t);
  }
  getPlaylistRetryOrSwitchAction(e, t) {
    const s = this.hls, n = Lr(s.config.playlistLoadPolicy, e), r = this.playlistError++;
    if (qs(n, r, Ys(e), e.response))
      return {
        action: De.RetryRequest,
        flags: Ke.None,
        retryConfig: n,
        retryCount: r
      };
    const a = this.getLevelSwitchAction(e, t);
    return n && (a.retryConfig = n, a.retryCount = r), a;
  }
  getFragRetryOrSwitchAction(e) {
    const t = this.hls, s = this.getVariantLevelIndex(e.frag), n = t.levels[s], {
      fragLoadPolicy: r,
      keyLoadPolicy: o
    } = t.config, a = Lr(e.details.startsWith("key") ? o : r, e), l = t.levels.reduce((u, d) => u + d.fragmentError, 0);
    if (n && (e.details !== C.FRAG_GAP && n.fragmentError++, qs(a, l, Ys(e), e.response)))
      return {
        action: De.RetryRequest,
        flags: Ke.None,
        retryConfig: a,
        retryCount: l
      };
    const c = this.getLevelSwitchAction(e, s);
    return a && (c.retryConfig = a, c.retryCount = l), c;
  }
  getLevelSwitchAction(e, t) {
    const s = this.hls;
    t == null && (t = s.loadLevel);
    const n = this.hls.levels[t];
    if (n) {
      var r, o;
      const c = e.details;
      n.loadError++, c === C.BUFFER_APPEND_ERROR && n.fragmentError++;
      let u = -1;
      const {
        levels: d,
        loadLevel: h,
        minAutoLevel: m,
        maxAutoLevel: f
      } = s;
      s.autoLevelEnabled || (s.loadLevel = -1);
      const g = (r = e.frag) == null ? void 0 : r.type, E = (g === Q.AUDIO && c === C.FRAG_PARSING_ERROR || e.sourceBufferName === "audio" && (c === C.BUFFER_ADD_CODEC_ERROR || c === C.BUFFER_APPEND_ERROR)) && d.some(({
        audioCodec: R
      }) => n.audioCodec !== R), v = e.sourceBufferName === "video" && (c === C.BUFFER_ADD_CODEC_ERROR || c === C.BUFFER_APPEND_ERROR) && d.some(({
        codecSet: R,
        audioCodec: L
      }) => n.codecSet !== R && n.audioCodec === L), {
        type: S,
        groupId: x
      } = (o = e.context) != null ? o : {};
      for (let R = d.length; R--; ) {
        const L = (R + h) % d.length;
        if (L !== h && L >= m && L <= f && d[L].loadError === 0) {
          var a, l;
          const _ = d[L];
          if (c === C.FRAG_GAP && g === Q.MAIN && e.frag) {
            const A = d[L].details;
            if (A) {
              const I = zs(e.frag, A.fragments, e.frag.start);
              if (I != null && I.gap)
                continue;
            }
          } else {
            if (S === re.AUDIO_TRACK && _.hasAudioGroup(x) || S === re.SUBTITLE_TRACK && _.hasSubtitleGroup(x))
              continue;
            if (g === Q.AUDIO && (a = n.audioGroups) != null && a.some((A) => _.hasAudioGroup(A)) || g === Q.SUBTITLE && (l = n.subtitleGroups) != null && l.some((A) => _.hasSubtitleGroup(A)) || E && n.audioCodec === _.audioCodec || !E && n.audioCodec !== _.audioCodec || v && n.codecSet === _.codecSet)
              continue;
          }
          u = L;
          break;
        }
      }
      if (u > -1 && s.loadLevel !== u)
        return e.levelRetry = !0, this.playlistError = 0, {
          action: De.SendAlternateToPenaltyBox,
          flags: Ke.None,
          nextAutoLevel: u
        };
    }
    return {
      action: De.SendAlternateToPenaltyBox,
      flags: Ke.MoveAllAlternatesMatchingHost
    };
  }
  onErrorOut(e, t) {
    var s;
    switch ((s = t.errorAction) == null ? void 0 : s.action) {
      case De.DoNothing:
        break;
      case De.SendAlternateToPenaltyBox:
        this.sendAlternateToPenaltyBox(t), !t.errorAction.resolved && t.details !== C.FRAG_GAP ? t.fatal = !0 : /MediaSource readyState: ended/.test(t.error.message) && (this.warn(`MediaSource ended after "${t.sourceBufferName}" sourceBuffer append error. Attempting to recover from media error.`), this.hls.recoverMediaError());
        break;
    }
    if (t.fatal) {
      this.hls.stopLoad();
      return;
    }
  }
  sendAlternateToPenaltyBox(e) {
    const t = this.hls, s = e.errorAction;
    if (!s)
      return;
    const {
      flags: n,
      hdcpLevel: r,
      nextAutoLevel: o
    } = s;
    switch (n) {
      case Ke.None:
        this.switchLevel(e, o);
        break;
      case Ke.MoveAllAlternatesMatchingHDCP:
        r && (t.maxHdcpLevel = Vn[Vn.indexOf(r) - 1], s.resolved = !0), this.warn(`Restricting playback to HDCP-LEVEL of "${t.maxHdcpLevel}" or lower`);
        break;
    }
    s.resolved || this.switchLevel(e, o);
  }
  switchLevel(e, t) {
    t !== void 0 && e.errorAction && (this.warn(`switching to level ${t} after ${e.details}`), this.hls.nextAutoLevel = t, e.errorAction.resolved = !0, this.hls.nextLoadLevel = this.hls.nextAutoLevel);
  }
}
class oi {
  constructor(e, t) {
    this.hls = void 0, this.timer = -1, this.requestScheduled = -1, this.canLoad = !1, this.log = void 0, this.warn = void 0, this.log = D.log.bind(D, `${t}:`), this.warn = D.warn.bind(D, `${t}:`), this.hls = e;
  }
  destroy() {
    this.clearTimer(), this.hls = this.log = this.warn = null;
  }
  clearTimer() {
    this.timer !== -1 && (self.clearTimeout(this.timer), this.timer = -1);
  }
  startLoad() {
    this.canLoad = !0, this.requestScheduled = -1, this.loadPlaylist();
  }
  stopLoad() {
    this.canLoad = !1, this.clearTimer();
  }
  switchParams(e, t, s) {
    const n = t == null ? void 0 : t.renditionReports;
    if (n) {
      let r = -1;
      for (let o = 0; o < n.length; o++) {
        const a = n[o];
        let l;
        try {
          l = new self.URL(a.URI, t.url).href;
        } catch (c) {
          D.warn(`Could not construct new URL for Rendition Report: ${c}`), l = a.URI || "";
        }
        if (l === e) {
          r = o;
          break;
        } else l === e.substring(0, l.length) && (r = o);
      }
      if (r !== -1) {
        const o = n[r], a = parseInt(o["LAST-MSN"]) || (t == null ? void 0 : t.lastPartSn);
        let l = parseInt(o["LAST-PART"]) || (t == null ? void 0 : t.lastPartIndex);
        if (this.hls.config.lowLatencyMode) {
          const u = Math.min(t.age - t.partTarget, t.targetduration);
          l >= 0 && u > t.partTarget && (l += 1);
        }
        const c = s && xr(s);
        return new vr(a, l >= 0 ? l : void 0, c);
      }
    }
  }
  loadPlaylist(e) {
    this.requestScheduled === -1 && (this.requestScheduled = self.performance.now());
  }
  shouldLoadPlaylist(e) {
    return this.canLoad && !!e && !!e.url && (!e.details || e.details.live);
  }
  shouldReloadPlaylist(e) {
    return this.timer === -1 && this.requestScheduled === -1 && this.shouldLoadPlaylist(e);
  }
  playlistLoaded(e, t, s) {
    const {
      details: n,
      stats: r
    } = t, o = self.performance.now(), a = r.loading.first ? Math.max(0, o - r.loading.first) : 0;
    if (n.advancedDateTime = Date.now() - a, n.live || s != null && s.live) {
      if (n.reloaded(s), s && this.log(`live playlist ${e} ${n.advanced ? "REFRESHED " + n.lastPartSn + "-" + n.lastPartIndex : n.updated ? "UPDATED" : "MISSED"}`), s && n.fragments.length > 0 && jf(s, n), !this.canLoad || !n.live)
        return;
      let l, c, u;
      if (n.canBlockReload && n.endSN && n.advanced) {
        const p = this.hls.config.lowLatencyMode, E = n.lastPartSn, y = n.endSN, v = n.lastPartIndex, S = v !== -1, x = E === y, R = p ? 0 : v;
        S ? (c = x ? y + 1 : E, u = x ? R : v + 1) : c = y + 1;
        const L = n.age, _ = L + n.ageHeader;
        let A = Math.min(_ - n.partTarget, n.targetduration * 1.5);
        if (A > 0) {
          if (s && A > s.tuneInGoal)
            this.warn(`CDN Tune-in goal increased from: ${s.tuneInGoal} to: ${A} with playlist age: ${n.age}`), A = 0;
          else {
            const I = Math.floor(A / n.targetduration);
            if (c += I, u !== void 0) {
              const w = Math.round(A % n.targetduration / n.partTarget);
              u += w;
            }
            this.log(`CDN Tune-in age: ${n.ageHeader}s last advanced ${L.toFixed(2)}s goal: ${A} skip sn ${I} to part ${u}`);
          }
          n.tuneInGoal = A;
        }
        if (l = this.getDeliveryDirectives(n, t.deliveryDirectives, c, u), p || !x) {
          this.loadPlaylist(l);
          return;
        }
      } else (n.canBlockReload || n.canSkipUntil) && (l = this.getDeliveryDirectives(n, t.deliveryDirectives, c, u));
      const d = this.hls.mainForwardBufferInfo, h = d ? d.end - d.len : 0, m = (n.edge - h) * 1e3, f = Jf(n, m);
      n.updated && o > this.requestScheduled + f && (this.requestScheduled = r.loading.start), c !== void 0 && n.canBlockReload ? this.requestScheduled = r.loading.first + f - (n.partTarget * 1e3 || 1e3) : this.requestScheduled === -1 || this.requestScheduled + f < o ? this.requestScheduled = o : this.requestScheduled - o <= 0 && (this.requestScheduled += f);
      let g = this.requestScheduled - o;
      g = Math.max(0, g), this.log(`reload live playlist ${e} in ${Math.round(g)} ms`), this.timer = self.setTimeout(() => this.loadPlaylist(l), g);
    } else
      this.clearTimer();
  }
  getDeliveryDirectives(e, t, s, n) {
    let r = xr(e);
    return t != null && t.skip && e.deltaUpdateFailed && (s = t.msn, n = t.part, r = Cs.No), new vr(s, n, r);
  }
  checkRetry(e) {
    const t = e.details, s = Ys(e), n = e.errorAction, {
      action: r,
      retryCount: o = 0,
      retryConfig: a
    } = n || {}, l = !!n && !!a && (r === De.RetryRequest || !n.resolved && r === De.SendAlternateToPenaltyBox);
    if (l) {
      var c;
      if (this.requestScheduled = -1, o >= a.maxNumRetry)
        return !1;
      if (s && (c = e.context) != null && c.deliveryDirectives)
        this.warn(`Retrying playlist loading ${o + 1}/${a.maxNumRetry} after "${t}" without delivery-directives`), this.loadPlaylist();
      else {
        const u = ri(a, o);
        this.timer = self.setTimeout(() => this.loadPlaylist(), u), this.warn(`Retrying playlist loading ${o + 1}/${a.maxNumRetry} after "${t}" in ${u}ms`);
      }
      e.levelRetry = !0, n.resolved = !0;
    }
    return l;
  }
}
class wt {
  //  About half of the estimated value will be from the last |halfLife| samples by weight.
  constructor(e, t = 0, s = 0) {
    this.halfLife = void 0, this.alpha_ = void 0, this.estimate_ = void 0, this.totalWeight_ = void 0, this.halfLife = e, this.alpha_ = e ? Math.exp(Math.log(0.5) / e) : 0, this.estimate_ = t, this.totalWeight_ = s;
  }
  sample(e, t) {
    const s = Math.pow(this.alpha_, e);
    this.estimate_ = t * (1 - s) + s * this.estimate_, this.totalWeight_ += e;
  }
  getTotalWeight() {
    return this.totalWeight_;
  }
  getEstimate() {
    if (this.alpha_) {
      const e = 1 - Math.pow(this.alpha_, this.totalWeight_);
      if (e)
        return this.estimate_ / e;
    }
    return this.estimate_;
  }
}
class am {
  constructor(e, t, s, n = 100) {
    this.defaultEstimate_ = void 0, this.minWeight_ = void 0, this.minDelayMs_ = void 0, this.slow_ = void 0, this.fast_ = void 0, this.defaultTTFB_ = void 0, this.ttfb_ = void 0, this.defaultEstimate_ = s, this.minWeight_ = 1e-3, this.minDelayMs_ = 50, this.slow_ = new wt(e), this.fast_ = new wt(t), this.defaultTTFB_ = n, this.ttfb_ = new wt(e);
  }
  update(e, t) {
    const {
      slow_: s,
      fast_: n,
      ttfb_: r
    } = this;
    s.halfLife !== e && (this.slow_ = new wt(e, s.getEstimate(), s.getTotalWeight())), n.halfLife !== t && (this.fast_ = new wt(t, n.getEstimate(), n.getTotalWeight())), r.halfLife !== e && (this.ttfb_ = new wt(e, r.getEstimate(), r.getTotalWeight()));
  }
  sample(e, t) {
    e = Math.max(e, this.minDelayMs_);
    const s = 8 * t, n = e / 1e3, r = s / n;
    this.fast_.sample(n, r), this.slow_.sample(n, r);
  }
  sampleTTFB(e) {
    const t = e / 1e3, s = Math.sqrt(2) * Math.exp(-Math.pow(t, 2) / 2);
    this.ttfb_.sample(s, Math.max(e, 5));
  }
  canEstimate() {
    return this.fast_.getTotalWeight() >= this.minWeight_;
  }
  getEstimate() {
    return this.canEstimate() ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate()) : this.defaultEstimate_;
  }
  getEstimateTTFB() {
    return this.ttfb_.getTotalWeight() >= this.minWeight_ ? this.ttfb_.getEstimate() : this.defaultTTFB_;
  }
  destroy() {
  }
}
const zo = {
  supported: !0,
  configurations: [],
  decodingInfoResults: [{
    supported: !0,
    powerEfficient: !0,
    smooth: !0
  }]
}, Dr = {};
function lm(i, e, t, s, n, r) {
  const o = i.audioCodec ? i.audioGroups : null, a = r == null ? void 0 : r.audioCodec, l = r == null ? void 0 : r.channels, c = l ? parseInt(l) : a ? 1 / 0 : 2;
  let u = null;
  if (o != null && o.length)
    try {
      o.length === 1 && o[0] ? u = e.groups[o[0]].channels : u = o.reduce((d, h) => {
        if (h) {
          const m = e.groups[h];
          if (!m)
            throw new Error(`Audio track group ${h} not found`);
          Object.keys(m.channels).forEach((f) => {
            d[f] = (d[f] || 0) + m.channels[f];
          });
        }
        return d;
      }, {
        2: 0
      });
    } catch {
      return !0;
    }
  return i.videoCodec !== void 0 && (i.width > 1920 && i.height > 1088 || i.height > 1920 && i.width > 1088 || i.frameRate > Math.max(s, 30) || i.videoRange !== "SDR" && i.videoRange !== t || i.bitrate > Math.max(n, 8e6)) || !!u && G(c) && Object.keys(u).some((d) => parseInt(d) > c);
}
function cm(i, e, t) {
  const s = i.videoCodec, n = i.audioCodec;
  if (!s || !n || !t)
    return Promise.resolve(zo);
  const r = {
    width: i.width,
    height: i.height,
    bitrate: Math.ceil(Math.max(i.bitrate * 0.9, i.averageBitrate)),
    // Assume a framerate of 30fps since MediaCapabilities will not accept Level default of 0.
    framerate: i.frameRate || 30
  }, o = i.videoRange;
  o !== "SDR" && (r.transferFunction = o.toLowerCase());
  const a = s.split(",").map((l) => ({
    type: "media-source",
    video: Re(Re({}, r), {}, {
      contentType: is(l, "video")
    })
  }));
  return n && i.audioGroups && i.audioGroups.forEach((l) => {
    var c;
    l && ((c = e.groups[l]) == null || c.tracks.forEach((u) => {
      if (u.groupId === l) {
        const d = u.channels || "", h = parseFloat(d);
        G(h) && h > 2 && a.push.apply(a, n.split(",").map((m) => ({
          type: "media-source",
          audio: {
            contentType: is(m, "audio"),
            channels: "" + h
            // spatialRendering:
            //   audioCodec === 'ec-3' && channels.indexOf('JOC'),
          }
        })));
      }
    }));
  }), Promise.all(a.map((l) => {
    const c = um(l);
    return Dr[c] || (Dr[c] = t.decodingInfo(l));
  })).then((l) => ({
    supported: !l.some((c) => !c.supported),
    configurations: a,
    decodingInfoResults: l
  })).catch((l) => ({
    supported: !1,
    configurations: a,
    decodingInfoResults: [],
    error: l
  }));
}
function um(i) {
  const {
    audio: e,
    video: t
  } = i, s = t || e;
  if (s) {
    const n = s.contentType.split('"')[1];
    if (t)
      return `r${t.height}x${t.width}f${Math.ceil(t.framerate)}${t.transferFunction || "sd"}_${n}_${Math.ceil(t.bitrate / 1e5)}`;
    if (e)
      return `c${e.channels}${e.spatialRendering ? "s" : "n"}_${n}`;
  }
  return "";
}
function dm() {
  if (typeof matchMedia == "function") {
    const i = matchMedia("(dynamic-range: high)"), e = matchMedia("bad query");
    if (i.media !== e.media)
      return i.matches === !0;
  }
  return !1;
}
function hm(i, e) {
  let t = !1, s = [];
  return i && (t = i !== "SDR", s = [i]), e && (s = e.allowedVideoRanges || Ws.slice(0), t = e.preferHDR !== void 0 ? e.preferHDR : dm(), t ? s = s.filter((n) => n !== "SDR") : s = ["SDR"]), {
    preferHDR: t,
    allowedVideoRanges: s
  };
}
function fm(i, e, t, s, n) {
  const r = Object.keys(i), o = s == null ? void 0 : s.channels, a = s == null ? void 0 : s.audioCodec, l = o && parseInt(o) === 2;
  let c = !0, u = !1, d = 1 / 0, h = 1 / 0, m = 1 / 0, f = 0, g = [];
  const {
    preferHDR: p,
    allowedVideoRanges: E
  } = hm(e, n);
  for (let x = r.length; x--; ) {
    const R = i[r[x]];
    c = R.channels[2] > 0, d = Math.min(d, R.minHeight), h = Math.min(h, R.minFramerate), m = Math.min(m, R.minBitrate);
    const L = E.filter((_) => R.videoRanges[_] > 0);
    L.length > 0 && (u = !0, g = L);
  }
  d = G(d) ? d : 0, h = G(h) ? h : 0;
  const y = Math.max(1080, d), v = Math.max(30, h);
  return m = G(m) ? m : t, t = Math.max(m, t), u || (e = void 0, g = []), {
    codecSet: r.reduce((x, R) => {
      const L = i[R];
      if (R === x)
        return x;
      if (L.minBitrate > t)
        return lt(R, `min bitrate of ${L.minBitrate} > current estimate of ${t}`), x;
      if (!L.hasDefaultAudio)
        return lt(R, "no renditions with default or auto-select sound found"), x;
      if (a && R.indexOf(a.substring(0, 4)) % 5 !== 0)
        return lt(R, `audio codec preference "${a}" not found`), x;
      if (o && !l) {
        if (!L.channels[o])
          return lt(R, `no renditions with ${o} channel sound found (channels options: ${Object.keys(L.channels)})`), x;
      } else if ((!a || l) && c && L.channels[2] === 0)
        return lt(R, "no renditions with stereo sound found"), x;
      return L.minHeight > y ? (lt(R, `min resolution of ${L.minHeight} > maximum of ${y}`), x) : L.minFramerate > v ? (lt(R, `min framerate of ${L.minFramerate} > maximum of ${v}`), x) : g.some((_) => L.videoRanges[_] > 0) ? L.maxScore < f ? (lt(R, `max score of ${L.maxScore} < selected max of ${f}`), x) : x && (Ks(R) >= Ks(x) || L.fragmentError > i[x].fragmentError) ? x : (f = L.maxScore, R) : (lt(R, `no variants with VIDEO-RANGE of ${JSON.stringify(g)} found`), x);
    }, void 0),
    videoRanges: g,
    preferHDR: p,
    minFramerate: h,
    minBitrate: m
  };
}
function lt(i, e) {
  D.log(`[abr] start candidates with "${i}" ignored because ${e}`);
}
function mm(i) {
  return i.reduce((e, t) => {
    let s = e.groups[t.groupId];
    s || (s = e.groups[t.groupId] = {
      tracks: [],
      channels: {
        2: 0
      },
      hasDefault: !1,
      hasAutoSelect: !1
    }), s.tracks.push(t);
    const n = t.channels || "2";
    return s.channels[n] = (s.channels[n] || 0) + 1, s.hasDefault = s.hasDefault || t.default, s.hasAutoSelect = s.hasAutoSelect || t.autoselect, s.hasDefault && (e.hasDefaultAudio = !0), s.hasAutoSelect && (e.hasAutoSelectAudio = !0), e;
  }, {
    hasDefaultAudio: !1,
    hasAutoSelectAudio: !1,
    groups: {}
  });
}
function gm(i, e, t, s) {
  return i.slice(t, s + 1).reduce((n, r) => {
    if (!r.codecSet)
      return n;
    const o = r.audioGroups;
    let a = n[r.codecSet];
    a || (n[r.codecSet] = a = {
      minBitrate: 1 / 0,
      minHeight: 1 / 0,
      minFramerate: 1 / 0,
      maxScore: 0,
      videoRanges: {
        SDR: 0
      },
      channels: {
        2: 0
      },
      hasDefaultAudio: !o,
      fragmentError: 0
    }), a.minBitrate = Math.min(a.minBitrate, r.bitrate);
    const l = Math.min(r.height, r.width);
    return a.minHeight = Math.min(a.minHeight, l), a.minFramerate = Math.min(a.minFramerate, r.frameRate), a.maxScore = Math.max(a.maxScore, r.score), a.fragmentError += r.fragmentError, a.videoRanges[r.videoRange] = (a.videoRanges[r.videoRange] || 0) + 1, o && o.forEach((c) => {
      if (!c)
        return;
      const u = e.groups[c];
      u && (a.hasDefaultAudio = a.hasDefaultAudio || e.hasDefaultAudio ? u.hasDefault : u.hasAutoSelect || !e.hasDefaultAudio && !e.hasAutoSelectAudio, Object.keys(u.channels).forEach((d) => {
        a.channels[d] = (a.channels[d] || 0) + u.channels[d];
      }));
    }), n;
  }, {});
}
function Qe(i, e, t) {
  if ("attrs" in i) {
    const s = e.indexOf(i);
    if (s !== -1)
      return s;
  }
  for (let s = 0; s < e.length; s++) {
    const n = e[s];
    if (Ut(i, n, t))
      return s;
  }
  return -1;
}
function Ut(i, e, t) {
  const {
    groupId: s,
    name: n,
    lang: r,
    assocLang: o,
    characteristics: a,
    default: l
  } = i, c = i.forced;
  return (s === void 0 || e.groupId === s) && (n === void 0 || e.name === n) && (r === void 0 || e.lang === r) && (r === void 0 || e.assocLang === o) && (l === void 0 || e.default === l) && (c === void 0 || e.forced === c) && (a === void 0 || pm(a, e.characteristics)) && (t === void 0 || t(i, e));
}
function pm(i, e = "") {
  const t = i.split(","), s = e.split(",");
  return t.length === s.length && !t.some((n) => s.indexOf(n) === -1);
}
function Mt(i, e) {
  const {
    audioCodec: t,
    channels: s
  } = i;
  return (t === void 0 || (e.audioCodec || "").substring(0, 4) === t.substring(0, 4)) && (s === void 0 || s === (e.channels || "2"));
}
function Tm(i, e, t, s, n) {
  const r = e[s], a = e.reduce((h, m, f) => {
    const g = m.uri;
    return (h[g] || (h[g] = [])).push(f), h;
  }, {})[r.uri];
  a.length > 1 && (s = Math.max.apply(Math, a));
  const l = r.videoRange, c = r.frameRate, u = r.codecSet.substring(0, 4), d = Ir(e, s, (h) => {
    if (h.videoRange !== l || h.frameRate !== c || h.codecSet.substring(0, 4) !== u)
      return !1;
    const m = h.audioGroups, f = t.filter((g) => !m || m.indexOf(g.groupId) !== -1);
    return Qe(i, f, n) > -1;
  });
  return d > -1 ? d : Ir(e, s, (h) => {
    const m = h.audioGroups, f = t.filter((g) => !m || m.indexOf(g.groupId) !== -1);
    return Qe(i, f, n) > -1;
  });
}
function Ir(i, e, t) {
  for (let s = e; s; s--)
    if (t(i[s]))
      return s;
  for (let s = e + 1; s < i.length; s++)
    if (t(i[s]))
      return s;
  return -1;
}
class Em {
  constructor(e) {
    this.hls = void 0, this.lastLevelLoadSec = 0, this.lastLoadedFragLevel = -1, this.firstSelection = -1, this._nextAutoLevel = -1, this.nextAutoLevelKey = "", this.audioTracksByGroup = null, this.codecTiers = null, this.timer = -1, this.fragCurrent = null, this.partCurrent = null, this.bitrateTestDelay = 0, this.bwEstimator = void 0, this._abandonRulesCheck = () => {
      const {
        fragCurrent: t,
        partCurrent: s,
        hls: n
      } = this, {
        autoLevelEnabled: r,
        media: o
      } = n;
      if (!t || !o)
        return;
      const a = performance.now(), l = s ? s.stats : t.stats, c = s ? s.duration : t.duration, u = a - l.loading.start, d = n.minAutoLevel;
      if (l.aborted || l.loaded && l.loaded === l.total || t.level <= d) {
        this.clearTimer(), this._nextAutoLevel = -1;
        return;
      }
      if (!r || o.paused || !o.playbackRate || !o.readyState)
        return;
      const h = n.mainForwardBufferInfo;
      if (h === null)
        return;
      const m = this.bwEstimator.getEstimateTTFB(), f = Math.abs(o.playbackRate);
      if (u <= Math.max(m, 1e3 * (c / (f * 2))))
        return;
      const g = h.len / f, p = l.loading.first ? l.loading.first - l.loading.start : -1, E = l.loaded && p > -1, y = this.getBwEstimate(), v = n.levels, S = v[t.level], x = l.total || Math.max(l.loaded, Math.round(c * S.averageBitrate / 8));
      let R = E ? u - p : u;
      R < 1 && E && (R = Math.min(u, l.loaded * 8 / y));
      const L = E ? l.loaded * 1e3 / R : 0, _ = L ? (x - l.loaded) / L : x * 8 / y + m / 1e3;
      if (_ <= g)
        return;
      const A = L ? L * 8 : y;
      let I = Number.POSITIVE_INFINITY, w;
      for (w = t.level - 1; w > d; w--) {
        const M = v[w].maxBitrate;
        if (I = this.getTimeToLoadFrag(m / 1e3, A, c * M, !v[w].details), I < g)
          break;
      }
      if (I >= _ || I > c * 10)
        return;
      n.nextLoadLevel = n.nextAutoLevel = w, E ? this.bwEstimator.sample(u - Math.min(m, p), l.loaded) : this.bwEstimator.sampleTTFB(u);
      const $ = v[w].maxBitrate;
      this.getBwEstimate() * this.hls.config.abrBandWidthUpFactor > $ && this.resetEstimator($), this.clearTimer(), D.warn(`[abr] Fragment ${t.sn}${s ? " part " + s.index : ""} of level ${t.level} is loading too slowly;
      Time to underbuffer: ${g.toFixed(3)} s
      Estimated load time for current fragment: ${_.toFixed(3)} s
      Estimated load time for down switch fragment: ${I.toFixed(3)} s
      TTFB estimate: ${p | 0} ms
      Current BW estimate: ${G(y) ? y | 0 : "Unknown"} bps
      New BW estimate: ${this.getBwEstimate() | 0} bps
      Switching to level ${w} @ ${$ | 0} bps`), n.trigger(T.FRAG_LOAD_EMERGENCY_ABORTED, {
        frag: t,
        part: s,
        stats: l
      });
    }, this.hls = e, this.bwEstimator = this.initEstimator(), this.registerListeners();
  }
  resetEstimator(e) {
    e && (D.log(`setting initial bwe to ${e}`), this.hls.config.abrEwmaDefaultEstimate = e), this.firstSelection = -1, this.bwEstimator = this.initEstimator();
  }
  initEstimator() {
    const e = this.hls.config;
    return new am(e.abrEwmaSlowVoD, e.abrEwmaFastVoD, e.abrEwmaDefaultEstimate);
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.FRAG_LOADING, this.onFragLoading, this), e.on(T.FRAG_LOADED, this.onFragLoaded, this), e.on(T.FRAG_BUFFERED, this.onFragBuffered, this), e.on(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(T.LEVEL_LOADED, this.onLevelLoaded, this), e.on(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(T.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this), e.on(T.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.FRAG_LOADING, this.onFragLoading, this), e.off(T.FRAG_LOADED, this.onFragLoaded, this), e.off(T.FRAG_BUFFERED, this.onFragBuffered, this), e.off(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(T.LEVEL_LOADED, this.onLevelLoaded, this), e.off(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(T.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this), e.off(T.ERROR, this.onError, this));
  }
  destroy() {
    this.unregisterListeners(), this.clearTimer(), this.hls = this._abandonRulesCheck = null, this.fragCurrent = this.partCurrent = null;
  }
  onManifestLoading(e, t) {
    this.lastLoadedFragLevel = -1, this.firstSelection = -1, this.lastLevelLoadSec = 0, this.fragCurrent = this.partCurrent = null, this.onLevelsUpdated(), this.clearTimer();
  }
  onLevelsUpdated() {
    this.lastLoadedFragLevel > -1 && this.fragCurrent && (this.lastLoadedFragLevel = this.fragCurrent.level), this._nextAutoLevel = -1, this.onMaxAutoLevelUpdated(), this.codecTiers = null, this.audioTracksByGroup = null;
  }
  onMaxAutoLevelUpdated() {
    this.firstSelection = -1, this.nextAutoLevelKey = "";
  }
  onFragLoading(e, t) {
    const s = t.frag;
    if (!this.ignoreFragment(s)) {
      if (!s.bitrateTest) {
        var n;
        this.fragCurrent = s, this.partCurrent = (n = t.part) != null ? n : null;
      }
      this.clearTimer(), this.timer = self.setInterval(this._abandonRulesCheck, 100);
    }
  }
  onLevelSwitching(e, t) {
    this.clearTimer();
  }
  onError(e, t) {
    if (!t.fatal)
      switch (t.details) {
        case C.BUFFER_ADD_CODEC_ERROR:
        case C.BUFFER_APPEND_ERROR:
          this.lastLoadedFragLevel = -1, this.firstSelection = -1;
          break;
        case C.FRAG_LOAD_TIMEOUT: {
          const s = t.frag, {
            fragCurrent: n,
            partCurrent: r
          } = this;
          if (s && n && s.sn === n.sn && s.level === n.level) {
            const o = performance.now(), a = r ? r.stats : s.stats, l = o - a.loading.start, c = a.loading.first ? a.loading.first - a.loading.start : -1;
            if (a.loaded && c > -1) {
              const d = this.bwEstimator.getEstimateTTFB();
              this.bwEstimator.sample(l - Math.min(d, c), a.loaded);
            } else
              this.bwEstimator.sampleTTFB(l);
          }
          break;
        }
      }
  }
  getTimeToLoadFrag(e, t, s, n) {
    const r = e + s / t, o = n ? this.lastLevelLoadSec : 0;
    return r + o;
  }
  onLevelLoaded(e, t) {
    const s = this.hls.config, {
      loading: n
    } = t.stats, r = n.end - n.start;
    G(r) && (this.lastLevelLoadSec = r / 1e3), t.details.live ? this.bwEstimator.update(s.abrEwmaSlowLive, s.abrEwmaFastLive) : this.bwEstimator.update(s.abrEwmaSlowVoD, s.abrEwmaFastVoD);
  }
  onFragLoaded(e, {
    frag: t,
    part: s
  }) {
    const n = s ? s.stats : t.stats;
    if (t.type === Q.MAIN && this.bwEstimator.sampleTTFB(n.loading.first - n.loading.start), !this.ignoreFragment(t)) {
      if (this.clearTimer(), t.level === this._nextAutoLevel && (this._nextAutoLevel = -1), this.firstSelection = -1, this.hls.config.abrMaxWithRealBitrate) {
        const r = s ? s.duration : t.duration, o = this.hls.levels[t.level], a = (o.loaded ? o.loaded.bytes : 0) + n.loaded, l = (o.loaded ? o.loaded.duration : 0) + r;
        o.loaded = {
          bytes: a,
          duration: l
        }, o.realBitrate = Math.round(8 * a / l);
      }
      if (t.bitrateTest) {
        const r = {
          stats: n,
          frag: t,
          part: s,
          id: t.type
        };
        this.onFragBuffered(T.FRAG_BUFFERED, r), t.bitrateTest = !1;
      } else
        this.lastLoadedFragLevel = t.level;
    }
  }
  onFragBuffered(e, t) {
    const {
      frag: s,
      part: n
    } = t, r = n != null && n.stats.loaded ? n.stats : s.stats;
    if (r.aborted || this.ignoreFragment(s))
      return;
    const o = r.parsing.end - r.loading.start - Math.min(r.loading.first - r.loading.start, this.bwEstimator.getEstimateTTFB());
    this.bwEstimator.sample(o, r.loaded), r.bwEstimate = this.getBwEstimate(), s.bitrateTest ? this.bitrateTestDelay = o / 1e3 : this.bitrateTestDelay = 0;
  }
  ignoreFragment(e) {
    return e.type !== Q.MAIN || e.sn === "initSegment";
  }
  clearTimer() {
    this.timer > -1 && (self.clearInterval(this.timer), this.timer = -1);
  }
  get firstAutoLevel() {
    const {
      maxAutoLevel: e,
      minAutoLevel: t
    } = this.hls, s = this.getBwEstimate(), n = this.hls.config.maxStarvationDelay, r = this.findBestLevel(s, t, e, 0, n, 1, 1);
    if (r > -1)
      return r;
    const o = this.hls.firstLevel, a = Math.min(Math.max(o, t), e);
    return D.warn(`[abr] Could not find best starting auto level. Defaulting to first in playlist ${o} clamped to ${a}`), a;
  }
  get forcedAutoLevel() {
    return this.nextAutoLevelKey ? -1 : this._nextAutoLevel;
  }
  // return next auto level
  get nextAutoLevel() {
    const e = this.forcedAutoLevel, s = this.bwEstimator.canEstimate(), n = this.lastLoadedFragLevel > -1;
    if (e !== -1 && (!s || !n || this.nextAutoLevelKey === this.getAutoLevelKey()))
      return e;
    const r = s && n ? this.getNextABRAutoLevel() : this.firstAutoLevel;
    if (e !== -1) {
      const o = this.hls.levels;
      if (o.length > Math.max(e, r) && o[e].loadError <= o[r].loadError)
        return e;
    }
    return this._nextAutoLevel = r, this.nextAutoLevelKey = this.getAutoLevelKey(), r;
  }
  getAutoLevelKey() {
    return `${this.getBwEstimate()}_${this.getStarvationDelay().toFixed(2)}`;
  }
  getNextABRAutoLevel() {
    const {
      fragCurrent: e,
      partCurrent: t,
      hls: s
    } = this, {
      maxAutoLevel: n,
      config: r,
      minAutoLevel: o
    } = s, a = t ? t.duration : e ? e.duration : 0, l = this.getBwEstimate(), c = this.getStarvationDelay();
    let u = r.abrBandWidthFactor, d = r.abrBandWidthUpFactor;
    if (c) {
      const p = this.findBestLevel(l, o, n, c, 0, u, d);
      if (p >= 0)
        return p;
    }
    let h = a ? Math.min(a, r.maxStarvationDelay) : r.maxStarvationDelay;
    if (!c) {
      const p = this.bitrateTestDelay;
      p && (h = (a ? Math.min(a, r.maxLoadingDelay) : r.maxLoadingDelay) - p, D.info(`[abr] bitrate test took ${Math.round(1e3 * p)}ms, set first fragment max fetchDuration to ${Math.round(1e3 * h)} ms`), u = d = 1);
    }
    const m = this.findBestLevel(l, o, n, c, h, u, d);
    if (D.info(`[abr] ${c ? "rebuffering expected" : "buffer is empty"}, optimal quality level ${m}`), m > -1)
      return m;
    const f = s.levels[o], g = s.levels[s.loadLevel];
    return (f == null ? void 0 : f.bitrate) < (g == null ? void 0 : g.bitrate) ? o : s.loadLevel;
  }
  getStarvationDelay() {
    const e = this.hls, t = e.media;
    if (!t)
      return 1 / 0;
    const s = t && t.playbackRate !== 0 ? Math.abs(t.playbackRate) : 1, n = e.mainForwardBufferInfo;
    return (n ? n.len : 0) / s;
  }
  getBwEstimate() {
    return this.bwEstimator.canEstimate() ? this.bwEstimator.getEstimate() : this.hls.config.abrEwmaDefaultEstimate;
  }
  findBestLevel(e, t, s, n, r, o, a) {
    var l;
    const c = n + r, u = this.lastLoadedFragLevel, d = u === -1 ? this.hls.firstLevel : u, {
      fragCurrent: h,
      partCurrent: m
    } = this, {
      levels: f,
      allAudioTracks: g,
      loadLevel: p,
      config: E
    } = this.hls;
    if (f.length === 1)
      return 0;
    const y = f[d], v = !!(y != null && (l = y.details) != null && l.live), S = p === -1 || u === -1;
    let x, R = "SDR", L = (y == null ? void 0 : y.frameRate) || 0;
    const {
      audioPreference: _,
      videoPreference: A
    } = E, I = this.audioTracksByGroup || (this.audioTracksByGroup = mm(g));
    if (S) {
      if (this.firstSelection !== -1)
        return this.firstSelection;
      const N = this.codecTiers || (this.codecTiers = gm(f, I, t, s)), H = fm(N, R, e, _, A), {
        codecSet: q,
        videoRanges: B,
        minFramerate: O,
        minBitrate: P,
        preferHDR: W
      } = H;
      x = q, R = W ? B[B.length - 1] : B[0], L = O, e = Math.max(e, P), D.log(`[abr] picked start tier ${JSON.stringify(H)}`);
    } else
      x = y == null ? void 0 : y.codecSet, R = y == null ? void 0 : y.videoRange;
    const w = m ? m.duration : h ? h.duration : 0, $ = this.bwEstimator.getEstimateTTFB() / 1e3, M = [];
    for (let N = s; N >= t; N--) {
      var U;
      const H = f[N], q = N > d;
      if (!H)
        continue;
      if (E.useMediaCapabilities && !H.supportedResult && !H.supportedPromise) {
        const j = navigator.mediaCapabilities;
        typeof (j == null ? void 0 : j.decodingInfo) == "function" && lm(H, I, R, L, e, _) ? (H.supportedPromise = cm(H, I, j), H.supportedPromise.then((z) => {
          if (!this.hls)
            return;
          H.supportedResult = z;
          const ne = this.hls.levels, he = ne.indexOf(H);
          z.error ? D.warn(`[abr] MediaCapabilities decodingInfo error: "${z.error}" for level ${he} ${JSON.stringify(z)}`) : z.supported || (D.warn(`[abr] Unsupported MediaCapabilities decodingInfo result for level ${he} ${JSON.stringify(z)}`), he > -1 && ne.length > 1 && (D.log(`[abr] Removing unsupported level ${he}`), this.hls.removeLevel(he)));
        })) : H.supportedResult = zo;
      }
      if (x && H.codecSet !== x || R && H.videoRange !== R || q && L > H.frameRate || !q && L > 0 && L < H.frameRate || H.supportedResult && !((U = H.supportedResult.decodingInfoResults) != null && U[0].smooth)) {
        M.push(N);
        continue;
      }
      const B = H.details, O = (m ? B == null ? void 0 : B.partTarget : B == null ? void 0 : B.averagetargetduration) || w;
      let P;
      q ? P = a * e : P = o * e;
      const W = w && n >= w * 2 && r === 0 ? f[N].averageBitrate : f[N].maxBitrate, K = this.getTimeToLoadFrag($, P, W * O, B === void 0);
      if (
        // if adjusted bw is greater than level bitrate AND
        P >= W && // no level change, or new level has no error history
        (N === u || H.loadError === 0 && H.fragmentError === 0) && // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
        // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
        // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
        (K <= $ || !G(K) || v && !this.bitrateTestDelay || K < c)
      ) {
        const j = this.forcedAutoLevel;
        return N !== p && (j === -1 || j !== p) && (M.length && D.trace(`[abr] Skipped level(s) ${M.join(",")} of ${s} max with CODECS and VIDEO-RANGE:"${f[M[0]].codecs}" ${f[M[0]].videoRange}; not compatible with "${y.codecs}" ${R}`), D.info(`[abr] switch candidate:${d}->${N} adjustedbw(${Math.round(P)})-bitrate=${Math.round(P - W)} ttfb:${$.toFixed(1)} avgDuration:${O.toFixed(1)} maxFetchDuration:${c.toFixed(1)} fetchDuration:${K.toFixed(1)} firstSelection:${S} codecSet:${x} videoRange:${R} hls.loadLevel:${p}`)), S && (this.firstSelection = N), N;
      }
    }
    return -1;
  }
  set nextAutoLevel(e) {
    const {
      maxAutoLevel: t,
      minAutoLevel: s
    } = this.hls, n = Math.min(Math.max(e, s), t);
    this._nextAutoLevel !== n && (this.nextAutoLevelKey = "", this._nextAutoLevel = n);
  }
}
class ym {
  constructor() {
    this._boundTick = void 0, this._tickTimer = null, this._tickInterval = null, this._tickCallCount = 0, this._boundTick = this.tick.bind(this);
  }
  destroy() {
    this.onHandlerDestroying(), this.onHandlerDestroyed();
  }
  onHandlerDestroying() {
    this.clearNextTick(), this.clearInterval();
  }
  onHandlerDestroyed() {
  }
  hasInterval() {
    return !!this._tickInterval;
  }
  hasNextTick() {
    return !!this._tickTimer;
  }
  /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */
  setInterval(e) {
    return this._tickInterval ? !1 : (this._tickCallCount = 0, this._tickInterval = self.setInterval(this._boundTick, e), !0);
  }
  /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */
  clearInterval() {
    return this._tickInterval ? (self.clearInterval(this._tickInterval), this._tickInterval = null, !0) : !1;
  }
  /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */
  clearNextTick() {
    return this._tickTimer ? (self.clearTimeout(this._tickTimer), this._tickTimer = null, !0) : !1;
  }
  /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */
  tick() {
    this._tickCallCount++, this._tickCallCount === 1 && (this.doTick(), this._tickCallCount > 1 && this.tickImmediate(), this._tickCallCount = 0);
  }
  tickImmediate() {
    this.clearNextTick(), this._tickTimer = self.setTimeout(this._boundTick, 0);
  }
  /**
   * For subclass to implement task logic
   * @abstract
   */
  doTick() {
  }
}
var Le = {
  NOT_LOADED: "NOT_LOADED",
  APPENDING: "APPENDING",
  PARTIAL: "PARTIAL",
  OK: "OK"
};
class xm {
  constructor(e) {
    this.activePartLists = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.fragments = /* @__PURE__ */ Object.create(null), this.timeRanges = /* @__PURE__ */ Object.create(null), this.bufferPadding = 0.2, this.hls = void 0, this.hasGaps = !1, this.hls = e, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.BUFFER_APPENDED, this.onBufferAppended, this), e.on(T.FRAG_BUFFERED, this.onFragBuffered, this), e.on(T.FRAG_LOADED, this.onFragLoaded, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.BUFFER_APPENDED, this.onBufferAppended, this), e.off(T.FRAG_BUFFERED, this.onFragBuffered, this), e.off(T.FRAG_LOADED, this.onFragLoaded, this);
  }
  destroy() {
    this._unregisterListeners(), this.fragments = // @ts-ignore
    this.activePartLists = // @ts-ignore
    this.endListFragments = this.timeRanges = null;
  }
  /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */
  getAppendedFrag(e, t) {
    const s = this.activePartLists[t];
    if (s)
      for (let n = s.length; n--; ) {
        const r = s[n];
        if (!r)
          break;
        const o = r.end;
        if (r.start <= e && o !== null && e <= o)
          return r;
      }
    return this.getBufferedFrag(e, t);
  }
  /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */
  getBufferedFrag(e, t) {
    const {
      fragments: s
    } = this, n = Object.keys(s);
    for (let r = n.length; r--; ) {
      const o = s[n[r]];
      if ((o == null ? void 0 : o.body.type) === t && o.buffered) {
        const a = o.body;
        if (a.start <= e && e <= a.end)
          return a;
      }
    }
    return null;
  }
  /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */
  detectEvictedFragments(e, t, s, n) {
    this.timeRanges && (this.timeRanges[e] = t);
    const r = (n == null ? void 0 : n.fragment.sn) || -1;
    Object.keys(this.fragments).forEach((o) => {
      const a = this.fragments[o];
      if (!a || r >= a.body.sn)
        return;
      if (!a.buffered && !a.loaded) {
        a.body.type === s && this.removeFragment(a.body);
        return;
      }
      const l = a.range[e];
      l && l.time.some((c) => {
        const u = !this.isTimeBuffered(c.startPTS, c.endPTS, t);
        return u && this.removeFragment(a.body), u;
      });
    });
  }
  /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */
  detectPartialFragments(e) {
    const t = this.timeRanges, {
      frag: s,
      part: n
    } = e;
    if (!t || s.sn === "initSegment")
      return;
    const r = kt(s), o = this.fragments[r];
    if (!o || o.buffered && s.gap)
      return;
    const a = !s.relurl;
    Object.keys(t).forEach((l) => {
      const c = s.elementaryStreams[l];
      if (!c)
        return;
      const u = t[l], d = a || c.partial === !0;
      o.range[l] = this.getBufferedTimes(s, n, d, u);
    }), o.loaded = null, Object.keys(o.range).length ? (o.buffered = !0, (o.body.endList = s.endList || o.body.endList) && (this.endListFragments[o.body.type] = o), xs(o) || this.removeParts(s.sn - 1, s.type)) : this.removeFragment(o.body);
  }
  removeParts(e, t) {
    const s = this.activePartLists[t];
    s && (this.activePartLists[t] = s.filter((n) => n.fragment.sn >= e));
  }
  fragBuffered(e, t) {
    const s = kt(e);
    let n = this.fragments[s];
    !n && t && (n = this.fragments[s] = {
      body: e,
      appendedPTS: null,
      loaded: null,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    }, e.gap && (this.hasGaps = !0)), n && (n.loaded = null, n.buffered = !0);
  }
  getBufferedTimes(e, t, s, n) {
    const r = {
      time: [],
      partial: s
    }, o = e.start, a = e.end, l = e.minEndPTS || a, c = e.maxStartPTS || o;
    for (let u = 0; u < n.length; u++) {
      const d = n.start(u) - this.bufferPadding, h = n.end(u) + this.bufferPadding;
      if (c >= d && l <= h) {
        r.time.push({
          startPTS: Math.max(o, n.start(u)),
          endPTS: Math.min(a, n.end(u))
        });
        break;
      } else if (o < h && a > d) {
        const m = Math.max(o, n.start(u)), f = Math.min(a, n.end(u));
        f > m && (r.partial = !0, r.time.push({
          startPTS: m,
          endPTS: f
        }));
      } else if (a <= d)
        break;
    }
    return r;
  }
  /**
   * Gets the partial fragment for a certain time
   */
  getPartialFragment(e) {
    let t = null, s, n, r, o = 0;
    const {
      bufferPadding: a,
      fragments: l
    } = this;
    return Object.keys(l).forEach((c) => {
      const u = l[c];
      u && xs(u) && (n = u.body.start - a, r = u.body.end + a, e >= n && e <= r && (s = Math.min(e - n, r - e), o <= s && (t = u.body, o = s)));
    }), t;
  }
  isEndListAppended(e) {
    const t = this.endListFragments[e];
    return t !== void 0 && (t.buffered || xs(t));
  }
  getState(e) {
    const t = kt(e), s = this.fragments[t];
    return s ? s.buffered ? xs(s) ? Le.PARTIAL : Le.OK : Le.APPENDING : Le.NOT_LOADED;
  }
  isTimeBuffered(e, t, s) {
    let n, r;
    for (let o = 0; o < s.length; o++) {
      if (n = s.start(o) - this.bufferPadding, r = s.end(o) + this.bufferPadding, e >= n && t <= r)
        return !0;
      if (t <= n)
        return !1;
    }
    return !1;
  }
  onFragLoaded(e, t) {
    const {
      frag: s,
      part: n
    } = t;
    if (s.sn === "initSegment" || s.bitrateTest)
      return;
    const r = n ? null : t, o = kt(s);
    this.fragments[o] = {
      body: s,
      appendedPTS: null,
      loaded: r,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    };
  }
  onBufferAppended(e, t) {
    const {
      frag: s,
      part: n,
      timeRanges: r
    } = t;
    if (s.sn === "initSegment")
      return;
    const o = s.type;
    if (n) {
      let a = this.activePartLists[o];
      a || (this.activePartLists[o] = a = []), a.push(n);
    }
    this.timeRanges = r, Object.keys(r).forEach((a) => {
      const l = r[a];
      this.detectEvictedFragments(a, l, o, n);
    });
  }
  onFragBuffered(e, t) {
    this.detectPartialFragments(t);
  }
  hasFragment(e) {
    const t = kt(e);
    return !!this.fragments[t];
  }
  hasParts(e) {
    var t;
    return !!((t = this.activePartLists[e]) != null && t.length);
  }
  removeFragmentsInRange(e, t, s, n, r) {
    n && !this.hasGaps || Object.keys(this.fragments).forEach((o) => {
      const a = this.fragments[o];
      if (!a)
        return;
      const l = a.body;
      l.type !== s || n && !l.gap || l.start < t && l.end > e && (a.buffered || r) && this.removeFragment(l);
    });
  }
  removeFragment(e) {
    const t = kt(e);
    e.stats.loaded = 0, e.clearElementaryStreamInfo();
    const s = this.activePartLists[e.type];
    if (s) {
      const n = e.sn;
      this.activePartLists[e.type] = s.filter((r) => r.fragment.sn !== n);
    }
    delete this.fragments[t], e.endList && delete this.endListFragments[e.type];
  }
  removeAllFragments() {
    this.fragments = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.activePartLists = /* @__PURE__ */ Object.create(null), this.hasGaps = !1;
  }
}
function xs(i) {
  var e, t, s;
  return i.buffered && (i.body.gap || ((e = i.range.video) == null ? void 0 : e.partial) || ((t = i.range.audio) == null ? void 0 : t.partial) || ((s = i.range.audiovideo) == null ? void 0 : s.partial));
}
function kt(i) {
  return `${i.type}_${i.level}_${i.sn}`;
}
const vm = {
  length: 0,
  start: () => 0,
  end: () => 0
};
class de {
  /**
   * Return true if `media`'s buffered include `position`
   */
  static isBuffered(e, t) {
    try {
      if (e) {
        const s = de.getBuffered(e);
        for (let n = 0; n < s.length; n++)
          if (t >= s.start(n) && t <= s.end(n))
            return !0;
      }
    } catch {
    }
    return !1;
  }
  static bufferInfo(e, t, s) {
    try {
      if (e) {
        const n = de.getBuffered(e), r = [];
        let o;
        for (o = 0; o < n.length; o++)
          r.push({
            start: n.start(o),
            end: n.end(o)
          });
        return this.bufferedInfo(r, t, s);
      }
    } catch {
    }
    return {
      len: 0,
      start: t,
      end: t,
      nextStart: void 0
    };
  }
  static bufferedInfo(e, t, s) {
    t = Math.max(0, t), e.sort(function(c, u) {
      const d = c.start - u.start;
      return d || u.end - c.end;
    });
    let n = [];
    if (s)
      for (let c = 0; c < e.length; c++) {
        const u = n.length;
        if (u) {
          const d = n[u - 1].end;
          e[c].start - d < s ? e[c].end > d && (n[u - 1].end = e[c].end) : n.push(e[c]);
        } else
          n.push(e[c]);
      }
    else
      n = e;
    let r = 0, o, a = t, l = t;
    for (let c = 0; c < n.length; c++) {
      const u = n[c].start, d = n[c].end;
      if (t + s >= u && t < d)
        a = u, l = d, r = l - t;
      else if (t + s < u) {
        o = u;
        break;
      }
    }
    return {
      len: r,
      start: a || 0,
      end: l || 0,
      nextStart: o
    };
  }
  /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */
  static getBuffered(e) {
    try {
      return e.buffered;
    } catch (t) {
      return D.log("failed to get media.buffered", t), vm;
    }
  }
}
class ai {
  constructor(e, t, s, n = 0, r = -1, o = !1) {
    this.level = void 0, this.sn = void 0, this.part = void 0, this.id = void 0, this.size = void 0, this.partial = void 0, this.transmuxing = vs(), this.buffering = {
      audio: vs(),
      video: vs(),
      audiovideo: vs()
    }, this.level = e, this.sn = t, this.id = s, this.size = n, this.part = r, this.partial = o;
  }
}
function vs() {
  return {
    start: 0,
    executeStart: 0,
    executeEnd: 0,
    end: 0
  };
}
function ws(i, e) {
  for (let s = 0, n = i.length; s < n; s++) {
    var t;
    if (((t = i[s]) == null ? void 0 : t.cc) === e)
      return i[s];
  }
  return null;
}
function Sm(i, e, t) {
  return !!(e && (t.endCC > t.startCC || i && i.cc < t.startCC));
}
function Am(i, e) {
  const t = i.fragments, s = e.fragments;
  if (!s.length || !t.length) {
    D.log("No fragments to align");
    return;
  }
  const n = ws(t, s[0].cc);
  if (!n || n && !n.startPTS) {
    D.log("No frag in previous level to align on");
    return;
  }
  return n;
}
function br(i, e) {
  if (i) {
    const t = i.start + e;
    i.start = i.startPTS = t, i.endPTS = t + i.duration;
  }
}
function jo(i, e) {
  const t = e.fragments;
  for (let s = 0, n = t.length; s < n; s++)
    br(t[s], i);
  e.fragmentHint && br(e.fragmentHint, i), e.alignedSliding = !0;
}
function Lm(i, e, t) {
  e && (Rm(i, t, e), !t.alignedSliding && e && js(t, e), !t.alignedSliding && e && !t.skippedSegments && Vo(e, t));
}
function Rm(i, e, t) {
  if (Sm(i, t, e)) {
    const s = Am(t, e);
    s && G(s.start) && (D.log(`Adjusting PTS using last level due to CC increase within current level ${e.url}`), jo(s.start, e));
  }
}
function js(i, e) {
  if (!i.hasProgramDateTime || !e.hasProgramDateTime)
    return;
  const t = i.fragments, s = e.fragments;
  if (!t.length || !s.length)
    return;
  let n, r;
  const o = Math.min(e.endCC, i.endCC);
  e.startCC < o && i.startCC < o && (n = ws(s, o), r = ws(t, o)), (!n || !r) && (n = s[Math.floor(s.length / 2)], r = ws(t, n.cc) || t[Math.floor(t.length / 2)]);
  const a = n.programDateTime, l = r.programDateTime;
  if (!a || !l)
    return;
  const c = (l - a) / 1e3 - (r.start - n.start);
  jo(c, i);
}
const _r = Math.pow(2, 17);
class Dm {
  constructor(e) {
    this.config = void 0, this.loader = null, this.partLoadTimeout = -1, this.config = e;
  }
  destroy() {
    this.loader && (this.loader.destroy(), this.loader = null);
  }
  abort() {
    this.loader && this.loader.abort();
  }
  load(e, t) {
    const s = e.url;
    if (!s)
      return Promise.reject(new ut({
        type: Z.NETWORK_ERROR,
        details: C.FRAG_LOAD_ERROR,
        fatal: !1,
        frag: e,
        error: new Error(`Fragment does not have a ${s ? "part list" : "url"}`),
        networkDetails: null
      }));
    this.abort();
    const n = this.config, r = n.fLoader, o = n.loader;
    return new Promise((a, l) => {
      if (this.loader && this.loader.destroy(), e.gap)
        if (e.tagList.some((m) => m[0] === "GAP")) {
          l(wr(e));
          return;
        } else
          e.gap = !1;
      const c = this.loader = e.loader = r ? new r(n) : new o(n), u = Cr(e), d = Rr(n.fragLoadPolicy.default), h = {
        loadPolicy: d,
        timeout: d.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: e.sn === "initSegment" ? 1 / 0 : _r
      };
      e.stats = c.stats, c.load(u, h, {
        onSuccess: (m, f, g, p) => {
          this.resetLoader(e, c);
          let E = m.data;
          g.resetIV && e.decryptdata && (e.decryptdata.iv = new Uint8Array(E.slice(0, 16)), E = E.slice(16)), a({
            frag: e,
            part: null,
            payload: E,
            networkDetails: p
          });
        },
        onError: (m, f, g, p) => {
          this.resetLoader(e, c), l(new ut({
            type: Z.NETWORK_ERROR,
            details: C.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            response: Re({
              url: s,
              data: void 0
            }, m),
            error: new Error(`HTTP Error ${m.code} ${m.text}`),
            networkDetails: g,
            stats: p
          }));
        },
        onAbort: (m, f, g) => {
          this.resetLoader(e, c), l(new ut({
            type: Z.NETWORK_ERROR,
            details: C.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            error: new Error("Aborted"),
            networkDetails: g,
            stats: m
          }));
        },
        onTimeout: (m, f, g) => {
          this.resetLoader(e, c), l(new ut({
            type: Z.NETWORK_ERROR,
            details: C.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            error: new Error(`Timeout after ${h.timeout}ms`),
            networkDetails: g,
            stats: m
          }));
        },
        onProgress: (m, f, g, p) => {
          t && t({
            frag: e,
            part: null,
            payload: g,
            networkDetails: p
          });
        }
      });
    });
  }
  loadPart(e, t, s) {
    this.abort();
    const n = this.config, r = n.fLoader, o = n.loader;
    return new Promise((a, l) => {
      if (this.loader && this.loader.destroy(), e.gap || t.gap) {
        l(wr(e, t));
        return;
      }
      const c = this.loader = e.loader = r ? new r(n) : new o(n), u = Cr(e, t), d = Rr(n.fragLoadPolicy.default), h = {
        loadPolicy: d,
        timeout: d.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: _r
      };
      t.stats = c.stats, c.load(u, h, {
        onSuccess: (m, f, g, p) => {
          this.resetLoader(e, c), this.updateStatsFromPart(e, t);
          const E = {
            frag: e,
            part: t,
            payload: m.data,
            networkDetails: p
          };
          s(E), a(E);
        },
        onError: (m, f, g, p) => {
          this.resetLoader(e, c), l(new ut({
            type: Z.NETWORK_ERROR,
            details: C.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            part: t,
            response: Re({
              url: u.url,
              data: void 0
            }, m),
            error: new Error(`HTTP Error ${m.code} ${m.text}`),
            networkDetails: g,
            stats: p
          }));
        },
        onAbort: (m, f, g) => {
          e.stats.aborted = t.stats.aborted, this.resetLoader(e, c), l(new ut({
            type: Z.NETWORK_ERROR,
            details: C.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            part: t,
            error: new Error("Aborted"),
            networkDetails: g,
            stats: m
          }));
        },
        onTimeout: (m, f, g) => {
          this.resetLoader(e, c), l(new ut({
            type: Z.NETWORK_ERROR,
            details: C.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            part: t,
            error: new Error(`Timeout after ${h.timeout}ms`),
            networkDetails: g,
            stats: m
          }));
        }
      });
    });
  }
  updateStatsFromPart(e, t) {
    const s = e.stats, n = t.stats, r = n.total;
    if (s.loaded += n.loaded, r) {
      const l = Math.round(e.duration / t.duration), c = Math.min(Math.round(s.loaded / r), l), d = (l - c) * Math.round(s.loaded / c);
      s.total = s.loaded + d;
    } else
      s.total = Math.max(s.loaded, s.total);
    const o = s.loading, a = n.loading;
    o.start ? o.first += a.first - a.start : (o.start = a.start, o.first = a.first), o.end = a.end;
  }
  resetLoader(e, t) {
    e.loader = null, this.loader === t && (self.clearTimeout(this.partLoadTimeout), this.loader = null), t.destroy();
  }
}
function Cr(i, e = null) {
  const t = e || i, s = {
    frag: i,
    part: e,
    responseType: "arraybuffer",
    url: t.url,
    headers: {},
    rangeStart: 0,
    rangeEnd: 0
  }, n = t.byteRangeStartOffset, r = t.byteRangeEndOffset;
  if (G(n) && G(r)) {
    var o;
    let a = n, l = r;
    if (i.sn === "initSegment" && ((o = i.decryptdata) == null ? void 0 : o.method) === "AES-128") {
      const c = r - n;
      c % 16 && (l = r + (16 - c % 16)), n !== 0 && (s.resetIV = !0, a = n - 16);
    }
    s.rangeStart = a, s.rangeEnd = l;
  }
  return s;
}
function wr(i, e) {
  const t = new Error(`GAP ${i.gap ? "tag" : "attribute"} found`), s = {
    type: Z.MEDIA_ERROR,
    details: C.FRAG_GAP,
    fatal: !1,
    frag: i,
    error: t,
    networkDetails: null
  };
  return e && (s.part = e), (e || i).stats.aborted = !0, new ut(s);
}
class ut extends Error {
  constructor(e) {
    super(e.error.message), this.data = void 0, this.data = e;
  }
}
class Im {
  constructor(e, t) {
    this.subtle = void 0, this.aesIV = void 0, this.subtle = e, this.aesIV = t;
  }
  decrypt(e, t) {
    return this.subtle.decrypt({
      name: "AES-CBC",
      iv: this.aesIV
    }, t, e);
  }
}
class bm {
  constructor(e, t) {
    this.subtle = void 0, this.key = void 0, this.subtle = e, this.key = t;
  }
  expandKey() {
    return this.subtle.importKey("raw", this.key, {
      name: "AES-CBC"
    }, !1, ["encrypt", "decrypt"]);
  }
}
function _m(i) {
  const e = i.byteLength, t = e && new DataView(i.buffer).getUint8(e - 1);
  return t ? St(i, 0, e - t) : i;
}
class Cm {
  constructor() {
    this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.sBox = new Uint32Array(256), this.invSBox = new Uint32Array(256), this.key = new Uint32Array(0), this.ksRows = 0, this.keySize = 0, this.keySchedule = void 0, this.invKeySchedule = void 0, this.initTable();
  }
  // Using view.getUint32() also swaps the byte order.
  uint8ArrayToUint32Array_(e) {
    const t = new DataView(e), s = new Uint32Array(4);
    for (let n = 0; n < 4; n++)
      s[n] = t.getUint32(n * 4);
    return s;
  }
  initTable() {
    const e = this.sBox, t = this.invSBox, s = this.subMix, n = s[0], r = s[1], o = s[2], a = s[3], l = this.invSubMix, c = l[0], u = l[1], d = l[2], h = l[3], m = new Uint32Array(256);
    let f = 0, g = 0, p = 0;
    for (p = 0; p < 256; p++)
      p < 128 ? m[p] = p << 1 : m[p] = p << 1 ^ 283;
    for (p = 0; p < 256; p++) {
      let E = g ^ g << 1 ^ g << 2 ^ g << 3 ^ g << 4;
      E = E >>> 8 ^ E & 255 ^ 99, e[f] = E, t[E] = f;
      const y = m[f], v = m[y], S = m[v];
      let x = m[E] * 257 ^ E * 16843008;
      n[f] = x << 24 | x >>> 8, r[f] = x << 16 | x >>> 16, o[f] = x << 8 | x >>> 24, a[f] = x, x = S * 16843009 ^ v * 65537 ^ y * 257 ^ f * 16843008, c[E] = x << 24 | x >>> 8, u[E] = x << 16 | x >>> 16, d[E] = x << 8 | x >>> 24, h[E] = x, f ? (f = y ^ m[m[m[S ^ y]]], g ^= m[m[g]]) : f = g = 1;
    }
  }
  expandKey(e) {
    const t = this.uint8ArrayToUint32Array_(e);
    let s = !0, n = 0;
    for (; n < t.length && s; )
      s = t[n] === this.key[n], n++;
    if (s)
      return;
    this.key = t;
    const r = this.keySize = t.length;
    if (r !== 4 && r !== 6 && r !== 8)
      throw new Error("Invalid aes key size=" + r);
    const o = this.ksRows = (r + 6 + 1) * 4;
    let a, l;
    const c = this.keySchedule = new Uint32Array(o), u = this.invKeySchedule = new Uint32Array(o), d = this.sBox, h = this.rcon, m = this.invSubMix, f = m[0], g = m[1], p = m[2], E = m[3];
    let y, v;
    for (a = 0; a < o; a++) {
      if (a < r) {
        y = c[a] = t[a];
        continue;
      }
      v = y, a % r === 0 ? (v = v << 8 | v >>> 24, v = d[v >>> 24] << 24 | d[v >>> 16 & 255] << 16 | d[v >>> 8 & 255] << 8 | d[v & 255], v ^= h[a / r | 0] << 24) : r > 6 && a % r === 4 && (v = d[v >>> 24] << 24 | d[v >>> 16 & 255] << 16 | d[v >>> 8 & 255] << 8 | d[v & 255]), c[a] = y = (c[a - r] ^ v) >>> 0;
    }
    for (l = 0; l < o; l++)
      a = o - l, l & 3 ? v = c[a] : v = c[a - 4], l < 4 || a <= 4 ? u[l] = v : u[l] = f[d[v >>> 24]] ^ g[d[v >>> 16 & 255]] ^ p[d[v >>> 8 & 255]] ^ E[d[v & 255]], u[l] = u[l] >>> 0;
  }
  // Adding this as a method greatly improves performance.
  networkToHostOrderSwap(e) {
    return e << 24 | (e & 65280) << 8 | (e & 16711680) >> 8 | e >>> 24;
  }
  decrypt(e, t, s) {
    const n = this.keySize + 6, r = this.invKeySchedule, o = this.invSBox, a = this.invSubMix, l = a[0], c = a[1], u = a[2], d = a[3], h = this.uint8ArrayToUint32Array_(s);
    let m = h[0], f = h[1], g = h[2], p = h[3];
    const E = new Int32Array(e), y = new Int32Array(E.length);
    let v, S, x, R, L, _, A, I, w, $, M, U, N, H;
    const q = this.networkToHostOrderSwap;
    for (; t < E.length; ) {
      for (w = q(E[t]), $ = q(E[t + 1]), M = q(E[t + 2]), U = q(E[t + 3]), L = w ^ r[0], _ = U ^ r[1], A = M ^ r[2], I = $ ^ r[3], N = 4, H = 1; H < n; H++)
        v = l[L >>> 24] ^ c[_ >> 16 & 255] ^ u[A >> 8 & 255] ^ d[I & 255] ^ r[N], S = l[_ >>> 24] ^ c[A >> 16 & 255] ^ u[I >> 8 & 255] ^ d[L & 255] ^ r[N + 1], x = l[A >>> 24] ^ c[I >> 16 & 255] ^ u[L >> 8 & 255] ^ d[_ & 255] ^ r[N + 2], R = l[I >>> 24] ^ c[L >> 16 & 255] ^ u[_ >> 8 & 255] ^ d[A & 255] ^ r[N + 3], L = v, _ = S, A = x, I = R, N = N + 4;
      v = o[L >>> 24] << 24 ^ o[_ >> 16 & 255] << 16 ^ o[A >> 8 & 255] << 8 ^ o[I & 255] ^ r[N], S = o[_ >>> 24] << 24 ^ o[A >> 16 & 255] << 16 ^ o[I >> 8 & 255] << 8 ^ o[L & 255] ^ r[N + 1], x = o[A >>> 24] << 24 ^ o[I >> 16 & 255] << 16 ^ o[L >> 8 & 255] << 8 ^ o[_ & 255] ^ r[N + 2], R = o[I >>> 24] << 24 ^ o[L >> 16 & 255] << 16 ^ o[_ >> 8 & 255] << 8 ^ o[A & 255] ^ r[N + 3], y[t] = q(v ^ m), y[t + 1] = q(R ^ f), y[t + 2] = q(x ^ g), y[t + 3] = q(S ^ p), m = w, f = $, g = M, p = U, t = t + 4;
    }
    return y.buffer;
  }
}
const wm = 16;
class li {
  constructor(e, {
    removePKCS7Padding: t = !0
  } = {}) {
    if (this.logEnabled = !0, this.removePKCS7Padding = void 0, this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null, this.useSoftware = void 0, this.useSoftware = e.enableSoftwareAES, this.removePKCS7Padding = t, t)
      try {
        const s = self.crypto;
        s && (this.subtle = s.subtle || s.webkitSubtle);
      } catch {
      }
    this.useSoftware = !this.subtle;
  }
  destroy() {
    this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null;
  }
  isSync() {
    return this.useSoftware;
  }
  flush() {
    const {
      currentResult: e,
      remainderData: t
    } = this;
    if (!e || t)
      return this.reset(), null;
    const s = new Uint8Array(e);
    return this.reset(), this.removePKCS7Padding ? _m(s) : s;
  }
  reset() {
    this.currentResult = null, this.currentIV = null, this.remainderData = null, this.softwareDecrypter && (this.softwareDecrypter = null);
  }
  decrypt(e, t, s) {
    return this.useSoftware ? new Promise((n, r) => {
      this.softwareDecrypt(new Uint8Array(e), t, s);
      const o = this.flush();
      o ? n(o.buffer) : r(new Error("[softwareDecrypt] Failed to decrypt data"));
    }) : this.webCryptoDecrypt(new Uint8Array(e), t, s);
  }
  // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
  // data is handled in the flush() call
  softwareDecrypt(e, t, s) {
    const {
      currentIV: n,
      currentResult: r,
      remainderData: o
    } = this;
    this.logOnce("JS AES decrypt"), o && (e = $e(o, e), this.remainderData = null);
    const a = this.getValidChunk(e);
    if (!a.length)
      return null;
    n && (s = n);
    let l = this.softwareDecrypter;
    l || (l = this.softwareDecrypter = new Cm()), l.expandKey(t);
    const c = r;
    return this.currentResult = l.decrypt(a.buffer, 0, s), this.currentIV = St(a, -16).buffer, c || null;
  }
  webCryptoDecrypt(e, t, s) {
    if (this.key !== t || !this.fastAesKey) {
      if (!this.subtle)
        return Promise.resolve(this.onWebCryptoError(e, t, s));
      this.key = t, this.fastAesKey = new bm(this.subtle, t);
    }
    return this.fastAesKey.expandKey().then((n) => this.subtle ? (this.logOnce("WebCrypto AES decrypt"), new Im(this.subtle, new Uint8Array(s)).decrypt(e.buffer, n)) : Promise.reject(new Error("web crypto not initialized"))).catch((n) => (D.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${n.name}: ${n.message}`), this.onWebCryptoError(e, t, s)));
  }
  onWebCryptoError(e, t, s) {
    this.useSoftware = !0, this.logEnabled = !0, this.softwareDecrypt(e, t, s);
    const n = this.flush();
    if (n)
      return n.buffer;
    throw new Error("WebCrypto and softwareDecrypt: failed to decrypt data");
  }
  getValidChunk(e) {
    let t = e;
    const s = e.length - e.length % wm;
    return s !== e.length && (t = St(e, 0, s), this.remainderData = St(e, s)), t;
  }
  logOnce(e) {
    this.logEnabled && (D.log(`[decrypter]: ${e}`), this.logEnabled = !1);
  }
}
const Mm = {
  toString: function(i) {
    let e = "";
    const t = i.length;
    for (let s = 0; s < t; s++)
      e += `[${i.start(s).toFixed(3)}-${i.end(s).toFixed(3)}]`;
    return e;
  }
}, k = {
  STOPPED: "STOPPED",
  IDLE: "IDLE",
  KEY_LOADING: "KEY_LOADING",
  FRAG_LOADING: "FRAG_LOADING",
  FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
  WAITING_TRACK: "WAITING_TRACK",
  PARSING: "PARSING",
  PARSED: "PARSED",
  ENDED: "ENDED",
  ERROR: "ERROR",
  WAITING_INIT_PTS: "WAITING_INIT_PTS",
  WAITING_LEVEL: "WAITING_LEVEL"
};
class ci extends ym {
  constructor(e, t, s, n, r) {
    super(), this.hls = void 0, this.fragPrevious = null, this.fragCurrent = null, this.fragmentTracker = void 0, this.transmuxer = null, this._state = k.STOPPED, this.playlistType = void 0, this.media = null, this.mediaBuffer = null, this.config = void 0, this.bitrateTest = !1, this.lastCurrentTime = 0, this.nextLoadPosition = 0, this.startPosition = 0, this.startTimeOffset = null, this.loadedmetadata = !1, this.retryDate = 0, this.levels = null, this.fragmentLoader = void 0, this.keyLoader = void 0, this.levelLastLoaded = null, this.startFragRequested = !1, this.decrypter = void 0, this.initPTS = [], this.onvseeking = null, this.onvended = null, this.logPrefix = "", this.log = void 0, this.warn = void 0, this.playlistType = r, this.logPrefix = n, this.log = D.log.bind(D, `${n}:`), this.warn = D.warn.bind(D, `${n}:`), this.hls = e, this.fragmentLoader = new Dm(e.config), this.keyLoader = s, this.fragmentTracker = t, this.config = e.config, this.decrypter = new li(e.config), e.on(T.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  doTick() {
    this.onTickEnd();
  }
  onTickEnd() {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  startLoad(e) {
  }
  stopLoad() {
    this.fragmentLoader.abort(), this.keyLoader.abort(this.playlistType);
    const e = this.fragCurrent;
    e != null && e.loader && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.resetTransmuxer(), this.fragCurrent = null, this.fragPrevious = null, this.clearInterval(), this.clearNextTick(), this.state = k.STOPPED;
  }
  _streamEnded(e, t) {
    if (t.live || e.nextStart || !e.end || !this.media)
      return !1;
    const s = t.partList;
    if (s != null && s.length) {
      const r = s[s.length - 1];
      return de.isBuffered(this.media, r.start + r.duration / 2);
    }
    const n = t.fragments[t.fragments.length - 1].type;
    return this.fragmentTracker.isEndListAppended(n);
  }
  getLevelDetails() {
    if (this.levels && this.levelLastLoaded !== null) {
      var e;
      return (e = this.levelLastLoaded) == null ? void 0 : e.details;
    }
  }
  onMediaAttached(e, t) {
    const s = this.media = this.mediaBuffer = t.media;
    this.onvseeking = this.onMediaSeeking.bind(this), this.onvended = this.onMediaEnded.bind(this), s.addEventListener("seeking", this.onvseeking), s.addEventListener("ended", this.onvended);
    const n = this.config;
    this.levels && n.autoStartLoad && this.state === k.STOPPED && this.startLoad(n.startPosition);
  }
  onMediaDetaching() {
    const e = this.media;
    e != null && e.ended && (this.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0), e && this.onvseeking && this.onvended && (e.removeEventListener("seeking", this.onvseeking), e.removeEventListener("ended", this.onvended), this.onvseeking = this.onvended = null), this.keyLoader && this.keyLoader.detach(), this.media = this.mediaBuffer = null, this.loadedmetadata = !1, this.fragmentTracker.removeAllFragments(), this.stopLoad();
  }
  onMediaSeeking() {
    const {
      config: e,
      fragCurrent: t,
      media: s,
      mediaBuffer: n,
      state: r
    } = this, o = s ? s.currentTime : 0, a = de.bufferInfo(n || s, o, e.maxBufferHole);
    if (this.log(`media seeking to ${G(o) ? o.toFixed(3) : o}, state: ${r}`), this.state === k.ENDED)
      this.resetLoadingState();
    else if (t) {
      const l = e.maxFragLookUpTolerance, c = t.start - l, u = t.start + t.duration + l;
      if (!a.len || u < a.start || c > a.end) {
        const d = o > u;
        (o < c || d) && (d && t.loader && (this.log("seeking outside of buffer while fragment load in progress, cancel fragment load"), t.abortRequests(), this.resetLoadingState()), this.fragPrevious = null);
      }
    }
    s && (this.fragmentTracker.removeFragmentsInRange(o, 1 / 0, this.playlistType, !0), this.lastCurrentTime = o), !this.loadedmetadata && !a.len && (this.nextLoadPosition = this.startPosition = o), this.tickImmediate();
  }
  onMediaEnded() {
    this.startPosition = this.lastCurrentTime = 0;
  }
  onManifestLoaded(e, t) {
    this.startTimeOffset = t.startTimeOffset, this.initPTS = [];
  }
  onHandlerDestroying() {
    this.hls.off(T.MANIFEST_LOADED, this.onManifestLoaded, this), this.stopLoad(), super.onHandlerDestroying(), this.hls = null;
  }
  onHandlerDestroyed() {
    this.state = k.STOPPED, this.fragmentLoader && this.fragmentLoader.destroy(), this.keyLoader && this.keyLoader.destroy(), this.decrypter && this.decrypter.destroy(), this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null, super.onHandlerDestroyed();
  }
  loadFragment(e, t, s) {
    this._loadFragForPlayback(e, t, s);
  }
  _loadFragForPlayback(e, t, s) {
    const n = (r) => {
      if (this.fragContextChanged(e)) {
        this.warn(`Fragment ${e.sn}${r.part ? " p: " + r.part.index : ""} of level ${e.level} was dropped during download.`), this.fragmentTracker.removeFragment(e);
        return;
      }
      e.stats.chunkCount++, this._handleFragmentLoadProgress(r);
    };
    this._doFragLoad(e, t, s, n).then((r) => {
      if (!r)
        return;
      const o = this.state;
      if (this.fragContextChanged(e)) {
        (o === k.FRAG_LOADING || !this.fragCurrent && o === k.PARSING) && (this.fragmentTracker.removeFragment(e), this.state = k.IDLE);
        return;
      }
      "payload" in r && (this.log(`Loaded fragment ${e.sn} of level ${e.level}`), this.hls.trigger(T.FRAG_LOADED, r)), this._handleFragmentLoadComplete(r);
    }).catch((r) => {
      this.state === k.STOPPED || this.state === k.ERROR || (this.warn(`Frag error: ${(r == null ? void 0 : r.message) || r}`), this.resetFragmentLoading(e));
    });
  }
  clearTrackerIfNeeded(e) {
    var t;
    const {
      fragmentTracker: s
    } = this;
    if (s.getState(e) === Le.APPENDING) {
      const r = e.type, o = this.getFwdBufferInfo(this.mediaBuffer, r), a = Math.max(e.duration, o ? o.len : this.config.maxBufferLength), l = this.backtrackFragment;
      ((l ? e.sn - l.sn : 0) === 1 || this.reduceMaxBufferLength(a, e.duration)) && s.removeFragment(e);
    } else ((t = this.mediaBuffer) == null ? void 0 : t.buffered.length) === 0 ? s.removeAllFragments() : s.hasParts(e.type) && (s.detectPartialFragments({
      frag: e,
      part: null,
      stats: e.stats,
      id: e.type
    }), s.getState(e) === Le.PARTIAL && s.removeFragment(e));
  }
  checkLiveUpdate(e) {
    if (e.updated && !e.live) {
      const t = e.fragments[e.fragments.length - 1];
      this.fragmentTracker.detectPartialFragments({
        frag: t,
        part: null,
        stats: t.stats,
        id: t.type
      });
    }
    e.fragments[0] || (e.deltaUpdateFailed = !0);
  }
  flushMainBuffer(e, t, s = null) {
    if (!(e - t))
      return;
    const n = {
      startOffset: e,
      endOffset: t,
      type: s
    };
    this.hls.trigger(T.BUFFER_FLUSHING, n);
  }
  _loadInitSegment(e, t) {
    this._doFragLoad(e, t).then((s) => {
      if (!s || this.fragContextChanged(e) || !this.levels)
        throw new Error("init load aborted");
      return s;
    }).then((s) => {
      const {
        hls: n
      } = this, {
        payload: r
      } = s, o = e.decryptdata;
      if (r && r.byteLength > 0 && o != null && o.key && o.iv && o.method === "AES-128") {
        const a = self.performance.now();
        return this.decrypter.decrypt(new Uint8Array(r), o.key.buffer, o.iv.buffer).catch((l) => {
          throw n.trigger(T.ERROR, {
            type: Z.MEDIA_ERROR,
            details: C.FRAG_DECRYPT_ERROR,
            fatal: !1,
            error: l,
            reason: l.message,
            frag: e
          }), l;
        }).then((l) => {
          const c = self.performance.now();
          return n.trigger(T.FRAG_DECRYPTED, {
            frag: e,
            payload: l,
            stats: {
              tstart: a,
              tdecrypt: c
            }
          }), s.payload = l, this.completeInitSegmentLoad(s);
        });
      }
      return this.completeInitSegmentLoad(s);
    }).catch((s) => {
      this.state === k.STOPPED || this.state === k.ERROR || (this.warn(s), this.resetFragmentLoading(e));
    });
  }
  completeInitSegmentLoad(e) {
    const {
      levels: t
    } = this;
    if (!t)
      throw new Error("init load aborted, missing levels");
    const s = e.frag.stats;
    this.state = k.IDLE, e.frag.data = new Uint8Array(e.payload), s.parsing.start = s.buffering.start = self.performance.now(), s.parsing.end = s.buffering.end = self.performance.now(), this.tick();
  }
  fragContextChanged(e) {
    const {
      fragCurrent: t
    } = this;
    return !e || !t || e.sn !== t.sn || e.level !== t.level;
  }
  fragBufferedComplete(e, t) {
    var s, n, r, o;
    const a = this.mediaBuffer ? this.mediaBuffer : this.media;
    if (this.log(`Buffered ${e.type} sn: ${e.sn}${t ? " part: " + t.index : ""} of ${this.playlistType === Q.MAIN ? "level" : "track"} ${e.level} (frag:[${((s = e.startPTS) != null ? s : NaN).toFixed(3)}-${((n = e.endPTS) != null ? n : NaN).toFixed(3)}] > buffer:${a ? Mm.toString(de.getBuffered(a)) : "(detached)"})`), e.sn !== "initSegment") {
      var l;
      if (e.type !== Q.SUBTITLE) {
        const u = e.elementaryStreams;
        if (!Object.keys(u).some((d) => !!u[d])) {
          this.state = k.IDLE;
          return;
        }
      }
      const c = (l = this.levels) == null ? void 0 : l[e.level];
      c != null && c.fragmentError && (this.log(`Resetting level fragment error count of ${c.fragmentError} on frag buffered`), c.fragmentError = 0);
    }
    this.state = k.IDLE, a && (!this.loadedmetadata && e.type == Q.MAIN && a.buffered.length && ((r = this.fragCurrent) == null ? void 0 : r.sn) === ((o = this.fragPrevious) == null ? void 0 : o.sn) && (this.loadedmetadata = !0, this.seekToStartPos()), this.tick());
  }
  seekToStartPos() {
  }
  _handleFragmentLoadComplete(e) {
    const {
      transmuxer: t
    } = this;
    if (!t)
      return;
    const {
      frag: s,
      part: n,
      partsLoaded: r
    } = e, o = !r || r.length === 0 || r.some((l) => !l), a = new ai(s.level, s.sn, s.stats.chunkCount + 1, 0, n ? n.index : -1, !o);
    t.flush(a);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _handleFragmentLoadProgress(e) {
  }
  _doFragLoad(e, t, s = null, n) {
    var r;
    const o = t == null ? void 0 : t.details;
    if (!this.levels || !o)
      throw new Error(`frag load aborted, missing level${o ? "" : " detail"}s`);
    let a = null;
    if (e.encrypted && !((r = e.decryptdata) != null && r.key) ? (this.log(`Loading key for ${e.sn} of [${o.startSN}-${o.endSN}], ${this.logPrefix === "[stream-controller]" ? "level" : "track"} ${e.level}`), this.state = k.KEY_LOADING, this.fragCurrent = e, a = this.keyLoader.load(e).then((u) => {
      if (!this.fragContextChanged(u.frag))
        return this.hls.trigger(T.KEY_LOADED, u), this.state === k.KEY_LOADING && (this.state = k.IDLE), u;
    }), this.hls.trigger(T.KEY_LOADING, {
      frag: e
    }), this.fragCurrent === null && (a = Promise.reject(new Error("frag load aborted, context changed in KEY_LOADING")))) : !e.encrypted && o.encryptedFragments.length && this.keyLoader.loadClear(e, o.encryptedFragments), s = Math.max(e.start, s || 0), this.config.lowLatencyMode && e.sn !== "initSegment") {
      const u = o.partList;
      if (u && n) {
        s > e.end && o.fragmentHint && (e = o.fragmentHint);
        const d = this.getNextPart(u, e, s);
        if (d > -1) {
          const h = u[d];
          this.log(`Loading part sn: ${e.sn} p: ${h.index} cc: ${e.cc} of playlist [${o.startSN}-${o.endSN}] parts [0-${d}-${u.length - 1}] ${this.logPrefix === "[stream-controller]" ? "level" : "track"}: ${e.level}, target: ${parseFloat(s.toFixed(3))}`), this.nextLoadPosition = h.start + h.duration, this.state = k.FRAG_LOADING;
          let m;
          return a ? m = a.then((f) => !f || this.fragContextChanged(f.frag) ? null : this.doFragPartsLoad(e, h, t, n)).catch((f) => this.handleFragLoadError(f)) : m = this.doFragPartsLoad(e, h, t, n).catch((f) => this.handleFragLoadError(f)), this.hls.trigger(T.FRAG_LOADING, {
            frag: e,
            part: h,
            targetBufferTime: s
          }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING parts")) : m;
        } else if (!e.url || this.loadedEndOfParts(u, s))
          return Promise.resolve(null);
      }
    }
    this.log(`Loading fragment ${e.sn} cc: ${e.cc} ${o ? "of [" + o.startSN + "-" + o.endSN + "] " : ""}${this.logPrefix === "[stream-controller]" ? "level" : "track"}: ${e.level}, target: ${parseFloat(s.toFixed(3))}`), G(e.sn) && !this.bitrateTest && (this.nextLoadPosition = e.start + e.duration), this.state = k.FRAG_LOADING;
    const l = this.config.progressive;
    let c;
    return l && a ? c = a.then((u) => !u || this.fragContextChanged(u == null ? void 0 : u.frag) ? null : this.fragmentLoader.load(e, n)).catch((u) => this.handleFragLoadError(u)) : c = Promise.all([this.fragmentLoader.load(e, l ? n : void 0), a]).then(([u]) => (!l && u && n && n(u), u)).catch((u) => this.handleFragLoadError(u)), this.hls.trigger(T.FRAG_LOADING, {
      frag: e,
      targetBufferTime: s
    }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING")) : c;
  }
  doFragPartsLoad(e, t, s, n) {
    return new Promise((r, o) => {
      var a;
      const l = [], c = (a = s.details) == null ? void 0 : a.partList, u = (d) => {
        this.fragmentLoader.loadPart(e, d, n).then((h) => {
          l[d.index] = h;
          const m = h.part;
          this.hls.trigger(T.FRAG_LOADED, h);
          const f = Ar(s, e.sn, d.index + 1) || Wo(c, e.sn, d.index + 1);
          if (f)
            u(f);
          else
            return r({
              frag: e,
              part: m,
              partsLoaded: l
            });
        }).catch(o);
      };
      u(t);
    });
  }
  handleFragLoadError(e) {
    if ("data" in e) {
      const t = e.data;
      e.data && t.details === C.INTERNAL_ABORTED ? this.handleFragLoadAborted(t.frag, t.part) : this.hls.trigger(T.ERROR, t);
    } else
      this.hls.trigger(T.ERROR, {
        type: Z.OTHER_ERROR,
        details: C.INTERNAL_EXCEPTION,
        err: e,
        error: e,
        fatal: !0
      });
    return null;
  }
  _handleTransmuxerFlush(e) {
    const t = this.getCurrentContext(e);
    if (!t || this.state !== k.PARSING) {
      !this.fragCurrent && this.state !== k.STOPPED && this.state !== k.ERROR && (this.state = k.IDLE);
      return;
    }
    const {
      frag: s,
      part: n,
      level: r
    } = t, o = self.performance.now();
    s.stats.parsing.end = o, n && (n.stats.parsing.end = o), this.updateLevelTiming(s, n, r, e.partial);
  }
  getCurrentContext(e) {
    const {
      levels: t,
      fragCurrent: s
    } = this, {
      level: n,
      sn: r,
      part: o
    } = e;
    if (!(t != null && t[n]))
      return this.warn(`Levels object was unset while buffering fragment ${r} of level ${n}. The current chunk will not be buffered.`), null;
    const a = t[n], l = o > -1 ? Ar(a, r, o) : null, c = l ? l.fragment : em(a, r, s);
    return c ? (s && s !== c && (c.stats = s.stats), {
      frag: c,
      part: l,
      level: a
    }) : null;
  }
  bufferFragmentData(e, t, s, n, r) {
    var o;
    if (!e || this.state !== k.PARSING)
      return;
    const {
      data1: a,
      data2: l
    } = e;
    let c = a;
    if (a && l && (c = $e(a, l)), !((o = c) != null && o.length))
      return;
    const u = {
      type: e.type,
      frag: t,
      part: s,
      chunkMeta: n,
      parent: t.type,
      data: c
    };
    if (this.hls.trigger(T.BUFFER_APPENDING, u), e.dropped && e.independent && !s) {
      if (r)
        return;
      this.flushBufferGap(t);
    }
  }
  flushBufferGap(e) {
    const t = this.media;
    if (!t)
      return;
    if (!de.isBuffered(t, t.currentTime)) {
      this.flushMainBuffer(0, e.start);
      return;
    }
    const s = t.currentTime, n = de.bufferInfo(t, s, 0), r = e.duration, o = Math.min(this.config.maxFragLookUpTolerance * 2, r * 0.25), a = Math.max(Math.min(e.start - o, n.end - o), s + o);
    e.start - a > o && this.flushMainBuffer(a, e.start);
  }
  getFwdBufferInfo(e, t) {
    const s = this.getLoadPosition();
    return G(s) ? this.getFwdBufferInfoAtPos(e, s, t) : null;
  }
  getFwdBufferInfoAtPos(e, t, s) {
    const {
      config: {
        maxBufferHole: n
      }
    } = this, r = de.bufferInfo(e, t, n);
    if (r.len === 0 && r.nextStart !== void 0) {
      const o = this.fragmentTracker.getBufferedFrag(t, s);
      if (o && r.nextStart < o.end)
        return de.bufferInfo(e, t, Math.max(r.nextStart, n));
    }
    return r;
  }
  getMaxBufferLength(e) {
    const {
      config: t
    } = this;
    let s;
    return e ? s = Math.max(8 * t.maxBufferSize / e, t.maxBufferLength) : s = t.maxBufferLength, Math.min(s, t.maxMaxBufferLength);
  }
  reduceMaxBufferLength(e, t) {
    const s = this.config, n = Math.max(Math.min(e - t, s.maxBufferLength), t), r = Math.max(e - t * 3, s.maxMaxBufferLength / 2, n);
    return r >= n ? (s.maxMaxBufferLength = r, this.warn(`Reduce max buffer length to ${r}s`), !0) : !1;
  }
  getAppendedFrag(e, t = Q.MAIN) {
    const s = this.fragmentTracker.getAppendedFrag(e, Q.MAIN);
    return s && "fragment" in s ? s.fragment : s;
  }
  getNextFragment(e, t) {
    const s = t.fragments, n = s.length;
    if (!n)
      return null;
    const {
      config: r
    } = this, o = s[0].start;
    let a;
    if (t.live) {
      const l = r.initialLiveManifestSize;
      if (n < l)
        return this.warn(`Not enough fragments to start playback (have: ${n}, need: ${l})`), null;
      (!t.PTSKnown && !this.startFragRequested && this.startPosition === -1 || e < o) && (a = this.getInitialLiveFragment(t, s), this.startPosition = this.nextLoadPosition = a ? this.hls.liveSyncPosition || a.start : e);
    } else e <= o && (a = s[0]);
    if (!a) {
      const l = r.lowLatencyMode ? t.partEnd : t.fragmentEnd;
      a = this.getFragmentAtPosition(e, l, t);
    }
    return this.mapToInitFragWhenRequired(a);
  }
  isLoopLoading(e, t) {
    const s = this.fragmentTracker.getState(e);
    return (s === Le.OK || s === Le.PARTIAL && !!e.gap) && this.nextLoadPosition > t;
  }
  getNextFragmentLoopLoading(e, t, s, n, r) {
    const o = e.gap, a = this.getNextFragment(this.nextLoadPosition, t);
    if (a === null)
      return a;
    if (e = a, o && e && !e.gap && s.nextStart) {
      const l = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, s.nextStart, n);
      if (l !== null && s.len + l.len >= r)
        return this.log(`buffer full after gaps in "${n}" playlist starting at sn: ${e.sn}`), null;
    }
    return e;
  }
  mapToInitFragWhenRequired(e) {
    return e != null && e.initSegment && !(e != null && e.initSegment.data) && !this.bitrateTest ? e.initSegment : e;
  }
  getNextPart(e, t, s) {
    let n = -1, r = !1, o = !0;
    for (let a = 0, l = e.length; a < l; a++) {
      const c = e[a];
      if (o = o && !c.independent, n > -1 && s < c.start)
        break;
      const u = c.loaded;
      u ? n = -1 : (r || c.independent || o) && c.fragment === t && (n = a), r = u;
    }
    return n;
  }
  loadedEndOfParts(e, t) {
    const s = e[e.length - 1];
    return s && t > s.start && s.loaded;
  }
  /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */
  getInitialLiveFragment(e, t) {
    const s = this.fragPrevious;
    let n = null;
    if (s) {
      if (e.hasProgramDateTime && (this.log(`Live playlist, switching playlist, load frag with same PDT: ${s.programDateTime}`), n = sm(t, s.endProgramDateTime, this.config.maxFragLookUpTolerance)), !n) {
        const r = s.sn + 1;
        if (r >= e.startSN && r <= e.endSN) {
          const o = t[r - e.startSN];
          s.cc === o.cc && (n = o, this.log(`Live playlist, switching playlist, load frag with next SN: ${n.sn}`));
        }
        n || (n = rm(t, s.cc), n && this.log(`Live playlist, switching playlist, load frag with same CC: ${n.sn}`));
      }
    } else {
      const r = this.hls.liveSyncPosition;
      r !== null && (n = this.getFragmentAtPosition(r, this.bitrateTest ? e.fragmentEnd : e.edge, e));
    }
    return n;
  }
  /*
  This method finds the best matching fragment given the provided position.
   */
  getFragmentAtPosition(e, t, s) {
    const {
      config: n
    } = this;
    let {
      fragPrevious: r
    } = this, {
      fragments: o,
      endSN: a
    } = s;
    const {
      fragmentHint: l
    } = s, {
      maxFragLookUpTolerance: c
    } = n, u = s.partList, d = !!(n.lowLatencyMode && u != null && u.length && l);
    d && l && !this.bitrateTest && (o = o.concat(l), a = l.sn);
    let h;
    if (e < t) {
      const m = e > t - c ? 0 : c;
      h = zs(r, o, e, m);
    } else
      h = o[o.length - 1];
    if (h) {
      const m = h.sn - s.startSN, f = this.fragmentTracker.getState(h);
      if ((f === Le.OK || f === Le.PARTIAL && h.gap) && (r = h), r && h.sn === r.sn && (!d || u[0].fragment.sn > h.sn) && r && h.level === r.level) {
        const p = o[m + 1];
        h.sn < a && this.fragmentTracker.getState(p) !== Le.OK ? h = p : h = null;
      }
    }
    return h;
  }
  synchronizeToLiveEdge(e) {
    const {
      config: t,
      media: s
    } = this;
    if (!s)
      return;
    const n = this.hls.liveSyncPosition, r = s.currentTime, o = e.fragments[0].start, a = e.edge, l = r >= o - t.maxFragLookUpTolerance && r <= a;
    if (n !== null && s.duration > n && (r < n || !l)) {
      const c = t.liveMaxLatencyDuration !== void 0 ? t.liveMaxLatencyDuration : t.liveMaxLatencyDurationCount * e.targetduration;
      (!l && s.readyState < 4 || r < a - c) && (this.loadedmetadata || (this.nextLoadPosition = n), s.readyState && (this.warn(`Playback: ${r.toFixed(3)} is located too far from the end of live sliding playlist: ${a}, reset currentTime to : ${n.toFixed(3)}`), s.currentTime = n));
    }
  }
  alignPlaylists(e, t, s) {
    const n = e.fragments.length;
    if (!n)
      return this.warn("No fragments in live playlist"), 0;
    const r = e.fragments[0].start, o = !t, a = e.alignedSliding && G(r);
    if (o || !a && !r) {
      const {
        fragPrevious: l
      } = this;
      Lm(l, s, e);
      const c = e.fragments[0].start;
      return this.log(`Live playlist sliding: ${c.toFixed(2)} start-sn: ${t ? t.startSN : "na"}->${e.startSN} prev-sn: ${l ? l.sn : "na"} fragments: ${n}`), c;
    }
    return r;
  }
  waitForCdnTuneIn(e) {
    return e.live && e.canBlockReload && e.partTarget && e.tuneInGoal > Math.max(e.partHoldBack, e.partTarget * 3);
  }
  setStartPosition(e, t) {
    let s = this.startPosition;
    if (s < t && (s = -1), s === -1 || this.lastCurrentTime === -1) {
      const n = this.startTimeOffset !== null, r = n ? this.startTimeOffset : e.startTimeOffset;
      r !== null && G(r) ? (s = t + r, r < 0 && (s += e.totalduration), s = Math.min(Math.max(t, s), t + e.totalduration), this.log(`Start time offset ${r} found in ${n ? "multivariant" : "media"} playlist, adjust startPosition to ${s}`), this.startPosition = s) : e.live ? s = this.hls.liveSyncPosition || t : this.startPosition = s = 0, this.lastCurrentTime = s;
    }
    this.nextLoadPosition = s;
  }
  getLoadPosition() {
    const {
      media: e
    } = this;
    let t = 0;
    return this.loadedmetadata && e ? t = e.currentTime : this.nextLoadPosition && (t = this.nextLoadPosition), t;
  }
  handleFragLoadAborted(e, t) {
    this.transmuxer && e.sn !== "initSegment" && e.stats.aborted && (this.warn(`Fragment ${e.sn}${t ? " part " + t.index : ""} of level ${e.level} was aborted`), this.resetFragmentLoading(e));
  }
  resetFragmentLoading(e) {
    (!this.fragCurrent || !this.fragContextChanged(e) && this.state !== k.FRAG_LOADING_WAITING_RETRY) && (this.state = k.IDLE);
  }
  onFragmentOrKeyLoadError(e, t) {
    if (t.chunkMeta && !t.frag) {
      const u = this.getCurrentContext(t.chunkMeta);
      u && (t.frag = u.frag);
    }
    const s = t.frag;
    if (!s || s.type !== e || !this.levels)
      return;
    if (this.fragContextChanged(s)) {
      var n;
      this.warn(`Frag load error must match current frag to retry ${s.url} > ${(n = this.fragCurrent) == null ? void 0 : n.url}`);
      return;
    }
    const r = t.details === C.FRAG_GAP;
    r && this.fragmentTracker.fragBuffered(s, !0);
    const o = t.errorAction, {
      action: a,
      retryCount: l = 0,
      retryConfig: c
    } = o || {};
    if (o && a === De.RetryRequest && c) {
      this.resetStartWhenNotLoaded(this.levelLastLoaded);
      const u = ri(c, l);
      this.warn(`Fragment ${s.sn} of ${e} ${s.level} errored with ${t.details}, retrying loading ${l + 1}/${c.maxNumRetry} in ${u}ms`), o.resolved = !0, this.retryDate = self.performance.now() + u, this.state = k.FRAG_LOADING_WAITING_RETRY;
    } else if (c && o)
      if (this.resetFragmentErrors(e), l < c.maxNumRetry)
        !r && a !== De.RemoveAlternatePermanently && (o.resolved = !0);
      else {
        D.warn(`${t.details} reached or exceeded max retry (${l})`);
        return;
      }
    else (o == null ? void 0 : o.action) === De.SendAlternateToPenaltyBox ? this.state = k.WAITING_LEVEL : this.state = k.ERROR;
    this.tickImmediate();
  }
  reduceLengthAndFlushBuffer(e) {
    if (this.state === k.PARSING || this.state === k.PARSED) {
      const t = e.frag, s = e.parent, n = this.getFwdBufferInfo(this.mediaBuffer, s), r = n && n.len > 0.5;
      r && this.reduceMaxBufferLength(n.len, (t == null ? void 0 : t.duration) || 10);
      const o = !r;
      return o && this.warn(`Buffer full error while media.currentTime is not buffered, flush ${s} buffer`), t && (this.fragmentTracker.removeFragment(t), this.nextLoadPosition = t.start), this.resetLoadingState(), o;
    }
    return !1;
  }
  resetFragmentErrors(e) {
    e === Q.AUDIO && (this.fragCurrent = null), this.loadedmetadata || (this.startFragRequested = !1), this.state !== k.STOPPED && (this.state = k.IDLE);
  }
  afterBufferFlushed(e, t, s) {
    if (!e)
      return;
    const n = de.getBuffered(e);
    this.fragmentTracker.detectEvictedFragments(t, n, s), this.state === k.ENDED && this.resetLoadingState();
  }
  resetLoadingState() {
    this.log("Reset loading state"), this.fragCurrent = null, this.fragPrevious = null, this.state = k.IDLE;
  }
  resetStartWhenNotLoaded(e) {
    if (!this.loadedmetadata) {
      this.startFragRequested = !1;
      const t = e ? e.details : null;
      t != null && t.live ? (this.startPosition = -1, this.setStartPosition(t, 0), this.resetLoadingState()) : this.nextLoadPosition = this.startPosition;
    }
  }
  resetWhenMissingContext(e) {
    this.warn(`The loading context changed while buffering fragment ${e.sn} of level ${e.level}. This chunk will not be buffered.`), this.removeUnbufferedFrags(), this.resetStartWhenNotLoaded(this.levelLastLoaded), this.resetLoadingState();
  }
  removeUnbufferedFrags(e = 0) {
    this.fragmentTracker.removeFragmentsInRange(e, 1 / 0, this.playlistType, !1, !0);
  }
  updateLevelTiming(e, t, s, n) {
    var r;
    const o = s.details;
    if (!o) {
      this.warn("level.details undefined");
      return;
    }
    if (!Object.keys(e.elementaryStreams).reduce((l, c) => {
      const u = e.elementaryStreams[c];
      if (u) {
        const d = u.endPTS - u.startPTS;
        if (d <= 0)
          return this.warn(`Could not parse fragment ${e.sn} ${c} duration reliably (${d})`), l || !1;
        const h = n ? 0 : Ko(o, e, u.startPTS, u.endPTS, u.startDTS, u.endDTS);
        return this.hls.trigger(T.LEVEL_PTS_UPDATED, {
          details: o,
          level: s,
          drift: h,
          type: c,
          frag: e,
          start: u.startPTS,
          end: u.endPTS
        }), !0;
      }
      return l;
    }, !1) && ((r = this.transmuxer) == null ? void 0 : r.error) === null) {
      const l = new Error(`Found no media in fragment ${e.sn} of level ${e.level} resetting transmuxer to fallback to playlist timing`);
      if (s.fragmentError === 0 && (s.fragmentError++, e.gap = !0, this.fragmentTracker.removeFragment(e), this.fragmentTracker.fragBuffered(e, !0)), this.warn(l.message), this.hls.trigger(T.ERROR, {
        type: Z.MEDIA_ERROR,
        details: C.FRAG_PARSING_ERROR,
        fatal: !1,
        error: l,
        frag: e,
        reason: `Found no media in msn ${e.sn} of level "${s.url}"`
      }), !this.hls)
        return;
      this.resetTransmuxer();
    }
    this.state = k.PARSED, this.hls.trigger(T.FRAG_PARSED, {
      frag: e,
      part: t
    });
  }
  resetTransmuxer() {
    this.transmuxer && (this.transmuxer.destroy(), this.transmuxer = null);
  }
  recoverWorkerError(e) {
    e.event === "demuxerWorker" && (this.fragmentTracker.removeAllFragments(), this.resetTransmuxer(), this.resetStartWhenNotLoaded(this.levelLastLoaded), this.resetLoadingState());
  }
  set state(e) {
    const t = this._state;
    t !== e && (this._state = e, this.log(`${t}->${e}`));
  }
  get state() {
    return this._state;
  }
}
class Xo {
  constructor() {
    this.chunks = [], this.dataLength = 0;
  }
  push(e) {
    this.chunks.push(e), this.dataLength += e.length;
  }
  flush() {
    const {
      chunks: e,
      dataLength: t
    } = this;
    let s;
    if (e.length)
      e.length === 1 ? s = e[0] : s = km(e, t);
    else return new Uint8Array(0);
    return this.reset(), s;
  }
  reset() {
    this.chunks.length = 0, this.dataLength = 0;
  }
}
function km(i, e) {
  const t = new Uint8Array(e);
  let s = 0;
  for (let n = 0; n < i.length; n++) {
    const r = i[n];
    t.set(r, s), s += r.length;
  }
  return t;
}
function Fm() {
  return typeof __HLS_WORKER_BUNDLE__ == "function";
}
function Pm() {
  const i = new self.Blob([`var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`], {
    type: "text/javascript"
  }), e = self.URL.createObjectURL(i);
  return {
    worker: new self.Worker(e),
    objectURL: e
  };
}
function Om(i) {
  const e = new self.URL(i, self.location.href).href;
  return {
    worker: new self.Worker(e),
    scriptURL: e
  };
}
function je(i = "", e = 9e4) {
  return {
    type: i,
    id: -1,
    pid: -1,
    inputTimeScale: e,
    sequenceNumber: -1,
    samples: [],
    dropped: 0
  };
}
class ui {
  constructor() {
    this._audioTrack = void 0, this._id3Track = void 0, this.frameIndex = 0, this.cachedData = null, this.basePTS = null, this.initPTS = null, this.lastPTS = null;
  }
  resetInitSegment(e, t, s, n) {
    this._id3Track = {
      type: "id3",
      id: 3,
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0
    };
  }
  resetTimeStamp(e) {
    this.initPTS = e, this.resetContiguity();
  }
  resetContiguity() {
    this.basePTS = null, this.lastPTS = null, this.frameIndex = 0;
  }
  canParse(e, t) {
    return !1;
  }
  appendFrame(e, t, s) {
  }
  // feed incoming data to the front of the parsing pipeline
  demux(e, t) {
    this.cachedData && (e = $e(this.cachedData, e), this.cachedData = null);
    let s = ss(e, 0), n = s ? s.length : 0, r;
    const o = this._audioTrack, a = this._id3Track, l = s ? ii(s) : void 0, c = e.length;
    for ((this.basePTS === null || this.frameIndex === 0 && G(l)) && (this.basePTS = Nm(l, t, this.initPTS), this.lastPTS = this.basePTS), this.lastPTS === null && (this.lastPTS = this.basePTS), s && s.length > 0 && a.samples.push({
      pts: this.lastPTS,
      dts: this.lastPTS,
      data: s,
      type: We.audioId3,
      duration: Number.POSITIVE_INFINITY
    }); n < c; ) {
      if (this.canParse(e, n)) {
        const u = this.appendFrame(o, e, n);
        u ? (this.frameIndex++, this.lastPTS = u.sample.pts, n += u.length, r = n) : n = c;
      } else rf(e, n) ? (s = ss(e, n), a.samples.push({
        pts: this.lastPTS,
        dts: this.lastPTS,
        data: s,
        type: We.audioId3,
        duration: Number.POSITIVE_INFINITY
      }), n += s.length, r = n) : n++;
      if (n === c && r !== c) {
        const u = St(e, r);
        this.cachedData ? this.cachedData = $e(this.cachedData, u) : this.cachedData = u;
      }
    }
    return {
      audioTrack: o,
      videoTrack: je(),
      id3Track: a,
      textTrack: je()
    };
  }
  demuxSampleAes(e, t, s) {
    return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
  }
  flush(e) {
    const t = this.cachedData;
    return t && (this.cachedData = null, this.demux(t, 0)), {
      audioTrack: this._audioTrack,
      videoTrack: je(),
      id3Track: this._id3Track,
      textTrack: je()
    };
  }
  destroy() {
  }
}
const Nm = (i, e, t) => {
  if (G(i))
    return i * 90;
  const s = t ? t.baseTime * 9e4 / t.timescale : 0;
  return e * 9e4 + s;
};
function Um(i, e, t, s) {
  let n, r, o, a;
  const l = navigator.userAgent.toLowerCase(), c = s, u = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
  n = ((e[t + 2] & 192) >>> 6) + 1;
  const d = (e[t + 2] & 60) >>> 2;
  if (d > u.length - 1) {
    const h = new Error(`invalid ADTS sampling index:${d}`);
    i.emit(T.ERROR, T.ERROR, {
      type: Z.MEDIA_ERROR,
      details: C.FRAG_PARSING_ERROR,
      fatal: !0,
      error: h,
      reason: h.message
    });
    return;
  }
  return o = (e[t + 2] & 1) << 2, o |= (e[t + 3] & 192) >>> 6, D.log(`manifest codec:${s}, ADTS type:${n}, samplingIndex:${d}`), /firefox/i.test(l) ? d >= 6 ? (n = 5, a = new Array(4), r = d - 3) : (n = 2, a = new Array(2), r = d) : l.indexOf("android") !== -1 ? (n = 2, a = new Array(2), r = d) : (n = 5, a = new Array(4), s && (s.indexOf("mp4a.40.29") !== -1 || s.indexOf("mp4a.40.5") !== -1) || !s && d >= 6 ? r = d - 3 : ((s && s.indexOf("mp4a.40.2") !== -1 && (d >= 6 && o === 1 || /vivaldi/i.test(l)) || !s && o === 1) && (n = 2, a = new Array(2)), r = d)), a[0] = n << 3, a[0] |= (d & 14) >> 1, a[1] |= (d & 1) << 7, a[1] |= o << 3, n === 5 && (a[1] |= (r & 14) >> 1, a[2] = (r & 1) << 7, a[2] |= 8, a[3] = 0), {
    config: a,
    samplerate: u[d],
    channelCount: o,
    codec: "mp4a.40." + n,
    manifestCodec: c
  };
}
function Qo(i, e) {
  return i[e] === 255 && (i[e + 1] & 246) === 240;
}
function Zo(i, e) {
  return i[e + 1] & 1 ? 7 : 9;
}
function di(i, e) {
  return (i[e + 3] & 3) << 11 | i[e + 4] << 3 | (i[e + 5] & 224) >>> 5;
}
function Bm(i, e) {
  return e + 5 < i.length;
}
function Xs(i, e) {
  return e + 1 < i.length && Qo(i, e);
}
function $m(i, e) {
  return Bm(i, e) && Qo(i, e) && di(i, e) <= i.length - e;
}
function Gm(i, e) {
  if (Xs(i, e)) {
    const t = Zo(i, e);
    if (e + t >= i.length)
      return !1;
    const s = di(i, e);
    if (s <= t)
      return !1;
    const n = e + s;
    return n === i.length || Xs(i, n);
  }
  return !1;
}
function Jo(i, e, t, s, n) {
  if (!i.samplerate) {
    const r = Um(e, t, s, n);
    if (!r)
      return;
    i.config = r.config, i.samplerate = r.samplerate, i.channelCount = r.channelCount, i.codec = r.codec, i.manifestCodec = r.manifestCodec, D.log(`parsed codec:${i.codec}, rate:${r.samplerate}, channels:${r.channelCount}`);
  }
}
function ea(i) {
  return 1024 * 9e4 / i;
}
function Hm(i, e) {
  const t = Zo(i, e);
  if (e + t <= i.length) {
    const s = di(i, e) - t;
    if (s > 0)
      return {
        headerLength: t,
        frameLength: s
      };
  }
}
function ta(i, e, t, s, n) {
  const r = ea(i.samplerate), o = s + n * r, a = Hm(e, t);
  let l;
  if (a) {
    const {
      frameLength: d,
      headerLength: h
    } = a, m = h + d, f = Math.max(0, t + m - e.length);
    f ? (l = new Uint8Array(m - h), l.set(e.subarray(t + h, e.length), 0)) : l = e.subarray(t + h, t + m);
    const g = {
      unit: l,
      pts: o
    };
    return f || i.samples.push(g), {
      sample: g,
      length: m,
      missing: f
    };
  }
  const c = e.length - t;
  return l = new Uint8Array(c), l.set(e.subarray(t, e.length), 0), {
    sample: {
      unit: l,
      pts: o
    },
    length: c,
    missing: -1
  };
}
let Ss = null;
const Km = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160], Vm = [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3], Wm = [
  // MPEG 2.5
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // Reserved
  [
    0,
    // Reserved
    0,
    // Layer3
    0,
    // Layer2
    0
    // Layer1
  ],
  // MPEG 2
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // MPEG 1
  [
    0,
    // Reserved
    144,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ]
], Ym = [
  0,
  // Reserved
  1,
  // Layer3
  1,
  // Layer2
  4
  // Layer1
];
function sa(i, e, t, s, n) {
  if (t + 24 > e.length)
    return;
  const r = na(e, t);
  if (r && t + r.frameLength <= e.length) {
    const o = r.samplesPerFrame * 9e4 / r.sampleRate, a = s + n * o, l = {
      unit: e.subarray(t, t + r.frameLength),
      pts: a,
      dts: a
    };
    return i.config = [], i.channelCount = r.channelCount, i.samplerate = r.sampleRate, i.samples.push(l), {
      sample: l,
      length: r.frameLength,
      missing: 0
    };
  }
}
function na(i, e) {
  const t = i[e + 1] >> 3 & 3, s = i[e + 1] >> 1 & 3, n = i[e + 2] >> 4 & 15, r = i[e + 2] >> 2 & 3;
  if (t !== 1 && n !== 0 && n !== 15 && r !== 3) {
    const o = i[e + 2] >> 1 & 1, a = i[e + 3] >> 6, l = t === 3 ? 3 - s : s === 3 ? 3 : 4, c = Km[l * 14 + n - 1] * 1e3, d = Vm[(t === 3 ? 0 : t === 2 ? 1 : 2) * 3 + r], h = a === 3 ? 1 : 2, m = Wm[t][s], f = Ym[s], g = m * 8 * f, p = Math.floor(m * c / d + o) * f;
    if (Ss === null) {
      const v = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      Ss = v ? parseInt(v[1]) : 0;
    }
    return Ss && Ss <= 87 && s === 2 && c >= 224e3 && a === 0 && (i[e + 3] = i[e + 3] | 128), {
      sampleRate: d,
      channelCount: h,
      frameLength: p,
      samplesPerFrame: g
    };
  }
}
function hi(i, e) {
  return i[e] === 255 && (i[e + 1] & 224) === 224 && (i[e + 1] & 6) !== 0;
}
function ia(i, e) {
  return e + 1 < i.length && hi(i, e);
}
function qm(i, e) {
  return hi(i, e) && 4 <= i.length - e;
}
function ra(i, e) {
  if (e + 1 < i.length && hi(i, e)) {
    const s = na(i, e);
    let n = 4;
    s != null && s.frameLength && (n = s.frameLength);
    const r = e + n;
    return r === i.length || ia(i, r);
  }
  return !1;
}
class zm extends ui {
  constructor(e, t) {
    super(), this.observer = void 0, this.config = void 0, this.observer = e, this.config = t;
  }
  resetInitSegment(e, t, s, n) {
    super.resetInitSegment(e, t, s, n), this._audioTrack = {
      container: "audio/adts",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "aac",
      samples: [],
      manifestCodec: t,
      duration: n,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
  static probe(e) {
    if (!e)
      return !1;
    const t = ss(e, 0);
    let s = (t == null ? void 0 : t.length) || 0;
    if (ra(e, s))
      return !1;
    for (let n = e.length; s < n; s++)
      if (Gm(e, s))
        return D.log("ADTS sync word found !"), !0;
    return !1;
  }
  canParse(e, t) {
    return $m(e, t);
  }
  appendFrame(e, t, s) {
    Jo(e, this.observer, t, s, e.manifestCodec);
    const n = ta(e, t, s, this.basePTS, this.frameIndex);
    if (n && n.missing === 0)
      return n;
  }
}
const jm = /\/emsg[-/]ID3/i;
class Xm {
  constructor(e, t) {
    this.remainderData = null, this.timeOffset = 0, this.config = void 0, this.videoTrack = void 0, this.audioTrack = void 0, this.id3Track = void 0, this.txtTrack = void 0, this.config = t;
  }
  resetTimeStamp() {
  }
  resetInitSegment(e, t, s, n) {
    const r = this.videoTrack = je("video", 1), o = this.audioTrack = je("audio", 1), a = this.txtTrack = je("text", 1);
    if (this.id3Track = je("id3", 1), this.timeOffset = 0, !(e != null && e.byteLength))
      return;
    const l = Po(e);
    if (l.video) {
      const {
        id: c,
        timescale: u,
        codec: d
      } = l.video;
      r.id = c, r.timescale = a.timescale = u, r.codec = d;
    }
    if (l.audio) {
      const {
        id: c,
        timescale: u,
        codec: d
      } = l.audio;
      o.id = c, o.timescale = u, o.codec = d;
    }
    a.id = Mo.text, r.sampleDuration = 0, r.duration = o.duration = n;
  }
  resetContiguity() {
    this.remainderData = null;
  }
  static probe(e) {
    return mf(e);
  }
  demux(e, t) {
    this.timeOffset = t;
    let s = e;
    const n = this.videoTrack, r = this.txtTrack;
    if (this.config.progressive) {
      this.remainderData && (s = $e(this.remainderData, e));
      const a = Sf(s);
      this.remainderData = a.remainder, n.samples = a.valid || new Uint8Array();
    } else
      n.samples = s;
    const o = this.extractID3Track(n, t);
    return r.samples = ir(t, n), {
      videoTrack: n,
      audioTrack: this.audioTrack,
      id3Track: o,
      textTrack: this.txtTrack
    };
  }
  flush() {
    const e = this.timeOffset, t = this.videoTrack, s = this.txtTrack;
    t.samples = this.remainderData || new Uint8Array(), this.remainderData = null;
    const n = this.extractID3Track(t, this.timeOffset);
    return s.samples = ir(e, t), {
      videoTrack: t,
      audioTrack: je(),
      id3Track: n,
      textTrack: je()
    };
  }
  extractID3Track(e, t) {
    const s = this.id3Track;
    if (e.samples.length) {
      const n = ee(e.samples, ["emsg"]);
      n && n.forEach((r) => {
        const o = Rf(r);
        if (jm.test(o.schemeIdUri)) {
          const a = G(o.presentationTime) ? o.presentationTime / o.timeScale : t + o.presentationTimeDelta / o.timeScale;
          let l = o.eventDuration === 4294967295 ? Number.POSITIVE_INFINITY : o.eventDuration / o.timeScale;
          l <= 1e-3 && (l = Number.POSITIVE_INFINITY);
          const c = o.payload;
          s.samples.push({
            data: c,
            len: c.byteLength,
            dts: a,
            pts: a,
            type: We.emsg,
            duration: l
          });
        }
      });
    }
    return s;
  }
  demuxSampleAes(e, t, s) {
    return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"));
  }
  destroy() {
  }
}
const oa = (i, e) => {
  let t = 0, s = 5;
  e += s;
  const n = new Uint32Array(1), r = new Uint32Array(1), o = new Uint8Array(1);
  for (; s > 0; ) {
    o[0] = i[e];
    const a = Math.min(s, 8), l = 8 - a;
    r[0] = 4278190080 >>> 24 + l << l, n[0] = (o[0] & r[0]) >> l, t = t ? t << a | n[0] : n[0], e += 1, s -= a;
  }
  return t;
};
class Qm extends ui {
  constructor(e) {
    super(), this.observer = void 0, this.observer = e;
  }
  resetInitSegment(e, t, s, n) {
    super.resetInitSegment(e, t, s, n), this._audioTrack = {
      container: "audio/ac-3",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "ac3",
      samples: [],
      manifestCodec: t,
      duration: n,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  canParse(e, t) {
    return t + 64 < e.length;
  }
  appendFrame(e, t, s) {
    const n = aa(e, t, s, this.basePTS, this.frameIndex);
    if (n !== -1)
      return {
        sample: e.samples[e.samples.length - 1],
        length: n,
        missing: 0
      };
  }
  static probe(e) {
    if (!e)
      return !1;
    const t = ss(e, 0);
    if (!t)
      return !1;
    const s = t.length;
    return e[s] === 11 && e[s + 1] === 119 && ii(t) !== void 0 && // check the bsid to confirm ac-3
    oa(e, s) < 16;
  }
}
function aa(i, e, t, s, n) {
  if (t + 8 > e.length || e[t] !== 11 || e[t + 1] !== 119)
    return -1;
  const r = e[t + 4] >> 6;
  if (r >= 3)
    return -1;
  const a = [48e3, 44100, 32e3][r], l = e[t + 4] & 63, u = [64, 69, 96, 64, 70, 96, 80, 87, 120, 80, 88, 120, 96, 104, 144, 96, 105, 144, 112, 121, 168, 112, 122, 168, 128, 139, 192, 128, 140, 192, 160, 174, 240, 160, 175, 240, 192, 208, 288, 192, 209, 288, 224, 243, 336, 224, 244, 336, 256, 278, 384, 256, 279, 384, 320, 348, 480, 320, 349, 480, 384, 417, 576, 384, 418, 576, 448, 487, 672, 448, 488, 672, 512, 557, 768, 512, 558, 768, 640, 696, 960, 640, 697, 960, 768, 835, 1152, 768, 836, 1152, 896, 975, 1344, 896, 976, 1344, 1024, 1114, 1536, 1024, 1115, 1536, 1152, 1253, 1728, 1152, 1254, 1728, 1280, 1393, 1920, 1280, 1394, 1920][l * 3 + r] * 2;
  if (t + u > e.length)
    return -1;
  const d = e[t + 6] >> 5;
  let h = 0;
  d === 2 ? h += 2 : (d & 1 && d !== 1 && (h += 2), d & 4 && (h += 2));
  const m = (e[t + 6] << 8 | e[t + 7]) >> 12 - h & 1, g = [2, 1, 2, 3, 3, 4, 4, 5][d] + m, p = e[t + 5] >> 3, E = e[t + 5] & 7, y = new Uint8Array([r << 6 | p << 1 | E >> 2, (E & 3) << 6 | d << 3 | m << 2 | l >> 4, l << 4 & 224]), v = 1536 / a * 9e4, S = s + n * v, x = e.subarray(t, t + u);
  return i.config = y, i.channelCount = g, i.samplerate = a, i.samples.push({
    unit: x,
    pts: S
  }), u;
}
class Zm {
  constructor() {
    this.VideoSample = null;
  }
  createVideoSample(e, t, s, n) {
    return {
      key: e,
      frame: !1,
      pts: t,
      dts: s,
      units: [],
      debug: n,
      length: 0
    };
  }
  getLastNalUnit(e) {
    var t;
    let s = this.VideoSample, n;
    if ((!s || s.units.length === 0) && (s = e[e.length - 1]), (t = s) != null && t.units) {
      const r = s.units;
      n = r[r.length - 1];
    }
    return n;
  }
  pushAccessUnit(e, t) {
    if (e.units.length && e.frame) {
      if (e.pts === void 0) {
        const s = t.samples, n = s.length;
        if (n) {
          const r = s[n - 1];
          e.pts = r.pts, e.dts = r.dts;
        } else {
          t.dropped++;
          return;
        }
      }
      t.samples.push(e);
    }
    e.debug.length && D.log(e.pts + "/" + e.dts + ":" + e.debug);
  }
}
class Mr {
  constructor(e) {
    this.data = void 0, this.bytesAvailable = void 0, this.word = void 0, this.bitsAvailable = void 0, this.data = e, this.bytesAvailable = e.byteLength, this.word = 0, this.bitsAvailable = 0;
  }
  // ():void
  loadWord() {
    const e = this.data, t = this.bytesAvailable, s = e.byteLength - t, n = new Uint8Array(4), r = Math.min(4, t);
    if (r === 0)
      throw new Error("no bytes available");
    n.set(e.subarray(s, s + r)), this.word = new DataView(n.buffer).getUint32(0), this.bitsAvailable = r * 8, this.bytesAvailable -= r;
  }
  // (count:int):void
  skipBits(e) {
    let t;
    e = Math.min(e, this.bytesAvailable * 8 + this.bitsAvailable), this.bitsAvailable > e ? (this.word <<= e, this.bitsAvailable -= e) : (e -= this.bitsAvailable, t = e >> 3, e -= t << 3, this.bytesAvailable -= t, this.loadWord(), this.word <<= e, this.bitsAvailable -= e);
  }
  // (size:int):uint
  readBits(e) {
    let t = Math.min(this.bitsAvailable, e);
    const s = this.word >>> 32 - t;
    if (e > 32 && D.error("Cannot read more than 32 bits at a time"), this.bitsAvailable -= t, this.bitsAvailable > 0)
      this.word <<= t;
    else if (this.bytesAvailable > 0)
      this.loadWord();
    else
      throw new Error("no bits available");
    return t = e - t, t > 0 && this.bitsAvailable ? s << t | this.readBits(t) : s;
  }
  // ():uint
  skipLZ() {
    let e;
    for (e = 0; e < this.bitsAvailable; ++e)
      if ((this.word & 2147483648 >>> e) !== 0)
        return this.word <<= e, this.bitsAvailable -= e, e;
    return this.loadWord(), e + this.skipLZ();
  }
  // ():void
  skipUEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():void
  skipEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():uint
  readUEG() {
    const e = this.skipLZ();
    return this.readBits(e + 1) - 1;
  }
  // ():int
  readEG() {
    const e = this.readUEG();
    return 1 & e ? 1 + e >>> 1 : -1 * (e >>> 1);
  }
  // Some convenience functions
  // :Boolean
  readBoolean() {
    return this.readBits(1) === 1;
  }
  // ():int
  readUByte() {
    return this.readBits(8);
  }
  // ():int
  readUShort() {
    return this.readBits(16);
  }
  // ():int
  readUInt() {
    return this.readBits(32);
  }
  /**
   * Advance the ExpGolomb decoder past a scaling list. The scaling
   * list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */
  skipScalingList(e) {
    let t = 8, s = 8, n;
    for (let r = 0; r < e; r++)
      s !== 0 && (n = this.readEG(), s = (t + n + 256) % 256), t = s === 0 ? t : s;
  }
  /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */
  readSPS() {
    let e = 0, t = 0, s = 0, n = 0, r, o, a;
    const l = this.readUByte.bind(this), c = this.readBits.bind(this), u = this.readUEG.bind(this), d = this.readBoolean.bind(this), h = this.skipBits.bind(this), m = this.skipEG.bind(this), f = this.skipUEG.bind(this), g = this.skipScalingList.bind(this);
    l();
    const p = l();
    if (c(5), h(3), l(), f(), p === 100 || p === 110 || p === 122 || p === 244 || p === 44 || p === 83 || p === 86 || p === 118 || p === 128) {
      const R = u();
      if (R === 3 && h(1), f(), f(), h(1), d())
        for (o = R !== 3 ? 8 : 12, a = 0; a < o; a++)
          d() && (a < 6 ? g(16) : g(64));
    }
    f();
    const E = u();
    if (E === 0)
      u();
    else if (E === 1)
      for (h(1), m(), m(), r = u(), a = 0; a < r; a++)
        m();
    f(), h(1);
    const y = u(), v = u(), S = c(1);
    S === 0 && h(1), h(1), d() && (e = u(), t = u(), s = u(), n = u());
    let x = [1, 1];
    if (d() && d())
      switch (l()) {
        case 1:
          x = [1, 1];
          break;
        case 2:
          x = [12, 11];
          break;
        case 3:
          x = [10, 11];
          break;
        case 4:
          x = [16, 11];
          break;
        case 5:
          x = [40, 33];
          break;
        case 6:
          x = [24, 11];
          break;
        case 7:
          x = [20, 11];
          break;
        case 8:
          x = [32, 11];
          break;
        case 9:
          x = [80, 33];
          break;
        case 10:
          x = [18, 11];
          break;
        case 11:
          x = [15, 11];
          break;
        case 12:
          x = [64, 33];
          break;
        case 13:
          x = [160, 99];
          break;
        case 14:
          x = [4, 3];
          break;
        case 15:
          x = [3, 2];
          break;
        case 16:
          x = [2, 1];
          break;
        case 255: {
          x = [l() << 8 | l(), l() << 8 | l()];
          break;
        }
      }
    return {
      width: Math.ceil((y + 1) * 16 - e * 2 - t * 2),
      height: (2 - S) * (v + 1) * 16 - (S ? 2 : 4) * (s + n),
      pixelRatio: x
    };
  }
  readSliceType() {
    return this.readUByte(), this.readUEG(), this.readUEG();
  }
}
class Jm extends Zm {
  parseAVCPES(e, t, s, n, r) {
    const o = this.parseAVCNALu(e, s.data);
    let a = this.VideoSample, l, c = !1;
    s.data = null, a && o.length && !e.audFound && (this.pushAccessUnit(a, e), a = this.VideoSample = this.createVideoSample(!1, s.pts, s.dts, "")), o.forEach((u) => {
      var d;
      switch (u.type) {
        // NDR
        case 1: {
          let g = !1;
          l = !0;
          const p = u.data;
          if (c && p.length > 4) {
            const E = new Mr(p).readSliceType();
            (E === 2 || E === 4 || E === 7 || E === 9) && (g = !0);
          }
          if (g) {
            var h;
            (h = a) != null && h.frame && !a.key && (this.pushAccessUnit(a, e), a = this.VideoSample = null);
          }
          a || (a = this.VideoSample = this.createVideoSample(!0, s.pts, s.dts, "")), a.frame = !0, a.key = g;
          break;
        }
        case 5:
          l = !0, (d = a) != null && d.frame && !a.key && (this.pushAccessUnit(a, e), a = this.VideoSample = null), a || (a = this.VideoSample = this.createVideoSample(!0, s.pts, s.dts, "")), a.key = !0, a.frame = !0;
          break;
        // SEI
        case 6: {
          l = !0, No(u.data, 1, s.pts, t.samples);
          break;
        }
        case 7: {
          var m, f;
          l = !0, c = !0;
          const g = u.data, E = new Mr(g).readSPS();
          if (!e.sps || e.width !== E.width || e.height !== E.height || ((m = e.pixelRatio) == null ? void 0 : m[0]) !== E.pixelRatio[0] || ((f = e.pixelRatio) == null ? void 0 : f[1]) !== E.pixelRatio[1]) {
            e.width = E.width, e.height = E.height, e.pixelRatio = E.pixelRatio, e.sps = [g], e.duration = r;
            const y = g.subarray(1, 4);
            let v = "avc1.";
            for (let S = 0; S < 3; S++) {
              let x = y[S].toString(16);
              x.length < 2 && (x = "0" + x), v += x;
            }
            e.codec = v;
          }
          break;
        }
        // PPS
        case 8:
          l = !0, e.pps = [u.data];
          break;
        // AUD
        case 9:
          l = !0, e.audFound = !0, a && this.pushAccessUnit(a, e), a = this.VideoSample = this.createVideoSample(!1, s.pts, s.dts, "");
          break;
        // Filler Data
        case 12:
          l = !0;
          break;
        default:
          l = !1, a && (a.debug += "unknown NAL " + u.type + " ");
          break;
      }
      a && l && a.units.push(u);
    }), n && a && (this.pushAccessUnit(a, e), this.VideoSample = null);
  }
  parseAVCNALu(e, t) {
    const s = t.byteLength;
    let n = e.naluState || 0;
    const r = n, o = [];
    let a = 0, l, c, u, d = -1, h = 0;
    for (n === -1 && (d = 0, h = t[0] & 31, n = 0, a = 1); a < s; ) {
      if (l = t[a++], !n) {
        n = l ? 0 : 1;
        continue;
      }
      if (n === 1) {
        n = l ? 0 : 2;
        continue;
      }
      if (!l)
        n = 3;
      else if (l === 1) {
        if (c = a - n - 1, d >= 0) {
          const m = {
            data: t.subarray(d, c),
            type: h
          };
          o.push(m);
        } else {
          const m = this.getLastNalUnit(e.samples);
          m && (r && a <= 4 - r && m.state && (m.data = m.data.subarray(0, m.data.byteLength - r)), c > 0 && (m.data = $e(m.data, t.subarray(0, c)), m.state = 0));
        }
        a < s ? (u = t[a] & 31, d = a, h = u, n = 0) : n = -1;
      } else
        n = 0;
    }
    if (d >= 0 && n >= 0) {
      const m = {
        data: t.subarray(d, s),
        type: h,
        state: n
      };
      o.push(m);
    }
    if (o.length === 0) {
      const m = this.getLastNalUnit(e.samples);
      m && (m.data = $e(m.data, t));
    }
    return e.naluState = n, o;
  }
}
class eg {
  constructor(e, t, s) {
    this.keyData = void 0, this.decrypter = void 0, this.keyData = s, this.decrypter = new li(t, {
      removePKCS7Padding: !1
    });
  }
  decryptBuffer(e) {
    return this.decrypter.decrypt(e, this.keyData.key.buffer, this.keyData.iv.buffer);
  }
  // AAC - encrypt all full 16 bytes blocks starting from offset 16
  decryptAacSample(e, t, s) {
    const n = e[t].unit;
    if (n.length <= 16)
      return;
    const r = n.subarray(16, n.length - n.length % 16), o = r.buffer.slice(r.byteOffset, r.byteOffset + r.length);
    this.decryptBuffer(o).then((a) => {
      const l = new Uint8Array(a);
      n.set(l, 16), this.decrypter.isSync() || this.decryptAacSamples(e, t + 1, s);
    });
  }
  decryptAacSamples(e, t, s) {
    for (; ; t++) {
      if (t >= e.length) {
        s();
        return;
      }
      if (!(e[t].unit.length < 32) && (this.decryptAacSample(e, t, s), !this.decrypter.isSync()))
        return;
    }
  }
  // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
  getAvcEncryptedData(e) {
    const t = Math.floor((e.length - 48) / 160) * 16 + 16, s = new Int8Array(t);
    let n = 0;
    for (let r = 32; r < e.length - 16; r += 160, n += 16)
      s.set(e.subarray(r, r + 16), n);
    return s;
  }
  getAvcDecryptedUnit(e, t) {
    const s = new Uint8Array(t);
    let n = 0;
    for (let r = 32; r < e.length - 16; r += 160, n += 16)
      e.set(s.subarray(n, n + 16), r);
    return e;
  }
  decryptAvcSample(e, t, s, n, r) {
    const o = Uo(r.data), a = this.getAvcEncryptedData(o);
    this.decryptBuffer(a.buffer).then((l) => {
      r.data = this.getAvcDecryptedUnit(o, l), this.decrypter.isSync() || this.decryptAvcSamples(e, t, s + 1, n);
    });
  }
  decryptAvcSamples(e, t, s, n) {
    if (e instanceof Uint8Array)
      throw new Error("Cannot decrypt samples of type Uint8Array");
    for (; ; t++, s = 0) {
      if (t >= e.length) {
        n();
        return;
      }
      const r = e[t].units;
      for (; !(s >= r.length); s++) {
        const o = r[s];
        if (!(o.data.length <= 48 || o.type !== 1 && o.type !== 5) && (this.decryptAvcSample(e, t, s, n, o), !this.decrypter.isSync()))
          return;
      }
    }
  }
}
const Ae = 188;
class pt {
  constructor(e, t, s) {
    this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.sampleAes = null, this.pmtParsed = !1, this.audioCodec = void 0, this.videoCodec = void 0, this._duration = 0, this._pmtId = -1, this._videoTrack = void 0, this._audioTrack = void 0, this._id3Track = void 0, this._txtTrack = void 0, this.aacOverFlow = null, this.remainderData = null, this.videoParser = void 0, this.observer = e, this.config = t, this.typeSupported = s, this.videoParser = new Jm();
  }
  static probe(e) {
    const t = pt.syncOffset(e);
    return t > 0 && D.warn(`MPEG2-TS detected but first sync word found @ offset ${t}`), t !== -1;
  }
  static syncOffset(e) {
    const t = e.length;
    let s = Math.min(Ae * 5, t - Ae) + 1, n = 0;
    for (; n < s; ) {
      let r = !1, o = -1, a = 0;
      for (let l = n; l < t; l += Ae)
        if (e[l] === 71 && (t - l === Ae || e[l + Ae] === 71)) {
          if (a++, o === -1 && (o = l, o !== 0 && (s = Math.min(o + Ae * 99, e.length - Ae) + 1)), r || (r = qn(e, l) === 0), r && a > 1 && (o === 0 && a > 2 || l + Ae > s))
            return o;
        } else {
          if (a)
            return -1;
          break;
        }
      n++;
    }
    return -1;
  }
  /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */
  static createTrack(e, t) {
    return {
      container: e === "video" || e === "audio" ? "video/mp2t" : void 0,
      type: e,
      id: Mo[e],
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0,
      duration: e === "audio" ? t : void 0
    };
  }
  /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */
  resetInitSegment(e, t, s, n) {
    this.pmtParsed = !1, this._pmtId = -1, this._videoTrack = pt.createTrack("video"), this._audioTrack = pt.createTrack("audio", n), this._id3Track = pt.createTrack("id3"), this._txtTrack = pt.createTrack("text"), this._audioTrack.segmentCodec = "aac", this.aacOverFlow = null, this.remainderData = null, this.audioCodec = t, this.videoCodec = s, this._duration = n;
  }
  resetTimeStamp() {
  }
  resetContiguity() {
    const {
      _audioTrack: e,
      _videoTrack: t,
      _id3Track: s
    } = this;
    e && (e.pesData = null), t && (t.pesData = null), s && (s.pesData = null), this.aacOverFlow = null, this.remainderData = null;
  }
  demux(e, t, s = !1, n = !1) {
    s || (this.sampleAes = null);
    let r;
    const o = this._videoTrack, a = this._audioTrack, l = this._id3Track, c = this._txtTrack;
    let u = o.pid, d = o.pesData, h = a.pid, m = l.pid, f = a.pesData, g = l.pesData, p = null, E = this.pmtParsed, y = this._pmtId, v = e.length;
    if (this.remainderData && (e = $e(this.remainderData, e), v = e.length, this.remainderData = null), v < Ae && !n)
      return this.remainderData = e, {
        audioTrack: a,
        videoTrack: o,
        id3Track: l,
        textTrack: c
      };
    const S = Math.max(0, pt.syncOffset(e));
    v -= (v - S) % Ae, v < e.byteLength && !n && (this.remainderData = new Uint8Array(e.buffer, v, e.buffer.byteLength - v));
    let x = 0;
    for (let L = S; L < v; L += Ae)
      if (e[L] === 71) {
        const _ = !!(e[L + 1] & 64), A = qn(e, L), I = (e[L + 3] & 48) >> 4;
        let w;
        if (I > 1) {
          if (w = L + 5 + e[L + 4], w === L + Ae)
            continue;
        } else
          w = L + 4;
        switch (A) {
          case u:
            _ && (d && (r = Ft(d)) && this.videoParser.parseAVCPES(o, c, r, !1, this._duration), d = {
              data: [],
              size: 0
            }), d && (d.data.push(e.subarray(w, L + Ae)), d.size += L + Ae - w);
            break;
          case h:
            if (_) {
              if (f && (r = Ft(f)))
                switch (a.segmentCodec) {
                  case "aac":
                    this.parseAACPES(a, r);
                    break;
                  case "mp3":
                    this.parseMPEGPES(a, r);
                    break;
                  case "ac3":
                    this.parseAC3PES(a, r);
                    break;
                }
              f = {
                data: [],
                size: 0
              };
            }
            f && (f.data.push(e.subarray(w, L + Ae)), f.size += L + Ae - w);
            break;
          case m:
            _ && (g && (r = Ft(g)) && this.parseID3PES(l, r), g = {
              data: [],
              size: 0
            }), g && (g.data.push(e.subarray(w, L + Ae)), g.size += L + Ae - w);
            break;
          case 0:
            _ && (w += e[w] + 1), y = this._pmtId = tg(e, w);
            break;
          case y: {
            _ && (w += e[w] + 1);
            const $ = sg(e, w, this.typeSupported, s, this.observer);
            u = $.videoPid, u > 0 && (o.pid = u, o.segmentCodec = $.segmentVideoCodec), h = $.audioPid, h > 0 && (a.pid = h, a.segmentCodec = $.segmentAudioCodec), m = $.id3Pid, m > 0 && (l.pid = m), p !== null && !E && (D.warn(`MPEG-TS PMT found at ${L} after unknown PID '${p}'. Backtracking to sync byte @${S} to parse all TS packets.`), p = null, L = S - 188), E = this.pmtParsed = !0;
            break;
          }
          case 17:
          case 8191:
            break;
          default:
            p = A;
            break;
        }
      } else
        x++;
    x > 0 && Qs(this.observer, new Error(`Found ${x} TS packet/s that do not start with 0x47`)), o.pesData = d, a.pesData = f, l.pesData = g;
    const R = {
      audioTrack: a,
      videoTrack: o,
      id3Track: l,
      textTrack: c
    };
    return n && this.extractRemainingSamples(R), R;
  }
  flush() {
    const {
      remainderData: e
    } = this;
    this.remainderData = null;
    let t;
    return e ? t = this.demux(e, -1, !1, !0) : t = {
      videoTrack: this._videoTrack,
      audioTrack: this._audioTrack,
      id3Track: this._id3Track,
      textTrack: this._txtTrack
    }, this.extractRemainingSamples(t), this.sampleAes ? this.decrypt(t, this.sampleAes) : t;
  }
  extractRemainingSamples(e) {
    const {
      audioTrack: t,
      videoTrack: s,
      id3Track: n,
      textTrack: r
    } = e, o = s.pesData, a = t.pesData, l = n.pesData;
    let c;
    if (o && (c = Ft(o)) ? (this.videoParser.parseAVCPES(s, r, c, !0, this._duration), s.pesData = null) : s.pesData = o, a && (c = Ft(a))) {
      switch (t.segmentCodec) {
        case "aac":
          this.parseAACPES(t, c);
          break;
        case "mp3":
          this.parseMPEGPES(t, c);
          break;
        case "ac3":
          this.parseAC3PES(t, c);
          break;
      }
      t.pesData = null;
    } else
      a != null && a.size && D.log("last AAC PES packet truncated,might overlap between fragments"), t.pesData = a;
    l && (c = Ft(l)) ? (this.parseID3PES(n, c), n.pesData = null) : n.pesData = l;
  }
  demuxSampleAes(e, t, s) {
    const n = this.demux(e, s, !0, !this.config.progressive), r = this.sampleAes = new eg(this.observer, this.config, t);
    return this.decrypt(n, r);
  }
  decrypt(e, t) {
    return new Promise((s) => {
      const {
        audioTrack: n,
        videoTrack: r
      } = e;
      n.samples && n.segmentCodec === "aac" ? t.decryptAacSamples(n.samples, 0, () => {
        r.samples ? t.decryptAvcSamples(r.samples, 0, 0, () => {
          s(e);
        }) : s(e);
      }) : r.samples && t.decryptAvcSamples(r.samples, 0, 0, () => {
        s(e);
      });
    });
  }
  destroy() {
    this._duration = 0;
  }
  parseAACPES(e, t) {
    let s = 0;
    const n = this.aacOverFlow;
    let r = t.data;
    if (n) {
      this.aacOverFlow = null;
      const d = n.missing, h = n.sample.unit.byteLength;
      if (d === -1)
        r = $e(n.sample.unit, r);
      else {
        const m = h - d;
        n.sample.unit.set(r.subarray(0, d), m), e.samples.push(n.sample), s = n.missing;
      }
    }
    let o, a;
    for (o = s, a = r.length; o < a - 1 && !Xs(r, o); o++)
      ;
    if (o !== s) {
      let d;
      const h = o < a - 1;
      if (h ? d = `AAC PES did not start with ADTS header,offset:${o}` : d = "No ADTS header found in AAC PES", Qs(this.observer, new Error(d), h), !h)
        return;
    }
    Jo(e, this.observer, r, o, this.audioCodec);
    let l;
    if (t.pts !== void 0)
      l = t.pts;
    else if (n) {
      const d = ea(e.samplerate);
      l = n.sample.pts + d;
    } else {
      D.warn("[tsdemuxer]: AAC PES unknown PTS");
      return;
    }
    let c = 0, u;
    for (; o < a; )
      if (u = ta(e, r, o, l, c), o += u.length, u.missing) {
        this.aacOverFlow = u;
        break;
      } else
        for (c++; o < a - 1 && !Xs(r, o); o++)
          ;
  }
  parseMPEGPES(e, t) {
    const s = t.data, n = s.length;
    let r = 0, o = 0;
    const a = t.pts;
    if (a === void 0) {
      D.warn("[tsdemuxer]: MPEG PES unknown PTS");
      return;
    }
    for (; o < n; )
      if (ia(s, o)) {
        const l = sa(e, s, o, a, r);
        if (l)
          o += l.length, r++;
        else
          break;
      } else
        o++;
  }
  parseAC3PES(e, t) {
    {
      const s = t.data, n = t.pts;
      if (n === void 0) {
        D.warn("[tsdemuxer]: AC3 PES unknown PTS");
        return;
      }
      const r = s.length;
      let o = 0, a = 0, l;
      for (; a < r && (l = aa(e, s, a, n, o++)) > 0; )
        a += l;
    }
  }
  parseID3PES(e, t) {
    if (t.pts === void 0) {
      D.warn("[tsdemuxer]: ID3 PES unknown PTS");
      return;
    }
    const s = ve({}, t, {
      type: this._videoTrack ? We.emsg : We.audioId3,
      duration: Number.POSITIVE_INFINITY
    });
    e.samples.push(s);
  }
}
function qn(i, e) {
  return ((i[e + 1] & 31) << 8) + i[e + 2];
}
function tg(i, e) {
  return (i[e + 10] & 31) << 8 | i[e + 11];
}
function sg(i, e, t, s, n) {
  const r = {
    audioPid: -1,
    videoPid: -1,
    id3Pid: -1,
    segmentVideoCodec: "avc",
    segmentAudioCodec: "aac"
  }, o = (i[e + 1] & 15) << 8 | i[e + 2], a = e + 3 + o - 4, l = (i[e + 10] & 15) << 8 | i[e + 11];
  for (e += 12 + l; e < a; ) {
    const c = qn(i, e), u = (i[e + 3] & 15) << 8 | i[e + 4];
    switch (i[e]) {
      case 207:
        if (!s) {
          xn("ADTS AAC");
          break;
        }
      /* falls through */
      case 15:
        r.audioPid === -1 && (r.audioPid = c);
        break;
      // Packetized metadata (ID3)
      case 21:
        r.id3Pid === -1 && (r.id3Pid = c);
        break;
      case 219:
        if (!s) {
          xn("H.264");
          break;
        }
      /* falls through */
      case 27:
        r.videoPid === -1 && (r.videoPid = c, r.segmentVideoCodec = "avc");
        break;
      // ISO/IEC 11172-3 (MPEG-1 audio)
      // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
      case 3:
      case 4:
        !t.mpeg && !t.mp3 ? D.log("MPEG audio found, not supported in this browser") : r.audioPid === -1 && (r.audioPid = c, r.segmentAudioCodec = "mp3");
        break;
      case 193:
        if (!s) {
          xn("AC-3");
          break;
        }
      /* falls through */
      case 129:
        t.ac3 ? r.audioPid === -1 && (r.audioPid = c, r.segmentAudioCodec = "ac3") : D.log("AC-3 audio found, not supported in this browser");
        break;
      case 6:
        if (r.audioPid === -1 && u > 0) {
          let d = e + 5, h = u;
          for (; h > 2; ) {
            i[d] === 106 && (t.ac3 !== !0 ? D.log("AC-3 audio found, not supported in this browser for now") : (r.audioPid = c, r.segmentAudioCodec = "ac3"));
            const f = i[d + 1] + 2;
            d += f, h -= f;
          }
        }
        break;
      case 194:
      // SAMPLE-AES EC3
      /* falls through */
      case 135:
        return Qs(n, new Error("Unsupported EC-3 in M2TS found")), r;
      case 36:
        return Qs(n, new Error("Unsupported HEVC in M2TS found")), r;
    }
    e += u + 5;
  }
  return r;
}
function Qs(i, e, t) {
  D.warn(`parsing error: ${e.message}`), i.emit(T.ERROR, T.ERROR, {
    type: Z.MEDIA_ERROR,
    details: C.FRAG_PARSING_ERROR,
    fatal: !1,
    levelRetry: t,
    error: e,
    reason: e.message
  });
}
function xn(i) {
  D.log(`${i} with AES-128-CBC encryption found in unencrypted stream`);
}
function Ft(i) {
  let e = 0, t, s, n, r, o;
  const a = i.data;
  if (!i || i.size === 0)
    return null;
  for (; a[0].length < 19 && a.length > 1; )
    a[0] = $e(a[0], a[1]), a.splice(1, 1);
  if (t = a[0], (t[0] << 16) + (t[1] << 8) + t[2] === 1) {
    if (s = (t[4] << 8) + t[5], s && s > i.size - 6)
      return null;
    const c = t[7];
    c & 192 && (r = (t[9] & 14) * 536870912 + // 1 << 29
    (t[10] & 255) * 4194304 + // 1 << 22
    (t[11] & 254) * 16384 + // 1 << 14
    (t[12] & 255) * 128 + // 1 << 7
    (t[13] & 254) / 2, c & 64 ? (o = (t[14] & 14) * 536870912 + // 1 << 29
    (t[15] & 255) * 4194304 + // 1 << 22
    (t[16] & 254) * 16384 + // 1 << 14
    (t[17] & 255) * 128 + // 1 << 7
    (t[18] & 254) / 2, r - o > 60 * 9e4 && (D.warn(`${Math.round((r - o) / 9e4)}s delta between PTS and DTS, align them`), r = o)) : o = r), n = t[8];
    let u = n + 9;
    if (i.size <= u)
      return null;
    i.size -= u;
    const d = new Uint8Array(i.size);
    for (let h = 0, m = a.length; h < m; h++) {
      t = a[h];
      let f = t.byteLength;
      if (u)
        if (u > f) {
          u -= f;
          continue;
        } else
          t = t.subarray(u), f -= u, u = 0;
      d.set(t, e), e += f;
    }
    return s && (s -= n + 3), {
      data: d,
      pts: r,
      dts: o,
      len: s
    };
  }
  return null;
}
class ng extends ui {
  resetInitSegment(e, t, s, n) {
    super.resetInitSegment(e, t, s, n), this._audioTrack = {
      container: "audio/mpeg",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "mp3",
      samples: [],
      manifestCodec: t,
      duration: n,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  static probe(e) {
    if (!e)
      return !1;
    const t = ss(e, 0);
    let s = (t == null ? void 0 : t.length) || 0;
    if (t && e[s] === 11 && e[s + 1] === 119 && ii(t) !== void 0 && // check the bsid to confirm ac-3 or ec-3 (not mp3)
    oa(e, s) <= 16)
      return !1;
    for (let n = e.length; s < n; s++)
      if (ra(e, s))
        return D.log("MPEG Audio sync word found !"), !0;
    return !1;
  }
  canParse(e, t) {
    return qm(e, t);
  }
  appendFrame(e, t, s) {
    if (this.basePTS !== null)
      return sa(e, t, s, this.basePTS, this.frameIndex);
  }
}
class kr {
  static getSilentFrame(e, t) {
    switch (e) {
      case "mp4a.40.2":
        if (t === 1)
          return new Uint8Array([0, 200, 0, 128, 35, 128]);
        if (t === 2)
          return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
        if (t === 3)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
        if (t === 4)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
        if (t === 5)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
        if (t === 6)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
        break;
      // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
      default:
        if (t === 1)
          return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (t === 2)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (t === 3)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        break;
    }
  }
}
const gt = Math.pow(2, 32) - 1;
class b {
  static init() {
    b.types = {
      avc1: [],
      // codingname
      avcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      ".mp3": [],
      dac3: [],
      "ac-3": [],
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: [],
      smhd: []
    };
    let e;
    for (e in b.types)
      b.types.hasOwnProperty(e) && (b.types[e] = [e.charCodeAt(0), e.charCodeAt(1), e.charCodeAt(2), e.charCodeAt(3)]);
    const t = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      118,
      105,
      100,
      101,
      // handler_type: 'vide'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      86,
      105,
      100,
      101,
      111,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'VideoHandler'
    ]), s = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      115,
      111,
      117,
      110,
      // handler_type: 'soun'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      83,
      111,
      117,
      110,
      100,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'SoundHandler'
    ]);
    b.HDLR_TYPES = {
      video: t,
      audio: s
    };
    const n = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1,
      // entry_count
      0,
      0,
      0,
      12,
      // entry_size
      117,
      114,
      108,
      32,
      // 'url' type
      0,
      // version 0
      0,
      0,
      1
      // entry_flags
    ]), r = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0
      // entry_count
    ]);
    b.STTS = b.STSC = b.STCO = r, b.STSZ = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // sample_size
      0,
      0,
      0,
      0
      // sample_count
    ]), b.VMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      1,
      // flags
      0,
      0,
      // graphicsmode
      0,
      0,
      0,
      0,
      0,
      0
      // opcolor
    ]), b.SMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      // balance
      0,
      0
      // reserved
    ]), b.STSD = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1
    ]);
    const o = new Uint8Array([105, 115, 111, 109]), a = new Uint8Array([97, 118, 99, 49]), l = new Uint8Array([0, 0, 0, 1]);
    b.FTYP = b.box(b.types.ftyp, o, l, o, a), b.DINF = b.box(b.types.dinf, b.box(b.types.dref, n));
  }
  static box(e, ...t) {
    let s = 8, n = t.length;
    const r = n;
    for (; n--; )
      s += t[n].byteLength;
    const o = new Uint8Array(s);
    for (o[0] = s >> 24 & 255, o[1] = s >> 16 & 255, o[2] = s >> 8 & 255, o[3] = s & 255, o.set(e, 4), n = 0, s = 8; n < r; n++)
      o.set(t[n], s), s += t[n].byteLength;
    return o;
  }
  static hdlr(e) {
    return b.box(b.types.hdlr, b.HDLR_TYPES[e]);
  }
  static mdat(e) {
    return b.box(b.types.mdat, e);
  }
  static mdhd(e, t) {
    t *= e;
    const s = Math.floor(t / (gt + 1)), n = Math.floor(t % (gt + 1));
    return b.box(b.types.mdhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      s >> 24,
      s >> 16 & 255,
      s >> 8 & 255,
      s & 255,
      n >> 24,
      n >> 16 & 255,
      n >> 8 & 255,
      n & 255,
      85,
      196,
      // 'und' language (undetermined)
      0,
      0
    ]));
  }
  static mdia(e) {
    return b.box(b.types.mdia, b.mdhd(e.timescale, e.duration), b.hdlr(e.type), b.minf(e));
  }
  static mfhd(e) {
    return b.box(b.types.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      // flags
      e >> 24,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255
      // sequence_number
    ]));
  }
  static minf(e) {
    return e.type === "audio" ? b.box(b.types.minf, b.box(b.types.smhd, b.SMHD), b.DINF, b.stbl(e)) : b.box(b.types.minf, b.box(b.types.vmhd, b.VMHD), b.DINF, b.stbl(e));
  }
  static moof(e, t, s) {
    return b.box(b.types.moof, b.mfhd(e), b.traf(s, t));
  }
  static moov(e) {
    let t = e.length;
    const s = [];
    for (; t--; )
      s[t] = b.trak(e[t]);
    return b.box.apply(null, [b.types.moov, b.mvhd(e[0].timescale, e[0].duration)].concat(s).concat(b.mvex(e)));
  }
  static mvex(e) {
    let t = e.length;
    const s = [];
    for (; t--; )
      s[t] = b.trex(e[t]);
    return b.box.apply(null, [b.types.mvex, ...s]);
  }
  static mvhd(e, t) {
    t *= e;
    const s = Math.floor(t / (gt + 1)), n = Math.floor(t % (gt + 1)), r = new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      s >> 24,
      s >> 16 & 255,
      s >> 8 & 255,
      s & 255,
      n >> 24,
      n >> 16 & 255,
      n >> 8 & 255,
      n & 255,
      0,
      1,
      0,
      0,
      // 1.0 rate
      1,
      0,
      // 1.0 volume
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // pre_defined
      255,
      255,
      255,
      255
      // next_track_ID
    ]);
    return b.box(b.types.mvhd, r);
  }
  static sdtp(e) {
    const t = e.samples || [], s = new Uint8Array(4 + t.length);
    let n, r;
    for (n = 0; n < t.length; n++)
      r = t[n].flags, s[n + 4] = r.dependsOn << 4 | r.isDependedOn << 2 | r.hasRedundancy;
    return b.box(b.types.sdtp, s);
  }
  static stbl(e) {
    return b.box(b.types.stbl, b.stsd(e), b.box(b.types.stts, b.STTS), b.box(b.types.stsc, b.STSC), b.box(b.types.stsz, b.STSZ), b.box(b.types.stco, b.STCO));
  }
  static avc1(e) {
    let t = [], s = [], n, r, o;
    for (n = 0; n < e.sps.length; n++)
      r = e.sps[n], o = r.byteLength, t.push(o >>> 8 & 255), t.push(o & 255), t = t.concat(Array.prototype.slice.call(r));
    for (n = 0; n < e.pps.length; n++)
      r = e.pps[n], o = r.byteLength, s.push(o >>> 8 & 255), s.push(o & 255), s = s.concat(Array.prototype.slice.call(r));
    const a = b.box(b.types.avcC, new Uint8Array([
      1,
      // version
      t[3],
      // profile
      t[4],
      // profile compat
      t[5],
      // level
      255,
      // lengthSizeMinusOne, hard-coded to 4 bytes
      224 | e.sps.length
      // 3bit reserved (111) + numOfSequenceParameterSets
    ].concat(t).concat([
      e.pps.length
      // numOfPictureParameterSets
    ]).concat(s))), l = e.width, c = e.height, u = e.pixelRatio[0], d = e.pixelRatio[1];
    return b.box(
      b.types.avc1,
      new Uint8Array([
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        l >> 8 & 255,
        l & 255,
        // width
        c >> 8 & 255,
        c & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        18,
        100,
        97,
        105,
        108,
        // dailymotion/hls.js
        121,
        109,
        111,
        116,
        105,
        111,
        110,
        47,
        104,
        108,
        115,
        46,
        106,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
      ]),
      // pre_defined = -1
      a,
      b.box(b.types.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
      ])),
      // avgBitrate
      b.box(b.types.pasp, new Uint8Array([
        u >> 24,
        // hSpacing
        u >> 16 & 255,
        u >> 8 & 255,
        u & 255,
        d >> 24,
        // vSpacing
        d >> 16 & 255,
        d >> 8 & 255,
        d & 255
      ]))
    );
  }
  static esds(e) {
    const t = e.config.length;
    return new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      3,
      // descriptor_type
      23 + t,
      // length
      0,
      1,
      // es_id
      0,
      // stream_priority
      4,
      // descriptor_type
      15 + t,
      // length
      64,
      // codec : mpeg4_audio
      21,
      // stream_type
      0,
      0,
      0,
      // buffer_size
      0,
      0,
      0,
      0,
      // maxBitrate
      0,
      0,
      0,
      0,
      // avgBitrate
      5
      // descriptor_type
    ].concat([t]).concat(e.config).concat([6, 1, 2]));
  }
  static audioStsd(e) {
    const t = e.samplerate;
    return new Uint8Array([
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      // reserved
      0,
      1,
      // data_reference_index
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      e.channelCount,
      // channelcount
      0,
      16,
      // sampleSize:16bits
      0,
      0,
      0,
      0,
      // reserved2
      t >> 8 & 255,
      t & 255,
      //
      0,
      0
    ]);
  }
  static mp4a(e) {
    return b.box(b.types.mp4a, b.audioStsd(e), b.box(b.types.esds, b.esds(e)));
  }
  static mp3(e) {
    return b.box(b.types[".mp3"], b.audioStsd(e));
  }
  static ac3(e) {
    return b.box(b.types["ac-3"], b.audioStsd(e), b.box(b.types.dac3, e.config));
  }
  static stsd(e) {
    return e.type === "audio" ? e.segmentCodec === "mp3" && e.codec === "mp3" ? b.box(b.types.stsd, b.STSD, b.mp3(e)) : e.segmentCodec === "ac3" ? b.box(b.types.stsd, b.STSD, b.ac3(e)) : b.box(b.types.stsd, b.STSD, b.mp4a(e)) : b.box(b.types.stsd, b.STSD, b.avc1(e));
  }
  static tkhd(e) {
    const t = e.id, s = e.duration * e.timescale, n = e.width, r = e.height, o = Math.floor(s / (gt + 1)), a = Math.floor(s % (gt + 1));
    return b.box(b.types.tkhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      7,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      t >> 24 & 255,
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255,
      // track_ID
      0,
      0,
      0,
      0,
      // reserved
      o >> 24,
      o >> 16 & 255,
      o >> 8 & 255,
      o & 255,
      a >> 24,
      a >> 16 & 255,
      a >> 8 & 255,
      a & 255,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      // layer
      0,
      0,
      // alternate_group
      0,
      0,
      // non-audio track volume
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      n >> 8 & 255,
      n & 255,
      0,
      0,
      // width
      r >> 8 & 255,
      r & 255,
      0,
      0
      // height
    ]));
  }
  static traf(e, t) {
    const s = b.sdtp(e), n = e.id, r = Math.floor(t / (gt + 1)), o = Math.floor(t % (gt + 1));
    return b.box(
      b.types.traf,
      b.box(b.types.tfhd, new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        n >> 24,
        n >> 16 & 255,
        n >> 8 & 255,
        n & 255
        // track_ID
      ])),
      b.box(b.types.tfdt, new Uint8Array([
        1,
        // version 1
        0,
        0,
        0,
        // flags
        r >> 24,
        r >> 16 & 255,
        r >> 8 & 255,
        r & 255,
        o >> 24,
        o >> 16 & 255,
        o >> 8 & 255,
        o & 255
      ])),
      b.trun(e, s.length + 16 + // tfhd
      20 + // tfdt
      8 + // traf header
      16 + // mfhd
      8 + // moof header
      8),
      // mdat header
      s
    );
  }
  /**
   * Generate a track box.
   * @param track a track definition
   */
  static trak(e) {
    return e.duration = e.duration || 4294967295, b.box(b.types.trak, b.tkhd(e), b.mdia(e));
  }
  static trex(e) {
    const t = e.id;
    return b.box(b.types.trex, new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      t >> 24,
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // default_sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      1,
      0,
      1
      // default_sample_flags
    ]));
  }
  static trun(e, t) {
    const s = e.samples || [], n = s.length, r = 12 + 16 * n, o = new Uint8Array(r);
    let a, l, c, u, d, h;
    for (t += 8 + r, o.set([
      e.type === "video" ? 1 : 0,
      // version 1 for video with signed-int sample_composition_time_offset
      0,
      15,
      1,
      // flags
      n >>> 24 & 255,
      n >>> 16 & 255,
      n >>> 8 & 255,
      n & 255,
      // sample_count
      t >>> 24 & 255,
      t >>> 16 & 255,
      t >>> 8 & 255,
      t & 255
      // data_offset
    ], 0), a = 0; a < n; a++)
      l = s[a], c = l.duration, u = l.size, d = l.flags, h = l.cts, o.set([
        c >>> 24 & 255,
        c >>> 16 & 255,
        c >>> 8 & 255,
        c & 255,
        // sample_duration
        u >>> 24 & 255,
        u >>> 16 & 255,
        u >>> 8 & 255,
        u & 255,
        // sample_size
        d.isLeading << 2 | d.dependsOn,
        d.isDependedOn << 6 | d.hasRedundancy << 4 | d.paddingValue << 1 | d.isNonSync,
        d.degradPrio & 61440,
        d.degradPrio & 15,
        // sample_flags
        h >>> 24 & 255,
        h >>> 16 & 255,
        h >>> 8 & 255,
        h & 255
        // sample_composition_time_offset
      ], 12 + 16 * a);
    return b.box(b.types.trun, o);
  }
  static initSegment(e) {
    b.types || b.init();
    const t = b.moov(e);
    return $e(b.FTYP, t);
  }
}
b.types = void 0;
b.HDLR_TYPES = void 0;
b.STTS = void 0;
b.STSC = void 0;
b.STCO = void 0;
b.STSZ = void 0;
b.VMHD = void 0;
b.SMHD = void 0;
b.STSD = void 0;
b.FTYP = void 0;
b.DINF = void 0;
const la = 9e4;
function fi(i, e, t = 1, s = !1) {
  const n = i * e * t;
  return s ? Math.round(n) : n;
}
function ig(i, e, t = 1, s = !1) {
  return fi(i, e, 1 / t, s);
}
function Xt(i, e = !1) {
  return fi(i, 1e3, 1 / la, e);
}
function rg(i, e = 1) {
  return fi(i, la, 1 / e);
}
const og = 10 * 1e3, Fr = 1024, ag = 1152, lg = 1536;
let Pt = null, vn = null;
class Ms {
  constructor(e, t, s, n = "") {
    if (this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.ISGenerated = !1, this._initPTS = null, this._initDTS = null, this.nextAvcDts = null, this.nextAudioPts = null, this.videoSampleDuration = null, this.isAudioContiguous = !1, this.isVideoContiguous = !1, this.videoTrackConfig = void 0, this.observer = e, this.config = t, this.typeSupported = s, this.ISGenerated = !1, Pt === null) {
      const o = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      Pt = o ? parseInt(o[1]) : 0;
    }
    if (vn === null) {
      const r = navigator.userAgent.match(/Safari\/(\d+)/i);
      vn = r ? parseInt(r[1]) : 0;
    }
  }
  destroy() {
    this.config = this.videoTrackConfig = this._initPTS = this._initDTS = null;
  }
  resetTimeStamp(e) {
    D.log("[mp4-remuxer]: initPTS & initDTS reset"), this._initPTS = this._initDTS = e;
  }
  resetNextTimestamp() {
    D.log("[mp4-remuxer]: reset next timestamp"), this.isVideoContiguous = !1, this.isAudioContiguous = !1;
  }
  resetInitSegment() {
    D.log("[mp4-remuxer]: ISGenerated flag reset"), this.ISGenerated = !1, this.videoTrackConfig = void 0;
  }
  getVideoStartPts(e) {
    let t = !1;
    const s = e.reduce((n, r) => {
      const o = r.pts - n;
      return o < -4294967296 ? (t = !0, Be(n, r.pts)) : o > 0 ? n : r.pts;
    }, e[0].pts);
    return t && D.debug("PTS rollover detected"), s;
  }
  remux(e, t, s, n, r, o, a, l) {
    let c, u, d, h, m, f, g = r, p = r;
    const E = e.pid > -1, y = t.pid > -1, v = t.samples.length, S = e.samples.length > 0, x = a && v > 0 || v > 1;
    if ((!E || S) && (!y || x) || this.ISGenerated || a) {
      if (this.ISGenerated) {
        var L, _, A, I;
        const U = this.videoTrackConfig;
        U && (t.width !== U.width || t.height !== U.height || ((L = t.pixelRatio) == null ? void 0 : L[0]) !== ((_ = U.pixelRatio) == null ? void 0 : _[0]) || ((A = t.pixelRatio) == null ? void 0 : A[1]) !== ((I = U.pixelRatio) == null ? void 0 : I[1])) && this.resetInitSegment();
      } else
        d = this.generateIS(e, t, r, o);
      const w = this.isVideoContiguous;
      let $ = -1, M;
      if (x && ($ = cg(t.samples), !w && this.config.forceKeyFrameOnDiscontinuity))
        if (f = !0, $ > 0) {
          D.warn(`[mp4-remuxer]: Dropped ${$} out of ${v} video samples due to a missing keyframe`);
          const U = this.getVideoStartPts(t.samples);
          t.samples = t.samples.slice($), t.dropped += $, p += (t.samples[0].pts - U) / t.inputTimeScale, M = p;
        } else $ === -1 && (D.warn(`[mp4-remuxer]: No keyframe found out of ${v} video samples`), f = !1);
      if (this.ISGenerated) {
        if (S && x) {
          const U = this.getVideoStartPts(t.samples), H = (Be(e.samples[0].pts, U) - U) / t.inputTimeScale;
          g += Math.max(0, H), p += Math.max(0, -H);
        }
        if (S) {
          if (e.samplerate || (D.warn("[mp4-remuxer]: regenerate InitSegment as audio detected"), d = this.generateIS(e, t, r, o)), u = this.remuxAudio(e, g, this.isAudioContiguous, o, y || x || l === Q.AUDIO ? p : void 0), x) {
            const U = u ? u.endPTS - u.startPTS : 0;
            t.inputTimeScale || (D.warn("[mp4-remuxer]: regenerate InitSegment as video detected"), d = this.generateIS(e, t, r, o)), c = this.remuxVideo(t, p, w, U);
          }
        } else x && (c = this.remuxVideo(t, p, w, 0));
        c && (c.firstKeyFrame = $, c.independent = $ !== -1, c.firstKeyFramePTS = M);
      }
    }
    return this.ISGenerated && this._initPTS && this._initDTS && (s.samples.length && (m = ca(s, r, this._initPTS, this._initDTS)), n.samples.length && (h = ua(n, r, this._initPTS))), {
      audio: u,
      video: c,
      initSegment: d,
      independent: f,
      text: h,
      id3: m
    };
  }
  generateIS(e, t, s, n) {
    const r = e.samples, o = t.samples, a = this.typeSupported, l = {}, c = this._initPTS;
    let u = !c || n, d = "audio/mp4", h, m, f;
    if (u && (h = m = 1 / 0), e.config && r.length) {
      switch (e.timescale = e.samplerate, e.segmentCodec) {
        case "mp3":
          a.mpeg ? (d = "audio/mpeg", e.codec = "") : a.mp3 && (e.codec = "mp3");
          break;
        case "ac3":
          e.codec = "ac-3";
          break;
      }
      l.audio = {
        id: "audio",
        container: d,
        codec: e.codec,
        initSegment: e.segmentCodec === "mp3" && a.mpeg ? new Uint8Array(0) : b.initSegment([e]),
        metadata: {
          channelCount: e.channelCount
        }
      }, u && (f = e.inputTimeScale, !c || f !== c.timescale ? h = m = r[0].pts - Math.round(f * s) : u = !1);
    }
    if (t.sps && t.pps && o.length) {
      if (t.timescale = t.inputTimeScale, l.video = {
        id: "main",
        container: "video/mp4",
        codec: t.codec,
        initSegment: b.initSegment([t]),
        metadata: {
          width: t.width,
          height: t.height
        }
      }, u)
        if (f = t.inputTimeScale, !c || f !== c.timescale) {
          const g = this.getVideoStartPts(o), p = Math.round(f * s);
          m = Math.min(m, Be(o[0].dts, g) - p), h = Math.min(h, g - p);
        } else
          u = !1;
      this.videoTrackConfig = {
        width: t.width,
        height: t.height,
        pixelRatio: t.pixelRatio
      };
    }
    if (Object.keys(l).length)
      return this.ISGenerated = !0, u ? (this._initPTS = {
        baseTime: h,
        timescale: f
      }, this._initDTS = {
        baseTime: m,
        timescale: f
      }) : h = f = void 0, {
        tracks: l,
        initPTS: h,
        timescale: f
      };
  }
  remuxVideo(e, t, s, n) {
    const r = e.inputTimeScale, o = e.samples, a = [], l = o.length, c = this._initPTS;
    let u = this.nextAvcDts, d = 8, h = this.videoSampleDuration, m, f, g = Number.POSITIVE_INFINITY, p = Number.NEGATIVE_INFINITY, E = !1;
    if (!s || u === null) {
      const O = t * r, P = o[0].pts - Be(o[0].dts, o[0].pts);
      Pt && u !== null && Math.abs(O - P - u) < 15e3 ? s = !0 : u = O - P;
    }
    const y = c.baseTime * r / c.timescale;
    for (let O = 0; O < l; O++) {
      const P = o[O];
      P.pts = Be(P.pts - y, u), P.dts = Be(P.dts - y, u), P.dts < o[O > 0 ? O - 1 : O].dts && (E = !0);
    }
    E && o.sort(function(O, P) {
      const W = O.dts - P.dts, K = O.pts - P.pts;
      return W || K;
    }), m = o[0].dts, f = o[o.length - 1].dts;
    const v = f - m, S = v ? Math.round(v / (l - 1)) : h || e.inputTimeScale / 30;
    if (s) {
      const O = m - u, P = O > S, W = O < -1;
      if ((P || W) && (P ? D.warn(`AVC: ${Xt(O, !0)} ms (${O}dts) hole between fragments detected at ${t.toFixed(3)}`) : D.warn(`AVC: ${Xt(-O, !0)} ms (${O}dts) overlapping between fragments detected at ${t.toFixed(3)}`), !W || u >= o[0].pts || Pt)) {
        m = u;
        const K = o[0].pts - O;
        if (P)
          o[0].dts = m, o[0].pts = K;
        else
          for (let J = 0; J < o.length && !(o[J].dts > K); J++)
            o[J].dts -= O, o[J].pts -= O;
        D.log(`Video: Initial PTS/DTS adjusted: ${Xt(K, !0)}/${Xt(m, !0)}, delta: ${Xt(O, !0)} ms`);
      }
    }
    m = Math.max(0, m);
    let x = 0, R = 0, L = m;
    for (let O = 0; O < l; O++) {
      const P = o[O], W = P.units, K = W.length;
      let J = 0;
      for (let j = 0; j < K; j++)
        J += W[j].data.length;
      R += J, x += K, P.length = J, P.dts < L ? (P.dts = L, L += S / 4 | 0 || 1) : L = P.dts, g = Math.min(P.pts, g), p = Math.max(P.pts, p);
    }
    f = o[l - 1].dts;
    const _ = R + 4 * x + 8;
    let A;
    try {
      A = new Uint8Array(_);
    } catch (O) {
      this.observer.emit(T.ERROR, T.ERROR, {
        type: Z.MUX_ERROR,
        details: C.REMUX_ALLOC_ERROR,
        fatal: !1,
        error: O,
        bytes: _,
        reason: `fail allocating video mdat ${_}`
      });
      return;
    }
    const I = new DataView(A.buffer);
    I.setUint32(0, _), A.set(b.types.mdat, 4);
    let w = !1, $ = Number.POSITIVE_INFINITY, M = Number.POSITIVE_INFINITY, U = Number.NEGATIVE_INFINITY, N = Number.NEGATIVE_INFINITY;
    for (let O = 0; O < l; O++) {
      const P = o[O], W = P.units;
      let K = 0;
      for (let z = 0, ne = W.length; z < ne; z++) {
        const he = W[z], Fe = he.data, we = he.data.byteLength;
        I.setUint32(d, we), d += 4, A.set(Fe, d), d += we, K += 4 + we;
      }
      let J;
      if (O < l - 1)
        h = o[O + 1].dts - P.dts, J = o[O + 1].pts - P.pts;
      else {
        const z = this.config, ne = O > 0 ? P.dts - o[O - 1].dts : S;
        if (J = O > 0 ? P.pts - o[O - 1].pts : S, z.stretchShortVideoTrack && this.nextAudioPts !== null) {
          const he = Math.floor(z.maxBufferHole * r), Fe = (n ? g + n * r : this.nextAudioPts) - P.pts;
          Fe > he ? (h = Fe - ne, h < 0 ? h = ne : w = !0, D.log(`[mp4-remuxer]: It is approximately ${Fe / 90} ms to the next segment; using duration ${h / 90} ms for the last video frame.`)) : h = ne;
        } else
          h = ne;
      }
      const j = Math.round(P.pts - P.dts);
      $ = Math.min($, h), U = Math.max(U, h), M = Math.min(M, J), N = Math.max(N, J), a.push(new Pr(P.key, h, K, j));
    }
    if (a.length) {
      if (Pt) {
        if (Pt < 70) {
          const O = a[0].flags;
          O.dependsOn = 2, O.isNonSync = 0;
        }
      } else if (vn && N - M < U - $ && S / U < 0.025 && a[0].cts === 0) {
        D.warn("Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.");
        let O = m;
        for (let P = 0, W = a.length; P < W; P++) {
          const K = O + a[P].duration, J = O + a[P].cts;
          if (P < W - 1) {
            const j = K + a[P + 1].cts;
            a[P].duration = j - J;
          } else
            a[P].duration = P ? a[P - 1].duration : S;
          a[P].cts = 0, O = K;
        }
      }
    }
    h = w || !h ? S : h, this.nextAvcDts = u = f + h, this.videoSampleDuration = h, this.isVideoContiguous = !0;
    const B = {
      data1: b.moof(e.sequenceNumber++, m, ve({}, e, {
        samples: a
      })),
      data2: A,
      startPTS: g / r,
      endPTS: (p + h) / r,
      startDTS: m / r,
      endDTS: u / r,
      type: "video",
      hasAudio: !1,
      hasVideo: !0,
      nb: a.length,
      dropped: e.dropped
    };
    return e.samples = [], e.dropped = 0, B;
  }
  getSamplesPerFrame(e) {
    switch (e.segmentCodec) {
      case "mp3":
        return ag;
      case "ac3":
        return lg;
      default:
        return Fr;
    }
  }
  remuxAudio(e, t, s, n, r) {
    const o = e.inputTimeScale, a = e.samplerate ? e.samplerate : o, l = o / a, c = this.getSamplesPerFrame(e), u = c * l, d = this._initPTS, h = e.segmentCodec === "mp3" && this.typeSupported.mpeg, m = [], f = r !== void 0;
    let g = e.samples, p = h ? 0 : 8, E = this.nextAudioPts || -1;
    const y = t * o, v = d.baseTime * o / d.timescale;
    if (this.isAudioContiguous = s = s || g.length && E > 0 && (n && Math.abs(y - E) < 9e3 || Math.abs(Be(g[0].pts - v, y) - E) < 20 * u), g.forEach(function(H) {
      H.pts = Be(H.pts - v, y);
    }), !s || E < 0) {
      if (g = g.filter((H) => H.pts >= 0), !g.length)
        return;
      r === 0 ? E = 0 : n && !f ? E = Math.max(0, y) : E = g[0].pts;
    }
    if (e.segmentCodec === "aac") {
      const H = this.config.maxAudioFramesDrift;
      for (let q = 0, B = E; q < g.length; q++) {
        const O = g[q], P = O.pts, W = P - B, K = Math.abs(1e3 * W / o);
        if (W <= -H * u && f)
          q === 0 && (D.warn(`Audio frame @ ${(P / o).toFixed(3)}s overlaps nextAudioPts by ${Math.round(1e3 * W / o)} ms.`), this.nextAudioPts = E = B = P);
        else if (W >= H * u && K < og && f) {
          let J = Math.round(W / u);
          B = P - J * u, B < 0 && (J--, B += u), q === 0 && (this.nextAudioPts = E = B), D.warn(`[mp4-remuxer]: Injecting ${J} audio frame @ ${(B / o).toFixed(3)}s due to ${Math.round(1e3 * W / o)} ms gap.`);
          for (let j = 0; j < J; j++) {
            const z = Math.max(B, 0);
            let ne = kr.getSilentFrame(e.manifestCodec || e.codec, e.channelCount);
            ne || (D.log("[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead."), ne = O.unit.subarray()), g.splice(q, 0, {
              unit: ne,
              pts: z
            }), B += u, q++;
          }
        }
        O.pts = B, B += u;
      }
    }
    let S = null, x = null, R, L = 0, _ = g.length;
    for (; _--; )
      L += g[_].unit.byteLength;
    for (let H = 0, q = g.length; H < q; H++) {
      const B = g[H], O = B.unit;
      let P = B.pts;
      if (x !== null) {
        const K = m[H - 1];
        K.duration = Math.round((P - x) / l);
      } else if (s && e.segmentCodec === "aac" && (P = E), S = P, L > 0) {
        L += p;
        try {
          R = new Uint8Array(L);
        } catch (K) {
          this.observer.emit(T.ERROR, T.ERROR, {
            type: Z.MUX_ERROR,
            details: C.REMUX_ALLOC_ERROR,
            fatal: !1,
            error: K,
            bytes: L,
            reason: `fail allocating audio mdat ${L}`
          });
          return;
        }
        h || (new DataView(R.buffer).setUint32(0, L), R.set(b.types.mdat, 4));
      } else
        return;
      R.set(O, p);
      const W = O.byteLength;
      p += W, m.push(new Pr(!0, c, W, 0)), x = P;
    }
    const A = m.length;
    if (!A)
      return;
    const I = m[m.length - 1];
    this.nextAudioPts = E = x + l * I.duration;
    const w = h ? new Uint8Array(0) : b.moof(e.sequenceNumber++, S / l, ve({}, e, {
      samples: m
    }));
    e.samples = [];
    const $ = S / o, M = E / o, N = {
      data1: w,
      data2: R,
      startPTS: $,
      endPTS: M,
      startDTS: $,
      endDTS: M,
      type: "audio",
      hasAudio: !0,
      hasVideo: !1,
      nb: A
    };
    return this.isAudioContiguous = !0, N;
  }
  remuxEmptyAudio(e, t, s, n) {
    const r = e.inputTimeScale, o = e.samplerate ? e.samplerate : r, a = r / o, l = this.nextAudioPts, c = this._initDTS, u = c.baseTime * 9e4 / c.timescale, d = (l !== null ? l : n.startDTS * r) + u, h = n.endDTS * r + u, m = a * Fr, f = Math.ceil((h - d) / m), g = kr.getSilentFrame(e.manifestCodec || e.codec, e.channelCount);
    if (D.warn("[mp4-remuxer]: remux empty Audio"), !g) {
      D.trace("[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec");
      return;
    }
    const p = [];
    for (let E = 0; E < f; E++) {
      const y = d + E * m;
      p.push({
        unit: g,
        pts: y,
        dts: y
      });
    }
    return e.samples = p, this.remuxAudio(e, t, s, !1);
  }
}
function Be(i, e) {
  let t;
  if (e === null)
    return i;
  for (e < i ? t = -8589934592 : t = 8589934592; Math.abs(i - e) > 4294967296; )
    i += t;
  return i;
}
function cg(i) {
  for (let e = 0; e < i.length; e++)
    if (i[e].key)
      return e;
  return -1;
}
function ca(i, e, t, s) {
  const n = i.samples.length;
  if (!n)
    return;
  const r = i.inputTimeScale;
  for (let a = 0; a < n; a++) {
    const l = i.samples[a];
    l.pts = Be(l.pts - t.baseTime * r / t.timescale, e * r) / r, l.dts = Be(l.dts - s.baseTime * r / s.timescale, e * r) / r;
  }
  const o = i.samples;
  return i.samples = [], {
    samples: o
  };
}
function ua(i, e, t) {
  const s = i.samples.length;
  if (!s)
    return;
  const n = i.inputTimeScale;
  for (let o = 0; o < s; o++) {
    const a = i.samples[o];
    a.pts = Be(a.pts - t.baseTime * n / t.timescale, e * n) / n;
  }
  i.samples.sort((o, a) => o.pts - a.pts);
  const r = i.samples;
  return i.samples = [], {
    samples: r
  };
}
class Pr {
  constructor(e, t, s, n) {
    this.size = void 0, this.duration = void 0, this.cts = void 0, this.flags = void 0, this.duration = t, this.size = s, this.cts = n, this.flags = {
      isLeading: 0,
      isDependedOn: 0,
      hasRedundancy: 0,
      degradPrio: 0,
      dependsOn: e ? 2 : 1,
      isNonSync: e ? 0 : 1
    };
  }
}
class ug {
  constructor() {
    this.emitInitSegment = !1, this.audioCodec = void 0, this.videoCodec = void 0, this.initData = void 0, this.initPTS = null, this.initTracks = void 0, this.lastEndTime = null;
  }
  destroy() {
  }
  resetTimeStamp(e) {
    this.initPTS = e, this.lastEndTime = null;
  }
  resetNextTimestamp() {
    this.lastEndTime = null;
  }
  resetInitSegment(e, t, s, n) {
    this.audioCodec = t, this.videoCodec = s, this.generateInitSegment(Tf(e, n)), this.emitInitSegment = !0;
  }
  generateInitSegment(e) {
    let {
      audioCodec: t,
      videoCodec: s
    } = this;
    if (!(e != null && e.byteLength)) {
      this.initTracks = void 0, this.initData = void 0;
      return;
    }
    const n = this.initData = Po(e);
    n.audio && (t = Or(n.audio, ae.AUDIO)), n.video && (s = Or(n.video, ae.VIDEO));
    const r = {};
    n.audio && n.video ? r.audiovideo = {
      container: "video/mp4",
      codec: t + "," + s,
      initSegment: e,
      id: "main"
    } : n.audio ? r.audio = {
      container: "audio/mp4",
      codec: t,
      initSegment: e,
      id: "audio"
    } : n.video ? r.video = {
      container: "video/mp4",
      codec: s,
      initSegment: e,
      id: "main"
    } : D.warn("[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes."), this.initTracks = r;
  }
  remux(e, t, s, n, r, o) {
    var a, l;
    let {
      initPTS: c,
      lastEndTime: u
    } = this;
    const d = {
      audio: void 0,
      video: void 0,
      text: n,
      id3: s,
      initSegment: void 0
    };
    G(u) || (u = this.lastEndTime = r || 0);
    const h = t.samples;
    if (!(h != null && h.length))
      return d;
    const m = {
      initPTS: void 0,
      timescale: 1
    };
    let f = this.initData;
    if ((a = f) != null && a.length || (this.generateInitSegment(h), f = this.initData), !((l = f) != null && l.length))
      return D.warn("[passthrough-remuxer.ts]: Failed to generate initSegment."), d;
    this.emitInitSegment && (m.tracks = this.initTracks, this.emitInitSegment = !1);
    const g = yf(h, f), p = Ef(f, h), E = p === null ? r : p;
    (dg(c, E, r, g) || m.timescale !== c.timescale && o) && (m.initPTS = E - r, c && c.timescale === 1 && D.warn(`Adjusting initPTS by ${m.initPTS - c.baseTime}`), this.initPTS = c = {
      baseTime: m.initPTS,
      timescale: 1
    });
    const y = e ? E - c.baseTime / c.timescale : u, v = y + g;
    vf(f, h, c.baseTime / c.timescale), g > 0 ? this.lastEndTime = v : (D.warn("Duration parsed from mp4 should be greater than zero"), this.resetNextTimestamp());
    const S = !!f.audio, x = !!f.video;
    let R = "";
    S && (R += "audio"), x && (R += "video");
    const L = {
      data1: h,
      startPTS: y,
      startDTS: y,
      endPTS: v,
      endDTS: v,
      type: R,
      hasAudio: S,
      hasVideo: x,
      nb: 1,
      dropped: 0
    };
    return d.audio = L.type === "audio" ? L : void 0, d.video = L.type !== "audio" ? L : void 0, d.initSegment = m, d.id3 = ca(s, r, c, c), n.samples.length && (d.text = ua(n, r, c)), d;
  }
}
function dg(i, e, t, s) {
  if (i === null)
    return !0;
  const n = Math.max(s, 1), r = e - i.baseTime / i.timescale;
  return Math.abs(r - t) > n;
}
function Or(i, e) {
  const t = i == null ? void 0 : i.codec;
  if (t && t.length > 4)
    return t;
  if (e === ae.AUDIO) {
    if (t === "ec-3" || t === "ac-3" || t === "alac")
      return t;
    if (t === "fLaC" || t === "Opus")
      return Vs(t, !1);
    const s = "mp4a.40.5";
    return D.info(`Parsed audio codec "${t}" or audio object type not handled. Using "${s}"`), s;
  }
  return D.warn(`Unhandled video codec "${t}"`), t === "hvc1" || t === "hev1" ? "hvc1.1.6.L120.90" : t === "av01" ? "av01.0.04M.08" : "avc1.42e01e";
}
let dt;
try {
  dt = self.performance.now.bind(self.performance);
} catch {
  D.debug("Unable to use Performance API on this environment"), dt = Gt == null ? void 0 : Gt.Date.now;
}
const ks = [{
  demux: Xm,
  remux: ug
}, {
  demux: pt,
  remux: Ms
}, {
  demux: zm,
  remux: Ms
}, {
  demux: ng,
  remux: Ms
}];
ks.splice(2, 0, {
  demux: Qm,
  remux: Ms
});
class Nr {
  constructor(e, t, s, n, r) {
    this.async = !1, this.observer = void 0, this.typeSupported = void 0, this.config = void 0, this.vendor = void 0, this.id = void 0, this.demuxer = void 0, this.remuxer = void 0, this.decrypter = void 0, this.probe = void 0, this.decryptionPromise = null, this.transmuxConfig = void 0, this.currentTransmuxState = void 0, this.observer = e, this.typeSupported = t, this.config = s, this.vendor = n, this.id = r;
  }
  configure(e) {
    this.transmuxConfig = e, this.decrypter && this.decrypter.reset();
  }
  push(e, t, s, n) {
    const r = s.transmuxing;
    r.executeStart = dt();
    let o = new Uint8Array(e);
    const {
      currentTransmuxState: a,
      transmuxConfig: l
    } = this;
    n && (this.currentTransmuxState = n);
    const {
      contiguous: c,
      discontinuity: u,
      trackSwitch: d,
      accurateTimeOffset: h,
      timeOffset: m,
      initSegmentChange: f
    } = n || a, {
      audioCodec: g,
      videoCodec: p,
      defaultInitPts: E,
      duration: y,
      initSegmentData: v
    } = l, S = hg(o, t);
    if (S && S.method === "AES-128") {
      const _ = this.getDecrypter();
      if (_.isSync()) {
        let A = _.softwareDecrypt(o, S.key.buffer, S.iv.buffer);
        if (s.part > -1 && (A = _.flush()), !A)
          return r.executeEnd = dt(), Sn(s);
        o = new Uint8Array(A);
      } else
        return this.decryptionPromise = _.webCryptoDecrypt(o, S.key.buffer, S.iv.buffer).then((A) => {
          const I = this.push(A, null, s);
          return this.decryptionPromise = null, I;
        }), this.decryptionPromise;
    }
    const x = this.needsProbing(u, d);
    if (x) {
      const _ = this.configureTransmuxer(o);
      if (_)
        return D.warn(`[transmuxer] ${_.message}`), this.observer.emit(T.ERROR, T.ERROR, {
          type: Z.MEDIA_ERROR,
          details: C.FRAG_PARSING_ERROR,
          fatal: !1,
          error: _,
          reason: _.message
        }), r.executeEnd = dt(), Sn(s);
    }
    (u || d || f || x) && this.resetInitSegment(v, g, p, y, t), (u || f || x) && this.resetInitialTimestamp(E), c || this.resetContiguity();
    const R = this.transmux(o, S, m, h, s), L = this.currentTransmuxState;
    return L.contiguous = !0, L.discontinuity = !1, L.trackSwitch = !1, r.executeEnd = dt(), R;
  }
  // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
  flush(e) {
    const t = e.transmuxing;
    t.executeStart = dt();
    const {
      decrypter: s,
      currentTransmuxState: n,
      decryptionPromise: r
    } = this;
    if (r)
      return r.then(() => this.flush(e));
    const o = [], {
      timeOffset: a
    } = n;
    if (s) {
      const d = s.flush();
      d && o.push(this.push(d, null, e));
    }
    const {
      demuxer: l,
      remuxer: c
    } = this;
    if (!l || !c)
      return t.executeEnd = dt(), [Sn(e)];
    const u = l.flush(a);
    return Fs(u) ? u.then((d) => (this.flushRemux(o, d, e), o)) : (this.flushRemux(o, u, e), o);
  }
  flushRemux(e, t, s) {
    const {
      audioTrack: n,
      videoTrack: r,
      id3Track: o,
      textTrack: a
    } = t, {
      accurateTimeOffset: l,
      timeOffset: c
    } = this.currentTransmuxState;
    D.log(`[transmuxer.ts]: Flushed fragment ${s.sn}${s.part > -1 ? " p: " + s.part : ""} of level ${s.level}`);
    const u = this.remuxer.remux(n, r, o, a, c, l, !0, this.id);
    e.push({
      remuxResult: u,
      chunkMeta: s
    }), s.transmuxing.executeEnd = dt();
  }
  resetInitialTimestamp(e) {
    const {
      demuxer: t,
      remuxer: s
    } = this;
    !t || !s || (t.resetTimeStamp(e), s.resetTimeStamp(e));
  }
  resetContiguity() {
    const {
      demuxer: e,
      remuxer: t
    } = this;
    !e || !t || (e.resetContiguity(), t.resetNextTimestamp());
  }
  resetInitSegment(e, t, s, n, r) {
    const {
      demuxer: o,
      remuxer: a
    } = this;
    !o || !a || (o.resetInitSegment(e, t, s, n), a.resetInitSegment(e, t, s, r));
  }
  destroy() {
    this.demuxer && (this.demuxer.destroy(), this.demuxer = void 0), this.remuxer && (this.remuxer.destroy(), this.remuxer = void 0);
  }
  transmux(e, t, s, n, r) {
    let o;
    return t && t.method === "SAMPLE-AES" ? o = this.transmuxSampleAes(e, t, s, n, r) : o = this.transmuxUnencrypted(e, s, n, r), o;
  }
  transmuxUnencrypted(e, t, s, n) {
    const {
      audioTrack: r,
      videoTrack: o,
      id3Track: a,
      textTrack: l
    } = this.demuxer.demux(e, t, !1, !this.config.progressive);
    return {
      remuxResult: this.remuxer.remux(r, o, a, l, t, s, !1, this.id),
      chunkMeta: n
    };
  }
  transmuxSampleAes(e, t, s, n, r) {
    return this.demuxer.demuxSampleAes(e, t, s).then((o) => ({
      remuxResult: this.remuxer.remux(o.audioTrack, o.videoTrack, o.id3Track, o.textTrack, s, n, !1, this.id),
      chunkMeta: r
    }));
  }
  configureTransmuxer(e) {
    const {
      config: t,
      observer: s,
      typeSupported: n,
      vendor: r
    } = this;
    let o;
    for (let h = 0, m = ks.length; h < m; h++) {
      var a;
      if ((a = ks[h].demux) != null && a.probe(e)) {
        o = ks[h];
        break;
      }
    }
    if (!o)
      return new Error("Failed to find demuxer by probing fragment data");
    const l = this.demuxer, c = this.remuxer, u = o.remux, d = o.demux;
    (!c || !(c instanceof u)) && (this.remuxer = new u(s, t, n, r)), (!l || !(l instanceof d)) && (this.demuxer = new d(s, t, n), this.probe = d.probe);
  }
  needsProbing(e, t) {
    return !this.demuxer || !this.remuxer || e || t;
  }
  getDecrypter() {
    let e = this.decrypter;
    return e || (e = this.decrypter = new li(this.config)), e;
  }
}
function hg(i, e) {
  let t = null;
  return i.byteLength > 0 && (e == null ? void 0 : e.key) != null && e.iv !== null && e.method != null && (t = e), t;
}
const Sn = (i) => ({
  remuxResult: {},
  chunkMeta: i
});
function Fs(i) {
  return "then" in i && i.then instanceof Function;
}
class fg {
  constructor(e, t, s, n, r) {
    this.audioCodec = void 0, this.videoCodec = void 0, this.initSegmentData = void 0, this.duration = void 0, this.defaultInitPts = void 0, this.audioCodec = e, this.videoCodec = t, this.initSegmentData = s, this.duration = n, this.defaultInitPts = r || null;
  }
}
class mg {
  constructor(e, t, s, n, r, o) {
    this.discontinuity = void 0, this.contiguous = void 0, this.accurateTimeOffset = void 0, this.trackSwitch = void 0, this.timeOffset = void 0, this.initSegmentChange = void 0, this.discontinuity = e, this.contiguous = t, this.accurateTimeOffset = s, this.trackSwitch = n, this.timeOffset = r, this.initSegmentChange = o;
  }
}
var da = { exports: {} };
(function(i) {
  var e = Object.prototype.hasOwnProperty, t = "~";
  function s() {
  }
  Object.create && (s.prototype = /* @__PURE__ */ Object.create(null), new s().__proto__ || (t = !1));
  function n(l, c, u) {
    this.fn = l, this.context = c, this.once = u || !1;
  }
  function r(l, c, u, d, h) {
    if (typeof u != "function")
      throw new TypeError("The listener must be a function");
    var m = new n(u, d || l, h), f = t ? t + c : c;
    return l._events[f] ? l._events[f].fn ? l._events[f] = [l._events[f], m] : l._events[f].push(m) : (l._events[f] = m, l._eventsCount++), l;
  }
  function o(l, c) {
    --l._eventsCount === 0 ? l._events = new s() : delete l._events[c];
  }
  function a() {
    this._events = new s(), this._eventsCount = 0;
  }
  a.prototype.eventNames = function() {
    var c = [], u, d;
    if (this._eventsCount === 0) return c;
    for (d in u = this._events)
      e.call(u, d) && c.push(t ? d.slice(1) : d);
    return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(u)) : c;
  }, a.prototype.listeners = function(c) {
    var u = t ? t + c : c, d = this._events[u];
    if (!d) return [];
    if (d.fn) return [d.fn];
    for (var h = 0, m = d.length, f = new Array(m); h < m; h++)
      f[h] = d[h].fn;
    return f;
  }, a.prototype.listenerCount = function(c) {
    var u = t ? t + c : c, d = this._events[u];
    return d ? d.fn ? 1 : d.length : 0;
  }, a.prototype.emit = function(c, u, d, h, m, f) {
    var g = t ? t + c : c;
    if (!this._events[g]) return !1;
    var p = this._events[g], E = arguments.length, y, v;
    if (p.fn) {
      switch (p.once && this.removeListener(c, p.fn, void 0, !0), E) {
        case 1:
          return p.fn.call(p.context), !0;
        case 2:
          return p.fn.call(p.context, u), !0;
        case 3:
          return p.fn.call(p.context, u, d), !0;
        case 4:
          return p.fn.call(p.context, u, d, h), !0;
        case 5:
          return p.fn.call(p.context, u, d, h, m), !0;
        case 6:
          return p.fn.call(p.context, u, d, h, m, f), !0;
      }
      for (v = 1, y = new Array(E - 1); v < E; v++)
        y[v - 1] = arguments[v];
      p.fn.apply(p.context, y);
    } else {
      var S = p.length, x;
      for (v = 0; v < S; v++)
        switch (p[v].once && this.removeListener(c, p[v].fn, void 0, !0), E) {
          case 1:
            p[v].fn.call(p[v].context);
            break;
          case 2:
            p[v].fn.call(p[v].context, u);
            break;
          case 3:
            p[v].fn.call(p[v].context, u, d);
            break;
          case 4:
            p[v].fn.call(p[v].context, u, d, h);
            break;
          default:
            if (!y) for (x = 1, y = new Array(E - 1); x < E; x++)
              y[x - 1] = arguments[x];
            p[v].fn.apply(p[v].context, y);
        }
    }
    return !0;
  }, a.prototype.on = function(c, u, d) {
    return r(this, c, u, d, !1);
  }, a.prototype.once = function(c, u, d) {
    return r(this, c, u, d, !0);
  }, a.prototype.removeListener = function(c, u, d, h) {
    var m = t ? t + c : c;
    if (!this._events[m]) return this;
    if (!u)
      return o(this, m), this;
    var f = this._events[m];
    if (f.fn)
      f.fn === u && (!h || f.once) && (!d || f.context === d) && o(this, m);
    else {
      for (var g = 0, p = [], E = f.length; g < E; g++)
        (f[g].fn !== u || h && !f[g].once || d && f[g].context !== d) && p.push(f[g]);
      p.length ? this._events[m] = p.length === 1 ? p[0] : p : o(this, m);
    }
    return this;
  }, a.prototype.removeAllListeners = function(c) {
    var u;
    return c ? (u = t ? t + c : c, this._events[u] && o(this, u)) : (this._events = new s(), this._eventsCount = 0), this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = t, a.EventEmitter = a, i.exports = a;
})(da);
var gg = da.exports, mi = /* @__PURE__ */ Nh(gg);
class ha {
  constructor(e, t, s, n) {
    this.error = null, this.hls = void 0, this.id = void 0, this.observer = void 0, this.frag = null, this.part = null, this.useWorker = void 0, this.workerContext = null, this.onwmsg = void 0, this.transmuxer = null, this.onTransmuxComplete = void 0, this.onFlush = void 0;
    const r = e.config;
    this.hls = e, this.id = t, this.useWorker = !!r.enableWorker, this.onTransmuxComplete = s, this.onFlush = n;
    const o = (c, u) => {
      u = u || {}, u.frag = this.frag, u.id = this.id, c === T.ERROR && (this.error = u.error), this.hls.trigger(c, u);
    };
    this.observer = new mi(), this.observer.on(T.FRAG_DECRYPTED, o), this.observer.on(T.ERROR, o);
    const a = Lt(r.preferManagedMediaSource) || {
      isTypeSupported: () => !1
    }, l = {
      mpeg: a.isTypeSupported("audio/mpeg"),
      mp3: a.isTypeSupported('audio/mp4; codecs="mp3"'),
      ac3: a.isTypeSupported('audio/mp4; codecs="ac-3"')
    };
    if (this.useWorker && typeof Worker != "undefined" && (r.workerPath || Fm())) {
      try {
        r.workerPath ? (D.log(`loading Web Worker ${r.workerPath} for "${t}"`), this.workerContext = Om(r.workerPath)) : (D.log(`injecting Web Worker for "${t}"`), this.workerContext = Pm()), this.onwmsg = (d) => this.onWorkerMessage(d);
        const {
          worker: u
        } = this.workerContext;
        u.addEventListener("message", this.onwmsg), u.onerror = (d) => {
          const h = new Error(`${d.message}  (${d.filename}:${d.lineno})`);
          r.enableWorker = !1, D.warn(`Error in "${t}" Web Worker, fallback to inline`), this.hls.trigger(T.ERROR, {
            type: Z.OTHER_ERROR,
            details: C.INTERNAL_EXCEPTION,
            fatal: !1,
            event: "demuxerWorker",
            error: h
          });
        }, u.postMessage({
          cmd: "init",
          typeSupported: l,
          vendor: "",
          id: t,
          config: JSON.stringify(r)
        });
      } catch (u) {
        D.warn(`Error setting up "${t}" Web Worker, fallback to inline`, u), this.resetWorker(), this.error = null, this.transmuxer = new Nr(this.observer, l, r, "", t);
      }
      return;
    }
    this.transmuxer = new Nr(this.observer, l, r, "", t);
  }
  resetWorker() {
    if (this.workerContext) {
      const {
        worker: e,
        objectURL: t
      } = this.workerContext;
      t && self.URL.revokeObjectURL(t), e.removeEventListener("message", this.onwmsg), e.onerror = null, e.terminate(), this.workerContext = null;
    }
  }
  destroy() {
    if (this.workerContext)
      this.resetWorker(), this.onwmsg = void 0;
    else {
      const t = this.transmuxer;
      t && (t.destroy(), this.transmuxer = null);
    }
    const e = this.observer;
    e && e.removeAllListeners(), this.frag = null, this.observer = null, this.hls = null;
  }
  push(e, t, s, n, r, o, a, l, c, u) {
    var d, h;
    c.transmuxing.start = self.performance.now();
    const {
      transmuxer: m
    } = this, f = o ? o.start : r.start, g = r.decryptdata, p = this.frag, E = !(p && r.cc === p.cc), y = !(p && c.level === p.level), v = p ? c.sn - p.sn : -1, S = this.part ? c.part - this.part.index : -1, x = v === 0 && c.id > 1 && c.id === (p == null ? void 0 : p.stats.chunkCount), R = !y && (v === 1 || v === 0 && (S === 1 || x && S <= 0)), L = self.performance.now();
    (y || v || r.stats.parsing.start === 0) && (r.stats.parsing.start = L), o && (S || !R) && (o.stats.parsing.start = L);
    const _ = !(p && ((d = r.initSegment) == null ? void 0 : d.url) === ((h = p.initSegment) == null ? void 0 : h.url)), A = new mg(E, R, l, y, f, _);
    if (!R || E || _) {
      D.log(`[transmuxer-interface, ${r.type}]: Starting new transmux session for sn: ${c.sn} p: ${c.part} level: ${c.level} id: ${c.id}
        discontinuity: ${E}
        trackSwitch: ${y}
        contiguous: ${R}
        accurateTimeOffset: ${l}
        timeOffset: ${f}
        initSegmentChange: ${_}`);
      const I = new fg(s, n, t, a, u);
      this.configureTransmuxer(I);
    }
    if (this.frag = r, this.part = o, this.workerContext)
      this.workerContext.worker.postMessage({
        cmd: "demux",
        data: e,
        decryptdata: g,
        chunkMeta: c,
        state: A
      }, e instanceof ArrayBuffer ? [e] : []);
    else if (m) {
      const I = m.push(e, g, c, A);
      Fs(I) ? (m.async = !0, I.then((w) => {
        this.handleTransmuxComplete(w);
      }).catch((w) => {
        this.transmuxerError(w, c, "transmuxer-interface push error");
      })) : (m.async = !1, this.handleTransmuxComplete(I));
    }
  }
  flush(e) {
    e.transmuxing.start = self.performance.now();
    const {
      transmuxer: t
    } = this;
    if (this.workerContext)
      this.workerContext.worker.postMessage({
        cmd: "flush",
        chunkMeta: e
      });
    else if (t) {
      let s = t.flush(e);
      Fs(s) || t.async ? (Fs(s) || (s = Promise.resolve(s)), s.then((r) => {
        this.handleFlushResult(r, e);
      }).catch((r) => {
        this.transmuxerError(r, e, "transmuxer-interface flush error");
      })) : this.handleFlushResult(s, e);
    }
  }
  transmuxerError(e, t, s) {
    this.hls && (this.error = e, this.hls.trigger(T.ERROR, {
      type: Z.MEDIA_ERROR,
      details: C.FRAG_PARSING_ERROR,
      chunkMeta: t,
      frag: this.frag || void 0,
      fatal: !1,
      error: e,
      err: e,
      reason: s
    }));
  }
  handleFlushResult(e, t) {
    e.forEach((s) => {
      this.handleTransmuxComplete(s);
    }), this.onFlush(t);
  }
  onWorkerMessage(e) {
    const t = e.data;
    if (!(t != null && t.event)) {
      D.warn(`worker message received with no ${t ? "event name" : "data"}`);
      return;
    }
    const s = this.hls;
    if (this.hls)
      switch (t.event) {
        case "init": {
          var n;
          const r = (n = this.workerContext) == null ? void 0 : n.objectURL;
          r && self.URL.revokeObjectURL(r);
          break;
        }
        case "transmuxComplete": {
          this.handleTransmuxComplete(t.data);
          break;
        }
        case "flush": {
          this.onFlush(t.data);
          break;
        }
        // pass logs from the worker thread to the main logger
        case "workerLog":
          D[t.data.logType] && D[t.data.logType](t.data.message);
          break;
        default: {
          t.data = t.data || {}, t.data.frag = this.frag, t.data.id = this.id, s.trigger(t.event, t.data);
          break;
        }
      }
  }
  configureTransmuxer(e) {
    const {
      transmuxer: t
    } = this;
    this.workerContext ? this.workerContext.worker.postMessage({
      cmd: "configure",
      config: e
    }) : t && t.configure(e);
  }
  handleTransmuxComplete(e) {
    e.chunkMeta.transmuxing.end = self.performance.now(), this.onTransmuxComplete(e);
  }
}
function fa(i, e) {
  if (i.length !== e.length)
    return !1;
  for (let t = 0; t < i.length; t++)
    if (!Kt(i[t].attrs, e[t].attrs))
      return !1;
  return !0;
}
function Kt(i, e, t) {
  const s = i["STABLE-RENDITION-ID"];
  return s && !t ? s === e["STABLE-RENDITION-ID"] : !(t || ["LANGUAGE", "NAME", "CHARACTERISTICS", "AUTOSELECT", "DEFAULT", "FORCED", "ASSOC-LANGUAGE"]).some((n) => i[n] !== e[n]);
}
function zn(i, e) {
  return e.label.toLowerCase() === i.name.toLowerCase() && (!e.language || e.language.toLowerCase() === (i.lang || "").toLowerCase());
}
const Ur = 100;
class pg extends ci {
  constructor(e, t, s) {
    super(e, t, s, "[audio-stream-controller]", Q.AUDIO), this.videoBuffer = null, this.videoTrackCC = -1, this.waitingVideoCC = -1, this.bufferedTrack = null, this.switchingTrack = null, this.trackId = -1, this.waitingData = null, this.mainDetails = null, this.flushing = !1, this.bufferFlushed = !1, this.cachedTrackLoadedData = null, this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners(), super.onHandlerDestroying(), this.mainDetails = null, this.bufferedTrack = null, this.switchingTrack = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.LEVEL_LOADED, this.onLevelLoaded, this), e.on(T.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.on(T.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(T.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(T.ERROR, this.onError, this), e.on(T.BUFFER_RESET, this.onBufferReset, this), e.on(T.BUFFER_CREATED, this.onBufferCreated, this), e.on(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(T.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(T.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(T.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.LEVEL_LOADED, this.onLevelLoaded, this), e.off(T.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.off(T.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(T.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(T.ERROR, this.onError, this), e.off(T.BUFFER_RESET, this.onBufferReset, this), e.off(T.BUFFER_CREATED, this.onBufferCreated, this), e.off(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(T.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(T.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(T.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
  onInitPtsFound(e, {
    frag: t,
    id: s,
    initPTS: n,
    timescale: r
  }) {
    if (s === "main") {
      const o = t.cc;
      this.initPTS[t.cc] = {
        baseTime: n,
        timescale: r
      }, this.log(`InitPTS for cc: ${o} found from main: ${n}`), this.videoTrackCC = o, this.state === k.WAITING_INIT_PTS && this.tick();
    }
  }
  startLoad(e) {
    if (!this.levels) {
      this.startPosition = e, this.state = k.STOPPED;
      return;
    }
    const t = this.lastCurrentTime;
    this.stopLoad(), this.setInterval(Ur), t > 0 && e === -1 ? (this.log(`Override startPosition with lastCurrentTime @${t.toFixed(3)}`), e = t, this.state = k.IDLE) : (this.loadedmetadata = !1, this.state = k.WAITING_TRACK), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
  }
  doTick() {
    switch (this.state) {
      case k.IDLE:
        this.doTickIdle();
        break;
      case k.WAITING_TRACK: {
        var e;
        const {
          levels: s,
          trackId: n
        } = this, r = s == null || (e = s[n]) == null ? void 0 : e.details;
        if (r) {
          if (this.waitForCdnTuneIn(r))
            break;
          this.state = k.WAITING_INIT_PTS;
        }
        break;
      }
      case k.FRAG_LOADING_WAITING_RETRY: {
        var t;
        const s = performance.now(), n = this.retryDate;
        if (!n || s >= n || (t = this.media) != null && t.seeking) {
          const {
            levels: r,
            trackId: o
          } = this;
          this.log("RetryDate reached, switch back to IDLE state"), this.resetStartWhenNotLoaded((r == null ? void 0 : r[o]) || null), this.state = k.IDLE;
        }
        break;
      }
      case k.WAITING_INIT_PTS: {
        const s = this.waitingData;
        if (s) {
          const {
            frag: n,
            part: r,
            cache: o,
            complete: a
          } = s;
          if (this.initPTS[n.cc] !== void 0) {
            this.waitingData = null, this.waitingVideoCC = -1, this.state = k.FRAG_LOADING;
            const l = o.flush(), c = {
              frag: n,
              part: r,
              payload: l,
              networkDetails: null
            };
            this._handleFragmentLoadProgress(c), a && super._handleFragmentLoadComplete(c);
          } else if (this.videoTrackCC !== this.waitingVideoCC)
            this.log(`Waiting fragment cc (${n.cc}) cancelled because video is at cc ${this.videoTrackCC}`), this.clearWaitingFragment();
          else {
            const l = this.getLoadPosition(), c = de.bufferInfo(this.mediaBuffer, l, this.config.maxBufferHole);
            Yn(c.end, this.config.maxFragLookUpTolerance, n) < 0 && (this.log(`Waiting fragment cc (${n.cc}) @ ${n.start} cancelled because another fragment at ${c.end} is needed`), this.clearWaitingFragment());
          }
        } else
          this.state = k.IDLE;
      }
    }
    this.onTickEnd();
  }
  clearWaitingFragment() {
    const e = this.waitingData;
    e && (this.fragmentTracker.removeFragment(e.frag), this.waitingData = null, this.waitingVideoCC = -1, this.state = k.IDLE);
  }
  resetLoadingState() {
    this.clearWaitingFragment(), super.resetLoadingState();
  }
  onTickEnd() {
    const {
      media: e
    } = this;
    e != null && e.readyState && (this.lastCurrentTime = e.currentTime);
  }
  doTickIdle() {
    const {
      hls: e,
      levels: t,
      media: s,
      trackId: n
    } = this, r = e.config;
    if (!s && (this.startFragRequested || !r.startFragPrefetch) || !(t != null && t[n]))
      return;
    const o = t[n], a = o.details;
    if (!a || a.live && this.levelLastLoaded !== o || this.waitForCdnTuneIn(a)) {
      this.state = k.WAITING_TRACK;
      return;
    }
    const l = this.mediaBuffer ? this.mediaBuffer : this.media;
    this.bufferFlushed && l && (this.bufferFlushed = !1, this.afterBufferFlushed(l, ae.AUDIO, Q.AUDIO));
    const c = this.getFwdBufferInfo(l, Q.AUDIO);
    if (c === null)
      return;
    const {
      bufferedTrack: u,
      switchingTrack: d
    } = this;
    if (!d && this._streamEnded(c, a)) {
      e.trigger(T.BUFFER_EOS, {
        type: "audio"
      }), this.state = k.ENDED;
      return;
    }
    const h = this.getFwdBufferInfo(this.videoBuffer ? this.videoBuffer : this.media, Q.MAIN), m = c.len, f = this.getMaxBufferLength(h == null ? void 0 : h.len), g = a.fragments, p = g[0].start;
    let E = this.flushing ? this.getLoadPosition() : c.end;
    if (d && s) {
      const x = this.getLoadPosition();
      u && !Kt(d.attrs, u.attrs) && (E = x), a.PTSKnown && x < p && (c.end > p || c.nextStart) && (this.log("Alt audio track ahead of main track, seek to start of alt audio track"), s.currentTime = p + 0.05);
    }
    if (m >= f && !d && E < g[g.length - 1].start)
      return;
    let y = this.getNextFragment(E, a), v = !1;
    if (y && this.isLoopLoading(y, E) && (v = !!y.gap, y = this.getNextFragmentLoopLoading(y, a, c, Q.MAIN, f)), !y) {
      this.bufferFlushed = !0;
      return;
    }
    const S = h && y.start > h.end + a.targetduration;
    if (S || // Or wait for main buffer after buffing some audio
    !(h != null && h.len) && c.len) {
      const x = this.getAppendedFrag(y.start, Q.MAIN);
      if (x === null || (v || (v = !!x.gap || !!S && h.len === 0), S && !v || v && c.nextStart && c.nextStart < x.end))
        return;
    }
    this.loadFragment(y, o, E);
  }
  getMaxBufferLength(e) {
    const t = super.getMaxBufferLength();
    return e ? Math.min(Math.max(t, e), this.config.maxMaxBufferLength) : t;
  }
  onMediaDetaching() {
    this.videoBuffer = null, this.bufferFlushed = this.flushing = !1, super.onMediaDetaching();
  }
  onAudioTracksUpdated(e, {
    audioTracks: t
  }) {
    this.resetTransmuxer(), this.levels = t.map((s) => new Ht(s));
  }
  onAudioTrackSwitching(e, t) {
    const s = !!t.url;
    this.trackId = t.id;
    const {
      fragCurrent: n
    } = this;
    n && (n.abortRequests(), this.removeUnbufferedFrags(n.start)), this.resetLoadingState(), s ? this.setInterval(Ur) : this.resetTransmuxer(), s ? (this.switchingTrack = t, this.state = k.IDLE, this.flushAudioIfNeeded(t)) : (this.switchingTrack = null, this.bufferedTrack = t, this.state = k.STOPPED), this.tick();
  }
  onManifestLoading() {
    this.fragmentTracker.removeAllFragments(), this.startPosition = this.lastCurrentTime = 0, this.bufferFlushed = this.flushing = !1, this.levels = this.mainDetails = this.waitingData = this.bufferedTrack = this.cachedTrackLoadedData = this.switchingTrack = null, this.startFragRequested = !1, this.trackId = this.videoTrackCC = this.waitingVideoCC = -1;
  }
  onLevelLoaded(e, t) {
    this.mainDetails = t.details, this.cachedTrackLoadedData !== null && (this.hls.trigger(T.AUDIO_TRACK_LOADED, this.cachedTrackLoadedData), this.cachedTrackLoadedData = null);
  }
  onAudioTrackLoaded(e, t) {
    var s;
    if (this.mainDetails == null) {
      this.cachedTrackLoadedData = t;
      return;
    }
    const {
      levels: n
    } = this, {
      details: r,
      id: o
    } = t;
    if (!n) {
      this.warn(`Audio tracks were reset while loading level ${o}`);
      return;
    }
    this.log(`Audio track ${o} loaded [${r.startSN},${r.endSN}]${r.lastPartSn ? `[part-${r.lastPartSn}-${r.lastPartIndex}]` : ""},duration:${r.totalduration}`);
    const a = n[o];
    let l = 0;
    if (r.live || (s = a.details) != null && s.live) {
      this.checkLiveUpdate(r);
      const u = this.mainDetails;
      if (r.deltaUpdateFailed || !u)
        return;
      if (!a.details && r.hasProgramDateTime && u.hasProgramDateTime)
        js(r, u), l = r.fragments[0].start;
      else {
        var c;
        l = this.alignPlaylists(r, a.details, (c = this.levelLastLoaded) == null ? void 0 : c.details);
      }
    }
    a.details = r, this.levelLastLoaded = a, !this.startFragRequested && (this.mainDetails || !r.live) && this.setStartPosition(this.mainDetails || r, l), this.state === k.WAITING_TRACK && !this.waitForCdnTuneIn(r) && (this.state = k.IDLE), this.tick();
  }
  _handleFragmentLoadProgress(e) {
    var t;
    const {
      frag: s,
      part: n,
      payload: r
    } = e, {
      config: o,
      trackId: a,
      levels: l
    } = this;
    if (!l) {
      this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${s.sn} of level ${s.level} will not be buffered`);
      return;
    }
    const c = l[a];
    if (!c) {
      this.warn("Audio track is undefined on fragment load progress");
      return;
    }
    const u = c.details;
    if (!u) {
      this.warn("Audio track details undefined on fragment load progress"), this.removeUnbufferedFrags(s.start);
      return;
    }
    const d = o.defaultAudioCodec || c.audioCodec || "mp4a.40.2";
    let h = this.transmuxer;
    h || (h = this.transmuxer = new ha(this.hls, Q.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)));
    const m = this.initPTS[s.cc], f = (t = s.initSegment) == null ? void 0 : t.data;
    if (m !== void 0) {
      const p = n ? n.index : -1, E = p !== -1, y = new ai(s.level, s.sn, s.stats.chunkCount, r.byteLength, p, E);
      h.push(r, f, d, "", s, n, u.totalduration, !1, y, m);
    } else {
      this.log(`Unknown video PTS for cc ${s.cc}, waiting for video PTS before demuxing audio frag ${s.sn} of [${u.startSN} ,${u.endSN}],track ${a}`);
      const {
        cache: g
      } = this.waitingData = this.waitingData || {
        frag: s,
        part: n,
        cache: new Xo(),
        complete: !1
      };
      g.push(new Uint8Array(r)), this.waitingVideoCC = this.videoTrackCC, this.state = k.WAITING_INIT_PTS;
    }
  }
  _handleFragmentLoadComplete(e) {
    if (this.waitingData) {
      this.waitingData.complete = !0;
      return;
    }
    super._handleFragmentLoadComplete(e);
  }
  onBufferReset() {
    this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1;
  }
  onBufferCreated(e, t) {
    const s = t.tracks.audio;
    s && (this.mediaBuffer = s.buffer || null), t.tracks.video && (this.videoBuffer = t.tracks.video.buffer || null);
  }
  onFragBuffered(e, t) {
    const {
      frag: s,
      part: n
    } = t;
    if (s.type !== Q.AUDIO) {
      if (!this.loadedmetadata && s.type === Q.MAIN) {
        const r = this.videoBuffer || this.media;
        r && de.getBuffered(r).length && (this.loadedmetadata = !0);
      }
      return;
    }
    if (this.fragContextChanged(s)) {
      this.warn(`Fragment ${s.sn}${n ? " p: " + n.index : ""} of level ${s.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : "false"}`);
      return;
    }
    if (s.sn !== "initSegment") {
      this.fragPrevious = s;
      const r = this.switchingTrack;
      r && (this.bufferedTrack = r, this.switchingTrack = null, this.hls.trigger(T.AUDIO_TRACK_SWITCHED, Re({}, r)));
    }
    this.fragBufferedComplete(s, n);
  }
  onError(e, t) {
    var s;
    if (t.fatal) {
      this.state = k.ERROR;
      return;
    }
    switch (t.details) {
      case C.FRAG_GAP:
      case C.FRAG_PARSING_ERROR:
      case C.FRAG_DECRYPT_ERROR:
      case C.FRAG_LOAD_ERROR:
      case C.FRAG_LOAD_TIMEOUT:
      case C.KEY_LOAD_ERROR:
      case C.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(Q.AUDIO, t);
        break;
      case C.AUDIO_TRACK_LOAD_ERROR:
      case C.AUDIO_TRACK_LOAD_TIMEOUT:
      case C.LEVEL_PARSING_ERROR:
        !t.levelRetry && this.state === k.WAITING_TRACK && ((s = t.context) == null ? void 0 : s.type) === re.AUDIO_TRACK && (this.state = k.IDLE);
        break;
      case C.BUFFER_APPEND_ERROR:
      case C.BUFFER_FULL_ERROR:
        if (!t.parent || t.parent !== "audio")
          return;
        if (t.details === C.BUFFER_APPEND_ERROR) {
          this.resetLoadingState();
          return;
        }
        this.reduceLengthAndFlushBuffer(t) && (this.bufferedTrack = null, super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"));
        break;
      case C.INTERNAL_EXCEPTION:
        this.recoverWorkerError(t);
        break;
    }
  }
  onBufferFlushing(e, {
    type: t
  }) {
    t !== ae.VIDEO && (this.flushing = !0);
  }
  onBufferFlushed(e, {
    type: t
  }) {
    if (t !== ae.VIDEO) {
      this.flushing = !1, this.bufferFlushed = !0, this.state === k.ENDED && (this.state = k.IDLE);
      const s = this.mediaBuffer || this.media;
      s && (this.afterBufferFlushed(s, t, Q.AUDIO), this.tick());
    }
  }
  _handleTransmuxComplete(e) {
    var t;
    const s = "audio", {
      hls: n
    } = this, {
      remuxResult: r,
      chunkMeta: o
    } = e, a = this.getCurrentContext(o);
    if (!a) {
      this.resetWhenMissingContext(o);
      return;
    }
    const {
      frag: l,
      part: c,
      level: u
    } = a, {
      details: d
    } = u, {
      audio: h,
      text: m,
      id3: f,
      initSegment: g
    } = r;
    if (this.fragContextChanged(l) || !d) {
      this.fragmentTracker.removeFragment(l);
      return;
    }
    if (this.state = k.PARSING, this.switchingTrack && h && this.completeAudioSwitch(this.switchingTrack), g != null && g.tracks) {
      const p = l.initSegment || l;
      this._bufferInitSegment(u, g.tracks, p, o), n.trigger(T.FRAG_PARSING_INIT_SEGMENT, {
        frag: p,
        id: s,
        tracks: g.tracks
      });
    }
    if (h) {
      const {
        startPTS: p,
        endPTS: E,
        startDTS: y,
        endDTS: v
      } = h;
      c && (c.elementaryStreams[ae.AUDIO] = {
        startPTS: p,
        endPTS: E,
        startDTS: y,
        endDTS: v
      }), l.setElementaryStreamInfo(ae.AUDIO, p, E, y, v), this.bufferFragmentData(h, l, c, o);
    }
    if (f != null && (t = f.samples) != null && t.length) {
      const p = ve({
        id: s,
        frag: l,
        details: d
      }, f);
      n.trigger(T.FRAG_PARSING_METADATA, p);
    }
    if (m) {
      const p = ve({
        id: s,
        frag: l,
        details: d
      }, m);
      n.trigger(T.FRAG_PARSING_USERDATA, p);
    }
  }
  _bufferInitSegment(e, t, s, n) {
    if (this.state !== k.PARSING)
      return;
    t.video && delete t.video;
    const r = t.audio;
    if (!r)
      return;
    r.id = "audio";
    const o = e.audioCodec;
    this.log(`Init audio buffer, container:${r.container}, codecs[level/parsed]=[${o}/${r.codec}]`), o && o.split(",").length === 1 && (r.levelCodec = o), this.hls.trigger(T.BUFFER_CODECS, t);
    const a = r.initSegment;
    if (a != null && a.byteLength) {
      const l = {
        type: "audio",
        frag: s,
        part: null,
        chunkMeta: n,
        parent: s.type,
        data: a
      };
      this.hls.trigger(T.BUFFER_APPENDING, l);
    }
    this.tickImmediate();
  }
  loadFragment(e, t, s) {
    const n = this.fragmentTracker.getState(e);
    if (this.fragCurrent = e, this.switchingTrack || n === Le.NOT_LOADED || n === Le.PARTIAL) {
      var r;
      if (e.sn === "initSegment")
        this._loadInitSegment(e, t);
      else if ((r = t.details) != null && r.live && !this.initPTS[e.cc]) {
        this.log(`Waiting for video PTS in continuity counter ${e.cc} of live stream before loading audio fragment ${e.sn} of level ${this.trackId}`), this.state = k.WAITING_INIT_PTS;
        const o = this.mainDetails;
        o && o.fragments[0].start !== t.details.fragments[0].start && js(t.details, o);
      } else
        this.startFragRequested = !0, super.loadFragment(e, t, s);
    } else
      this.clearTrackerIfNeeded(e);
  }
  flushAudioIfNeeded(e) {
    const {
      media: t,
      bufferedTrack: s
    } = this, n = s == null ? void 0 : s.attrs, r = e.attrs;
    t && n && (n.CHANNELS !== r.CHANNELS || s.name !== e.name || s.lang !== e.lang) && (this.log("Switching audio track : flushing all audio"), super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"), this.bufferedTrack = null);
  }
  completeAudioSwitch(e) {
    const {
      hls: t
    } = this;
    this.flushAudioIfNeeded(e), this.bufferedTrack = e, this.switchingTrack = null, t.trigger(T.AUDIO_TRACK_SWITCHED, Re({}, e));
  }
}
class Tg extends oi {
  constructor(e) {
    super(e, "[audio-track-controller]"), this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0, this.registerListeners();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.LEVEL_LOADING, this.onLevelLoading, this), e.on(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(T.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(T.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.LEVEL_LOADING, this.onLevelLoading, this), e.off(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(T.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(T.ERROR, this.onError, this);
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.currentTrack = null, super.destroy();
  }
  onManifestLoading() {
    this.tracks = [], this.tracksInGroup = [], this.groupIds = null, this.currentTrack = null, this.trackId = -1, this.selectDefaultTrack = !0;
  }
  onManifestParsed(e, t) {
    this.tracks = t.audioTracks || [];
  }
  onAudioTrackLoaded(e, t) {
    const {
      id: s,
      groupId: n,
      details: r
    } = t, o = this.tracksInGroup[s];
    if (!o || o.groupId !== n) {
      this.warn(`Audio track with id:${s} and group:${n} not found in active group ${o == null ? void 0 : o.groupId}`);
      return;
    }
    const a = o.details;
    o.details = t.details, this.log(`Audio track ${s} "${o.name}" lang:${o.lang} group:${n} loaded [${r.startSN}-${r.endSN}]`), s === this.trackId && this.playlistLoaded(s, t, a);
  }
  onLevelLoading(e, t) {
    this.switchLevel(t.level);
  }
  onLevelSwitching(e, t) {
    this.switchLevel(t.level);
  }
  switchLevel(e) {
    const t = this.hls.levels[e];
    if (!t)
      return;
    const s = t.audioGroups || null, n = this.groupIds;
    let r = this.currentTrack;
    if (!s || (n == null ? void 0 : n.length) !== (s == null ? void 0 : s.length) || s != null && s.some((a) => (n == null ? void 0 : n.indexOf(a)) === -1)) {
      this.groupIds = s, this.trackId = -1, this.currentTrack = null;
      const a = this.tracks.filter((h) => !s || s.indexOf(h.groupId) !== -1);
      if (a.length)
        this.selectDefaultTrack && !a.some((h) => h.default) && (this.selectDefaultTrack = !1), a.forEach((h, m) => {
          h.id = m;
        });
      else if (!r && !this.tracksInGroup.length)
        return;
      this.tracksInGroup = a;
      const l = this.hls.config.audioPreference;
      if (!r && l) {
        const h = Qe(l, a, Mt);
        if (h > -1)
          r = a[h];
        else {
          const m = Qe(l, this.tracks);
          r = this.tracks[m];
        }
      }
      let c = this.findTrackId(r);
      c === -1 && r && (c = this.findTrackId(null));
      const u = {
        audioTracks: a
      };
      this.log(`Updating audio tracks, ${a.length} track(s) found in group(s): ${s == null ? void 0 : s.join(",")}`), this.hls.trigger(T.AUDIO_TRACKS_UPDATED, u);
      const d = this.trackId;
      if (c !== -1 && d === -1)
        this.setAudioTrack(c);
      else if (a.length && d === -1) {
        var o;
        const h = new Error(`No audio track selected for current audio group-ID(s): ${(o = this.groupIds) == null ? void 0 : o.join(",")} track count: ${a.length}`);
        this.warn(h.message), this.hls.trigger(T.ERROR, {
          type: Z.MEDIA_ERROR,
          details: C.AUDIO_TRACK_LOAD_ERROR,
          fatal: !0,
          error: h
        });
      }
    } else this.shouldReloadPlaylist(r) && this.setAudioTrack(this.trackId);
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === re.AUDIO_TRACK && t.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(t.context.groupId) !== -1) && (this.requestScheduled = -1, this.checkRetry(t));
  }
  get allAudioTracks() {
    return this.tracks;
  }
  get audioTracks() {
    return this.tracksInGroup;
  }
  get audioTrack() {
    return this.trackId;
  }
  set audioTrack(e) {
    this.selectDefaultTrack = !1, this.setAudioTrack(e);
  }
  setAudioOption(e) {
    const t = this.hls;
    if (t.config.audioPreference = e, e) {
      const s = this.allAudioTracks;
      if (this.selectDefaultTrack = !1, s.length) {
        const n = this.currentTrack;
        if (n && Ut(e, n, Mt))
          return n;
        const r = Qe(e, this.tracksInGroup, Mt);
        if (r > -1) {
          const o = this.tracksInGroup[r];
          return this.setAudioTrack(r), o;
        } else if (n) {
          let o = t.loadLevel;
          o === -1 && (o = t.firstAutoLevel);
          const a = Tm(e, t.levels, s, o, Mt);
          if (a === -1)
            return null;
          t.nextLoadLevel = a;
        }
        if (e.channels || e.audioCodec) {
          const o = Qe(e, s);
          if (o > -1)
            return s[o];
        }
      }
    }
    return null;
  }
  setAudioTrack(e) {
    const t = this.tracksInGroup;
    if (e < 0 || e >= t.length) {
      this.warn(`Invalid audio track id: ${e}`);
      return;
    }
    this.clearTimer(), this.selectDefaultTrack = !1;
    const s = this.currentTrack, n = t[e], r = n.details && !n.details.live;
    if (e === this.trackId && n === s && r || (this.log(`Switching to audio-track ${e} "${n.name}" lang:${n.lang} group:${n.groupId} channels:${n.channels}`), this.trackId = e, this.currentTrack = n, this.hls.trigger(T.AUDIO_TRACK_SWITCHING, Re({}, n)), r))
      return;
    const o = this.switchParams(n.url, s == null ? void 0 : s.details, n.details);
    this.loadPlaylist(o);
  }
  findTrackId(e) {
    const t = this.tracksInGroup;
    for (let s = 0; s < t.length; s++) {
      const n = t[s];
      if (!(this.selectDefaultTrack && !n.default) && (!e || Ut(e, n, Mt)))
        return s;
    }
    if (e) {
      const {
        name: s,
        lang: n,
        assocLang: r,
        characteristics: o,
        audioCodec: a,
        channels: l
      } = e;
      for (let c = 0; c < t.length; c++) {
        const u = t[c];
        if (Ut({
          name: s,
          lang: n,
          assocLang: r,
          characteristics: o,
          audioCodec: a,
          channels: l
        }, u, Mt))
          return c;
      }
      for (let c = 0; c < t.length; c++) {
        const u = t[c];
        if (Kt(e.attrs, u.attrs, ["LANGUAGE", "ASSOC-LANGUAGE", "CHARACTERISTICS"]))
          return c;
      }
      for (let c = 0; c < t.length; c++) {
        const u = t[c];
        if (Kt(e.attrs, u.attrs, ["LANGUAGE"]))
          return c;
      }
    }
    return -1;
  }
  loadPlaylist(e) {
    const t = this.currentTrack;
    if (this.shouldLoadPlaylist(t) && t) {
      super.loadPlaylist();
      const s = t.id, n = t.groupId;
      let r = t.url;
      if (e)
        try {
          r = e.addDirectives(r);
        } catch (o) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${o}`);
        }
      this.log(`loading audio-track playlist ${s} "${t.name}" lang:${t.lang} group:${n}`), this.clearTimer(), this.hls.trigger(T.AUDIO_TRACK_LOADING, {
        url: r,
        id: s,
        groupId: n,
        deliveryDirectives: e || null
      });
    }
  }
}
const Br = 500;
class Eg extends ci {
  constructor(e, t, s) {
    super(e, t, s, "[subtitle-stream-controller]", Q.SUBTITLE), this.currentTrackId = -1, this.tracksBuffered = [], this.mainDetails = null, this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners(), super.onHandlerDestroying(), this.mainDetails = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.LEVEL_LOADED, this.onLevelLoaded, this), e.on(T.ERROR, this.onError, this), e.on(T.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(T.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.on(T.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(T.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.on(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(T.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.LEVEL_LOADED, this.onLevelLoaded, this), e.off(T.ERROR, this.onError, this), e.off(T.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(T.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.off(T.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(T.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.off(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(T.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  startLoad(e) {
    this.stopLoad(), this.state = k.IDLE, this.setInterval(Br), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
  }
  onManifestLoading() {
    this.mainDetails = null, this.fragmentTracker.removeAllFragments();
  }
  onMediaDetaching() {
    this.tracksBuffered = [], super.onMediaDetaching();
  }
  onLevelLoaded(e, t) {
    this.mainDetails = t.details;
  }
  onSubtitleFragProcessed(e, t) {
    const {
      frag: s,
      success: n
    } = t;
    if (this.fragPrevious = s, this.state = k.IDLE, !n)
      return;
    const r = this.tracksBuffered[this.currentTrackId];
    if (!r)
      return;
    let o;
    const a = s.start;
    for (let c = 0; c < r.length; c++)
      if (a >= r[c].start && a <= r[c].end) {
        o = r[c];
        break;
      }
    const l = s.start + s.duration;
    o ? o.end = l : (o = {
      start: a,
      end: l
    }, r.push(o)), this.fragmentTracker.fragBuffered(s), this.fragBufferedComplete(s, null);
  }
  onBufferFlushing(e, t) {
    const {
      startOffset: s,
      endOffset: n
    } = t;
    if (s === 0 && n !== Number.POSITIVE_INFINITY) {
      const r = n - 1;
      if (r <= 0)
        return;
      t.endOffsetSubtitles = Math.max(0, r), this.tracksBuffered.forEach((o) => {
        for (let a = 0; a < o.length; ) {
          if (o[a].end <= r) {
            o.shift();
            continue;
          } else if (o[a].start < r)
            o[a].start = r;
          else
            break;
          a++;
        }
      }), this.fragmentTracker.removeFragmentsInRange(s, r, Q.SUBTITLE);
    }
  }
  onFragBuffered(e, t) {
    if (!this.loadedmetadata && t.frag.type === Q.MAIN) {
      var s;
      (s = this.media) != null && s.buffered.length && (this.loadedmetadata = !0);
    }
  }
  // If something goes wrong, proceed to next frag, if we were processing one.
  onError(e, t) {
    const s = t.frag;
    (s == null ? void 0 : s.type) === Q.SUBTITLE && (t.details === C.FRAG_GAP && this.fragmentTracker.fragBuffered(s, !0), this.fragCurrent && this.fragCurrent.abortRequests(), this.state !== k.STOPPED && (this.state = k.IDLE));
  }
  // Got all new subtitle levels.
  onSubtitleTracksUpdated(e, {
    subtitleTracks: t
  }) {
    if (this.levels && fa(this.levels, t)) {
      this.levels = t.map((s) => new Ht(s));
      return;
    }
    this.tracksBuffered = [], this.levels = t.map((s) => {
      const n = new Ht(s);
      return this.tracksBuffered[n.id] = [], n;
    }), this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, Q.SUBTITLE), this.fragPrevious = null, this.mediaBuffer = null;
  }
  onSubtitleTrackSwitch(e, t) {
    var s;
    if (this.currentTrackId = t.id, !((s = this.levels) != null && s.length) || this.currentTrackId === -1) {
      this.clearInterval();
      return;
    }
    const n = this.levels[this.currentTrackId];
    n != null && n.details ? this.mediaBuffer = this.mediaBufferTimeRanges : this.mediaBuffer = null, n && this.setInterval(Br);
  }
  // Got a new set of subtitle fragments.
  onSubtitleTrackLoaded(e, t) {
    var s;
    const {
      currentTrackId: n,
      levels: r
    } = this, {
      details: o,
      id: a
    } = t;
    if (!r) {
      this.warn(`Subtitle tracks were reset while loading level ${a}`);
      return;
    }
    const l = r[a];
    if (a >= r.length || !l)
      return;
    this.log(`Subtitle track ${a} loaded [${o.startSN},${o.endSN}]${o.lastPartSn ? `[part-${o.lastPartSn}-${o.lastPartIndex}]` : ""},duration:${o.totalduration}`), this.mediaBuffer = this.mediaBufferTimeRanges;
    let c = 0;
    if (o.live || (s = l.details) != null && s.live) {
      const d = this.mainDetails;
      if (o.deltaUpdateFailed || !d)
        return;
      const h = d.fragments[0];
      if (!l.details)
        o.hasProgramDateTime && d.hasProgramDateTime ? (js(o, d), c = o.fragments[0].start) : h && (c = h.start, Wn(o, c));
      else {
        var u;
        c = this.alignPlaylists(o, l.details, (u = this.levelLastLoaded) == null ? void 0 : u.details), c === 0 && h && (c = h.start, Wn(o, c));
      }
    }
    l.details = o, this.levelLastLoaded = l, a === n && (!this.startFragRequested && (this.mainDetails || !o.live) && this.setStartPosition(this.mainDetails || o, c), this.tick(), o.live && !this.fragCurrent && this.media && this.state === k.IDLE && (zs(null, o.fragments, this.media.currentTime, 0) || (this.warn("Subtitle playlist not aligned with playback"), l.details = void 0)));
  }
  _handleFragmentLoadComplete(e) {
    const {
      frag: t,
      payload: s
    } = e, n = t.decryptdata, r = this.hls;
    if (!this.fragContextChanged(t) && s && s.byteLength > 0 && n != null && n.key && n.iv && n.method === "AES-128") {
      const o = performance.now();
      this.decrypter.decrypt(new Uint8Array(s), n.key.buffer, n.iv.buffer).catch((a) => {
        throw r.trigger(T.ERROR, {
          type: Z.MEDIA_ERROR,
          details: C.FRAG_DECRYPT_ERROR,
          fatal: !1,
          error: a,
          reason: a.message,
          frag: t
        }), a;
      }).then((a) => {
        const l = performance.now();
        r.trigger(T.FRAG_DECRYPTED, {
          frag: t,
          payload: a,
          stats: {
            tstart: o,
            tdecrypt: l
          }
        });
      }).catch((a) => {
        this.warn(`${a.name}: ${a.message}`), this.state = k.IDLE;
      });
    }
  }
  doTick() {
    if (!this.media) {
      this.state = k.IDLE;
      return;
    }
    if (this.state === k.IDLE) {
      const {
        currentTrackId: e,
        levels: t
      } = this, s = t == null ? void 0 : t[e];
      if (!s || !t.length || !s.details)
        return;
      const {
        config: n
      } = this, r = this.getLoadPosition(), o = de.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], r, n.maxBufferHole), {
        end: a,
        len: l
      } = o, c = this.getFwdBufferInfo(this.media, Q.MAIN), u = s.details, d = this.getMaxBufferLength(c == null ? void 0 : c.len) + u.levelTargetDuration;
      if (l > d)
        return;
      const h = u.fragments, m = h.length, f = u.edge;
      let g = null;
      const p = this.fragPrevious;
      if (a < f) {
        const E = n.maxFragLookUpTolerance, y = a > f - E ? 0 : E;
        g = zs(p, h, Math.max(h[0].start, a), y), !g && p && p.start < h[0].start && (g = h[0]);
      } else
        g = h[m - 1];
      if (!g)
        return;
      if (g = this.mapToInitFragWhenRequired(g), g.sn !== "initSegment") {
        const E = g.sn - u.startSN, y = h[E - 1];
        y && y.cc === g.cc && this.fragmentTracker.getState(y) === Le.NOT_LOADED && (g = y);
      }
      this.fragmentTracker.getState(g) === Le.NOT_LOADED && this.loadFragment(g, s, a);
    }
  }
  getMaxBufferLength(e) {
    const t = super.getMaxBufferLength();
    return e ? Math.max(t, e) : t;
  }
  loadFragment(e, t, s) {
    this.fragCurrent = e, e.sn === "initSegment" ? this._loadInitSegment(e, t) : (this.startFragRequested = !0, super.loadFragment(e, t, s));
  }
  get mediaBufferTimeRanges() {
    return new yg(this.tracksBuffered[this.currentTrackId] || []);
  }
}
class yg {
  constructor(e) {
    this.buffered = void 0;
    const t = (s, n, r) => {
      if (n = n >>> 0, n > r - 1)
        throw new DOMException(`Failed to execute '${s}' on 'TimeRanges': The index provided (${n}) is greater than the maximum bound (${r})`);
      return e[n][s];
    };
    this.buffered = {
      get length() {
        return e.length;
      },
      end(s) {
        return t("end", s, e.length);
      },
      start(s) {
        return t("start", s, e.length);
      }
    };
  }
}
class xg extends oi {
  constructor(e) {
    super(e, "[subtitle-track-controller]"), this.media = null, this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0, this.queuedDefaultTrack = -1, this.asyncPollTrackChange = () => this.pollTrackChange(0), this.useTextTrackPolling = !1, this.subtitlePollingInterval = -1, this._subtitleDisplay = !0, this.onTextTracksChanged = () => {
      if (this.useTextTrackPolling || self.clearInterval(this.subtitlePollingInterval), !this.media || !this.hls.config.renderTextTracksNatively)
        return;
      let t = null;
      const s = _s(this.media.textTracks);
      for (let r = 0; r < s.length; r++)
        if (s[r].mode === "hidden")
          t = s[r];
        else if (s[r].mode === "showing") {
          t = s[r];
          break;
        }
      const n = this.findTrackForTextTrack(t);
      this.subtitleTrack !== n && this.setSubtitleTrack(n);
    }, this.registerListeners();
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.currentTrack = null, this.onTextTracksChanged = this.asyncPollTrackChange = null, super.destroy();
  }
  get subtitleDisplay() {
    return this._subtitleDisplay;
  }
  set subtitleDisplay(e) {
    this._subtitleDisplay = e, this.trackId > -1 && this.toggleTrackModes();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.LEVEL_LOADING, this.onLevelLoading, this), e.on(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(T.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(T.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.LEVEL_LOADING, this.onLevelLoading, this), e.off(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(T.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(T.ERROR, this.onError, this);
  }
  // Listen for subtitle track change, then extract the current track ID.
  onMediaAttached(e, t) {
    this.media = t.media, this.media && (this.queuedDefaultTrack > -1 && (this.subtitleTrack = this.queuedDefaultTrack, this.queuedDefaultTrack = -1), this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks), this.useTextTrackPolling ? this.pollTrackChange(500) : this.media.textTracks.addEventListener("change", this.asyncPollTrackChange));
  }
  pollTrackChange(e) {
    self.clearInterval(this.subtitlePollingInterval), this.subtitlePollingInterval = self.setInterval(this.onTextTracksChanged, e);
  }
  onMediaDetaching() {
    if (!this.media)
      return;
    self.clearInterval(this.subtitlePollingInterval), this.useTextTrackPolling || this.media.textTracks.removeEventListener("change", this.asyncPollTrackChange), this.trackId > -1 && (this.queuedDefaultTrack = this.trackId), _s(this.media.textTracks).forEach((t) => {
      Ot(t);
    }), this.subtitleTrack = -1, this.media = null;
  }
  onManifestLoading() {
    this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0;
  }
  // Fired whenever a new manifest is loaded.
  onManifestParsed(e, t) {
    this.tracks = t.subtitleTracks;
  }
  onSubtitleTrackLoaded(e, t) {
    const {
      id: s,
      groupId: n,
      details: r
    } = t, o = this.tracksInGroup[s];
    if (!o || o.groupId !== n) {
      this.warn(`Subtitle track with id:${s} and group:${n} not found in active group ${o == null ? void 0 : o.groupId}`);
      return;
    }
    const a = o.details;
    o.details = t.details, this.log(`Subtitle track ${s} "${o.name}" lang:${o.lang} group:${n} loaded [${r.startSN}-${r.endSN}]`), s === this.trackId && this.playlistLoaded(s, t, a);
  }
  onLevelLoading(e, t) {
    this.switchLevel(t.level);
  }
  onLevelSwitching(e, t) {
    this.switchLevel(t.level);
  }
  switchLevel(e) {
    const t = this.hls.levels[e];
    if (!t)
      return;
    const s = t.subtitleGroups || null, n = this.groupIds;
    let r = this.currentTrack;
    if (!s || (n == null ? void 0 : n.length) !== (s == null ? void 0 : s.length) || s != null && s.some((o) => (n == null ? void 0 : n.indexOf(o)) === -1)) {
      this.groupIds = s, this.trackId = -1, this.currentTrack = null;
      const o = this.tracks.filter((u) => !s || s.indexOf(u.groupId) !== -1);
      if (o.length)
        this.selectDefaultTrack && !o.some((u) => u.default) && (this.selectDefaultTrack = !1), o.forEach((u, d) => {
          u.id = d;
        });
      else if (!r && !this.tracksInGroup.length)
        return;
      this.tracksInGroup = o;
      const a = this.hls.config.subtitlePreference;
      if (!r && a) {
        this.selectDefaultTrack = !1;
        const u = Qe(a, o);
        if (u > -1)
          r = o[u];
        else {
          const d = Qe(a, this.tracks);
          r = this.tracks[d];
        }
      }
      let l = this.findTrackId(r);
      l === -1 && r && (l = this.findTrackId(null));
      const c = {
        subtitleTracks: o
      };
      this.log(`Updating subtitle tracks, ${o.length} track(s) found in "${s == null ? void 0 : s.join(",")}" group-id`), this.hls.trigger(T.SUBTITLE_TRACKS_UPDATED, c), l !== -1 && this.trackId === -1 && this.setSubtitleTrack(l);
    } else this.shouldReloadPlaylist(r) && this.setSubtitleTrack(this.trackId);
  }
  findTrackId(e) {
    const t = this.tracksInGroup, s = this.selectDefaultTrack;
    for (let n = 0; n < t.length; n++) {
      const r = t[n];
      if (!(s && !r.default || !s && !e) && (!e || Ut(r, e)))
        return n;
    }
    if (e) {
      for (let n = 0; n < t.length; n++) {
        const r = t[n];
        if (Kt(e.attrs, r.attrs, ["LANGUAGE", "ASSOC-LANGUAGE", "CHARACTERISTICS"]))
          return n;
      }
      for (let n = 0; n < t.length; n++) {
        const r = t[n];
        if (Kt(e.attrs, r.attrs, ["LANGUAGE"]))
          return n;
      }
    }
    return -1;
  }
  findTrackForTextTrack(e) {
    if (e) {
      const t = this.tracksInGroup;
      for (let s = 0; s < t.length; s++) {
        const n = t[s];
        if (zn(n, e))
          return s;
      }
    }
    return -1;
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === re.SUBTITLE_TRACK && t.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(t.context.groupId) !== -1) && this.checkRetry(t);
  }
  get allSubtitleTracks() {
    return this.tracks;
  }
  /** get alternate subtitle tracks list from playlist **/
  get subtitleTracks() {
    return this.tracksInGroup;
  }
  /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/
  get subtitleTrack() {
    return this.trackId;
  }
  set subtitleTrack(e) {
    this.selectDefaultTrack = !1, this.setSubtitleTrack(e);
  }
  setSubtitleOption(e) {
    if (this.hls.config.subtitlePreference = e, e) {
      const t = this.allSubtitleTracks;
      if (this.selectDefaultTrack = !1, t.length) {
        const s = this.currentTrack;
        if (s && Ut(e, s))
          return s;
        const n = Qe(e, this.tracksInGroup);
        if (n > -1) {
          const r = this.tracksInGroup[n];
          return this.setSubtitleTrack(n), r;
        } else {
          if (s)
            return null;
          {
            const r = Qe(e, t);
            if (r > -1)
              return t[r];
          }
        }
      }
    }
    return null;
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const t = this.currentTrack;
    if (this.shouldLoadPlaylist(t) && t) {
      const s = t.id, n = t.groupId;
      let r = t.url;
      if (e)
        try {
          r = e.addDirectives(r);
        } catch (o) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${o}`);
        }
      this.log(`Loading subtitle playlist for id ${s}`), this.hls.trigger(T.SUBTITLE_TRACK_LOADING, {
        url: r,
        id: s,
        groupId: n,
        deliveryDirectives: e || null
      });
    }
  }
  /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */
  toggleTrackModes() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = _s(e.textTracks), s = this.currentTrack;
    let n;
    if (s && (n = t.filter((r) => zn(s, r))[0], n || this.warn(`Unable to find subtitle TextTrack with name "${s.name}" and language "${s.lang}"`)), [].slice.call(t).forEach((r) => {
      r.mode !== "disabled" && r !== n && (r.mode = "disabled");
    }), n) {
      const r = this.subtitleDisplay ? "showing" : "hidden";
      n.mode !== r && (n.mode = r);
    }
  }
  /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */
  setSubtitleTrack(e) {
    const t = this.tracksInGroup;
    if (!this.media) {
      this.queuedDefaultTrack = e;
      return;
    }
    if (e < -1 || e >= t.length || !G(e)) {
      this.warn(`Invalid subtitle track id: ${e}`);
      return;
    }
    this.clearTimer(), this.selectDefaultTrack = !1;
    const s = this.currentTrack, n = t[e] || null;
    if (this.trackId = e, this.currentTrack = n, this.toggleTrackModes(), !n) {
      this.hls.trigger(T.SUBTITLE_TRACK_SWITCH, {
        id: e
      });
      return;
    }
    const r = !!n.details && !n.details.live;
    if (e === this.trackId && n === s && r)
      return;
    this.log(`Switching to subtitle-track ${e}` + (n ? ` "${n.name}" lang:${n.lang} group:${n.groupId}` : ""));
    const {
      id: o,
      groupId: a = "",
      name: l,
      type: c,
      url: u
    } = n;
    this.hls.trigger(T.SUBTITLE_TRACK_SWITCH, {
      id: o,
      groupId: a,
      name: l,
      type: c,
      url: u
    });
    const d = this.switchParams(n.url, s == null ? void 0 : s.details, n.details);
    this.loadPlaylist(d);
  }
}
class vg {
  constructor(e) {
    this.buffers = void 0, this.queues = {
      video: [],
      audio: [],
      audiovideo: []
    }, this.buffers = e;
  }
  append(e, t, s) {
    const n = this.queues[t];
    n.push(e), n.length === 1 && !s && this.executeNext(t);
  }
  insertAbort(e, t) {
    this.queues[t].unshift(e), this.executeNext(t);
  }
  appendBlocker(e) {
    let t;
    const s = new Promise((r) => {
      t = r;
    }), n = {
      execute: t,
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: () => {
      }
    };
    return this.append(n, e), s;
  }
  executeNext(e) {
    const t = this.queues[e];
    if (t.length) {
      const s = t[0];
      try {
        s.execute();
      } catch (n) {
        D.warn(`[buffer-operation-queue]: Exception executing "${e}" SourceBuffer operation: ${n}`), s.onError(n);
        const r = this.buffers[e];
        r != null && r.updating || this.shiftAndExecuteNext(e);
      }
    }
  }
  shiftAndExecuteNext(e) {
    this.queues[e].shift(), this.executeNext(e);
  }
  current(e) {
    return this.queues[e][0];
  }
}
const $r = /(avc[1234]|hvc1|hev1|dvh[1e]|vp09|av01)(?:\.[^.,]+)+/;
class Sg {
  constructor(e) {
    this.details = null, this._objectUrl = null, this.operationQueue = void 0, this.listeners = void 0, this.hls = void 0, this.bufferCodecEventsExpected = 0, this._bufferCodecEventsTotal = 0, this.media = null, this.mediaSource = null, this.lastMpegAudioChunk = null, this.appendSource = void 0, this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    }, this.tracks = {}, this.pendingTracks = {}, this.sourceBuffer = void 0, this.log = void 0, this.warn = void 0, this.error = void 0, this._onEndStreaming = (s) => {
      this.hls && this.hls.pauseBuffering();
    }, this._onStartStreaming = (s) => {
      this.hls && this.hls.resumeBuffering();
    }, this._onMediaSourceOpen = () => {
      const {
        media: s,
        mediaSource: n
      } = this;
      this.log("Media source opened"), s && (s.removeEventListener("emptied", this._onMediaEmptied), this.updateMediaElementDuration(), this.hls.trigger(T.MEDIA_ATTACHED, {
        media: s,
        mediaSource: n
      })), n && n.removeEventListener("sourceopen", this._onMediaSourceOpen), this.checkPendingTracks();
    }, this._onMediaSourceClose = () => {
      this.log("Media source closed");
    }, this._onMediaSourceEnded = () => {
      this.log("Media source ended");
    }, this._onMediaEmptied = () => {
      const {
        mediaSrc: s,
        _objectUrl: n
      } = this;
      s !== n && D.error(`Media element src was set while attaching MediaSource (${n} > ${s})`);
    }, this.hls = e;
    const t = "[buffer-controller]";
    this.appendSource = wf(Lt(e.config.preferManagedMediaSource)), this.log = D.log.bind(D, t), this.warn = D.warn.bind(D, t), this.error = D.error.bind(D, t), this._initSourceBuffer(), this.registerListeners();
  }
  hasSourceTypes() {
    return this.getSourceBufferTypes().length > 0 || Object.keys(this.pendingTracks).length > 0;
  }
  destroy() {
    this.unregisterListeners(), this.details = null, this.lastMpegAudioChunk = null, this.hls = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.BUFFER_RESET, this.onBufferReset, this), e.on(T.BUFFER_APPENDING, this.onBufferAppending, this), e.on(T.BUFFER_CODECS, this.onBufferCodecs, this), e.on(T.BUFFER_EOS, this.onBufferEos, this), e.on(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(T.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(T.FRAG_PARSED, this.onFragParsed, this), e.on(T.FRAG_CHANGED, this.onFragChanged, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.BUFFER_RESET, this.onBufferReset, this), e.off(T.BUFFER_APPENDING, this.onBufferAppending, this), e.off(T.BUFFER_CODECS, this.onBufferCodecs, this), e.off(T.BUFFER_EOS, this.onBufferEos, this), e.off(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(T.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(T.FRAG_PARSED, this.onFragParsed, this), e.off(T.FRAG_CHANGED, this.onFragChanged, this);
  }
  _initSourceBuffer() {
    this.sourceBuffer = {}, this.operationQueue = new vg(this.sourceBuffer), this.listeners = {
      audio: [],
      video: [],
      audiovideo: []
    }, this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    }, this.lastMpegAudioChunk = null;
  }
  onManifestLoading() {
    this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = 0, this.details = null;
  }
  onManifestParsed(e, t) {
    let s = 2;
    (t.audio && !t.video || !t.altAudio) && (s = 1), this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = s, this.log(`${this.bufferCodecEventsExpected} bufferCodec event(s) expected`);
  }
  onMediaAttaching(e, t) {
    const s = this.media = t.media, n = Lt(this.appendSource);
    if (s && n) {
      var r;
      const o = this.mediaSource = new n();
      this.log(`created media source: ${(r = o.constructor) == null ? void 0 : r.name}`), o.addEventListener("sourceopen", this._onMediaSourceOpen), o.addEventListener("sourceended", this._onMediaSourceEnded), o.addEventListener("sourceclose", this._onMediaSourceClose), this.appendSource && (o.addEventListener("startstreaming", this._onStartStreaming), o.addEventListener("endstreaming", this._onEndStreaming));
      const a = this._objectUrl = self.URL.createObjectURL(o);
      if (this.appendSource)
        try {
          s.removeAttribute("src");
          const l = self.ManagedMediaSource;
          s.disableRemotePlayback = s.disableRemotePlayback || l && o instanceof l, Gr(s), Ag(s, a), s.load();
        } catch {
          s.src = a;
        }
      else
        s.src = a;
      s.addEventListener("emptied", this._onMediaEmptied);
    }
  }
  onMediaDetaching() {
    const {
      media: e,
      mediaSource: t,
      _objectUrl: s
    } = this;
    if (t) {
      if (this.log("media source detaching"), t.readyState === "open")
        try {
          t.endOfStream();
        } catch (n) {
          this.warn(`onMediaDetaching: ${n.message} while calling endOfStream`);
        }
      this.onBufferReset(), t.removeEventListener("sourceopen", this._onMediaSourceOpen), t.removeEventListener("sourceended", this._onMediaSourceEnded), t.removeEventListener("sourceclose", this._onMediaSourceClose), this.appendSource && (t.removeEventListener("startstreaming", this._onStartStreaming), t.removeEventListener("endstreaming", this._onEndStreaming)), e && (e.removeEventListener("emptied", this._onMediaEmptied), s && self.URL.revokeObjectURL(s), this.mediaSrc === s ? (e.removeAttribute("src"), this.appendSource && Gr(e), e.load()) : this.warn("media|source.src was changed by a third party - skip cleanup")), this.mediaSource = null, this.media = null, this._objectUrl = null, this.bufferCodecEventsExpected = this._bufferCodecEventsTotal, this.pendingTracks = {}, this.tracks = {};
    }
    this.hls.trigger(T.MEDIA_DETACHED, void 0);
  }
  onBufferReset() {
    this.getSourceBufferTypes().forEach((e) => {
      this.resetBuffer(e);
    }), this._initSourceBuffer();
  }
  resetBuffer(e) {
    const t = this.sourceBuffer[e];
    try {
      if (t) {
        var s;
        this.removeBufferListeners(e), this.sourceBuffer[e] = void 0, (s = this.mediaSource) != null && s.sourceBuffers.length && this.mediaSource.removeSourceBuffer(t);
      }
    } catch (n) {
      this.warn(`onBufferReset ${e}`, n);
    }
  }
  onBufferCodecs(e, t) {
    const s = this.getSourceBufferTypes().length, n = Object.keys(t);
    if (n.forEach((o) => {
      if (s) {
        const l = this.tracks[o];
        if (l && typeof l.buffer.changeType == "function") {
          var a;
          const {
            id: c,
            codec: u,
            levelCodec: d,
            container: h,
            metadata: m
          } = t[o], f = lr(l.codec, l.levelCodec), g = f == null ? void 0 : f.replace($r, "$1");
          let p = lr(u, d);
          const E = (a = p) == null ? void 0 : a.replace($r, "$1");
          if (p && g !== E) {
            o.slice(0, 5) === "audio" && (p = Vs(p, this.appendSource));
            const y = `${h};codecs=${p}`;
            this.appendChangeType(o, y), this.log(`switching codec ${f} to ${p}`), this.tracks[o] = {
              buffer: l.buffer,
              codec: u,
              container: h,
              levelCodec: d,
              metadata: m,
              id: c
            };
          }
        }
      } else
        this.pendingTracks[o] = t[o];
    }), s)
      return;
    const r = Math.max(this.bufferCodecEventsExpected - 1, 0);
    this.bufferCodecEventsExpected !== r && (this.log(`${r} bufferCodec event(s) expected ${n.join(",")}`), this.bufferCodecEventsExpected = r), this.mediaSource && this.mediaSource.readyState === "open" && this.checkPendingTracks();
  }
  appendChangeType(e, t) {
    const {
      operationQueue: s
    } = this, n = {
      execute: () => {
        const r = this.sourceBuffer[e];
        r && (this.log(`changing ${e} sourceBuffer type to ${t}`), r.changeType(t)), s.shiftAndExecuteNext(e);
      },
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: (r) => {
        this.warn(`Failed to change ${e} SourceBuffer type`, r);
      }
    };
    s.append(n, e, !!this.pendingTracks[e]);
  }
  onBufferAppending(e, t) {
    const {
      hls: s,
      operationQueue: n,
      tracks: r
    } = this, {
      data: o,
      type: a,
      frag: l,
      part: c,
      chunkMeta: u
    } = t, d = u.buffering[a], h = self.performance.now();
    d.start = h;
    const m = l.stats.buffering, f = c ? c.stats.buffering : null;
    m.start === 0 && (m.start = h), f && f.start === 0 && (f.start = h);
    const g = r.audio;
    let p = !1;
    a === "audio" && (g == null ? void 0 : g.container) === "audio/mpeg" && (p = !this.lastMpegAudioChunk || u.id === 1 || this.lastMpegAudioChunk.sn !== u.sn, this.lastMpegAudioChunk = u);
    const E = l.start, y = {
      execute: () => {
        if (d.executeStart = self.performance.now(), p) {
          const v = this.sourceBuffer[a];
          if (v) {
            const S = E - v.timestampOffset;
            Math.abs(S) >= 0.1 && (this.log(`Updating audio SourceBuffer timestampOffset to ${E} (delta: ${S}) sn: ${l.sn})`), v.timestampOffset = E);
          }
        }
        this.appendExecutor(o, a);
      },
      onStart: () => {
      },
      onComplete: () => {
        const v = self.performance.now();
        d.executeEnd = d.end = v, m.first === 0 && (m.first = v), f && f.first === 0 && (f.first = v);
        const {
          sourceBuffer: S
        } = this, x = {};
        for (const R in S)
          x[R] = de.getBuffered(S[R]);
        this.appendErrors[a] = 0, a === "audio" || a === "video" ? this.appendErrors.audiovideo = 0 : (this.appendErrors.audio = 0, this.appendErrors.video = 0), this.hls.trigger(T.BUFFER_APPENDED, {
          type: a,
          frag: l,
          part: c,
          chunkMeta: u,
          parent: l.type,
          timeRanges: x
        });
      },
      onError: (v) => {
        const S = {
          type: Z.MEDIA_ERROR,
          parent: l.type,
          details: C.BUFFER_APPEND_ERROR,
          sourceBufferName: a,
          frag: l,
          part: c,
          chunkMeta: u,
          error: v,
          err: v,
          fatal: !1
        };
        if (v.code === DOMException.QUOTA_EXCEEDED_ERR)
          S.details = C.BUFFER_FULL_ERROR;
        else {
          const x = ++this.appendErrors[a];
          S.details = C.BUFFER_APPEND_ERROR, this.warn(`Failed ${x}/${s.config.appendErrorMaxRetry} times to append segment in "${a}" sourceBuffer`), x >= s.config.appendErrorMaxRetry && (S.fatal = !0);
        }
        s.trigger(T.ERROR, S);
      }
    };
    n.append(y, a, !!this.pendingTracks[a]);
  }
  onBufferFlushing(e, t) {
    const {
      operationQueue: s
    } = this, n = (r) => ({
      execute: this.removeExecutor.bind(this, r, t.startOffset, t.endOffset),
      onStart: () => {
      },
      onComplete: () => {
        this.hls.trigger(T.BUFFER_FLUSHED, {
          type: r
        });
      },
      onError: (o) => {
        this.warn(`Failed to remove from ${r} SourceBuffer`, o);
      }
    });
    t.type ? s.append(n(t.type), t.type) : this.getSourceBufferTypes().forEach((r) => {
      s.append(n(r), r);
    });
  }
  onFragParsed(e, t) {
    const {
      frag: s,
      part: n
    } = t, r = [], o = n ? n.elementaryStreams : s.elementaryStreams;
    o[ae.AUDIOVIDEO] ? r.push("audiovideo") : (o[ae.AUDIO] && r.push("audio"), o[ae.VIDEO] && r.push("video"));
    const a = () => {
      const l = self.performance.now();
      s.stats.buffering.end = l, n && (n.stats.buffering.end = l);
      const c = n ? n.stats : s.stats;
      this.hls.trigger(T.FRAG_BUFFERED, {
        frag: s,
        part: n,
        stats: c,
        id: s.type
      });
    };
    r.length === 0 && this.warn(`Fragments must have at least one ElementaryStreamType set. type: ${s.type} level: ${s.level} sn: ${s.sn}`), this.blockBuffers(a, r);
  }
  onFragChanged(e, t) {
    this.trimBuffers();
  }
  // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
  // an undefined data.type will mark all buffers as EOS.
  onBufferEos(e, t) {
    this.getSourceBufferTypes().reduce((n, r) => {
      const o = this.sourceBuffer[r];
      return o && (!t.type || t.type === r) && (o.ending = !0, o.ended || (o.ended = !0, this.log(`${r} sourceBuffer now EOS`))), n && !!(!o || o.ended);
    }, !0) && (this.log("Queueing mediaSource.endOfStream()"), this.blockBuffers(() => {
      this.getSourceBufferTypes().forEach((r) => {
        const o = this.sourceBuffer[r];
        o && (o.ending = !1);
      });
      const {
        mediaSource: n
      } = this;
      if (!n || n.readyState !== "open") {
        n && this.log(`Could not call mediaSource.endOfStream(). mediaSource.readyState: ${n.readyState}`);
        return;
      }
      this.log("Calling mediaSource.endOfStream()"), n.endOfStream();
    }));
  }
  onLevelUpdated(e, {
    details: t
  }) {
    t.fragments.length && (this.details = t, this.getSourceBufferTypes().length ? this.blockBuffers(this.updateMediaElementDuration.bind(this)) : this.updateMediaElementDuration());
  }
  trimBuffers() {
    const {
      hls: e,
      details: t,
      media: s
    } = this;
    if (!s || t === null || !this.getSourceBufferTypes().length)
      return;
    const r = e.config, o = s.currentTime, a = t.levelTargetDuration, l = t.live && r.liveBackBufferLength !== null ? r.liveBackBufferLength : r.backBufferLength;
    if (G(l) && l > 0) {
      const c = Math.max(l, a), u = Math.floor(o / a) * a - c;
      this.flushBackBuffer(o, a, u);
    }
    if (G(r.frontBufferFlushThreshold) && r.frontBufferFlushThreshold > 0) {
      const c = Math.max(r.maxBufferLength, r.frontBufferFlushThreshold), u = Math.max(c, a), d = Math.floor(o / a) * a + u;
      this.flushFrontBuffer(o, a, d);
    }
  }
  flushBackBuffer(e, t, s) {
    const {
      details: n,
      sourceBuffer: r
    } = this;
    this.getSourceBufferTypes().forEach((a) => {
      const l = r[a];
      if (l) {
        const c = de.getBuffered(l);
        if (c.length > 0 && s > c.start(0)) {
          if (this.hls.trigger(T.BACK_BUFFER_REACHED, {
            bufferEnd: s
          }), n != null && n.live)
            this.hls.trigger(T.LIVE_BACK_BUFFER_REACHED, {
              bufferEnd: s
            });
          else if (l.ended && c.end(c.length - 1) - e < t * 2) {
            this.log(`Cannot flush ${a} back buffer while SourceBuffer is in ended state`);
            return;
          }
          this.hls.trigger(T.BUFFER_FLUSHING, {
            startOffset: 0,
            endOffset: s,
            type: a
          });
        }
      }
    });
  }
  flushFrontBuffer(e, t, s) {
    const {
      sourceBuffer: n
    } = this;
    this.getSourceBufferTypes().forEach((o) => {
      const a = n[o];
      if (a) {
        const l = de.getBuffered(a), c = l.length;
        if (c < 2)
          return;
        const u = l.start(c - 1), d = l.end(c - 1);
        if (s > u || e >= u && e <= d)
          return;
        if (a.ended && e - d < 2 * t) {
          this.log(`Cannot flush ${o} front buffer while SourceBuffer is in ended state`);
          return;
        }
        this.hls.trigger(T.BUFFER_FLUSHING, {
          startOffset: u,
          endOffset: 1 / 0,
          type: o
        });
      }
    });
  }
  /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */
  updateMediaElementDuration() {
    if (!this.details || !this.media || !this.mediaSource || this.mediaSource.readyState !== "open")
      return;
    const {
      details: e,
      hls: t,
      media: s,
      mediaSource: n
    } = this, r = e.fragments[0].start + e.totalduration, o = s.duration, a = G(n.duration) ? n.duration : 0;
    e.live && t.config.liveDurationInfinity ? (n.duration = 1 / 0, this.updateSeekableRange(e)) : (r > a && r > o || !G(o)) && (this.log(`Updating Media Source duration to ${r.toFixed(3)}`), n.duration = r);
  }
  updateSeekableRange(e) {
    const t = this.mediaSource, s = e.fragments;
    if (s.length && e.live && t != null && t.setLiveSeekableRange) {
      const r = Math.max(0, s[0].start), o = Math.max(r, r + e.totalduration);
      this.log(`Media Source duration is set to ${t.duration}. Setting seekable range to ${r}-${o}.`), t.setLiveSeekableRange(r, o);
    }
  }
  checkPendingTracks() {
    const {
      bufferCodecEventsExpected: e,
      operationQueue: t,
      pendingTracks: s
    } = this, n = Object.keys(s).length;
    if (n && (!e || n === 2 || "audiovideo" in s)) {
      this.createSourceBuffers(s), this.pendingTracks = {};
      const r = this.getSourceBufferTypes();
      if (r.length)
        this.hls.trigger(T.BUFFER_CREATED, {
          tracks: this.tracks
        }), r.forEach((o) => {
          t.executeNext(o);
        });
      else {
        const o = new Error("could not create source buffer for media codec(s)");
        this.hls.trigger(T.ERROR, {
          type: Z.MEDIA_ERROR,
          details: C.BUFFER_INCOMPATIBLE_CODECS_ERROR,
          fatal: !0,
          error: o,
          reason: o.message
        });
      }
    }
  }
  createSourceBuffers(e) {
    const {
      sourceBuffer: t,
      mediaSource: s
    } = this;
    if (!s)
      throw Error("createSourceBuffers called when mediaSource was null");
    for (const r in e)
      if (!t[r]) {
        var n;
        const o = e[r];
        if (!o)
          throw Error(`source buffer exists for track ${r}, however track does not`);
        let a = ((n = o.levelCodec) == null ? void 0 : n.indexOf(",")) === -1 ? o.levelCodec : o.codec;
        a && r.slice(0, 5) === "audio" && (a = Vs(a, this.appendSource));
        const l = `${o.container};codecs=${a}`;
        this.log(`creating sourceBuffer(${l})`);
        try {
          const c = t[r] = s.addSourceBuffer(l), u = r;
          this.addBufferListener(u, "updatestart", this._onSBUpdateStart), this.addBufferListener(u, "updateend", this._onSBUpdateEnd), this.addBufferListener(u, "error", this._onSBUpdateError), this.appendSource && this.addBufferListener(u, "bufferedchange", (d, h) => {
            const m = h.removedRanges;
            m != null && m.length && this.hls.trigger(T.BUFFER_FLUSHED, {
              type: r
            });
          }), this.tracks[r] = {
            buffer: c,
            codec: a,
            container: o.container,
            levelCodec: o.levelCodec,
            metadata: o.metadata,
            id: o.id
          };
        } catch (c) {
          this.error(`error while trying to add sourceBuffer: ${c.message}`), this.hls.trigger(T.ERROR, {
            type: Z.MEDIA_ERROR,
            details: C.BUFFER_ADD_CODEC_ERROR,
            fatal: !1,
            error: c,
            sourceBufferName: r,
            mimeType: l
          });
        }
      }
  }
  get mediaSrc() {
    var e;
    const t = ((e = this.media) == null ? void 0 : e.firstChild) || this.media;
    return t == null ? void 0 : t.src;
  }
  _onSBUpdateStart(e) {
    const {
      operationQueue: t
    } = this;
    t.current(e).onStart();
  }
  _onSBUpdateEnd(e) {
    var t;
    if (((t = this.mediaSource) == null ? void 0 : t.readyState) === "closed") {
      this.resetBuffer(e);
      return;
    }
    const {
      operationQueue: s
    } = this;
    s.current(e).onComplete(), s.shiftAndExecuteNext(e);
  }
  _onSBUpdateError(e, t) {
    var s;
    const n = new Error(`${e} SourceBuffer error. MediaSource readyState: ${(s = this.mediaSource) == null ? void 0 : s.readyState}`);
    this.error(`${n}`, t), this.hls.trigger(T.ERROR, {
      type: Z.MEDIA_ERROR,
      details: C.BUFFER_APPENDING_ERROR,
      sourceBufferName: e,
      error: n,
      fatal: !1
    });
    const r = this.operationQueue.current(e);
    r && r.onError(n);
  }
  // This method must result in an updateend event; if remove is not called, _onSBUpdateEnd must be called manually
  removeExecutor(e, t, s) {
    const {
      media: n,
      mediaSource: r,
      operationQueue: o,
      sourceBuffer: a
    } = this, l = a[e];
    if (!n || !r || !l) {
      this.warn(`Attempting to remove from the ${e} SourceBuffer, but it does not exist`), o.shiftAndExecuteNext(e);
      return;
    }
    const c = G(n.duration) ? n.duration : 1 / 0, u = G(r.duration) ? r.duration : 1 / 0, d = Math.max(0, t), h = Math.min(s, c, u);
    h > d && (!l.ending || l.ended) ? (l.ended = !1, this.log(`Removing [${d},${h}] from the ${e} SourceBuffer`), l.remove(d, h)) : o.shiftAndExecuteNext(e);
  }
  // This method must result in an updateend event; if append is not called, _onSBUpdateEnd must be called manually
  appendExecutor(e, t) {
    const s = this.sourceBuffer[t];
    if (!s) {
      if (!this.pendingTracks[t])
        throw new Error(`Attempting to append to the ${t} SourceBuffer, but it does not exist`);
      return;
    }
    s.ended = !1, s.appendBuffer(e);
  }
  // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
  // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
  // upon completion, since we already do it here
  blockBuffers(e, t = this.getSourceBufferTypes()) {
    if (!t.length) {
      this.log("Blocking operation requested, but no SourceBuffers exist"), Promise.resolve().then(e);
      return;
    }
    const {
      operationQueue: s
    } = this, n = t.map((r) => s.appendBlocker(r));
    Promise.all(n).then(() => {
      e(), t.forEach((r) => {
        const o = this.sourceBuffer[r];
        o != null && o.updating || s.shiftAndExecuteNext(r);
      });
    });
  }
  getSourceBufferTypes() {
    return Object.keys(this.sourceBuffer);
  }
  addBufferListener(e, t, s) {
    const n = this.sourceBuffer[e];
    if (!n)
      return;
    const r = s.bind(this, e);
    this.listeners[e].push({
      event: t,
      listener: r
    }), n.addEventListener(t, r);
  }
  removeBufferListeners(e) {
    const t = this.sourceBuffer[e];
    t && this.listeners[e].forEach((s) => {
      t.removeEventListener(s.event, s.listener);
    });
  }
}
function Gr(i) {
  const e = i.querySelectorAll("source");
  [].slice.call(e).forEach((t) => {
    i.removeChild(t);
  });
}
function Ag(i, e) {
  const t = self.document.createElement("source");
  t.type = "video/mp4", t.src = e, i.appendChild(t);
}
const Lg = {
  42: 225,
  // lowercase a, acute accent
  92: 233,
  // lowercase e, acute accent
  94: 237,
  // lowercase i, acute accent
  95: 243,
  // lowercase o, acute accent
  96: 250,
  // lowercase u, acute accent
  123: 231,
  // lowercase c with cedilla
  124: 247,
  // division symbol
  125: 209,
  // uppercase N tilde
  126: 241,
  // lowercase n tilde
  127: 9608,
  // Full block
  // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
  // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
  128: 174,
  // Registered symbol (R)
  129: 176,
  // degree sign
  130: 189,
  // 1/2 symbol
  131: 191,
  // Inverted (open) question mark
  132: 8482,
  // Trademark symbol (TM)
  133: 162,
  // Cents symbol
  134: 163,
  // Pounds sterling
  135: 9834,
  // Music 8'th note
  136: 224,
  // lowercase a, grave accent
  137: 32,
  // transparent space (regular)
  138: 232,
  // lowercase e, grave accent
  139: 226,
  // lowercase a, circumflex accent
  140: 234,
  // lowercase e, circumflex accent
  141: 238,
  // lowercase i, circumflex accent
  142: 244,
  // lowercase o, circumflex accent
  143: 251,
  // lowercase u, circumflex accent
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
  144: 193,
  // capital letter A with acute
  145: 201,
  // capital letter E with acute
  146: 211,
  // capital letter O with acute
  147: 218,
  // capital letter U with acute
  148: 220,
  // capital letter U with diaresis
  149: 252,
  // lowercase letter U with diaeresis
  150: 8216,
  // opening single quote
  151: 161,
  // inverted exclamation mark
  152: 42,
  // asterisk
  153: 8217,
  // closing single quote
  154: 9473,
  // box drawings heavy horizontal
  155: 169,
  // copyright sign
  156: 8480,
  // Service mark
  157: 8226,
  // (round) bullet
  158: 8220,
  // Left double quotation mark
  159: 8221,
  // Right double quotation mark
  160: 192,
  // uppercase A, grave accent
  161: 194,
  // uppercase A, circumflex
  162: 199,
  // uppercase C with cedilla
  163: 200,
  // uppercase E, grave accent
  164: 202,
  // uppercase E, circumflex
  165: 203,
  // capital letter E with diaresis
  166: 235,
  // lowercase letter e with diaresis
  167: 206,
  // uppercase I, circumflex
  168: 207,
  // uppercase I, with diaresis
  169: 239,
  // lowercase i, with diaresis
  170: 212,
  // uppercase O, circumflex
  171: 217,
  // uppercase U, grave accent
  172: 249,
  // lowercase u, grave accent
  173: 219,
  // uppercase U, circumflex
  174: 171,
  // left-pointing double angle quotation mark
  175: 187,
  // right-pointing double angle quotation mark
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
  176: 195,
  // Uppercase A, tilde
  177: 227,
  // Lowercase a, tilde
  178: 205,
  // Uppercase I, acute accent
  179: 204,
  // Uppercase I, grave accent
  180: 236,
  // Lowercase i, grave accent
  181: 210,
  // Uppercase O, grave accent
  182: 242,
  // Lowercase o, grave accent
  183: 213,
  // Uppercase O, tilde
  184: 245,
  // Lowercase o, tilde
  185: 123,
  // Open curly brace
  186: 125,
  // Closing curly brace
  187: 92,
  // Backslash
  188: 94,
  // Caret
  189: 95,
  // Underscore
  190: 124,
  // Pipe (vertical line)
  191: 8764,
  // Tilde operator
  192: 196,
  // Uppercase A, umlaut
  193: 228,
  // Lowercase A, umlaut
  194: 214,
  // Uppercase O, umlaut
  195: 246,
  // Lowercase o, umlaut
  196: 223,
  // Esszett (sharp S)
  197: 165,
  // Yen symbol
  198: 164,
  // Generic currency sign
  199: 9475,
  // Box drawings heavy vertical
  200: 197,
  // Uppercase A, ring
  201: 229,
  // Lowercase A, ring
  202: 216,
  // Uppercase O, stroke
  203: 248,
  // Lowercase o, strok
  204: 9487,
  // Box drawings heavy down and right
  205: 9491,
  // Box drawings heavy down and left
  206: 9495,
  // Box drawings heavy up and right
  207: 9499
  // Box drawings heavy up and left
}, ma = (i) => String.fromCharCode(Lg[i] || i), Ve = 15, ct = 100, Rg = {
  17: 1,
  18: 3,
  21: 5,
  22: 7,
  23: 9,
  16: 11,
  19: 12,
  20: 14
}, Dg = {
  17: 2,
  18: 4,
  21: 6,
  22: 8,
  23: 10,
  19: 13,
  20: 15
}, Ig = {
  25: 1,
  26: 3,
  29: 5,
  30: 7,
  31: 9,
  24: 11,
  27: 12,
  28: 14
}, bg = {
  25: 2,
  26: 4,
  29: 6,
  30: 8,
  31: 10,
  27: 13,
  28: 15
}, _g = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"];
class Cg {
  constructor() {
    this.time = null, this.verboseLevel = 0;
  }
  log(e, t) {
    if (this.verboseLevel >= e) {
      const s = typeof t == "function" ? t() : t;
      D.log(`${this.time} [${e}] ${s}`);
    }
  }
}
const yt = function(e) {
  const t = [];
  for (let s = 0; s < e.length; s++)
    t.push(e[s].toString(16));
  return t;
};
class ga {
  constructor() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  reset() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  setStyles(e) {
    const t = ["foreground", "underline", "italics", "background", "flash"];
    for (let s = 0; s < t.length; s++) {
      const n = t[s];
      e.hasOwnProperty(n) && (this[n] = e[n]);
    }
  }
  isDefault() {
    return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
  }
  equals(e) {
    return this.foreground === e.foreground && this.underline === e.underline && this.italics === e.italics && this.background === e.background && this.flash === e.flash;
  }
  copy(e) {
    this.foreground = e.foreground, this.underline = e.underline, this.italics = e.italics, this.background = e.background, this.flash = e.flash;
  }
  toString() {
    return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
  }
}
class wg {
  constructor() {
    this.uchar = " ", this.penState = new ga();
  }
  reset() {
    this.uchar = " ", this.penState.reset();
  }
  setChar(e, t) {
    this.uchar = e, this.penState.copy(t);
  }
  setPenState(e) {
    this.penState.copy(e);
  }
  equals(e) {
    return this.uchar === e.uchar && this.penState.equals(e.penState);
  }
  copy(e) {
    this.uchar = e.uchar, this.penState.copy(e.penState);
  }
  isEmpty() {
    return this.uchar === " " && this.penState.isDefault();
  }
}
class Mg {
  constructor(e) {
    this.chars = [], this.pos = 0, this.currPenState = new ga(), this.cueStartTime = null, this.logger = void 0;
    for (let t = 0; t < ct; t++)
      this.chars.push(new wg());
    this.logger = e;
  }
  equals(e) {
    for (let t = 0; t < ct; t++)
      if (!this.chars[t].equals(e.chars[t]))
        return !1;
    return !0;
  }
  copy(e) {
    for (let t = 0; t < ct; t++)
      this.chars[t].copy(e.chars[t]);
  }
  isEmpty() {
    let e = !0;
    for (let t = 0; t < ct; t++)
      if (!this.chars[t].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  /**
   *  Set the cursor to a valid column.
   */
  setCursor(e) {
    this.pos !== e && (this.pos = e), this.pos < 0 ? (this.logger.log(3, "Negative cursor position " + this.pos), this.pos = 0) : this.pos > ct && (this.logger.log(3, "Too large cursor position " + this.pos), this.pos = ct);
  }
  /**
   * Move the cursor relative to current position.
   */
  moveCursor(e) {
    const t = this.pos + e;
    if (e > 1)
      for (let s = this.pos + 1; s < t + 1; s++)
        this.chars[s].setPenState(this.currPenState);
    this.setCursor(t);
  }
  /**
   * Backspace, move one step back and clear character.
   */
  backSpace() {
    this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
  }
  insertChar(e) {
    e >= 144 && this.backSpace();
    const t = ma(e);
    if (this.pos >= ct) {
      this.logger.log(0, () => "Cannot insert " + e.toString(16) + " (" + t + ") at position " + this.pos + ". Skipping it!");
      return;
    }
    this.chars[this.pos].setChar(t, this.currPenState), this.moveCursor(1);
  }
  clearFromPos(e) {
    let t;
    for (t = e; t < ct; t++)
      this.chars[t].reset();
  }
  clear() {
    this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
  }
  clearToEndOfRow() {
    this.clearFromPos(this.pos);
  }
  getTextString() {
    const e = [];
    let t = !0;
    for (let s = 0; s < ct; s++) {
      const n = this.chars[s].uchar;
      n !== " " && (t = !1), e.push(n);
    }
    return t ? "" : e.join("");
  }
  setPenStyles(e) {
    this.currPenState.setStyles(e), this.chars[this.pos].setPenState(this.currPenState);
  }
}
class An {
  constructor(e) {
    this.rows = [], this.currRow = Ve - 1, this.nrRollUpRows = null, this.lastOutputScreen = null, this.logger = void 0;
    for (let t = 0; t < Ve; t++)
      this.rows.push(new Mg(e));
    this.logger = e;
  }
  reset() {
    for (let e = 0; e < Ve; e++)
      this.rows[e].clear();
    this.currRow = Ve - 1;
  }
  equals(e) {
    let t = !0;
    for (let s = 0; s < Ve; s++)
      if (!this.rows[s].equals(e.rows[s])) {
        t = !1;
        break;
      }
    return t;
  }
  copy(e) {
    for (let t = 0; t < Ve; t++)
      this.rows[t].copy(e.rows[t]);
  }
  isEmpty() {
    let e = !0;
    for (let t = 0; t < Ve; t++)
      if (!this.rows[t].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  backSpace() {
    this.rows[this.currRow].backSpace();
  }
  clearToEndOfRow() {
    this.rows[this.currRow].clearToEndOfRow();
  }
  /**
   * Insert a character (without styling) in the current row.
   */
  insertChar(e) {
    this.rows[this.currRow].insertChar(e);
  }
  setPen(e) {
    this.rows[this.currRow].setPenStyles(e);
  }
  moveCursor(e) {
    this.rows[this.currRow].moveCursor(e);
  }
  setCursor(e) {
    this.logger.log(2, "setCursor: " + e), this.rows[this.currRow].setCursor(e);
  }
  setPAC(e) {
    this.logger.log(2, () => "pacData = " + JSON.stringify(e));
    let t = e.row - 1;
    if (this.nrRollUpRows && t < this.nrRollUpRows - 1 && (t = this.nrRollUpRows - 1), this.nrRollUpRows && this.currRow !== t) {
      for (let a = 0; a < Ve; a++)
        this.rows[a].clear();
      const r = this.currRow + 1 - this.nrRollUpRows, o = this.lastOutputScreen;
      if (o) {
        const a = o.rows[r].cueStartTime, l = this.logger.time;
        if (a !== null && l !== null && a < l)
          for (let c = 0; c < this.nrRollUpRows; c++)
            this.rows[t - this.nrRollUpRows + c + 1].copy(o.rows[r + c]);
      }
    }
    this.currRow = t;
    const s = this.rows[this.currRow];
    if (e.indent !== null) {
      const r = e.indent, o = Math.max(r - 1, 0);
      s.setCursor(e.indent), e.color = s.chars[o].penState.foreground;
    }
    const n = {
      foreground: e.color,
      underline: e.underline,
      italics: e.italics,
      background: "black",
      flash: !1
    };
    this.setPen(n);
  }
  /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */
  setBkgData(e) {
    this.logger.log(2, () => "bkgData = " + JSON.stringify(e)), this.backSpace(), this.setPen(e), this.insertChar(32);
  }
  setRollUpRows(e) {
    this.nrRollUpRows = e;
  }
  rollUp() {
    if (this.nrRollUpRows === null) {
      this.logger.log(3, "roll_up but nrRollUpRows not set yet");
      return;
    }
    this.logger.log(1, () => this.getDisplayText());
    const e = this.currRow + 1 - this.nrRollUpRows, t = this.rows.splice(e, 1)[0];
    t.clear(), this.rows.splice(this.currRow, 0, t), this.logger.log(2, "Rolling up");
  }
  /**
   * Get all non-empty rows with as unicode text.
   */
  getDisplayText(e) {
    e = e || !1;
    const t = [];
    let s = "", n = -1;
    for (let r = 0; r < Ve; r++) {
      const o = this.rows[r].getTextString();
      o && (n = r + 1, e ? t.push("Row " + n + ": '" + o + "'") : t.push(o.trim()));
    }
    return t.length > 0 && (e ? s = "[" + t.join(" | ") + "]" : s = t.join(`
`)), s;
  }
  getTextAndFormat() {
    return this.rows;
  }
}
class Hr {
  constructor(e, t, s) {
    this.chNr = void 0, this.outputFilter = void 0, this.mode = void 0, this.verbose = void 0, this.displayedMemory = void 0, this.nonDisplayedMemory = void 0, this.lastOutputScreen = void 0, this.currRollUpRow = void 0, this.writeScreen = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chNr = e, this.outputFilter = t, this.mode = null, this.verbose = 0, this.displayedMemory = new An(s), this.nonDisplayedMemory = new An(s), this.lastOutputScreen = new An(s), this.currRollUpRow = this.displayedMemory.rows[Ve - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.logger = s;
  }
  reset() {
    this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.outputFilter.reset(), this.currRollUpRow = this.displayedMemory.rows[Ve - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
  }
  getHandler() {
    return this.outputFilter;
  }
  setHandler(e) {
    this.outputFilter = e;
  }
  setPAC(e) {
    this.writeScreen.setPAC(e);
  }
  setBkgData(e) {
    this.writeScreen.setBkgData(e);
  }
  setMode(e) {
    e !== this.mode && (this.mode = e, this.logger.log(2, () => "MODE=" + e), this.mode === "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = e);
  }
  insertChars(e) {
    for (let s = 0; s < e.length; s++)
      this.writeScreen.insertChar(e[s]);
    const t = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
    this.logger.log(2, () => t + ": " + this.writeScreen.getDisplayText(!0)), (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") && (this.logger.log(1, () => "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
  }
  ccRCL() {
    this.logger.log(2, "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
  }
  ccBS() {
    this.logger.log(2, "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
  }
  ccAOF() {
  }
  ccAON() {
  }
  ccDER() {
    this.logger.log(2, "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
  }
  ccRU(e) {
    this.logger.log(2, "RU(" + e + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(e);
  }
  ccFON() {
    this.logger.log(2, "FON - Flash On"), this.writeScreen.setPen({
      flash: !0
    });
  }
  ccRDC() {
    this.logger.log(2, "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
  }
  ccTR() {
    this.logger.log(2, "TR"), this.setMode("MODE_TEXT");
  }
  ccRTD() {
    this.logger.log(2, "RTD"), this.setMode("MODE_TEXT");
  }
  ccEDM() {
    this.logger.log(2, "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate(!0);
  }
  ccCR() {
    this.logger.log(2, "CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate(!0);
  }
  ccENM() {
    this.logger.log(2, "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
  }
  ccEOC() {
    if (this.logger.log(2, "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
      const e = this.displayedMemory;
      this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = e, this.writeScreen = this.nonDisplayedMemory, this.logger.log(1, () => "DISP: " + this.displayedMemory.getDisplayText());
    }
    this.outputDataUpdate(!0);
  }
  ccTO(e) {
    this.logger.log(2, "TO(" + e + ") - Tab Offset"), this.writeScreen.moveCursor(e);
  }
  ccMIDROW(e) {
    const t = {
      flash: !1
    };
    if (t.underline = e % 2 === 1, t.italics = e >= 46, t.italics)
      t.foreground = "white";
    else {
      const s = Math.floor(e / 2) - 16, n = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
      t.foreground = n[s];
    }
    this.logger.log(2, "MIDROW: " + JSON.stringify(t)), this.writeScreen.setPen(t);
  }
  outputDataUpdate(e = !1) {
    const t = this.logger.time;
    t !== null && this.outputFilter && (this.cueStartTime === null && !this.displayedMemory.isEmpty() ? this.cueStartTime = t : this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen), e && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue(), this.cueStartTime = this.displayedMemory.isEmpty() ? null : t), this.lastOutputScreen.copy(this.displayedMemory));
  }
  cueSplitAtTime(e) {
    this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, e, this.displayedMemory), this.cueStartTime = e));
  }
}
class Kr {
  constructor(e, t, s) {
    this.channels = void 0, this.currentChannel = 0, this.cmdHistory = Fg(), this.logger = void 0;
    const n = this.logger = new Cg();
    this.channels = [null, new Hr(e, t, n), new Hr(e + 1, s, n)];
  }
  getHandler(e) {
    return this.channels[e].getHandler();
  }
  setHandler(e, t) {
    this.channels[e].setHandler(t);
  }
  /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */
  addData(e, t) {
    this.logger.time = e;
    for (let s = 0; s < t.length; s += 2) {
      const n = t[s] & 127, r = t[s + 1] & 127;
      let o = !1, a = null;
      if (n === 0 && r === 0)
        continue;
      this.logger.log(3, () => "[" + yt([t[s], t[s + 1]]) + "] -> (" + yt([n, r]) + ")");
      const l = this.cmdHistory;
      if (n >= 16 && n <= 31) {
        if (kg(n, r, l)) {
          As(null, null, l), this.logger.log(3, () => "Repeated command (" + yt([n, r]) + ") is dropped");
          continue;
        }
        As(n, r, this.cmdHistory), o = this.parseCmd(n, r), o || (o = this.parseMidrow(n, r)), o || (o = this.parsePAC(n, r)), o || (o = this.parseBackgroundAttributes(n, r));
      } else
        As(null, null, l);
      if (!o && (a = this.parseChars(n, r), a)) {
        const u = this.currentChannel;
        u && u > 0 ? this.channels[u].insertChars(a) : this.logger.log(2, "No channel found yet. TEXT-MODE?");
      }
      !o && !a && this.logger.log(2, () => "Couldn't parse cleaned data " + yt([n, r]) + " orig: " + yt([t[s], t[s + 1]]));
    }
  }
  /**
   * Parse Command.
   * @returns True if a command was found
   */
  parseCmd(e, t) {
    const s = (e === 20 || e === 28 || e === 21 || e === 29) && t >= 32 && t <= 47, n = (e === 23 || e === 31) && t >= 33 && t <= 35;
    if (!(s || n))
      return !1;
    const r = e === 20 || e === 21 || e === 23 ? 1 : 2, o = this.channels[r];
    return e === 20 || e === 21 || e === 28 || e === 29 ? t === 32 ? o.ccRCL() : t === 33 ? o.ccBS() : t === 34 ? o.ccAOF() : t === 35 ? o.ccAON() : t === 36 ? o.ccDER() : t === 37 ? o.ccRU(2) : t === 38 ? o.ccRU(3) : t === 39 ? o.ccRU(4) : t === 40 ? o.ccFON() : t === 41 ? o.ccRDC() : t === 42 ? o.ccTR() : t === 43 ? o.ccRTD() : t === 44 ? o.ccEDM() : t === 45 ? o.ccCR() : t === 46 ? o.ccENM() : t === 47 && o.ccEOC() : o.ccTO(t - 32), this.currentChannel = r, !0;
  }
  /**
   * Parse midrow styling command
   */
  parseMidrow(e, t) {
    let s = 0;
    if ((e === 17 || e === 25) && t >= 32 && t <= 47) {
      if (e === 17 ? s = 1 : s = 2, s !== this.currentChannel)
        return this.logger.log(0, "Mismatch channel in midrow parsing"), !1;
      const n = this.channels[s];
      return n ? (n.ccMIDROW(t), this.logger.log(3, () => "MIDROW (" + yt([e, t]) + ")"), !0) : !1;
    }
    return !1;
  }
  /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */
  parsePAC(e, t) {
    let s;
    const n = (e >= 17 && e <= 23 || e >= 25 && e <= 31) && t >= 64 && t <= 127, r = (e === 16 || e === 24) && t >= 64 && t <= 95;
    if (!(n || r))
      return !1;
    const o = e <= 23 ? 1 : 2;
    t >= 64 && t <= 95 ? s = o === 1 ? Rg[e] : Ig[e] : s = o === 1 ? Dg[e] : bg[e];
    const a = this.channels[o];
    return a ? (a.setPAC(this.interpretPAC(s, t)), this.currentChannel = o, !0) : !1;
  }
  /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */
  interpretPAC(e, t) {
    let s;
    const n = {
      color: null,
      italics: !1,
      indent: null,
      underline: !1,
      row: e
    };
    return t > 95 ? s = t - 96 : s = t - 64, n.underline = (s & 1) === 1, s <= 13 ? n.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(s / 2)] : s <= 15 ? (n.italics = !0, n.color = "white") : n.indent = Math.floor((s - 16) / 2) * 4, n;
  }
  /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */
  parseChars(e, t) {
    let s, n = null, r = null;
    if (e >= 25 ? (s = 2, r = e - 8) : (s = 1, r = e), r >= 17 && r <= 19) {
      let o;
      r === 17 ? o = t + 80 : r === 18 ? o = t + 112 : o = t + 144, this.logger.log(2, () => "Special char '" + ma(o) + "' in channel " + s), n = [o];
    } else e >= 32 && e <= 127 && (n = t === 0 ? [e] : [e, t]);
    return n && this.logger.log(3, () => "Char codes =  " + yt(n).join(",")), n;
  }
  /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */
  parseBackgroundAttributes(e, t) {
    const s = (e === 16 || e === 24) && t >= 32 && t <= 47, n = (e === 23 || e === 31) && t >= 45 && t <= 47;
    if (!(s || n))
      return !1;
    let r;
    const o = {};
    e === 16 || e === 24 ? (r = Math.floor((t - 32) / 2), o.background = _g[r], t % 2 === 1 && (o.background = o.background + "_semi")) : t === 45 ? o.background = "transparent" : (o.foreground = "black", t === 47 && (o.underline = !0));
    const a = e <= 23 ? 1 : 2;
    return this.channels[a].setBkgData(o), !0;
  }
  /**
   * Reset state of parser and its channels.
   */
  reset() {
    for (let e = 0; e < Object.keys(this.channels).length; e++) {
      const t = this.channels[e];
      t && t.reset();
    }
    As(null, null, this.cmdHistory);
  }
  /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */
  cueSplitAtTime(e) {
    for (let t = 0; t < this.channels.length; t++) {
      const s = this.channels[t];
      s && s.cueSplitAtTime(e);
    }
  }
}
function As(i, e, t) {
  t.a = i, t.b = e;
}
function kg(i, e, t) {
  return t.a === i && t.b === e;
}
function Fg() {
  return {
    a: null,
    b: null
  };
}
class Ls {
  constructor(e, t) {
    this.timelineController = void 0, this.cueRanges = [], this.trackName = void 0, this.startTime = null, this.endTime = null, this.screen = null, this.timelineController = e, this.trackName = t;
  }
  dispatchCue() {
    this.startTime !== null && (this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges), this.startTime = null);
  }
  newCue(e, t, s) {
    (this.startTime === null || this.startTime > e) && (this.startTime = e), this.endTime = t, this.screen = s, this.timelineController.createCaptionsTrack(this.trackName);
  }
  reset() {
    this.cueRanges = [], this.startTime = null;
  }
}
var gi = (function() {
  if (Gt != null && Gt.VTTCue)
    return self.VTTCue;
  const i = ["", "lr", "rl"], e = ["start", "middle", "end", "left", "right"];
  function t(a, l) {
    if (typeof l != "string" || !Array.isArray(a))
      return !1;
    const c = l.toLowerCase();
    return ~a.indexOf(c) ? c : !1;
  }
  function s(a) {
    return t(i, a);
  }
  function n(a) {
    return t(e, a);
  }
  function r(a, ...l) {
    let c = 1;
    for (; c < arguments.length; c++) {
      const u = arguments[c];
      for (const d in u)
        a[d] = u[d];
    }
    return a;
  }
  function o(a, l, c) {
    const u = this, d = {
      enumerable: !0
    };
    u.hasBeenReset = !1;
    let h = "", m = !1, f = a, g = l, p = c, E = null, y = "", v = !0, S = "auto", x = "start", R = 50, L = "middle", _ = 50, A = "middle";
    Object.defineProperty(u, "id", r({}, d, {
      get: function() {
        return h;
      },
      set: function(I) {
        h = "" + I;
      }
    })), Object.defineProperty(u, "pauseOnExit", r({}, d, {
      get: function() {
        return m;
      },
      set: function(I) {
        m = !!I;
      }
    })), Object.defineProperty(u, "startTime", r({}, d, {
      get: function() {
        return f;
      },
      set: function(I) {
        if (typeof I != "number")
          throw new TypeError("Start time must be set to a number.");
        f = I, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "endTime", r({}, d, {
      get: function() {
        return g;
      },
      set: function(I) {
        if (typeof I != "number")
          throw new TypeError("End time must be set to a number.");
        g = I, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "text", r({}, d, {
      get: function() {
        return p;
      },
      set: function(I) {
        p = "" + I, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "region", r({}, d, {
      get: function() {
        return E;
      },
      set: function(I) {
        E = I, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "vertical", r({}, d, {
      get: function() {
        return y;
      },
      set: function(I) {
        const w = s(I);
        if (w === !1)
          throw new SyntaxError("An invalid or illegal string was specified.");
        y = w, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "snapToLines", r({}, d, {
      get: function() {
        return v;
      },
      set: function(I) {
        v = !!I, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "line", r({}, d, {
      get: function() {
        return S;
      },
      set: function(I) {
        if (typeof I != "number" && I !== "auto")
          throw new SyntaxError("An invalid number or illegal string was specified.");
        S = I, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "lineAlign", r({}, d, {
      get: function() {
        return x;
      },
      set: function(I) {
        const w = n(I);
        if (!w)
          throw new SyntaxError("An invalid or illegal string was specified.");
        x = w, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "position", r({}, d, {
      get: function() {
        return R;
      },
      set: function(I) {
        if (I < 0 || I > 100)
          throw new Error("Position must be between 0 and 100.");
        R = I, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "positionAlign", r({}, d, {
      get: function() {
        return L;
      },
      set: function(I) {
        const w = n(I);
        if (!w)
          throw new SyntaxError("An invalid or illegal string was specified.");
        L = w, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "size", r({}, d, {
      get: function() {
        return _;
      },
      set: function(I) {
        if (I < 0 || I > 100)
          throw new Error("Size must be between 0 and 100.");
        _ = I, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "align", r({}, d, {
      get: function() {
        return A;
      },
      set: function(I) {
        const w = n(I);
        if (!w)
          throw new SyntaxError("An invalid or illegal string was specified.");
        A = w, this.hasBeenReset = !0;
      }
    })), u.displayState = void 0;
  }
  return o.prototype.getCueAsHTML = function() {
    return self.WebVTT.convertCueToDOMTree(self, this.text);
  }, o;
})();
class Pg {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  decode(e, t) {
    if (!e)
      return "";
    if (typeof e != "string")
      throw new Error("Error - expected string data.");
    return decodeURIComponent(encodeURIComponent(e));
  }
}
function pa(i) {
  function e(s, n, r, o) {
    return (s | 0) * 3600 + (n | 0) * 60 + (r | 0) + parseFloat(o || 0);
  }
  const t = i.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
  return t ? parseFloat(t[2]) > 59 ? e(t[2], t[3], 0, t[4]) : e(t[1], t[2], t[3], t[4]) : null;
}
class Og {
  constructor() {
    this.values = /* @__PURE__ */ Object.create(null);
  }
  // Only accept the first assignment to any key.
  set(e, t) {
    !this.get(e) && t !== "" && (this.values[e] = t);
  }
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get(e, t, s) {
    return s ? this.has(e) ? this.values[e] : t[s] : this.has(e) ? this.values[e] : t;
  }
  // Check whether we have a value for a key.
  has(e) {
    return e in this.values;
  }
  // Accept a setting if its one of the given alternatives.
  alt(e, t, s) {
    for (let n = 0; n < s.length; ++n)
      if (t === s[n]) {
        this.set(e, t);
        break;
      }
  }
  // Accept a setting if its a valid (signed) integer.
  integer(e, t) {
    /^-?\d+$/.test(t) && this.set(e, parseInt(t, 10));
  }
  // Accept a setting if its a valid percentage.
  percent(e, t) {
    if (/^([\d]{1,3})(\.[\d]*)?%$/.test(t)) {
      const s = parseFloat(t);
      if (s >= 0 && s <= 100)
        return this.set(e, s), !0;
    }
    return !1;
  }
}
function Ta(i, e, t, s) {
  const n = s ? i.split(s) : [i];
  for (const r in n) {
    if (typeof n[r] != "string")
      continue;
    const o = n[r].split(t);
    if (o.length !== 2)
      continue;
    const a = o[0], l = o[1];
    e(a, l);
  }
}
const jn = new gi(0, 0, ""), Rs = jn.align === "middle" ? "middle" : "center";
function Ng(i, e, t) {
  const s = i;
  function n() {
    const a = pa(i);
    if (a === null)
      throw new Error("Malformed timestamp: " + s);
    return i = i.replace(/^[^\sa-zA-Z-]+/, ""), a;
  }
  function r(a, l) {
    const c = new Og();
    Ta(a, function(h, m) {
      let f;
      switch (h) {
        case "region":
          for (let g = t.length - 1; g >= 0; g--)
            if (t[g].id === m) {
              c.set(h, t[g].region);
              break;
            }
          break;
        case "vertical":
          c.alt(h, m, ["rl", "lr"]);
          break;
        case "line":
          f = m.split(","), c.integer(h, f[0]), c.percent(h, f[0]) && c.set("snapToLines", !1), c.alt(h, f[0], ["auto"]), f.length === 2 && c.alt("lineAlign", f[1], ["start", Rs, "end"]);
          break;
        case "position":
          f = m.split(","), c.percent(h, f[0]), f.length === 2 && c.alt("positionAlign", f[1], ["start", Rs, "end", "line-left", "line-right", "auto"]);
          break;
        case "size":
          c.percent(h, m);
          break;
        case "align":
          c.alt(h, m, ["start", Rs, "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/), l.region = c.get("region", null), l.vertical = c.get("vertical", "");
    let u = c.get("line", "auto");
    u === "auto" && jn.line === -1 && (u = -1), l.line = u, l.lineAlign = c.get("lineAlign", "start"), l.snapToLines = c.get("snapToLines", !0), l.size = c.get("size", 100), l.align = c.get("align", Rs);
    let d = c.get("position", "auto");
    d === "auto" && jn.position === 50 && (d = l.align === "start" || l.align === "left" ? 0 : l.align === "end" || l.align === "right" ? 100 : 50), l.position = d;
  }
  function o() {
    i = i.replace(/^\s+/, "");
  }
  if (o(), e.startTime = n(), o(), i.slice(0, 3) !== "-->")
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + s);
  i = i.slice(3), o(), e.endTime = n(), o(), r(i, e);
}
function Ea(i) {
  return i.replace(/<br(?: \/)?>/gi, `
`);
}
class Ug {
  constructor() {
    this.state = "INITIAL", this.buffer = "", this.decoder = new Pg(), this.regionList = [], this.cue = null, this.oncue = void 0, this.onparsingerror = void 0, this.onflush = void 0;
  }
  parse(e) {
    const t = this;
    e && (t.buffer += t.decoder.decode(e, {
      stream: !0
    }));
    function s() {
      let r = t.buffer, o = 0;
      for (r = Ea(r); o < r.length && r[o] !== "\r" && r[o] !== `
`; )
        ++o;
      const a = r.slice(0, o);
      return r[o] === "\r" && ++o, r[o] === `
` && ++o, t.buffer = r.slice(o), a;
    }
    function n(r) {
      Ta(r, function(o, a) {
      }, /:/);
    }
    try {
      let r = "";
      if (t.state === "INITIAL") {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        r = s();
        const a = r.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
        if (!(a != null && a[0]))
          throw new Error("Malformed WebVTT signature.");
        t.state = "HEADER";
      }
      let o = !1;
      for (; t.buffer; ) {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        switch (o ? o = !1 : r = s(), t.state) {
          case "HEADER":
            /:/.test(r) ? n(r) : r || (t.state = "ID");
            continue;
          case "NOTE":
            r || (t.state = "ID");
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(r)) {
              t.state = "NOTE";
              break;
            }
            if (!r)
              continue;
            if (t.cue = new gi(0, 0, ""), t.state = "CUE", r.indexOf("-->") === -1) {
              t.cue.id = r;
              continue;
            }
          // Process line as start of a cue.
          /* falls through */
          case "CUE":
            if (!t.cue) {
              t.state = "BADCUE";
              continue;
            }
            try {
              Ng(r, t.cue, t.regionList);
            } catch {
              t.cue = null, t.state = "BADCUE";
              continue;
            }
            t.state = "CUETEXT";
            continue;
          case "CUETEXT":
            {
              const a = r.indexOf("-->") !== -1;
              if (!r || a && (o = !0)) {
                t.oncue && t.cue && t.oncue(t.cue), t.cue = null, t.state = "ID";
                continue;
              }
              if (t.cue === null)
                continue;
              t.cue.text && (t.cue.text += `
`), t.cue.text += r;
            }
            continue;
          case "BADCUE":
            r || (t.state = "ID");
        }
      }
    } catch {
      t.state === "CUETEXT" && t.cue && t.oncue && t.oncue(t.cue), t.cue = null, t.state = t.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  }
  flush() {
    const e = this;
    try {
      if ((e.cue || e.state === "HEADER") && (e.buffer += `

`, e.parse()), e.state === "INITIAL" || e.state === "BADWEBVTT")
        throw new Error("Malformed WebVTT signature.");
    } catch (t) {
      e.onparsingerror && e.onparsingerror(t);
    }
    return e.onflush && e.onflush(), this;
  }
}
const Bg = /\r\n|\n\r|\n|\r/g, Ln = function(e, t, s = 0) {
  return e.slice(s, s + t.length) === t;
}, $g = function(e) {
  let t = parseInt(e.slice(-3));
  const s = parseInt(e.slice(-6, -4)), n = parseInt(e.slice(-9, -7)), r = e.length > 9 ? parseInt(e.substring(0, e.indexOf(":"))) : 0;
  if (!G(t) || !G(s) || !G(n) || !G(r))
    throw Error(`Malformed X-TIMESTAMP-MAP: Local:${e}`);
  return t += 1e3 * s, t += 60 * 1e3 * n, t += 3600 * 1e3 * r, t;
}, Rn = function(e) {
  let t = 5381, s = e.length;
  for (; s; )
    t = t * 33 ^ e.charCodeAt(--s);
  return (t >>> 0).toString();
};
function pi(i, e, t) {
  return Rn(i.toString()) + Rn(e.toString()) + Rn(t);
}
const Gg = function(e, t, s) {
  let n = e[t], r = e[n.prevCC];
  if (!r || !r.new && n.new) {
    e.ccOffset = e.presentationOffset = n.start, n.new = !1;
    return;
  }
  for (; (o = r) != null && o.new; ) {
    var o;
    e.ccOffset += n.start - r.start, n.new = !1, n = r, r = e[n.prevCC];
  }
  e.presentationOffset = s;
};
function Hg(i, e, t, s, n, r, o) {
  const a = new Ug(), l = Ze(new Uint8Array(i)).trim().replace(Bg, `
`).split(`
`), c = [], u = e ? rg(e.baseTime, e.timescale) : 0;
  let d = "00:00.000", h = 0, m = 0, f, g = !0;
  a.oncue = function(p) {
    const E = t[s];
    let y = t.ccOffset;
    const v = (h - u) / 9e4;
    if (E != null && E.new && (m !== void 0 ? y = t.ccOffset = E.start : Gg(t, s, v)), v) {
      if (!e) {
        f = new Error("Missing initPTS for VTT MPEGTS");
        return;
      }
      y = v - t.presentationOffset;
    }
    const S = p.endTime - p.startTime, x = Be((p.startTime + y - m) * 9e4, n * 9e4) / 9e4;
    p.startTime = Math.max(x, 0), p.endTime = Math.max(x + S, 0);
    const R = p.text.trim();
    p.text = decodeURIComponent(encodeURIComponent(R)), p.id || (p.id = pi(p.startTime, p.endTime, R)), p.endTime > 0 && c.push(p);
  }, a.onparsingerror = function(p) {
    f = p;
  }, a.onflush = function() {
    if (f) {
      o(f);
      return;
    }
    r(c);
  }, l.forEach((p) => {
    if (g)
      if (Ln(p, "X-TIMESTAMP-MAP=")) {
        g = !1, p.slice(16).split(",").forEach((E) => {
          Ln(E, "LOCAL:") ? d = E.slice(6) : Ln(E, "MPEGTS:") && (h = parseInt(E.slice(7)));
        });
        try {
          m = $g(d) / 1e3;
        } catch (E) {
          f = E;
        }
        return;
      } else p === "" && (g = !1);
    a.parse(p + `
`);
  }), a.flush();
}
const Dn = "stpp.ttml.im1t", ya = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/, xa = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/, Kg = {
  left: "start",
  center: "center",
  right: "end",
  start: "start",
  end: "end"
};
function Vr(i, e, t, s) {
  const n = ee(new Uint8Array(i), ["mdat"]);
  if (n.length === 0) {
    s(new Error("Could not parse IMSC1 mdat"));
    return;
  }
  const r = n.map((a) => Ze(a)), o = ig(e.baseTime, 1, e.timescale);
  try {
    r.forEach((a) => t(Vg(a, o)));
  } catch (a) {
    s(a);
  }
}
function Vg(i, e) {
  const n = new DOMParser().parseFromString(i, "text/xml").getElementsByTagName("tt")[0];
  if (!n)
    throw new Error("Invalid ttml");
  const r = {
    frameRate: 30,
    subFrameRate: 1,
    frameRateMultiplier: 0,
    tickRate: 0
  }, o = Object.keys(r).reduce((d, h) => (d[h] = n.getAttribute(`ttp:${h}`) || r[h], d), {}), a = n.getAttribute("xml:space") !== "preserve", l = Wr(In(n, "styling", "style")), c = Wr(In(n, "layout", "region")), u = In(n, "body", "[begin]");
  return [].map.call(u, (d) => {
    const h = va(d, a);
    if (!h || !d.hasAttribute("begin"))
      return null;
    const m = _n(d.getAttribute("begin"), o), f = _n(d.getAttribute("dur"), o);
    let g = _n(d.getAttribute("end"), o);
    if (m === null)
      throw Yr(d);
    if (g === null) {
      if (f === null)
        throw Yr(d);
      g = m + f;
    }
    const p = new gi(m - e, g - e, h);
    p.id = pi(p.startTime, p.endTime, p.text);
    const E = c[d.getAttribute("region")], y = l[d.getAttribute("style")], v = Wg(E, y, l), {
      textAlign: S
    } = v;
    if (S) {
      const x = Kg[S];
      x && (p.lineAlign = x), p.align = S;
    }
    return ve(p, v), p;
  }).filter((d) => d !== null);
}
function In(i, e, t) {
  const s = i.getElementsByTagName(e)[0];
  return s ? [].slice.call(s.querySelectorAll(t)) : [];
}
function Wr(i) {
  return i.reduce((e, t) => {
    const s = t.getAttribute("xml:id");
    return s && (e[s] = t), e;
  }, {});
}
function va(i, e) {
  return [].slice.call(i.childNodes).reduce((t, s, n) => {
    var r;
    return s.nodeName === "br" && n ? t + `
` : (r = s.childNodes) != null && r.length ? va(s, e) : e ? t + s.textContent.trim().replace(/\s+/g, " ") : t + s.textContent;
  }, "");
}
function Wg(i, e, t) {
  const s = "http://www.w3.org/ns/ttml#styling";
  let n = null;
  const r = [
    "displayAlign",
    "textAlign",
    "color",
    "backgroundColor",
    "fontSize",
    "fontFamily"
    // 'fontWeight',
    // 'lineHeight',
    // 'wrapOption',
    // 'fontStyle',
    // 'direction',
    // 'writingMode'
  ], o = i != null && i.hasAttribute("style") ? i.getAttribute("style") : null;
  return o && t.hasOwnProperty(o) && (n = t[o]), r.reduce((a, l) => {
    const c = bn(e, s, l) || bn(i, s, l) || bn(n, s, l);
    return c && (a[l] = c), a;
  }, {});
}
function bn(i, e, t) {
  return i && i.hasAttributeNS(e, t) ? i.getAttributeNS(e, t) : null;
}
function Yr(i) {
  return new Error(`Could not parse ttml timestamp ${i}`);
}
function _n(i, e) {
  if (!i)
    return null;
  let t = pa(i);
  return t === null && (ya.test(i) ? t = Yg(i, e) : xa.test(i) && (t = qg(i, e))), t;
}
function Yg(i, e) {
  const t = ya.exec(i), s = (t[4] | 0) + (t[5] | 0) / e.subFrameRate;
  return (t[1] | 0) * 3600 + (t[2] | 0) * 60 + (t[3] | 0) + s / e.frameRate;
}
function qg(i, e) {
  const t = xa.exec(i), s = Number(t[1]);
  switch (t[2]) {
    case "h":
      return s * 3600;
    case "m":
      return s * 60;
    case "ms":
      return s * 1e3;
    case "f":
      return s / e.frameRate;
    case "t":
      return s / e.tickRate;
  }
  return s;
}
class zg {
  constructor(e) {
    this.hls = void 0, this.media = null, this.config = void 0, this.enabled = !0, this.Cues = void 0, this.textTracks = [], this.tracks = [], this.initPTS = [], this.unparsedVttFrags = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.cea608Parser1 = void 0, this.cea608Parser2 = void 0, this.lastCc = -1, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = zr(), this.captionsProperties = void 0, this.hls = e, this.config = e.config, this.Cues = e.config.cueHandler, this.captionsProperties = {
      textTrack1: {
        label: this.config.captionsTextTrack1Label,
        languageCode: this.config.captionsTextTrack1LanguageCode
      },
      textTrack2: {
        label: this.config.captionsTextTrack2Label,
        languageCode: this.config.captionsTextTrack2LanguageCode
      },
      textTrack3: {
        label: this.config.captionsTextTrack3Label,
        languageCode: this.config.captionsTextTrack3LanguageCode
      },
      textTrack4: {
        label: this.config.captionsTextTrack4Label,
        languageCode: this.config.captionsTextTrack4LanguageCode
      }
    }, e.on(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(T.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(T.FRAG_LOADING, this.onFragLoading, this), e.on(T.FRAG_LOADED, this.onFragLoaded, this), e.on(T.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.on(T.FRAG_DECRYPTED, this.onFragDecrypted, this), e.on(T.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(T.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.on(T.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  destroy() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(T.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(T.FRAG_LOADING, this.onFragLoading, this), e.off(T.FRAG_LOADED, this.onFragLoaded, this), e.off(T.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.off(T.FRAG_DECRYPTED, this.onFragDecrypted, this), e.off(T.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(T.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.off(T.BUFFER_FLUSHING, this.onBufferFlushing, this), this.hls = this.config = null, this.cea608Parser1 = this.cea608Parser2 = void 0;
  }
  initCea608Parsers() {
    if (this.config.enableCEA708Captions && (!this.cea608Parser1 || !this.cea608Parser2)) {
      const e = new Ls(this, "textTrack1"), t = new Ls(this, "textTrack2"), s = new Ls(this, "textTrack3"), n = new Ls(this, "textTrack4");
      this.cea608Parser1 = new Kr(1, e, t), this.cea608Parser2 = new Kr(3, s, n);
    }
  }
  addCues(e, t, s, n, r) {
    let o = !1;
    for (let a = r.length; a--; ) {
      const l = r[a], c = jg(l[0], l[1], t, s);
      if (c >= 0 && (l[0] = Math.min(l[0], t), l[1] = Math.max(l[1], s), o = !0, c / (s - t) > 0.5))
        return;
    }
    if (o || r.push([t, s]), this.config.renderTextTracksNatively) {
      const a = this.captionsTracks[e];
      this.Cues.newCue(a, t, s, n);
    } else {
      const a = this.Cues.newCue(null, t, s, n);
      this.hls.trigger(T.CUES_PARSED, {
        type: "captions",
        cues: a,
        track: e
      });
    }
  }
  // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
  onInitPtsFound(e, {
    frag: t,
    id: s,
    initPTS: n,
    timescale: r
  }) {
    const {
      unparsedVttFrags: o
    } = this;
    s === "main" && (this.initPTS[t.cc] = {
      baseTime: n,
      timescale: r
    }), o.length && (this.unparsedVttFrags = [], o.forEach((a) => {
      this.onFragLoaded(T.FRAG_LOADED, a);
    }));
  }
  getExistingTrack(e, t) {
    const {
      media: s
    } = this;
    if (s)
      for (let n = 0; n < s.textTracks.length; n++) {
        const r = s.textTracks[n];
        if (qr(r, {
          name: e,
          lang: t
        }))
          return r;
      }
    return null;
  }
  createCaptionsTrack(e) {
    this.config.renderTextTracksNatively ? this.createNativeTrack(e) : this.createNonNativeTrack(e);
  }
  createNativeTrack(e) {
    if (this.captionsTracks[e])
      return;
    const {
      captionsProperties: t,
      captionsTracks: s,
      media: n
    } = this, {
      label: r,
      languageCode: o
    } = t[e], a = this.getExistingTrack(r, o);
    if (a)
      s[e] = a, Ot(s[e]), Go(s[e], n);
    else {
      const l = this.createTextTrack("captions", r, o);
      l && (l[e] = !0, s[e] = l);
    }
  }
  createNonNativeTrack(e) {
    if (this.nonNativeCaptionsTracks[e])
      return;
    const t = this.captionsProperties[e];
    if (!t)
      return;
    const s = t.label, n = {
      _id: e,
      label: s,
      kind: "captions",
      default: t.media ? !!t.media.default : !1,
      closedCaptions: t.media
    };
    this.nonNativeCaptionsTracks[e] = n, this.hls.trigger(T.NON_NATIVE_TEXT_TRACKS_FOUND, {
      tracks: [n]
    });
  }
  createTextTrack(e, t, s) {
    const n = this.media;
    if (n)
      return n.addTextTrack(e, t, s);
  }
  onMediaAttaching(e, t) {
    this.media = t.media, this._cleanTracks();
  }
  onMediaDetaching() {
    const {
      captionsTracks: e
    } = this;
    Object.keys(e).forEach((t) => {
      Ot(e[t]), delete e[t];
    }), this.nonNativeCaptionsTracks = {};
  }
  onManifestLoading() {
    this.lastCc = -1, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = zr(), this._cleanTracks(), this.tracks = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.textTracks = [], this.unparsedVttFrags = [], this.initPTS = [], this.cea608Parser1 && this.cea608Parser2 && (this.cea608Parser1.reset(), this.cea608Parser2.reset());
  }
  _cleanTracks() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = e.textTracks;
    if (t)
      for (let s = 0; s < t.length; s++)
        Ot(t[s]);
  }
  onSubtitleTracksUpdated(e, t) {
    const s = t.subtitleTracks || [], n = s.some((r) => r.textCodec === Dn);
    if (this.config.enableWebVTT || n && this.config.enableIMSC1) {
      if (fa(this.tracks, s)) {
        this.tracks = s;
        return;
      }
      if (this.textTracks = [], this.tracks = s, this.config.renderTextTracksNatively) {
        const o = this.media, a = o ? _s(o.textTracks) : null;
        if (this.tracks.forEach((l, c) => {
          let u;
          if (a) {
            let d = null;
            for (let h = 0; h < a.length; h++)
              if (a[h] && qr(a[h], l)) {
                d = a[h], a[h] = null;
                break;
              }
            d && (u = d);
          }
          if (u)
            Ot(u);
          else {
            const d = Sa(l);
            u = this.createTextTrack(d, l.name, l.lang), u && (u.mode = "disabled");
          }
          u && this.textTracks.push(u);
        }), a != null && a.length) {
          const l = a.filter((c) => c !== null).map((c) => c.label);
          l.length && D.warn(`Media element contains unused subtitle tracks: ${l.join(", ")}. Replace media element for each source to clear TextTracks and captions menu.`);
        }
      } else if (this.tracks.length) {
        const o = this.tracks.map((a) => ({
          label: a.name,
          kind: a.type.toLowerCase(),
          default: a.default,
          subtitleTrack: a
        }));
        this.hls.trigger(T.NON_NATIVE_TEXT_TRACKS_FOUND, {
          tracks: o
        });
      }
    }
  }
  onManifestLoaded(e, t) {
    this.config.enableCEA708Captions && t.captions && t.captions.forEach((s) => {
      const n = /(?:CC|SERVICE)([1-4])/.exec(s.instreamId);
      if (!n)
        return;
      const r = `textTrack${n[1]}`, o = this.captionsProperties[r];
      o && (o.label = s.name, s.lang && (o.languageCode = s.lang), o.media = s);
    });
  }
  closedCaptionsForLevel(e) {
    const t = this.hls.levels[e.level];
    return t == null ? void 0 : t.attrs["CLOSED-CAPTIONS"];
  }
  onFragLoading(e, t) {
    if (this.enabled && t.frag.type === Q.MAIN) {
      var s, n;
      const {
        cea608Parser1: r,
        cea608Parser2: o,
        lastSn: a
      } = this, {
        cc: l,
        sn: c
      } = t.frag, u = (s = (n = t.part) == null ? void 0 : n.index) != null ? s : -1;
      r && o && (c !== a + 1 || c === a && u !== this.lastPartIndex + 1 || l !== this.lastCc) && (r.reset(), o.reset()), this.lastCc = l, this.lastSn = c, this.lastPartIndex = u;
    }
  }
  onFragLoaded(e, t) {
    const {
      frag: s,
      payload: n
    } = t;
    if (s.type === Q.SUBTITLE)
      if (n.byteLength) {
        const r = s.decryptdata, o = "stats" in t;
        if (r == null || !r.encrypted || o) {
          const a = this.tracks[s.level], l = this.vttCCs;
          l[s.cc] || (l[s.cc] = {
            start: s.start,
            prevCC: this.prevCC,
            new: !0
          }, this.prevCC = s.cc), a && a.textCodec === Dn ? this._parseIMSC1(s, n) : this._parseVTTs(t);
        }
      } else
        this.hls.trigger(T.SUBTITLE_FRAG_PROCESSED, {
          success: !1,
          frag: s,
          error: new Error("Empty subtitle payload")
        });
  }
  _parseIMSC1(e, t) {
    const s = this.hls;
    Vr(t, this.initPTS[e.cc], (n) => {
      this._appendCues(n, e.level), s.trigger(T.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: e
      });
    }, (n) => {
      D.log(`Failed to parse IMSC1: ${n}`), s.trigger(T.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: e,
        error: n
      });
    });
  }
  _parseVTTs(e) {
    var t;
    const {
      frag: s,
      payload: n
    } = e, {
      initPTS: r,
      unparsedVttFrags: o
    } = this, a = r.length - 1;
    if (!r[s.cc] && a === -1) {
      o.push(e);
      return;
    }
    const l = this.hls, c = (t = s.initSegment) != null && t.data ? $e(s.initSegment.data, new Uint8Array(n)) : n;
    Hg(c, this.initPTS[s.cc], this.vttCCs, s.cc, s.start, (u) => {
      this._appendCues(u, s.level), l.trigger(T.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: s
      });
    }, (u) => {
      const d = u.message === "Missing initPTS for VTT MPEGTS";
      d ? o.push(e) : this._fallbackToIMSC1(s, n), D.log(`Failed to parse VTT cue: ${u}`), !(d && a > s.cc) && l.trigger(T.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: s,
        error: u
      });
    });
  }
  _fallbackToIMSC1(e, t) {
    const s = this.tracks[e.level];
    s.textCodec || Vr(t, this.initPTS[e.cc], () => {
      s.textCodec = Dn, this._parseIMSC1(e, t);
    }, () => {
      s.textCodec = "wvtt";
    });
  }
  _appendCues(e, t) {
    const s = this.hls;
    if (this.config.renderTextTracksNatively) {
      const n = this.textTracks[t];
      if (!n || n.mode === "disabled")
        return;
      e.forEach((r) => Ho(n, r));
    } else {
      const n = this.tracks[t];
      if (!n)
        return;
      const r = n.default ? "default" : "subtitles" + t;
      s.trigger(T.CUES_PARSED, {
        type: "subtitles",
        cues: e,
        track: r
      });
    }
  }
  onFragDecrypted(e, t) {
    const {
      frag: s
    } = t;
    s.type === Q.SUBTITLE && this.onFragLoaded(T.FRAG_LOADED, t);
  }
  onSubtitleTracksCleared() {
    this.tracks = [], this.captionsTracks = {};
  }
  onFragParsingUserdata(e, t) {
    this.initCea608Parsers();
    const {
      cea608Parser1: s,
      cea608Parser2: n
    } = this;
    if (!this.enabled || !s || !n)
      return;
    const {
      frag: r,
      samples: o
    } = t;
    if (!(r.type === Q.MAIN && this.closedCaptionsForLevel(r) === "NONE"))
      for (let a = 0; a < o.length; a++) {
        const l = o[a].bytes;
        if (l) {
          const c = this.extractCea608Data(l);
          s.addData(o[a].pts, c[0]), n.addData(o[a].pts, c[1]);
        }
      }
  }
  onBufferFlushing(e, {
    startOffset: t,
    endOffset: s,
    endOffsetSubtitles: n,
    type: r
  }) {
    const {
      media: o
    } = this;
    if (!(!o || o.currentTime < s)) {
      if (!r || r === "video") {
        const {
          captionsTracks: a
        } = this;
        Object.keys(a).forEach((l) => Hn(a[l], t, s));
      }
      if (this.config.renderTextTracksNatively && t === 0 && n !== void 0) {
        const {
          textTracks: a
        } = this;
        Object.keys(a).forEach((l) => Hn(a[l], t, n));
      }
    }
  }
  extractCea608Data(e) {
    const t = [[], []], s = e[0] & 31;
    let n = 2;
    for (let r = 0; r < s; r++) {
      const o = e[n++], a = 127 & e[n++], l = 127 & e[n++];
      if (a === 0 && l === 0)
        continue;
      if ((4 & o) !== 0) {
        const u = 3 & o;
        (u === 0 || u === 1) && (t[u].push(a), t[u].push(l));
      }
    }
    return t;
  }
}
function Sa(i) {
  return i.characteristics && /transcribes-spoken-dialog/gi.test(i.characteristics) && /describes-music-and-sound/gi.test(i.characteristics) ? "captions" : "subtitles";
}
function qr(i, e) {
  return !!i && i.kind === Sa(e) && zn(e, i);
}
function jg(i, e, t, s) {
  return Math.min(e, s) - Math.max(i, t);
}
function zr() {
  return {
    ccOffset: 0,
    presentationOffset: 0,
    0: {
      start: 0,
      prevCC: -1,
      new: !0
    }
  };
}
class Ti {
  constructor(e) {
    this.hls = void 0, this.autoLevelCapping = void 0, this.firstLevel = void 0, this.media = void 0, this.restrictedLevels = void 0, this.timer = void 0, this.clientRect = void 0, this.streamController = void 0, this.hls = e, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.firstLevel = -1, this.media = null, this.restrictedLevels = [], this.timer = void 0, this.clientRect = null, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  destroy() {
    this.hls && this.unregisterListener(), this.timer && this.stopCapping(), this.media = null, this.clientRect = null, this.hls = this.streamController = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.on(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(T.BUFFER_CODECS, this.onBufferCodecs, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListener() {
    const {
      hls: e
    } = this;
    e.off(T.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.off(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(T.BUFFER_CODECS, this.onBufferCodecs, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  onFpsDropLevelCapping(e, t) {
    const s = this.hls.levels[t.droppedLevel];
    this.isLevelAllowed(s) && this.restrictedLevels.push({
      bitrate: s.bitrate,
      height: s.height,
      width: s.width
    });
  }
  onMediaAttaching(e, t) {
    this.media = t.media instanceof HTMLVideoElement ? t.media : null, this.clientRect = null, this.timer && this.hls.levels.length && this.detectPlayerSize();
  }
  onManifestParsed(e, t) {
    const s = this.hls;
    this.restrictedLevels = [], this.firstLevel = t.firstLevel, s.config.capLevelToPlayerSize && t.video && this.startCapping();
  }
  onLevelsUpdated(e, t) {
    this.timer && G(this.autoLevelCapping) && this.detectPlayerSize();
  }
  // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
  // to the first level
  onBufferCodecs(e, t) {
    this.hls.config.capLevelToPlayerSize && t.video && this.startCapping();
  }
  onMediaDetaching() {
    this.stopCapping();
  }
  detectPlayerSize() {
    if (this.media) {
      if (this.mediaHeight <= 0 || this.mediaWidth <= 0) {
        this.clientRect = null;
        return;
      }
      const e = this.hls.levels;
      if (e.length) {
        const t = this.hls, s = this.getMaxLevel(e.length - 1);
        s !== this.autoLevelCapping && D.log(`Setting autoLevelCapping to ${s}: ${e[s].height}p@${e[s].bitrate} for media ${this.mediaWidth}x${this.mediaHeight}`), t.autoLevelCapping = s, t.autoLevelCapping > this.autoLevelCapping && this.streamController && this.streamController.nextLevelSwitch(), this.autoLevelCapping = t.autoLevelCapping;
      }
    }
  }
  /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */
  getMaxLevel(e) {
    const t = this.hls.levels;
    if (!t.length)
      return -1;
    const s = t.filter((n, r) => this.isLevelAllowed(n) && r <= e);
    return this.clientRect = null, Ti.getMaxLevelByMediaSize(s, this.mediaWidth, this.mediaHeight);
  }
  startCapping() {
    this.timer || (this.autoLevelCapping = Number.POSITIVE_INFINITY, self.clearInterval(this.timer), this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1e3), this.detectPlayerSize());
  }
  stopCapping() {
    this.restrictedLevels = [], this.firstLevel = -1, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.timer && (self.clearInterval(this.timer), this.timer = void 0);
  }
  getDimensions() {
    if (this.clientRect)
      return this.clientRect;
    const e = this.media, t = {
      width: 0,
      height: 0
    };
    if (e) {
      const s = e.getBoundingClientRect();
      t.width = s.width, t.height = s.height, !t.width && !t.height && (t.width = s.right - s.left || e.width || 0, t.height = s.bottom - s.top || e.height || 0);
    }
    return this.clientRect = t, t;
  }
  get mediaWidth() {
    return this.getDimensions().width * this.contentScaleFactor;
  }
  get mediaHeight() {
    return this.getDimensions().height * this.contentScaleFactor;
  }
  get contentScaleFactor() {
    let e = 1;
    if (!this.hls.config.ignoreDevicePixelRatio)
      try {
        e = self.devicePixelRatio;
      } catch {
      }
    return e;
  }
  isLevelAllowed(e) {
    return !this.restrictedLevels.some((s) => e.bitrate === s.bitrate && e.width === s.width && e.height === s.height);
  }
  static getMaxLevelByMediaSize(e, t, s) {
    if (!(e != null && e.length))
      return -1;
    const n = (a, l) => l ? a.width !== l.width || a.height !== l.height : !0;
    let r = e.length - 1;
    const o = Math.max(t, s);
    for (let a = 0; a < e.length; a += 1) {
      const l = e[a];
      if ((l.width >= o || l.height >= o) && n(l, e[a + 1])) {
        r = a;
        break;
      }
    }
    return r;
  }
}
class Xg {
  constructor(e) {
    this.hls = void 0, this.isVideoPlaybackQualityAvailable = !1, this.timer = void 0, this.media = null, this.lastTime = void 0, this.lastDroppedFrames = 0, this.lastDecodedFrames = 0, this.streamController = void 0, this.hls = e, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  registerListeners() {
    this.hls.on(T.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  unregisterListeners() {
    this.hls.off(T.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  destroy() {
    this.timer && clearInterval(this.timer), this.unregisterListeners(), this.isVideoPlaybackQualityAvailable = !1, this.media = null;
  }
  onMediaAttaching(e, t) {
    const s = this.hls.config;
    if (s.capLevelOnFPSDrop) {
      const n = t.media instanceof self.HTMLVideoElement ? t.media : null;
      this.media = n, n && typeof n.getVideoPlaybackQuality == "function" && (this.isVideoPlaybackQualityAvailable = !0), self.clearInterval(this.timer), this.timer = self.setInterval(this.checkFPSInterval.bind(this), s.fpsDroppedMonitoringPeriod);
    }
  }
  checkFPS(e, t, s) {
    const n = performance.now();
    if (t) {
      if (this.lastTime) {
        const r = n - this.lastTime, o = s - this.lastDroppedFrames, a = t - this.lastDecodedFrames, l = 1e3 * o / r, c = this.hls;
        if (c.trigger(T.FPS_DROP, {
          currentDropped: o,
          currentDecoded: a,
          totalDroppedFrames: s
        }), l > 0 && o > c.config.fpsDroppedMonitoringThreshold * a) {
          let u = c.currentLevel;
          D.warn("drop FPS ratio greater than max allowed value for currentLevel: " + u), u > 0 && (c.autoLevelCapping === -1 || c.autoLevelCapping >= u) && (u = u - 1, c.trigger(T.FPS_DROP_LEVEL_CAPPING, {
            level: u,
            droppedLevel: c.currentLevel
          }), c.autoLevelCapping = u, this.streamController.nextLevelSwitch());
        }
      }
      this.lastTime = n, this.lastDroppedFrames = s, this.lastDecodedFrames = t;
    }
  }
  checkFPSInterval() {
    const e = this.media;
    if (e)
      if (this.isVideoPlaybackQualityAvailable) {
        const t = e.getVideoPlaybackQuality();
        this.checkFPS(e, t.totalVideoFrames, t.droppedVideoFrames);
      } else
        this.checkFPS(e, e.webkitDecodedFrameCount, e.webkitDroppedFrameCount);
  }
}
const Ds = "[eme]";
class Bt {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = null, this.keyFormatPromise = null, this.keySystemAccessPromises = {}, this._requestLicenseFailureCount = 0, this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, this.setMediaKeysQueue = Bt.CDMCleanupPromise ? [Bt.CDMCleanupPromise] : [], this.onMediaEncrypted = this._onMediaEncrypted.bind(this), this.onWaitingForKey = this._onWaitingForKey.bind(this), this.debug = D.debug.bind(D, Ds), this.log = D.log.bind(D, Ds), this.warn = D.warn.bind(D, Ds), this.error = D.error.bind(D, Ds), this.hls = e, this.config = e.config, this.registerListeners();
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetached();
    const e = this.config;
    e.requestMediaKeySystemAccessFunc = null, e.licenseXhrSetup = e.licenseResponseCallback = void 0, e.drmSystems = e.drmSystemOptions = {}, this.hls = this.onMediaEncrypted = this.onWaitingForKey = this.keyIdToKeySessionPromise = null, this.config = null;
  }
  registerListeners() {
    this.hls.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(T.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.on(T.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(T.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  unregisterListeners() {
    this.hls.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(T.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.off(T.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.off(T.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  getLicenseServerUrl(e) {
    const {
      drmSystems: t,
      widevineLicenseUrl: s
    } = this.config, n = t[e];
    if (n)
      return n.licenseUrl;
    if (e === me.WIDEVINE && s)
      return s;
    throw new Error(`no license server URL configured for key-system "${e}"`);
  }
  getServerCertificateUrl(e) {
    const {
      drmSystems: t
    } = this.config, s = t[e];
    if (s)
      return s.serverCertificateUrl;
    this.log(`No Server Certificate in config.drmSystems["${e}"]`);
  }
  attemptKeySystemAccess(e) {
    const t = this.hls.levels, s = (o, a, l) => !!o && l.indexOf(o) === a, n = t.map((o) => o.audioCodec).filter(s), r = t.map((o) => o.videoCodec).filter(s);
    return n.length + r.length === 0 && r.push("avc1.42e01e"), new Promise((o, a) => {
      const l = (c) => {
        const u = c.shift();
        this.getMediaKeysPromise(u, n, r).then((d) => o({
          keySystem: u,
          mediaKeys: d
        })).catch((d) => {
          c.length ? l(c) : d instanceof Ue ? a(d) : a(new Ue({
            type: Z.KEY_SYSTEM_ERROR,
            details: C.KEY_SYSTEM_NO_ACCESS,
            error: d,
            fatal: !0
          }, d.message));
        });
      };
      l(e);
    });
  }
  requestMediaKeySystemAccess(e, t) {
    const {
      requestMediaKeySystemAccessFunc: s
    } = this.config;
    if (typeof s != "function") {
      let n = `Configured requestMediaKeySystemAccess is not a function ${s}`;
      return bo === null && self.location.protocol === "http:" && (n = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`), Promise.reject(new Error(n));
    }
    return s(e, t);
  }
  getMediaKeysPromise(e, t, s) {
    const n = sf(e, t, s, this.config.drmSystemOptions), r = this.keySystemAccessPromises[e];
    let o = r == null ? void 0 : r.keySystemAccess;
    if (!o) {
      this.log(`Requesting encrypted media "${e}" key-system access with config: ${JSON.stringify(n)}`), o = this.requestMediaKeySystemAccess(e, n);
      const a = this.keySystemAccessPromises[e] = {
        keySystemAccess: o
      };
      return o.catch((l) => {
        this.log(`Failed to obtain access to key-system "${e}": ${l}`);
      }), o.then((l) => {
        this.log(`Access for key-system "${l.keySystem}" obtained`);
        const c = this.fetchServerCertificate(e);
        return this.log(`Create media-keys for "${e}"`), a.mediaKeys = l.createMediaKeys().then((u) => (this.log(`Media-keys created for "${e}"`), c.then((d) => d ? this.setMediaKeysServerCertificate(u, e, d) : u))), a.mediaKeys.catch((u) => {
          this.error(`Failed to create media-keys for "${e}"}: ${u}`);
        }), a.mediaKeys;
      });
    }
    return o.then(() => r.mediaKeys);
  }
  createMediaKeySessionContext({
    decryptdata: e,
    keySystem: t,
    mediaKeys: s
  }) {
    this.log(`Creating key-system session "${t}" keyId: ${ze.hexDump(e.keyId || [])}`);
    const n = s.createSession(), r = {
      decryptdata: e,
      keySystem: t,
      mediaKeys: s,
      mediaKeysSession: n,
      keyStatus: "status-pending"
    };
    return this.mediaKeySessions.push(r), r;
  }
  renewKeySession(e) {
    const t = e.decryptdata;
    if (t.pssh) {
      const s = this.createMediaKeySessionContext(e), n = this.getKeyIdString(t), r = "cenc";
      this.keyIdToKeySessionPromise[n] = this.generateRequestWithPreferredKeySession(s, r, t.pssh, "expired");
    } else
      this.warn("Could not renew expired session. Missing pssh initData.");
    this.removeSession(e);
  }
  getKeyIdString(e) {
    if (!e)
      throw new Error("Could not read keyId of undefined decryptdata");
    if (e.keyId === null)
      throw new Error("keyId is null");
    return ze.hexDump(e.keyId);
  }
  updateKeySession(e, t) {
    var s;
    const n = e.mediaKeysSession;
    return this.log(`Updating key-session "${n.sessionId}" for keyID ${ze.hexDump(((s = e.decryptdata) == null ? void 0 : s.keyId) || [])}
      } (data length: ${t && t.byteLength})`), n.update(t);
  }
  selectKeySystemFormat(e) {
    const t = Object.keys(e.levelkeys || {});
    return this.keyFormatPromise || (this.log(`Selecting key-system from fragment (sn: ${e.sn} ${e.type}: ${e.level}) key formats ${t.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(t)), this.keyFormatPromise;
  }
  getKeyFormatPromise(e) {
    return new Promise((t, s) => {
      const n = dn(this.config), r = e.map(tr).filter((o) => !!o && n.indexOf(o) !== -1);
      return this.getKeySystemSelectionPromise(r).then(({
        keySystem: o
      }) => {
        const a = sr(o);
        a ? t(a) : s(new Error(`Unable to find format for key-system "${o}"`));
      }).catch(s);
    });
  }
  loadKey(e) {
    const t = e.keyInfo.decryptdata, s = this.getKeyIdString(t), n = `(keyId: ${s} format: "${t.keyFormat}" method: ${t.method} uri: ${t.uri})`;
    this.log(`Starting session for key ${n}`);
    let r = this.keyIdToKeySessionPromise[s];
    return r || (r = this.keyIdToKeySessionPromise[s] = this.getKeySystemForKeyPromise(t).then(({
      keySystem: o,
      mediaKeys: a
    }) => (this.throwIfDestroyed(), this.log(`Handle encrypted media sn: ${e.frag.sn} ${e.frag.type}: ${e.frag.level} using key ${n}`), this.attemptSetMediaKeys(o, a).then(() => {
      this.throwIfDestroyed();
      const l = this.createMediaKeySessionContext({
        keySystem: o,
        mediaKeys: a,
        decryptdata: t
      });
      return this.generateRequestWithPreferredKeySession(l, "cenc", t.pssh, "playlist-key");
    }))), r.catch((o) => this.handleError(o))), r;
  }
  throwIfDestroyed(e = "Invalid state") {
    if (!this.hls)
      throw new Error("invalid state");
  }
  handleError(e) {
    this.hls && (this.error(e.message), e instanceof Ue ? this.hls.trigger(T.ERROR, e.data) : this.hls.trigger(T.ERROR, {
      type: Z.KEY_SYSTEM_ERROR,
      details: C.KEY_SYSTEM_NO_KEYS,
      error: e,
      fatal: !0
    }));
  }
  getKeySystemForKeyPromise(e) {
    const t = this.getKeyIdString(e), s = this.keyIdToKeySessionPromise[t];
    if (!s) {
      const n = tr(e.keyFormat), r = n ? [n] : dn(this.config);
      return this.attemptKeySystemAccess(r);
    }
    return s;
  }
  getKeySystemSelectionPromise(e) {
    if (e.length || (e = dn(this.config)), e.length === 0)
      throw new Ue({
        type: Z.KEY_SYSTEM_ERROR,
        details: C.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
        fatal: !0
      }, `Missing key-system license configuration options ${JSON.stringify({
        drmSystems: this.config.drmSystems
      })}`);
    return this.attemptKeySystemAccess(e);
  }
  _onMediaEncrypted(e) {
    const {
      initDataType: t,
      initData: s
    } = e;
    if (this.debug(`"${e.type}" event: init data type: "${t}"`), s === null)
      return;
    let n, r;
    if (t === "sinf" && this.config.drmSystems[me.FAIRPLAY]) {
      const u = Se(new Uint8Array(s));
      try {
        const d = si(JSON.parse(u).sinf), h = Oo(new Uint8Array(d));
        if (!h)
          return;
        n = h.subarray(8, 24), r = me.FAIRPLAY;
      } catch {
        this.warn('Failed to parse sinf "encrypted" event message initData');
        return;
      }
    } else {
      const u = bf(s);
      if (u === null)
        return;
      u.version === 0 && u.systemId === Io.WIDEVINE && u.data && (n = u.data.subarray(8, 24)), r = tf(u.systemId);
    }
    if (!r || !n)
      return;
    const o = ze.hexDump(n), {
      keyIdToKeySessionPromise: a,
      mediaKeySessions: l
    } = this;
    let c = a[o];
    for (let u = 0; u < l.length; u++) {
      const d = l[u], h = d.decryptdata;
      if (h.pssh || !h.keyId)
        continue;
      const m = ze.hexDump(h.keyId);
      if (o === m || h.uri.replace(/-/g, "").indexOf(o) !== -1) {
        c = a[m], delete a[m], h.pssh = new Uint8Array(s), h.keyId = n, c = a[o] = c.then(() => this.generateRequestWithPreferredKeySession(d, t, s, "encrypted-event-key-match"));
        break;
      }
    }
    c || (c = a[o] = this.getKeySystemSelectionPromise([r]).then(({
      keySystem: u,
      mediaKeys: d
    }) => {
      var h;
      this.throwIfDestroyed();
      const m = new ns("ISO-23001-7", o, (h = sr(u)) != null ? h : "");
      return m.pssh = new Uint8Array(s), m.keyId = n, this.attemptSetMediaKeys(u, d).then(() => {
        this.throwIfDestroyed();
        const f = this.createMediaKeySessionContext({
          decryptdata: m,
          keySystem: u,
          mediaKeys: d
        });
        return this.generateRequestWithPreferredKeySession(f, t, s, "encrypted-event-no-match");
      });
    })), c.catch((u) => this.handleError(u));
  }
  _onWaitingForKey(e) {
    this.log(`"${e.type}" event`);
  }
  attemptSetMediaKeys(e, t) {
    const s = this.setMediaKeysQueue.slice();
    this.log(`Setting media-keys for "${e}"`);
    const n = Promise.all(s).then(() => {
      if (!this.media)
        throw new Error("Attempted to set mediaKeys without media element attached");
      return this.media.setMediaKeys(t);
    });
    return this.setMediaKeysQueue.push(n), n.then(() => {
      this.log(`Media-keys set for "${e}"`), s.push(n), this.setMediaKeysQueue = this.setMediaKeysQueue.filter((r) => s.indexOf(r) === -1);
    });
  }
  generateRequestWithPreferredKeySession(e, t, s, n) {
    var r, o;
    const a = (r = this.config.drmSystems) == null || (o = r[e.keySystem]) == null ? void 0 : o.generateRequest;
    if (a)
      try {
        const f = a.call(this.hls, t, s, e);
        if (!f)
          throw new Error("Invalid response from configured generateRequest filter");
        t = f.initDataType, s = e.decryptdata.pssh = f.initData ? new Uint8Array(f.initData) : null;
      } catch (f) {
        var l;
        if (this.warn(f.message), (l = this.hls) != null && l.config.debug)
          throw f;
      }
    if (s === null)
      return this.log(`Skipping key-session request for "${n}" (no initData)`), Promise.resolve(e);
    const c = this.getKeyIdString(e.decryptdata);
    this.log(`Generating key-session request for "${n}": ${c} (init data type: ${t} length: ${s ? s.byteLength : null})`);
    const u = new mi(), d = e._onmessage = (f) => {
      const g = e.mediaKeysSession;
      if (!g) {
        u.emit("error", new Error("invalid state"));
        return;
      }
      const {
        messageType: p,
        message: E
      } = f;
      this.log(`"${p}" message event for session "${g.sessionId}" message size: ${E.byteLength}`), p === "license-request" || p === "license-renewal" ? this.renewLicense(e, E).catch((y) => {
        this.handleError(y), u.emit("error", y);
      }) : p === "license-release" ? e.keySystem === me.FAIRPLAY && (this.updateKeySession(e, $n("acknowledged")), this.removeSession(e)) : this.warn(`unhandled media key message type "${p}"`);
    }, h = e._onkeystatuseschange = (f) => {
      if (!e.mediaKeysSession) {
        u.emit("error", new Error("invalid state"));
        return;
      }
      this.onKeyStatusChange(e);
      const p = e.keyStatus;
      u.emit("keyStatus", p), p === "expired" && (this.warn(`${e.keySystem} expired for key ${c}`), this.renewKeySession(e));
    };
    e.mediaKeysSession.addEventListener("message", d), e.mediaKeysSession.addEventListener("keystatuseschange", h);
    const m = new Promise((f, g) => {
      u.on("error", g), u.on("keyStatus", (p) => {
        p.startsWith("usable") ? f() : p === "output-restricted" ? g(new Ue({
          type: Z.KEY_SYSTEM_ERROR,
          details: C.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,
          fatal: !1
        }, "HDCP level output restricted")) : p === "internal-error" ? g(new Ue({
          type: Z.KEY_SYSTEM_ERROR,
          details: C.KEY_SYSTEM_STATUS_INTERNAL_ERROR,
          fatal: !0
        }, `key status changed to "${p}"`)) : p === "expired" ? g(new Error("key expired while generating request")) : this.warn(`unhandled key status change "${p}"`);
      });
    });
    return e.mediaKeysSession.generateRequest(t, s).then(() => {
      var f;
      this.log(`Request generated for key-session "${(f = e.mediaKeysSession) == null ? void 0 : f.sessionId}" keyId: ${c}`);
    }).catch((f) => {
      throw new Ue({
        type: Z.KEY_SYSTEM_ERROR,
        details: C.KEY_SYSTEM_NO_SESSION,
        error: f,
        fatal: !1
      }, `Error generating key-session request: ${f}`);
    }).then(() => m).catch((f) => {
      throw u.removeAllListeners(), this.removeSession(e), f;
    }).then(() => (u.removeAllListeners(), e));
  }
  onKeyStatusChange(e) {
    e.mediaKeysSession.keyStatuses.forEach((t, s) => {
      this.log(`key status change "${t}" for keyStatuses keyId: ${ze.hexDump("buffer" in s ? new Uint8Array(s.buffer, s.byteOffset, s.byteLength) : new Uint8Array(s))} session keyId: ${ze.hexDump(new Uint8Array(e.decryptdata.keyId || []))} uri: ${e.decryptdata.uri}`), e.keyStatus = t;
    });
  }
  fetchServerCertificate(e) {
    const t = this.config, s = t.loader, n = new s(t), r = this.getServerCertificateUrl(e);
    return r ? (this.log(`Fetching server certificate for "${e}"`), new Promise((o, a) => {
      const l = {
        responseType: "arraybuffer",
        url: r
      }, c = t.certLoadPolicy.default, u = {
        loadPolicy: c,
        timeout: c.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, d = {
        onSuccess: (h, m, f, g) => {
          o(h.data);
        },
        onError: (h, m, f, g) => {
          a(new Ue({
            type: Z.KEY_SYSTEM_ERROR,
            details: C.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: f,
            response: Re({
              url: l.url,
              data: void 0
            }, h)
          }, `"${e}" certificate request failed (${r}). Status: ${h.code} (${h.text})`));
        },
        onTimeout: (h, m, f) => {
          a(new Ue({
            type: Z.KEY_SYSTEM_ERROR,
            details: C.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: f,
            response: {
              url: l.url,
              data: void 0
            }
          }, `"${e}" certificate request timed out (${r})`));
        },
        onAbort: (h, m, f) => {
          a(new Error("aborted"));
        }
      };
      n.load(l, u, d);
    })) : Promise.resolve();
  }
  setMediaKeysServerCertificate(e, t, s) {
    return new Promise((n, r) => {
      e.setServerCertificate(s).then((o) => {
        this.log(`setServerCertificate ${o ? "success" : "not supported by CDM"} (${s == null ? void 0 : s.byteLength}) on "${t}"`), n(e);
      }).catch((o) => {
        r(new Ue({
          type: Z.KEY_SYSTEM_ERROR,
          details: C.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
          error: o,
          fatal: !0
        }, o.message));
      });
    });
  }
  renewLicense(e, t) {
    return this.requestLicense(e, new Uint8Array(t)).then((s) => this.updateKeySession(e, new Uint8Array(s)).catch((n) => {
      throw new Ue({
        type: Z.KEY_SYSTEM_ERROR,
        details: C.KEY_SYSTEM_SESSION_UPDATE_FAILED,
        error: n,
        fatal: !0
      }, n.message);
    }));
  }
  unpackPlayReadyKeyMessage(e, t) {
    const s = String.fromCharCode.apply(null, new Uint16Array(t.buffer));
    if (!s.includes("PlayReadyKeyMessage"))
      return e.setRequestHeader("Content-Type", "text/xml; charset=utf-8"), t;
    const n = new DOMParser().parseFromString(s, "application/xml"), r = n.querySelectorAll("HttpHeader");
    if (r.length > 0) {
      let u;
      for (let d = 0, h = r.length; d < h; d++) {
        var o, a;
        u = r[d];
        const m = (o = u.querySelector("name")) == null ? void 0 : o.textContent, f = (a = u.querySelector("value")) == null ? void 0 : a.textContent;
        m && f && e.setRequestHeader(m, f);
      }
    }
    const l = n.querySelector("Challenge"), c = l == null ? void 0 : l.textContent;
    if (!c)
      throw new Error("Cannot find <Challenge> in key message");
    return $n(atob(c));
  }
  setupLicenseXHR(e, t, s, n) {
    const r = this.config.licenseXhrSetup;
    return r ? Promise.resolve().then(() => {
      if (!s.decryptdata)
        throw new Error("Key removed");
      return r.call(this.hls, e, t, s, n);
    }).catch((o) => {
      if (!s.decryptdata)
        throw o;
      return e.open("POST", t, !0), r.call(this.hls, e, t, s, n);
    }).then((o) => (e.readyState || e.open("POST", t, !0), {
      xhr: e,
      licenseChallenge: o || n
    })) : (e.open("POST", t, !0), Promise.resolve({
      xhr: e,
      licenseChallenge: n
    }));
  }
  requestLicense(e, t) {
    const s = this.config.keyLoadPolicy.default;
    return new Promise((n, r) => {
      const o = this.getLicenseServerUrl(e.keySystem);
      this.log(`Sending license request to URL: ${o}`);
      const a = new XMLHttpRequest();
      a.responseType = "arraybuffer", a.onreadystatechange = () => {
        if (!this.hls || !e.mediaKeysSession)
          return r(new Error("invalid state"));
        if (a.readyState === 4)
          if (a.status === 200) {
            this._requestLicenseFailureCount = 0;
            let l = a.response;
            this.log(`License received ${l instanceof ArrayBuffer ? l.byteLength : l}`);
            const c = this.config.licenseResponseCallback;
            if (c)
              try {
                l = c.call(this.hls, a, o, e);
              } catch (u) {
                this.error(u);
              }
            n(l);
          } else {
            const l = s.errorRetry, c = l ? l.maxNumRetry : 0;
            if (this._requestLicenseFailureCount++, this._requestLicenseFailureCount > c || a.status >= 400 && a.status < 500)
              r(new Ue({
                type: Z.KEY_SYSTEM_ERROR,
                details: C.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: !0,
                networkDetails: a,
                response: {
                  url: o,
                  data: void 0,
                  code: a.status,
                  text: a.statusText
                }
              }, `License Request XHR failed (${o}). Status: ${a.status} (${a.statusText})`));
            else {
              const u = c - this._requestLicenseFailureCount + 1;
              this.warn(`Retrying license request, ${u} attempts left`), this.requestLicense(e, t).then(n, r);
            }
          }
      }, e.licenseXhr && e.licenseXhr.readyState !== XMLHttpRequest.DONE && e.licenseXhr.abort(), e.licenseXhr = a, this.setupLicenseXHR(a, o, e, t).then(({
        xhr: l,
        licenseChallenge: c
      }) => {
        e.keySystem == me.PLAYREADY && (c = this.unpackPlayReadyKeyMessage(l, c)), l.send(c);
      });
    });
  }
  onMediaAttached(e, t) {
    if (!this.config.emeEnabled)
      return;
    const s = t.media;
    this.media = s, s.addEventListener("encrypted", this.onMediaEncrypted), s.addEventListener("waitingforkey", this.onWaitingForKey);
  }
  onMediaDetached() {
    const e = this.media, t = this.mediaKeySessions;
    e && (e.removeEventListener("encrypted", this.onMediaEncrypted), e.removeEventListener("waitingforkey", this.onWaitingForKey), this.media = null), this._requestLicenseFailureCount = 0, this.setMediaKeysQueue = [], this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, ns.clearKeyUriToKeyIdMap();
    const s = t.length;
    Bt.CDMCleanupPromise = Promise.all(t.map((n) => this.removeSession(n)).concat(e == null ? void 0 : e.setMediaKeys(null).catch((n) => {
      this.log(`Could not clear media keys: ${n}`);
    }))).then(() => {
      s && (this.log("finished closing key sessions and clearing media keys"), t.length = 0);
    }).catch((n) => {
      this.log(`Could not close sessions and clear media keys: ${n}`);
    });
  }
  onManifestLoading() {
    this.keyFormatPromise = null;
  }
  onManifestLoaded(e, {
    sessionKeys: t
  }) {
    if (!(!t || !this.config.emeEnabled) && !this.keyFormatPromise) {
      const s = t.reduce((n, r) => (n.indexOf(r.keyFormat) === -1 && n.push(r.keyFormat), n), []);
      this.log(`Selecting key-system from session-keys ${s.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(s);
    }
  }
  removeSession(e) {
    const {
      mediaKeysSession: t,
      licenseXhr: s
    } = e;
    if (t) {
      this.log(`Remove licenses and keys and close session ${t.sessionId}`), e._onmessage && (t.removeEventListener("message", e._onmessage), e._onmessage = void 0), e._onkeystatuseschange && (t.removeEventListener("keystatuseschange", e._onkeystatuseschange), e._onkeystatuseschange = void 0), s && s.readyState !== XMLHttpRequest.DONE && s.abort(), e.mediaKeysSession = e.decryptdata = e.licenseXhr = void 0;
      const n = this.mediaKeySessions.indexOf(e);
      return n > -1 && this.mediaKeySessions.splice(n, 1), t.remove().catch((r) => {
        this.log(`Could not remove session: ${r}`);
      }).then(() => t.close()).catch((r) => {
        this.log(`Could not close session: ${r}`);
      });
    }
  }
}
Bt.CDMCleanupPromise = void 0;
class Ue extends Error {
  constructor(e, t) {
    super(t), this.data = void 0, e.error || (e.error = new Error(t)), this.data = e, e.err = e.error;
  }
}
var be;
(function(i) {
  i.MANIFEST = "m", i.AUDIO = "a", i.VIDEO = "v", i.MUXED = "av", i.INIT = "i", i.CAPTION = "c", i.TIMED_TEXT = "tt", i.KEY = "k", i.OTHER = "o";
})(be || (be = {}));
var Xn;
(function(i) {
  i.DASH = "d", i.HLS = "h", i.SMOOTH = "s", i.OTHER = "o";
})(Xn || (Xn = {}));
var vt;
(function(i) {
  i.OBJECT = "CMCD-Object", i.REQUEST = "CMCD-Request", i.SESSION = "CMCD-Session", i.STATUS = "CMCD-Status";
})(vt || (vt = {}));
const Qg = {
  [vt.OBJECT]: ["br", "d", "ot", "tb"],
  [vt.REQUEST]: ["bl", "dl", "mtp", "nor", "nrr", "su"],
  [vt.SESSION]: ["cid", "pr", "sf", "sid", "st", "v"],
  [vt.STATUS]: ["bs", "rtp"]
};
class Vt {
  constructor(e, t) {
    this.value = void 0, this.params = void 0, Array.isArray(e) && (e = e.map((s) => s instanceof Vt ? s : new Vt(s))), this.value = e, this.params = t;
  }
}
class Aa {
  constructor(e) {
    this.description = void 0, this.description = e;
  }
}
const Zg = "Dict";
function Jg(i) {
  return Array.isArray(i) ? JSON.stringify(i) : i instanceof Map ? "Map{}" : i instanceof Set ? "Set{}" : typeof i == "object" ? JSON.stringify(i) : String(i);
}
function e0(i, e, t, s) {
  return new Error(`failed to ${i} "${Jg(e)}" as ${t}`, {
    cause: s
  });
}
const jr = "Bare Item", t0 = "Boolean", s0 = "Byte Sequence", n0 = "Decimal", i0 = "Integer";
function r0(i) {
  return i < -999999999999999 || 999999999999999 < i;
}
const o0 = /[\x00-\x1f\x7f]+/, a0 = "Token", l0 = "Key";
function et(i, e, t) {
  return e0("serialize", i, e, t);
}
function c0(i) {
  if (typeof i != "boolean")
    throw et(i, t0);
  return i ? "?1" : "?0";
}
function u0(i) {
  return btoa(String.fromCharCode(...i));
}
function d0(i) {
  if (ArrayBuffer.isView(i) === !1)
    throw et(i, s0);
  return `:${u0(i)}:`;
}
function La(i) {
  if (r0(i))
    throw et(i, i0);
  return i.toString();
}
function h0(i) {
  return `@${La(i.getTime() / 1e3)}`;
}
function Ra(i, e) {
  if (i < 0)
    return -Ra(-i, e);
  const t = Math.pow(10, e);
  if (Math.abs(i * t % 1 - 0.5) < Number.EPSILON) {
    const n = Math.floor(i * t);
    return (n % 2 === 0 ? n : n + 1) / t;
  } else
    return Math.round(i * t) / t;
}
function f0(i) {
  const e = Ra(i, 3);
  if (Math.floor(Math.abs(e)).toString().length > 12)
    throw et(i, n0);
  const t = e.toString();
  return t.includes(".") ? t : `${t}.0`;
}
const m0 = "String";
function g0(i) {
  if (o0.test(i))
    throw et(i, m0);
  return `"${i.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
}
function p0(i) {
  return i.description || i.toString().slice(7, -1);
}
function Xr(i) {
  const e = p0(i);
  if (/^([a-zA-Z*])([!#$%&'*+\-.^_`|~\w:/]*)$/.test(e) === !1)
    throw et(e, a0);
  return e;
}
function Qn(i) {
  switch (typeof i) {
    case "number":
      if (!G(i))
        throw et(i, jr);
      return Number.isInteger(i) ? La(i) : f0(i);
    case "string":
      return g0(i);
    case "symbol":
      return Xr(i);
    case "boolean":
      return c0(i);
    case "object":
      if (i instanceof Date)
        return h0(i);
      if (i instanceof Uint8Array)
        return d0(i);
      if (i instanceof Aa)
        return Xr(i);
    default:
      throw et(i, jr);
  }
}
function Zn(i) {
  if (/^[a-z*][a-z0-9\-_.*]*$/.test(i) === !1)
    throw et(i, l0);
  return i;
}
function Ei(i) {
  return i == null ? "" : Object.entries(i).map(([e, t]) => t === !0 ? `;${Zn(e)}` : `;${Zn(e)}=${Qn(t)}`).join("");
}
function Da(i) {
  return i instanceof Vt ? `${Qn(i.value)}${Ei(i.params)}` : Qn(i);
}
function T0(i) {
  return `(${i.value.map(Da).join(" ")})${Ei(i.params)}`;
}
function E0(i, e = {
  whitespace: !0
}) {
  if (typeof i != "object")
    throw et(i, Zg);
  const t = i instanceof Map ? i.entries() : Object.entries(i), s = e != null && e.whitespace ? " " : "";
  return Array.from(t).map(([n, r]) => {
    r instanceof Vt || (r = new Vt(r));
    let o = Zn(n);
    return r.value === !0 ? o += Ei(r.params) : (o += "=", Array.isArray(r.value) ? o += T0(r) : o += Da(r)), o;
  }).join(`,${s}`);
}
function y0(i, e) {
  return E0(i, e);
}
const x0 = (i) => i === "ot" || i === "sf" || i === "st", v0 = (i) => typeof i == "number" ? G(i) : i != null && i !== "" && i !== !1;
function S0(i, e) {
  const t = new URL(i), s = new URL(e);
  if (t.origin !== s.origin)
    return i;
  const n = t.pathname.split("/").slice(1), r = s.pathname.split("/").slice(1, -1);
  for (; n[0] === r[0]; )
    n.shift(), r.shift();
  for (; r.length; )
    r.shift(), n.unshift("..");
  return n.join("/");
}
function A0() {
  try {
    return crypto.randomUUID();
  } catch {
    try {
      const e = URL.createObjectURL(new Blob()), t = e.toString();
      return URL.revokeObjectURL(e), t.slice(t.lastIndexOf("/") + 1);
    } catch {
      let t = (/* @__PURE__ */ new Date()).getTime();
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (n) => {
        const r = (t + Math.random() * 16) % 16 | 0;
        return t = Math.floor(t / 16), (n == "x" ? r : r & 3 | 8).toString(16);
      });
    }
  }
}
const Ps = (i) => Math.round(i), L0 = (i, e) => (e != null && e.baseUrl && (i = S0(i, e.baseUrl)), encodeURIComponent(i)), Is = (i) => Ps(i / 100) * 100, R0 = {
  /**
   * Bitrate (kbps) rounded integer
   */
  br: Ps,
  /**
   * Duration (milliseconds) rounded integer
   */
  d: Ps,
  /**
   * Buffer Length (milliseconds) rounded nearest 100ms
   */
  bl: Is,
  /**
   * Deadline (milliseconds) rounded nearest 100ms
   */
  dl: Is,
  /**
   * Measured Throughput (kbps) rounded nearest 100kbps
   */
  mtp: Is,
  /**
   * Next Object Request URL encoded
   */
  nor: L0,
  /**
   * Requested maximum throughput (kbps) rounded nearest 100kbps
   */
  rtp: Is,
  /**
   * Top Bitrate (kbps) rounded integer
   */
  tb: Ps
};
function D0(i, e) {
  const t = {};
  if (i == null || typeof i != "object")
    return t;
  const s = Object.keys(i).sort(), n = ve({}, R0, e == null ? void 0 : e.formatters), r = e == null ? void 0 : e.filter;
  return s.forEach((o) => {
    if (r != null && r(o))
      return;
    let a = i[o];
    const l = n[o];
    l && (a = l(a, e)), !(o === "v" && a === 1) && (o == "pr" && a === 1 || v0(a) && (x0(o) && typeof a == "string" && (a = new Aa(a)), t[o] = a));
  }), t;
}
function Ia(i, e = {}) {
  return i ? y0(D0(i, e), ve({
    whitespace: !1
  }, e)) : "";
}
function I0(i, e = {}) {
  if (!i)
    return {};
  const t = Object.entries(i), s = Object.entries(Qg).concat(Object.entries((e == null ? void 0 : e.customHeaderMap) || {})), n = t.reduce((r, o) => {
    var a, l;
    const [c, u] = o, d = ((a = s.find((h) => h[1].includes(c))) == null ? void 0 : a[0]) || vt.REQUEST;
    return (l = r[d]) != null || (r[d] = {}), r[d][c] = u, r;
  }, {});
  return Object.entries(n).reduce((r, [o, a]) => (r[o] = Ia(a, e), r), {});
}
function b0(i, e, t) {
  return ve(i, I0(e, t));
}
const _0 = "CMCD";
function C0(i, e = {}) {
  if (!i)
    return "";
  const t = Ia(i, e);
  return `${_0}=${encodeURIComponent(t)}`;
}
const Qr = /CMCD=[^&#]+/;
function w0(i, e, t) {
  const s = C0(e, t);
  if (!s)
    return i;
  if (Qr.test(i))
    return i.replace(Qr, s);
  const n = i.includes("?") ? "&" : "?";
  return `${i}${n}${s}`;
}
class M0 {
  // eslint-disable-line no-restricted-globals
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = void 0, this.sid = void 0, this.cid = void 0, this.useHeaders = !1, this.includeKeys = void 0, this.initialized = !1, this.starved = !1, this.buffering = !0, this.audioBuffer = void 0, this.videoBuffer = void 0, this.onWaiting = () => {
      this.initialized && (this.starved = !0), this.buffering = !0;
    }, this.onPlaying = () => {
      this.initialized || (this.initialized = !0), this.buffering = !1;
    }, this.applyPlaylistData = (n) => {
      try {
        this.apply(n, {
          ot: be.MANIFEST,
          su: !this.initialized
        });
      } catch (r) {
        D.warn("Could not generate manifest CMCD data.", r);
      }
    }, this.applyFragmentData = (n) => {
      try {
        const r = n.frag, o = this.hls.levels[r.level], a = this.getObjectType(r), l = {
          d: r.duration * 1e3,
          ot: a
        };
        (a === be.VIDEO || a === be.AUDIO || a == be.MUXED) && (l.br = o.bitrate / 1e3, l.tb = this.getTopBandwidth(a) / 1e3, l.bl = this.getBufferLength(a)), this.apply(n, l);
      } catch (r) {
        D.warn("Could not generate segment CMCD data.", r);
      }
    }, this.hls = e;
    const t = this.config = e.config, {
      cmcd: s
    } = t;
    s != null && (t.pLoader = this.createPlaylistLoader(), t.fLoader = this.createFragmentLoader(), this.sid = s.sessionId || A0(), this.cid = s.contentId, this.useHeaders = s.useHeaders === !0, this.includeKeys = s.includeKeys, this.registerListeners());
  }
  registerListeners() {
    const e = this.hls;
    e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHED, this.onMediaDetached, this), e.on(T.BUFFER_CREATED, this.onBufferCreated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHED, this.onMediaDetached, this), e.off(T.BUFFER_CREATED, this.onBufferCreated, this);
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetached(), this.hls = this.config = this.audioBuffer = this.videoBuffer = null, this.onWaiting = this.onPlaying = null;
  }
  onMediaAttached(e, t) {
    this.media = t.media, this.media.addEventListener("waiting", this.onWaiting), this.media.addEventListener("playing", this.onPlaying);
  }
  onMediaDetached() {
    this.media && (this.media.removeEventListener("waiting", this.onWaiting), this.media.removeEventListener("playing", this.onPlaying), this.media = null);
  }
  onBufferCreated(e, t) {
    var s, n;
    this.audioBuffer = (s = t.tracks.audio) == null ? void 0 : s.buffer, this.videoBuffer = (n = t.tracks.video) == null ? void 0 : n.buffer;
  }
  /**
   * Create baseline CMCD data
   */
  createData() {
    var e;
    return {
      v: 1,
      sf: Xn.HLS,
      sid: this.sid,
      cid: this.cid,
      pr: (e = this.media) == null ? void 0 : e.playbackRate,
      mtp: this.hls.bandwidthEstimate / 1e3
    };
  }
  /**
   * Apply CMCD data to a request.
   */
  apply(e, t = {}) {
    ve(t, this.createData());
    const s = t.ot === be.INIT || t.ot === be.VIDEO || t.ot === be.MUXED;
    this.starved && s && (t.bs = !0, t.su = !0, this.starved = !1), t.su == null && (t.su = this.buffering);
    const {
      includeKeys: n
    } = this;
    n && (t = Object.keys(t).reduce((r, o) => (n.includes(o) && (r[o] = t[o]), r), {})), this.useHeaders ? (e.headers || (e.headers = {}), b0(e.headers, t)) : e.url = w0(e.url, t);
  }
  /**
   * The CMCD object type.
   */
  getObjectType(e) {
    const {
      type: t
    } = e;
    if (t === "subtitle")
      return be.TIMED_TEXT;
    if (e.sn === "initSegment")
      return be.INIT;
    if (t === "audio")
      return be.AUDIO;
    if (t === "main")
      return this.hls.audioTracks.length ? be.VIDEO : be.MUXED;
  }
  /**
   * Get the highest bitrate.
   */
  getTopBandwidth(e) {
    let t = 0, s;
    const n = this.hls;
    if (e === be.AUDIO)
      s = n.audioTracks;
    else {
      const r = n.maxAutoLevel, o = r > -1 ? r + 1 : n.levels.length;
      s = n.levels.slice(0, o);
    }
    for (const r of s)
      r.bitrate > t && (t = r.bitrate);
    return t > 0 ? t : NaN;
  }
  /**
   * Get the buffer length for a media type in milliseconds
   */
  getBufferLength(e) {
    const t = this.hls.media, s = e === be.AUDIO ? this.audioBuffer : this.videoBuffer;
    return !s || !t ? NaN : de.bufferInfo(s, t.currentTime, this.config.maxBufferHole).len * 1e3;
  }
  /**
   * Create a playlist loader
   */
  createPlaylistLoader() {
    const {
      pLoader: e
    } = this.config, t = this.applyPlaylistData, s = e || this.config.loader;
    return class {
      constructor(r) {
        this.loader = void 0, this.loader = new s(r);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(r, o, a) {
        t(r), this.loader.load(r, o, a);
      }
    };
  }
  /**
   * Create a playlist loader
   */
  createFragmentLoader() {
    const {
      fLoader: e
    } = this.config, t = this.applyFragmentData, s = e || this.config.loader;
    return class {
      constructor(r) {
        this.loader = void 0, this.loader = new s(r);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(r, o, a) {
        t(r), this.loader.load(r, o, a);
      }
    };
  }
}
const k0 = 3e5;
class F0 {
  constructor(e) {
    this.hls = void 0, this.log = void 0, this.loader = null, this.uri = null, this.pathwayId = ".", this.pathwayPriority = null, this.timeToLoad = 300, this.reloadTimer = -1, this.updated = 0, this.started = !1, this.enabled = !0, this.levels = null, this.audioTracks = null, this.subtitleTracks = null, this.penalizedPathways = {}, this.hls = e, this.log = D.log.bind(D, "[content-steering]:"), this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.ERROR, this.onError, this));
  }
  startLoad() {
    if (this.started = !0, this.clearTimeout(), this.enabled && this.uri) {
      if (this.updated) {
        const e = this.timeToLoad * 1e3 - (performance.now() - this.updated);
        if (e > 0) {
          this.scheduleRefresh(this.uri, e);
          return;
        }
      }
      this.loadSteeringManifest(this.uri);
    }
  }
  stopLoad() {
    this.started = !1, this.loader && (this.loader.destroy(), this.loader = null), this.clearTimeout();
  }
  clearTimeout() {
    this.reloadTimer !== -1 && (self.clearTimeout(this.reloadTimer), this.reloadTimer = -1);
  }
  destroy() {
    this.unregisterListeners(), this.stopLoad(), this.hls = null, this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  removeLevel(e) {
    const t = this.levels;
    t && (this.levels = t.filter((s) => s !== e));
  }
  onManifestLoading() {
    this.stopLoad(), this.enabled = !0, this.timeToLoad = 300, this.updated = 0, this.uri = null, this.pathwayId = ".", this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  onManifestLoaded(e, t) {
    const {
      contentSteering: s
    } = t;
    s !== null && (this.pathwayId = s.pathwayId, this.uri = s.uri, this.started && this.startLoad());
  }
  onManifestParsed(e, t) {
    this.audioTracks = t.audioTracks, this.subtitleTracks = t.subtitleTracks;
  }
  onError(e, t) {
    const {
      errorAction: s
    } = t;
    if ((s == null ? void 0 : s.action) === De.SendAlternateToPenaltyBox && s.flags === Ke.MoveAllAlternatesMatchingHost) {
      const n = this.levels;
      let r = this.pathwayPriority, o = this.pathwayId;
      if (t.context) {
        const {
          groupId: a,
          pathwayId: l,
          type: c
        } = t.context;
        a && n ? o = this.getPathwayForGroupId(a, c, o) : l && (o = l);
      }
      o in this.penalizedPathways || (this.penalizedPathways[o] = performance.now()), !r && n && (r = n.reduce((a, l) => (a.indexOf(l.pathwayId) === -1 && a.push(l.pathwayId), a), [])), r && r.length > 1 && (this.updatePathwayPriority(r), s.resolved = this.pathwayId !== o), s.resolved || D.warn(`Could not resolve ${t.details} ("${t.error.message}") with content-steering for Pathway: ${o} levels: ${n && n.length} priorities: ${JSON.stringify(r)} penalized: ${JSON.stringify(this.penalizedPathways)}`);
    }
  }
  filterParsedLevels(e) {
    this.levels = e;
    let t = this.getLevelsForPathway(this.pathwayId);
    if (t.length === 0) {
      const s = e[0].pathwayId;
      this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${s}"`), t = this.getLevelsForPathway(s), this.pathwayId = s;
    }
    return t.length !== e.length ? (this.log(`Found ${t.length}/${e.length} levels in Pathway "${this.pathwayId}"`), t) : e;
  }
  getLevelsForPathway(e) {
    return this.levels === null ? [] : this.levels.filter((t) => e === t.pathwayId);
  }
  updatePathwayPriority(e) {
    this.pathwayPriority = e;
    let t;
    const s = this.penalizedPathways, n = performance.now();
    Object.keys(s).forEach((r) => {
      n - s[r] > k0 && delete s[r];
    });
    for (let r = 0; r < e.length; r++) {
      const o = e[r];
      if (o in s)
        continue;
      if (o === this.pathwayId)
        return;
      const a = this.hls.nextLoadLevel, l = this.hls.levels[a];
      if (t = this.getLevelsForPathway(o), t.length > 0) {
        this.log(`Setting Pathway to "${o}"`), this.pathwayId = o, Yo(t), this.hls.trigger(T.LEVELS_UPDATED, {
          levels: t
        });
        const c = this.hls.levels[a];
        l && c && this.levels && (c.attrs["STABLE-VARIANT-ID"] !== l.attrs["STABLE-VARIANT-ID"] && c.bitrate !== l.bitrate && this.log(`Unstable Pathways change from bitrate ${l.bitrate} to ${c.bitrate}`), this.hls.nextLoadLevel = a);
        break;
      }
    }
  }
  getPathwayForGroupId(e, t, s) {
    const n = this.getLevelsForPathway(s).concat(this.levels || []);
    for (let r = 0; r < n.length; r++)
      if (t === re.AUDIO_TRACK && n[r].hasAudioGroup(e) || t === re.SUBTITLE_TRACK && n[r].hasSubtitleGroup(e))
        return n[r].pathwayId;
    return s;
  }
  clonePathways(e) {
    const t = this.levels;
    if (!t)
      return;
    const s = {}, n = {};
    e.forEach((r) => {
      const {
        ID: o,
        "BASE-ID": a,
        "URI-REPLACEMENT": l
      } = r;
      if (t.some((u) => u.pathwayId === o))
        return;
      const c = this.getLevelsForPathway(a).map((u) => {
        const d = new ge(u.attrs);
        d["PATHWAY-ID"] = o;
        const h = d.AUDIO && `${d.AUDIO}_clone_${o}`, m = d.SUBTITLES && `${d.SUBTITLES}_clone_${o}`;
        h && (s[d.AUDIO] = h, d.AUDIO = h), m && (n[d.SUBTITLES] = m, d.SUBTITLES = m);
        const f = ba(u.uri, d["STABLE-VARIANT-ID"], "PER-VARIANT-URIS", l), g = new Ht({
          attrs: d,
          audioCodec: u.audioCodec,
          bitrate: u.bitrate,
          height: u.height,
          name: u.name,
          url: f,
          videoCodec: u.videoCodec,
          width: u.width
        });
        if (u.audioGroups)
          for (let p = 1; p < u.audioGroups.length; p++)
            g.addGroupId("audio", `${u.audioGroups[p]}_clone_${o}`);
        if (u.subtitleGroups)
          for (let p = 1; p < u.subtitleGroups.length; p++)
            g.addGroupId("text", `${u.subtitleGroups[p]}_clone_${o}`);
        return g;
      });
      t.push(...c), Zr(this.audioTracks, s, l, o), Zr(this.subtitleTracks, n, l, o);
    });
  }
  loadSteeringManifest(e) {
    const t = this.hls.config, s = t.loader;
    this.loader && this.loader.destroy(), this.loader = new s(t);
    let n;
    try {
      n = new self.URL(e);
    } catch {
      this.enabled = !1, this.log(`Failed to parse Steering Manifest URI: ${e}`);
      return;
    }
    if (n.protocol !== "data:") {
      const u = (this.hls.bandwidthEstimate || t.abrEwmaDefaultEstimate) | 0;
      n.searchParams.set("_HLS_pathway", this.pathwayId), n.searchParams.set("_HLS_throughput", "" + u);
    }
    const r = {
      responseType: "json",
      url: n.href
    }, o = t.steeringManifestLoadPolicy.default, a = o.errorRetry || o.timeoutRetry || {}, l = {
      loadPolicy: o,
      timeout: o.maxLoadTimeMs,
      maxRetry: a.maxNumRetry || 0,
      retryDelay: a.retryDelayMs || 0,
      maxRetryDelay: a.maxRetryDelayMs || 0
    }, c = {
      onSuccess: (u, d, h, m) => {
        this.log(`Loaded steering manifest: "${n}"`);
        const f = u.data;
        if (f.VERSION !== 1) {
          this.log(`Steering VERSION ${f.VERSION} not supported!`);
          return;
        }
        this.updated = performance.now(), this.timeToLoad = f.TTL;
        const {
          "RELOAD-URI": g,
          "PATHWAY-CLONES": p,
          "PATHWAY-PRIORITY": E
        } = f;
        if (g)
          try {
            this.uri = new self.URL(g, n).href;
          } catch {
            this.enabled = !1, this.log(`Failed to parse Steering Manifest RELOAD-URI: ${g}`);
            return;
          }
        this.scheduleRefresh(this.uri || h.url), p && this.clonePathways(p);
        const y = {
          steeringManifest: f,
          url: n.toString()
        };
        this.hls.trigger(T.STEERING_MANIFEST_LOADED, y), E && this.updatePathwayPriority(E);
      },
      onError: (u, d, h, m) => {
        if (this.log(`Error loading steering manifest: ${u.code} ${u.text} (${d.url})`), this.stopLoad(), u.code === 410) {
          this.enabled = !1, this.log(`Steering manifest ${d.url} no longer available`);
          return;
        }
        let f = this.timeToLoad * 1e3;
        if (u.code === 429) {
          const g = this.loader;
          if (typeof (g == null ? void 0 : g.getResponseHeader) == "function") {
            const p = g.getResponseHeader("Retry-After");
            p && (f = parseFloat(p) * 1e3);
          }
          this.log(`Steering manifest ${d.url} rate limited`);
          return;
        }
        this.scheduleRefresh(this.uri || d.url, f);
      },
      onTimeout: (u, d, h) => {
        this.log(`Timeout loading steering manifest (${d.url})`), this.scheduleRefresh(this.uri || d.url);
      }
    };
    this.log(`Requesting steering manifest: ${n}`), this.loader.load(r, l, c);
  }
  scheduleRefresh(e, t = this.timeToLoad * 1e3) {
    this.clearTimeout(), this.reloadTimer = self.setTimeout(() => {
      var s;
      const n = (s = this.hls) == null ? void 0 : s.media;
      if (n && !n.ended) {
        this.loadSteeringManifest(e);
        return;
      }
      this.scheduleRefresh(e, this.timeToLoad * 1e3);
    }, t);
  }
}
function Zr(i, e, t, s) {
  i && Object.keys(e).forEach((n) => {
    const r = i.filter((o) => o.groupId === n).map((o) => {
      const a = ve({}, o);
      return a.details = void 0, a.attrs = new ge(a.attrs), a.url = a.attrs.URI = ba(o.url, o.attrs["STABLE-RENDITION-ID"], "PER-RENDITION-URIS", t), a.groupId = a.attrs["GROUP-ID"] = e[n], a.attrs["PATHWAY-ID"] = s, a;
    });
    i.push(...r);
  });
}
function ba(i, e, t, s) {
  const {
    HOST: n,
    PARAMS: r,
    [t]: o
  } = s;
  let a;
  e && (a = o == null ? void 0 : o[e], a && (i = a));
  const l = new self.URL(i);
  return n && !a && (l.host = n), r && Object.keys(r).sort().forEach((c) => {
    c && l.searchParams.set(c, r[c]);
  }), l.href;
}
const P0 = /^age:\s*[\d.]+\s*$/im;
class _a {
  constructor(e) {
    this.xhrSetup = void 0, this.requestTimeout = void 0, this.retryTimeout = void 0, this.retryDelay = void 0, this.config = null, this.callbacks = null, this.context = null, this.loader = null, this.stats = void 0, this.xhrSetup = e && e.xhrSetup || null, this.stats = new en(), this.retryDelay = 0;
  }
  destroy() {
    this.callbacks = null, this.abortInternal(), this.loader = null, this.config = null, this.context = null, this.xhrSetup = null;
  }
  abortInternal() {
    const e = this.loader;
    self.clearTimeout(this.requestTimeout), self.clearTimeout(this.retryTimeout), e && (e.onreadystatechange = null, e.onprogress = null, e.readyState !== 4 && (this.stats.aborted = !0, e.abort()));
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.loader);
  }
  load(e, t, s) {
    if (this.stats.loading.start)
      throw new Error("Loader can only be used once.");
    this.stats.loading.start = self.performance.now(), this.context = e, this.config = t, this.callbacks = s, this.loadInternal();
  }
  loadInternal() {
    const {
      config: e,
      context: t
    } = this;
    if (!e || !t)
      return;
    const s = this.loader = new self.XMLHttpRequest(), n = this.stats;
    n.loading.first = 0, n.loaded = 0, n.aborted = !1;
    const r = this.xhrSetup;
    r ? Promise.resolve().then(() => {
      if (!(this.loader !== s || this.stats.aborted))
        return r(s, t.url);
    }).catch((o) => {
      if (!(this.loader !== s || this.stats.aborted))
        return s.open("GET", t.url, !0), r(s, t.url);
    }).then(() => {
      this.loader !== s || this.stats.aborted || this.openAndSendXhr(s, t, e);
    }).catch((o) => {
      this.callbacks.onError({
        code: s.status,
        text: o.message
      }, t, s, n);
    }) : this.openAndSendXhr(s, t, e);
  }
  openAndSendXhr(e, t, s) {
    e.readyState || e.open("GET", t.url, !0);
    const n = t.headers, {
      maxTimeToFirstByteMs: r,
      maxLoadTimeMs: o
    } = s.loadPolicy;
    if (n)
      for (const a in n)
        e.setRequestHeader(a, n[a]);
    t.rangeEnd && e.setRequestHeader("Range", "bytes=" + t.rangeStart + "-" + (t.rangeEnd - 1)), e.onreadystatechange = this.readystatechange.bind(this), e.onprogress = this.loadprogress.bind(this), e.responseType = t.responseType, self.clearTimeout(this.requestTimeout), s.timeout = r && G(r) ? r : o, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), s.timeout), e.send();
  }
  readystatechange() {
    const {
      context: e,
      loader: t,
      stats: s
    } = this;
    if (!e || !t)
      return;
    const n = t.readyState, r = this.config;
    if (!s.aborted && n >= 2 && (s.loading.first === 0 && (s.loading.first = Math.max(self.performance.now(), s.loading.start), r.timeout !== r.loadPolicy.maxLoadTimeMs && (self.clearTimeout(this.requestTimeout), r.timeout = r.loadPolicy.maxLoadTimeMs, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), r.loadPolicy.maxLoadTimeMs - (s.loading.first - s.loading.start)))), n === 4)) {
      self.clearTimeout(this.requestTimeout), t.onreadystatechange = null, t.onprogress = null;
      const o = t.status, a = t.responseType !== "text";
      if (o >= 200 && o < 300 && (a && t.response || t.responseText !== null)) {
        s.loading.end = Math.max(self.performance.now(), s.loading.first);
        const l = a ? t.response : t.responseText, c = t.responseType === "arraybuffer" ? l.byteLength : l.length;
        if (s.loaded = s.total = c, s.bwEstimate = s.total * 8e3 / (s.loading.end - s.loading.first), !this.callbacks)
          return;
        const u = this.callbacks.onProgress;
        if (u && u(s, e, l, t), !this.callbacks)
          return;
        const d = {
          url: t.responseURL,
          data: l,
          code: o
        };
        this.callbacks.onSuccess(d, s, e, t);
      } else {
        const l = r.loadPolicy.errorRetry, c = s.retry, u = {
          url: e.url,
          data: void 0,
          code: o
        };
        qs(l, c, !1, u) ? this.retry(l) : (D.error(`${o} while loading ${e.url}`), this.callbacks.onError({
          code: o,
          text: t.statusText
        }, e, t, s));
      }
    }
  }
  loadtimeout() {
    if (!this.config) return;
    const e = this.config.loadPolicy.timeoutRetry, t = this.stats.retry;
    if (qs(e, t, !0))
      this.retry(e);
    else {
      var s;
      D.warn(`timeout while loading ${(s = this.context) == null ? void 0 : s.url}`);
      const n = this.callbacks;
      n && (this.abortInternal(), n.onTimeout(this.stats, this.context, this.loader));
    }
  }
  retry(e) {
    const {
      context: t,
      stats: s
    } = this;
    this.retryDelay = ri(e, s.retry), s.retry++, D.warn(`${status ? "HTTP Status " + status : "Timeout"} while loading ${t == null ? void 0 : t.url}, retrying ${s.retry}/${e.maxNumRetry} in ${this.retryDelay}ms`), this.abortInternal(), this.loader = null, self.clearTimeout(this.retryTimeout), this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
  }
  loadprogress(e) {
    const t = this.stats;
    t.loaded = e.loaded, e.lengthComputable && (t.total = e.total);
  }
  getCacheAge() {
    let e = null;
    if (this.loader && P0.test(this.loader.getAllResponseHeaders())) {
      const t = this.loader.getResponseHeader("age");
      e = t ? parseFloat(t) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.loader && new RegExp(`^${e}:\\s*[\\d.]+\\s*$`, "im").test(this.loader.getAllResponseHeaders()) ? this.loader.getResponseHeader(e) : null;
  }
}
function O0() {
  if (
    // @ts-ignore
    self.fetch && self.AbortController && self.ReadableStream && self.Request
  )
    try {
      return new self.ReadableStream({}), !0;
    } catch {
    }
  return !1;
}
const N0 = /(\d+)-(\d+)\/(\d+)/;
class Jr {
  constructor(e) {
    this.fetchSetup = void 0, this.requestTimeout = void 0, this.request = null, this.response = null, this.controller = void 0, this.context = null, this.config = null, this.callbacks = null, this.stats = void 0, this.loader = null, this.fetchSetup = e.fetchSetup || G0, this.controller = new self.AbortController(), this.stats = new en();
  }
  destroy() {
    this.loader = this.callbacks = this.context = this.config = this.request = null, this.abortInternal(), this.response = null, this.fetchSetup = this.controller = this.stats = null;
  }
  abortInternal() {
    this.controller && !this.stats.loading.end && (this.stats.aborted = !0, this.controller.abort());
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.response);
  }
  load(e, t, s) {
    const n = this.stats;
    if (n.loading.start)
      throw new Error("Loader can only be used once.");
    n.loading.start = self.performance.now();
    const r = U0(e, this.controller.signal), o = s.onProgress, a = e.responseType === "arraybuffer", l = a ? "byteLength" : "length", {
      maxTimeToFirstByteMs: c,
      maxLoadTimeMs: u
    } = t.loadPolicy;
    this.context = e, this.config = t, this.callbacks = s, this.request = this.fetchSetup(e, r), self.clearTimeout(this.requestTimeout), t.timeout = c && G(c) ? c : u, this.requestTimeout = self.setTimeout(() => {
      this.abortInternal(), s.onTimeout(n, e, this.response);
    }, t.timeout), self.fetch(this.request).then((d) => {
      this.response = this.loader = d;
      const h = Math.max(self.performance.now(), n.loading.start);
      if (self.clearTimeout(this.requestTimeout), t.timeout = u, this.requestTimeout = self.setTimeout(() => {
        this.abortInternal(), s.onTimeout(n, e, this.response);
      }, u - (h - n.loading.start)), !d.ok) {
        const {
          status: m,
          statusText: f
        } = d;
        throw new H0(f || "fetch, bad network response", m, d);
      }
      return n.loading.first = h, n.total = $0(d.headers) || n.total, o && G(t.highWaterMark) ? this.loadProgressively(d, n, e, t.highWaterMark, o) : a ? d.arrayBuffer() : e.responseType === "json" ? d.json() : d.text();
    }).then((d) => {
      const h = this.response;
      if (!h)
        throw new Error("loader destroyed");
      self.clearTimeout(this.requestTimeout), n.loading.end = Math.max(self.performance.now(), n.loading.first);
      const m = d[l];
      m && (n.loaded = n.total = m);
      const f = {
        url: h.url,
        data: d,
        code: h.status
      };
      o && !G(t.highWaterMark) && o(n, e, d, h), s.onSuccess(f, n, e, h);
    }).catch((d) => {
      if (self.clearTimeout(this.requestTimeout), n.aborted)
        return;
      const h = d && d.code || 0, m = d ? d.message : null;
      s.onError({
        code: h,
        text: m
      }, e, d ? d.details : null, n);
    });
  }
  getCacheAge() {
    let e = null;
    if (this.response) {
      const t = this.response.headers.get("age");
      e = t ? parseFloat(t) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.response ? this.response.headers.get(e) : null;
  }
  loadProgressively(e, t, s, n = 0, r) {
    const o = new Xo(), a = e.body.getReader(), l = () => a.read().then((c) => {
      if (c.done)
        return o.dataLength && r(t, s, o.flush(), e), Promise.resolve(new ArrayBuffer(0));
      const u = c.value, d = u.length;
      return t.loaded += d, d < n || o.dataLength ? (o.push(u), o.dataLength >= n && r(t, s, o.flush(), e)) : r(t, s, u, e), l();
    }).catch(() => Promise.reject());
    return l();
  }
}
function U0(i, e) {
  const t = {
    method: "GET",
    mode: "cors",
    credentials: "same-origin",
    signal: e,
    headers: new self.Headers(ve({}, i.headers))
  };
  return i.rangeEnd && t.headers.set("Range", "bytes=" + i.rangeStart + "-" + String(i.rangeEnd - 1)), t;
}
function B0(i) {
  const e = N0.exec(i);
  if (e)
    return parseInt(e[2]) - parseInt(e[1]) + 1;
}
function $0(i) {
  const e = i.get("Content-Range");
  if (e) {
    const s = B0(e);
    if (G(s))
      return s;
  }
  const t = i.get("Content-Length");
  if (t)
    return parseInt(t);
}
function G0(i, e) {
  return new self.Request(i.url, e);
}
class H0 extends Error {
  constructor(e, t, s) {
    super(e), this.code = void 0, this.details = void 0, this.code = t, this.details = s;
  }
}
const K0 = /\s/, V0 = {
  newCue(i, e, t, s) {
    const n = [];
    let r, o, a, l, c;
    const u = self.VTTCue || self.TextTrackCue;
    for (let h = 0; h < s.rows.length; h++)
      if (r = s.rows[h], a = !0, l = 0, c = "", !r.isEmpty()) {
        var d;
        for (let g = 0; g < r.chars.length; g++)
          K0.test(r.chars[g].uchar) && a ? l++ : (c += r.chars[g].uchar, a = !1);
        r.cueStartTime = e, e === t && (t += 1e-4), l >= 16 ? l-- : l++;
        const m = Ea(c.trim()), f = pi(e, t, m);
        i != null && (d = i.cues) != null && d.getCueById(f) || (o = new u(e, t, m), o.id = f, o.line = h + 1, o.align = "left", o.position = 10 + Math.min(80, Math.floor(l * 8 / 32) * 10), n.push(o));
      }
    return i && n.length && (n.sort((h, m) => h.line === "auto" || m.line === "auto" ? 0 : h.line > 8 && m.line > 8 ? m.line - h.line : h.line - m.line), n.forEach((h) => Ho(i, h))), n;
  }
}, W0 = {
  maxTimeToFirstByteMs: 8e3,
  maxLoadTimeMs: 2e4,
  timeoutRetry: null,
  errorRetry: null
}, Ca = Re(Re({
  autoStartLoad: !0,
  // used by stream-controller
  startPosition: -1,
  // used by stream-controller
  defaultAudioCodec: void 0,
  // used by stream-controller
  debug: !1,
  // used by logger
  capLevelOnFPSDrop: !1,
  // used by fps-controller
  capLevelToPlayerSize: !1,
  // used by cap-level-controller
  ignoreDevicePixelRatio: !1,
  // used by cap-level-controller
  preferManagedMediaSource: !0,
  initialLiveManifestSize: 1,
  // used by stream-controller
  maxBufferLength: 30,
  // used by stream-controller
  backBufferLength: 1 / 0,
  // used by buffer-controller
  frontBufferFlushThreshold: 1 / 0,
  maxBufferSize: 60 * 1e3 * 1e3,
  // used by stream-controller
  maxBufferHole: 0.1,
  // used by stream-controller
  highBufferWatchdogPeriod: 2,
  // used by stream-controller
  nudgeOffset: 0.1,
  // used by stream-controller
  nudgeMaxRetry: 3,
  // used by stream-controller
  maxFragLookUpTolerance: 0.25,
  // used by stream-controller
  liveSyncDurationCount: 3,
  // used by latency-controller
  liveMaxLatencyDurationCount: 1 / 0,
  // used by latency-controller
  liveSyncDuration: void 0,
  // used by latency-controller
  liveMaxLatencyDuration: void 0,
  // used by latency-controller
  maxLiveSyncPlaybackRate: 1,
  // used by latency-controller
  liveDurationInfinity: !1,
  // used by buffer-controller
  /**
   * @deprecated use backBufferLength
   */
  liveBackBufferLength: null,
  // used by buffer-controller
  maxMaxBufferLength: 600,
  // used by stream-controller
  enableWorker: !0,
  // used by transmuxer
  workerPath: null,
  // used by transmuxer
  enableSoftwareAES: !0,
  // used by decrypter
  startLevel: void 0,
  // used by level-controller
  startFragPrefetch: !1,
  // used by stream-controller
  fpsDroppedMonitoringPeriod: 5e3,
  // used by fps-controller
  fpsDroppedMonitoringThreshold: 0.2,
  // used by fps-controller
  appendErrorMaxRetry: 3,
  // used by buffer-controller
  loader: _a,
  // loader: FetchLoader,
  fLoader: void 0,
  // used by fragment-loader
  pLoader: void 0,
  // used by playlist-loader
  xhrSetup: void 0,
  // used by xhr-loader
  licenseXhrSetup: void 0,
  // used by eme-controller
  licenseResponseCallback: void 0,
  // used by eme-controller
  abrController: Em,
  bufferController: Sg,
  capLevelController: Ti,
  errorController: om,
  fpsController: Xg,
  stretchShortVideoTrack: !1,
  // used by mp4-remuxer
  maxAudioFramesDrift: 1,
  // used by mp4-remuxer
  forceKeyFrameOnDiscontinuity: !0,
  // used by ts-demuxer
  abrEwmaFastLive: 3,
  // used by abr-controller
  abrEwmaSlowLive: 9,
  // used by abr-controller
  abrEwmaFastVoD: 3,
  // used by abr-controller
  abrEwmaSlowVoD: 9,
  // used by abr-controller
  abrEwmaDefaultEstimate: 5e5,
  // 500 kbps  // used by abr-controller
  abrEwmaDefaultEstimateMax: 5e6,
  // 5 mbps
  abrBandWidthFactor: 0.95,
  // used by abr-controller
  abrBandWidthUpFactor: 0.7,
  // used by abr-controller
  abrMaxWithRealBitrate: !1,
  // used by abr-controller
  maxStarvationDelay: 4,
  // used by abr-controller
  maxLoadingDelay: 4,
  // used by abr-controller
  minAutoBitrate: 0,
  // used by hls
  emeEnabled: !1,
  // used by eme-controller
  widevineLicenseUrl: void 0,
  // used by eme-controller
  drmSystems: {},
  // used by eme-controller
  drmSystemOptions: {},
  // used by eme-controller
  requestMediaKeySystemAccessFunc: bo,
  // used by eme-controller
  testBandwidth: !0,
  progressive: !1,
  lowLatencyMode: !0,
  cmcd: void 0,
  enableDateRangeMetadataCues: !0,
  enableEmsgMetadataCues: !0,
  enableID3MetadataCues: !0,
  useMediaCapabilities: !0,
  certLoadPolicy: {
    default: W0
  },
  keyLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 8e3,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      },
      errorRetry: {
        maxNumRetry: 8,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      }
    }
  },
  manifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1 / 0,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  playlistLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 2,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  fragLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 12e4,
      timeoutRetry: {
        maxNumRetry: 4,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 6,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  steeringManifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  // These default settings are deprecated in favor of the above policies
  // and are maintained for backwards compatibility
  manifestLoadingTimeOut: 1e4,
  manifestLoadingMaxRetry: 1,
  manifestLoadingRetryDelay: 1e3,
  manifestLoadingMaxRetryTimeout: 64e3,
  levelLoadingTimeOut: 1e4,
  levelLoadingMaxRetry: 4,
  levelLoadingRetryDelay: 1e3,
  levelLoadingMaxRetryTimeout: 64e3,
  fragLoadingTimeOut: 2e4,
  fragLoadingMaxRetry: 6,
  fragLoadingRetryDelay: 1e3,
  fragLoadingMaxRetryTimeout: 64e3
}, Y0()), {}, {
  subtitleStreamController: Eg,
  subtitleTrackController: xg,
  timelineController: zg,
  audioStreamController: pg,
  audioTrackController: Tg,
  emeController: Bt,
  cmcdController: M0,
  contentSteeringController: F0
});
function Y0() {
  return {
    cueHandler: V0,
    // used by timeline-controller
    enableWebVTT: !0,
    // used by timeline-controller
    enableIMSC1: !0,
    // used by timeline-controller
    enableCEA708Captions: !0,
    // used by timeline-controller
    captionsTextTrack1Label: "English",
    // used by timeline-controller
    captionsTextTrack1LanguageCode: "en",
    // used by timeline-controller
    captionsTextTrack2Label: "Spanish",
    // used by timeline-controller
    captionsTextTrack2LanguageCode: "es",
    // used by timeline-controller
    captionsTextTrack3Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack3LanguageCode: "",
    // used by timeline-controller
    captionsTextTrack4Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack4LanguageCode: "",
    // used by timeline-controller
    renderTextTracksNatively: !0
  };
}
function q0(i, e) {
  if ((e.liveSyncDurationCount || e.liveMaxLatencyDurationCount) && (e.liveSyncDuration || e.liveMaxLatencyDuration))
    throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
  if (e.liveMaxLatencyDurationCount !== void 0 && (e.liveSyncDurationCount === void 0 || e.liveMaxLatencyDurationCount <= e.liveSyncDurationCount))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
  if (e.liveMaxLatencyDuration !== void 0 && (e.liveSyncDuration === void 0 || e.liveMaxLatencyDuration <= e.liveSyncDuration))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
  const t = Jn(i), s = ["manifest", "level", "frag"], n = ["TimeOut", "MaxRetry", "RetryDelay", "MaxRetryTimeout"];
  return s.forEach((r) => {
    const o = `${r === "level" ? "playlist" : r}LoadPolicy`, a = e[o] === void 0, l = [];
    n.forEach((c) => {
      const u = `${r}Loading${c}`, d = e[u];
      if (d !== void 0 && a) {
        l.push(u);
        const h = t[o].default;
        switch (e[o] = {
          default: h
        }, c) {
          case "TimeOut":
            h.maxLoadTimeMs = d, h.maxTimeToFirstByteMs = d;
            break;
          case "MaxRetry":
            h.errorRetry.maxNumRetry = d, h.timeoutRetry.maxNumRetry = d;
            break;
          case "RetryDelay":
            h.errorRetry.retryDelayMs = d, h.timeoutRetry.retryDelayMs = d;
            break;
          case "MaxRetryTimeout":
            h.errorRetry.maxRetryDelayMs = d, h.timeoutRetry.maxRetryDelayMs = d;
            break;
        }
      }
    }), l.length && D.warn(`hls.js config: "${l.join('", "')}" setting(s) are deprecated, use "${o}": ${JSON.stringify(e[o])}`);
  }), Re(Re({}, t), e);
}
function Jn(i) {
  return i && typeof i == "object" ? Array.isArray(i) ? i.map(Jn) : Object.keys(i).reduce((e, t) => (e[t] = Jn(i[t]), e), {}) : i;
}
function z0(i) {
  const e = i.loader;
  e !== Jr && e !== _a ? (D.log("[config]: Custom loader detected, cannot enable progressive streaming"), i.progressive = !1) : O0() && (i.loader = Jr, i.progressive = !0, i.enableSoftwareAES = !0, D.log("[config]: Progressive streaming enabled, using FetchLoader"));
}
let Cn;
class j0 extends oi {
  constructor(e, t) {
    super(e, "[level-controller]"), this._levels = [], this._firstLevel = -1, this._maxAutoLevel = -1, this._startLevel = void 0, this.currentLevel = null, this.currentLevelIndex = -1, this.manualLevelIndex = -1, this.steering = void 0, this.onParsedComplete = void 0, this.steering = t, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(T.LEVEL_LOADED, this.onLevelLoaded, this), e.on(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(T.FRAG_BUFFERED, this.onFragBuffered, this), e.on(T.ERROR, this.onError, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(T.LEVEL_LOADED, this.onLevelLoaded, this), e.off(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(T.FRAG_BUFFERED, this.onFragBuffered, this), e.off(T.ERROR, this.onError, this);
  }
  destroy() {
    this._unregisterListeners(), this.steering = null, this.resetLevels(), super.destroy();
  }
  stopLoad() {
    this._levels.forEach((t) => {
      t.loadError = 0, t.fragmentError = 0;
    }), super.stopLoad();
  }
  resetLevels() {
    this._startLevel = void 0, this.manualLevelIndex = -1, this.currentLevelIndex = -1, this.currentLevel = null, this._levels = [], this._maxAutoLevel = -1;
  }
  onManifestLoading(e, t) {
    this.resetLevels();
  }
  onManifestLoaded(e, t) {
    const s = this.hls.config.preferManagedMediaSource, n = [], r = {}, o = {};
    let a = !1, l = !1, c = !1;
    t.levels.forEach((u) => {
      var d, h;
      const m = u.attrs;
      let {
        audioCodec: f,
        videoCodec: g
      } = u;
      ((d = f) == null ? void 0 : d.indexOf("mp4a.40.34")) !== -1 && (Cn || (Cn = /chrome|firefox/i.test(navigator.userAgent)), Cn && (u.audioCodec = f = void 0)), f && (u.audioCodec = f = Vs(f, s)), ((h = g) == null ? void 0 : h.indexOf("avc1")) === 0 && (g = u.videoCodec = Pf(g));
      const {
        width: p,
        height: E,
        unknownCodecs: y
      } = u;
      if (a || (a = !!(p && E)), l || (l = !!g), c || (c = !!f), y != null && y.length || f && !gn(f, "audio", s) || g && !gn(g, "video", s))
        return;
      const {
        CODECS: v,
        "FRAME-RATE": S,
        "HDCP-LEVEL": x,
        "PATHWAY-ID": R,
        RESOLUTION: L,
        "VIDEO-RANGE": _
      } = m, I = `${`${R || "."}-`}${u.bitrate}-${L}-${S}-${v}-${_}-${x}`;
      if (r[I])
        if (r[I].uri !== u.url && !u.attrs["PATHWAY-ID"]) {
          const w = o[I] += 1;
          u.attrs["PATHWAY-ID"] = new Array(w + 1).join(".");
          const $ = new Ht(u);
          r[I] = $, n.push($);
        } else
          r[I].addGroupId("audio", m.AUDIO), r[I].addGroupId("text", m.SUBTITLES);
      else {
        const w = new Ht(u);
        r[I] = w, o[I] = 1, n.push(w);
      }
    }), this.filterAndSortMediaOptions(n, t, a, l, c);
  }
  filterAndSortMediaOptions(e, t, s, n, r) {
    let o = [], a = [], l = e;
    if ((s || n) && r && (l = l.filter(({
      videoCodec: f,
      videoRange: g,
      width: p,
      height: E
    }) => (!!f || !!(p && E)) && zf(g))), l.length === 0) {
      Promise.resolve().then(() => {
        if (this.hls) {
          t.levels.length && this.warn(`One or more CODECS in variant not supported: ${JSON.stringify(t.levels[0].attrs)}`);
          const f = new Error("no level with compatible codecs found in manifest");
          this.hls.trigger(T.ERROR, {
            type: Z.MEDIA_ERROR,
            details: C.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
            fatal: !0,
            url: t.url,
            error: f,
            reason: f.message
          });
        }
      });
      return;
    }
    if (t.audioTracks) {
      const {
        preferManagedMediaSource: f
      } = this.hls.config;
      o = t.audioTracks.filter((g) => !g.audioCodec || gn(g.audioCodec, "audio", f)), eo(o);
    }
    t.subtitles && (a = t.subtitles, eo(a));
    const c = l.slice(0);
    l.sort((f, g) => {
      if (f.attrs["HDCP-LEVEL"] !== g.attrs["HDCP-LEVEL"])
        return (f.attrs["HDCP-LEVEL"] || "") > (g.attrs["HDCP-LEVEL"] || "") ? 1 : -1;
      if (s && f.height !== g.height)
        return f.height - g.height;
      if (f.frameRate !== g.frameRate)
        return f.frameRate - g.frameRate;
      if (f.videoRange !== g.videoRange)
        return Ws.indexOf(f.videoRange) - Ws.indexOf(g.videoRange);
      if (f.videoCodec !== g.videoCodec) {
        const p = ar(f.videoCodec), E = ar(g.videoCodec);
        if (p !== E)
          return E - p;
      }
      if (f.uri === g.uri && f.codecSet !== g.codecSet) {
        const p = Ks(f.codecSet), E = Ks(g.codecSet);
        if (p !== E)
          return E - p;
      }
      return f.averageBitrate !== g.averageBitrate ? f.averageBitrate - g.averageBitrate : 0;
    });
    let u = c[0];
    if (this.steering && (l = this.steering.filterParsedLevels(l), l.length !== c.length)) {
      for (let f = 0; f < c.length; f++)
        if (c[f].pathwayId === l[0].pathwayId) {
          u = c[f];
          break;
        }
    }
    this._levels = l;
    for (let f = 0; f < l.length; f++)
      if (l[f] === u) {
        var d;
        this._firstLevel = f;
        const g = u.bitrate, p = this.hls.bandwidthEstimate;
        if (this.log(`manifest loaded, ${l.length} level(s) found, first bitrate: ${g}`), ((d = this.hls.userConfig) == null ? void 0 : d.abrEwmaDefaultEstimate) === void 0) {
          const E = Math.min(g, this.hls.config.abrEwmaDefaultEstimateMax);
          E > p && p === Ca.abrEwmaDefaultEstimate && (this.hls.bandwidthEstimate = E);
        }
        break;
      }
    const h = r && !n, m = {
      levels: l,
      audioTracks: o,
      subtitleTracks: a,
      sessionData: t.sessionData,
      sessionKeys: t.sessionKeys,
      firstLevel: this._firstLevel,
      stats: t.stats,
      audio: r,
      video: n,
      altAudio: !h && o.some((f) => !!f.url)
    };
    this.hls.trigger(T.MANIFEST_PARSED, m), (this.hls.config.autoStartLoad || this.hls.forceStartLoad) && this.hls.startLoad(this.hls.config.startPosition);
  }
  get levels() {
    return this._levels.length === 0 ? null : this._levels;
  }
  get level() {
    return this.currentLevelIndex;
  }
  set level(e) {
    const t = this._levels;
    if (t.length === 0)
      return;
    if (e < 0 || e >= t.length) {
      const u = new Error("invalid level idx"), d = e < 0;
      if (this.hls.trigger(T.ERROR, {
        type: Z.OTHER_ERROR,
        details: C.LEVEL_SWITCH_ERROR,
        level: e,
        fatal: d,
        error: u,
        reason: u.message
      }), d)
        return;
      e = Math.min(e, t.length - 1);
    }
    const s = this.currentLevelIndex, n = this.currentLevel, r = n ? n.attrs["PATHWAY-ID"] : void 0, o = t[e], a = o.attrs["PATHWAY-ID"];
    if (this.currentLevelIndex = e, this.currentLevel = o, s === e && o.details && n && r === a)
      return;
    this.log(`Switching to level ${e} (${o.height ? o.height + "p " : ""}${o.videoRange ? o.videoRange + " " : ""}${o.codecSet ? o.codecSet + " " : ""}@${o.bitrate})${a ? " with Pathway " + a : ""} from level ${s}${r ? " with Pathway " + r : ""}`);
    const l = {
      level: e,
      attrs: o.attrs,
      details: o.details,
      bitrate: o.bitrate,
      averageBitrate: o.averageBitrate,
      maxBitrate: o.maxBitrate,
      realBitrate: o.realBitrate,
      width: o.width,
      height: o.height,
      codecSet: o.codecSet,
      audioCodec: o.audioCodec,
      videoCodec: o.videoCodec,
      audioGroups: o.audioGroups,
      subtitleGroups: o.subtitleGroups,
      loaded: o.loaded,
      loadError: o.loadError,
      fragmentError: o.fragmentError,
      name: o.name,
      id: o.id,
      uri: o.uri,
      url: o.url,
      urlId: 0,
      audioGroupIds: o.audioGroupIds,
      textGroupIds: o.textGroupIds
    };
    this.hls.trigger(T.LEVEL_SWITCHING, l);
    const c = o.details;
    if (!c || c.live) {
      const u = this.switchParams(o.uri, n == null ? void 0 : n.details, c);
      this.loadPlaylist(u);
    }
  }
  get manualLevel() {
    return this.manualLevelIndex;
  }
  set manualLevel(e) {
    this.manualLevelIndex = e, this._startLevel === void 0 && (this._startLevel = e), e !== -1 && (this.level = e);
  }
  get firstLevel() {
    return this._firstLevel;
  }
  set firstLevel(e) {
    this._firstLevel = e;
  }
  get startLevel() {
    if (this._startLevel === void 0) {
      const e = this.hls.config.startLevel;
      return e !== void 0 ? e : this.hls.firstAutoLevel;
    }
    return this._startLevel;
  }
  set startLevel(e) {
    this._startLevel = e;
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === re.LEVEL && t.context.level === this.level && this.checkRetry(t);
  }
  // reset errors on the successful load of a fragment
  onFragBuffered(e, {
    frag: t
  }) {
    if (t !== void 0 && t.type === Q.MAIN) {
      const s = t.elementaryStreams;
      if (!Object.keys(s).some((r) => !!s[r]))
        return;
      const n = this._levels[t.level];
      n != null && n.loadError && (this.log(`Resetting level error count of ${n.loadError} on frag buffered`), n.loadError = 0);
    }
  }
  onLevelLoaded(e, t) {
    var s;
    const {
      level: n,
      details: r
    } = t, o = this._levels[n];
    if (!o) {
      var a;
      this.warn(`Invalid level index ${n}`), (a = t.deliveryDirectives) != null && a.skip && (r.deltaUpdateFailed = !0);
      return;
    }
    n === this.currentLevelIndex ? (o.fragmentError === 0 && (o.loadError = 0), this.playlistLoaded(n, t, o.details)) : (s = t.deliveryDirectives) != null && s.skip && (r.deltaUpdateFailed = !0);
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const t = this.currentLevelIndex, s = this.currentLevel;
    if (s && this.shouldLoadPlaylist(s)) {
      let n = s.uri;
      if (e)
        try {
          n = e.addDirectives(n);
        } catch (o) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${o}`);
        }
      const r = s.attrs["PATHWAY-ID"];
      this.log(`Loading level index ${t}${(e == null ? void 0 : e.msn) !== void 0 ? " at sn " + e.msn + " part " + e.part : ""} with${r ? " Pathway " + r : ""} ${n}`), this.clearTimer(), this.hls.trigger(T.LEVEL_LOADING, {
        url: n,
        level: t,
        pathwayId: s.attrs["PATHWAY-ID"],
        id: 0,
        // Deprecated Level urlId
        deliveryDirectives: e || null
      });
    }
  }
  get nextLoadLevel() {
    return this.manualLevelIndex !== -1 ? this.manualLevelIndex : this.hls.nextAutoLevel;
  }
  set nextLoadLevel(e) {
    this.level = e, this.manualLevelIndex === -1 && (this.hls.nextAutoLevel = e);
  }
  removeLevel(e) {
    var t;
    const s = this._levels.filter((n, r) => r !== e ? !0 : (this.steering && this.steering.removeLevel(n), n === this.currentLevel && (this.currentLevel = null, this.currentLevelIndex = -1, n.details && n.details.fragments.forEach((o) => o.level = -1)), !1));
    Yo(s), this._levels = s, this.currentLevelIndex > -1 && (t = this.currentLevel) != null && t.details && (this.currentLevelIndex = this.currentLevel.details.fragments[0].level), this.hls.trigger(T.LEVELS_UPDATED, {
      levels: s
    });
  }
  onLevelsUpdated(e, {
    levels: t
  }) {
    this._levels = t;
  }
  checkMaxAutoUpdated() {
    const {
      autoLevelCapping: e,
      maxAutoLevel: t,
      maxHdcpLevel: s
    } = this.hls;
    this._maxAutoLevel !== t && (this._maxAutoLevel = t, this.hls.trigger(T.MAX_AUTO_LEVEL_UPDATED, {
      autoLevelCapping: e,
      levels: this.levels,
      maxAutoLevel: t,
      minAutoLevel: this.hls.minAutoLevel,
      maxHdcpLevel: s
    }));
  }
}
function eo(i) {
  const e = {};
  i.forEach((t) => {
    const s = t.groupId || "";
    t.id = e[s] = e[s] || 0, e[s]++;
  });
}
class X0 {
  constructor(e) {
    this.config = void 0, this.keyUriToKeyInfo = {}, this.emeController = null, this.config = e;
  }
  abort(e) {
    for (const s in this.keyUriToKeyInfo) {
      const n = this.keyUriToKeyInfo[s].loader;
      if (n) {
        var t;
        if (e && e !== ((t = n.context) == null ? void 0 : t.frag.type))
          return;
        n.abort();
      }
    }
  }
  detach() {
    for (const e in this.keyUriToKeyInfo) {
      const t = this.keyUriToKeyInfo[e];
      (t.mediaKeySessionContext || t.decryptdata.isCommonEncryption) && delete this.keyUriToKeyInfo[e];
    }
  }
  destroy() {
    this.detach();
    for (const e in this.keyUriToKeyInfo) {
      const t = this.keyUriToKeyInfo[e].loader;
      t && t.destroy();
    }
    this.keyUriToKeyInfo = {};
  }
  createKeyLoadError(e, t = C.KEY_LOAD_ERROR, s, n, r) {
    return new ut({
      type: Z.NETWORK_ERROR,
      details: t,
      fatal: !1,
      frag: e,
      response: r,
      error: s,
      networkDetails: n
    });
  }
  loadClear(e, t) {
    if (this.emeController && this.config.emeEnabled) {
      const {
        sn: s,
        cc: n
      } = e;
      for (let r = 0; r < t.length; r++) {
        const o = t[r];
        if (n <= o.cc && (s === "initSegment" || o.sn === "initSegment" || s < o.sn)) {
          this.emeController.selectKeySystemFormat(o).then((a) => {
            o.setKeyFormat(a);
          });
          break;
        }
      }
    }
  }
  load(e) {
    return !e.decryptdata && e.encrypted && this.emeController ? this.emeController.selectKeySystemFormat(e).then((t) => this.loadInternal(e, t)) : this.loadInternal(e);
  }
  loadInternal(e, t) {
    var s, n;
    t && e.setKeyFormat(t);
    const r = e.decryptdata;
    if (!r) {
      const c = new Error(t ? `Expected frag.decryptdata to be defined after setting format ${t}` : "Missing decryption data on fragment in onKeyLoading");
      return Promise.reject(this.createKeyLoadError(e, C.KEY_LOAD_ERROR, c));
    }
    const o = r.uri;
    if (!o)
      return Promise.reject(this.createKeyLoadError(e, C.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${o}"`)));
    let a = this.keyUriToKeyInfo[o];
    if ((s = a) != null && s.decryptdata.key)
      return r.key = a.decryptdata.key, Promise.resolve({
        frag: e,
        keyInfo: a
      });
    if ((n = a) != null && n.keyLoadPromise) {
      var l;
      switch ((l = a.mediaKeySessionContext) == null ? void 0 : l.keyStatus) {
        case void 0:
        case "status-pending":
        case "usable":
        case "usable-in-future":
          return a.keyLoadPromise.then((c) => (r.key = c.keyInfo.decryptdata.key, {
            frag: e,
            keyInfo: a
          }));
      }
    }
    switch (a = this.keyUriToKeyInfo[o] = {
      decryptdata: r,
      keyLoadPromise: null,
      loader: null,
      mediaKeySessionContext: null
    }, r.method) {
      case "ISO-23001-7":
      case "SAMPLE-AES":
      case "SAMPLE-AES-CENC":
      case "SAMPLE-AES-CTR":
        return r.keyFormat === "identity" ? this.loadKeyHTTP(a, e) : this.loadKeyEME(a, e);
      case "AES-128":
        return this.loadKeyHTTP(a, e);
      default:
        return Promise.reject(this.createKeyLoadError(e, C.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${r.method}"`)));
    }
  }
  loadKeyEME(e, t) {
    const s = {
      frag: t,
      keyInfo: e
    };
    if (this.emeController && this.config.emeEnabled) {
      const n = this.emeController.loadKey(s);
      if (n)
        return (e.keyLoadPromise = n.then((r) => (e.mediaKeySessionContext = r, s))).catch((r) => {
          throw e.keyLoadPromise = null, r;
        });
    }
    return Promise.resolve(s);
  }
  loadKeyHTTP(e, t) {
    const s = this.config, n = s.loader, r = new n(s);
    return t.keyLoader = e.loader = r, e.keyLoadPromise = new Promise((o, a) => {
      const l = {
        keyInfo: e,
        frag: t,
        responseType: "arraybuffer",
        url: e.decryptdata.uri
      }, c = s.keyLoadPolicy.default, u = {
        loadPolicy: c,
        timeout: c.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, d = {
        onSuccess: (h, m, f, g) => {
          const {
            frag: p,
            keyInfo: E,
            url: y
          } = f;
          if (!p.decryptdata || E !== this.keyUriToKeyInfo[y])
            return a(this.createKeyLoadError(p, C.KEY_LOAD_ERROR, new Error("after key load, decryptdata unset or changed"), g));
          E.decryptdata.key = p.decryptdata.key = new Uint8Array(h.data), p.keyLoader = null, E.loader = null, o({
            frag: p,
            keyInfo: E
          });
        },
        onError: (h, m, f, g) => {
          this.resetLoader(m), a(this.createKeyLoadError(t, C.KEY_LOAD_ERROR, new Error(`HTTP Error ${h.code} loading key ${h.text}`), f, Re({
            url: l.url,
            data: void 0
          }, h)));
        },
        onTimeout: (h, m, f) => {
          this.resetLoader(m), a(this.createKeyLoadError(t, C.KEY_LOAD_TIMEOUT, new Error("key loading timed out"), f));
        },
        onAbort: (h, m, f) => {
          this.resetLoader(m), a(this.createKeyLoadError(t, C.INTERNAL_ABORTED, new Error("key loading aborted"), f));
        }
      };
      r.load(l, u, d);
    });
  }
  resetLoader(e) {
    const {
      frag: t,
      keyInfo: s,
      url: n
    } = e, r = s.loader;
    t.keyLoader === r && (t.keyLoader = null, s.loader = null), delete this.keyUriToKeyInfo[n], r && r.destroy();
  }
}
function wa() {
  return self.SourceBuffer || self.WebKitSourceBuffer;
}
function Ma() {
  if (!Lt())
    return !1;
  const e = wa();
  return !e || e.prototype && typeof e.prototype.appendBuffer == "function" && typeof e.prototype.remove == "function";
}
function Q0() {
  if (!Ma())
    return !1;
  const i = Lt();
  return typeof (i == null ? void 0 : i.isTypeSupported) == "function" && (["avc1.42E01E,mp4a.40.2", "av01.0.01M.08", "vp09.00.50.08"].some((e) => i.isTypeSupported(is(e, "video"))) || ["mp4a.40.2", "fLaC"].some((e) => i.isTypeSupported(is(e, "audio"))));
}
function Z0() {
  var i;
  const e = wa();
  return typeof (e == null || (i = e.prototype) == null ? void 0 : i.changeType) == "function";
}
const J0 = 250, Os = 2, ep = 0.1, tp = 0.05;
class sp {
  constructor(e, t, s, n) {
    this.config = void 0, this.media = null, this.fragmentTracker = void 0, this.hls = void 0, this.nudgeRetry = 0, this.stallReported = !1, this.stalled = null, this.moved = !1, this.seeking = !1, this.config = e, this.media = t, this.fragmentTracker = s, this.hls = n;
  }
  destroy() {
    this.media = null, this.hls = this.fragmentTracker = null;
  }
  /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */
  poll(e, t) {
    const {
      config: s,
      media: n,
      stalled: r
    } = this;
    if (n === null)
      return;
    const {
      currentTime: o,
      seeking: a
    } = n, l = this.seeking && !a, c = !this.seeking && a;
    if (this.seeking = a, o !== e) {
      if (this.moved = !0, a || (this.nudgeRetry = 0), r !== null) {
        if (this.stallReported) {
          const p = self.performance.now() - r;
          D.warn(`playback not stuck anymore @${o}, after ${Math.round(p)}ms`), this.stallReported = !1;
        }
        this.stalled = null;
      }
      return;
    }
    if (c || l) {
      this.stalled = null;
      return;
    }
    if (n.paused && !a || n.ended || n.playbackRate === 0 || !de.getBuffered(n).length) {
      this.nudgeRetry = 0;
      return;
    }
    const u = de.bufferInfo(n, o, 0), d = u.nextStart || 0;
    if (a) {
      const p = u.len > Os, E = !d || t && t.start <= o || d - o > Os && !this.fragmentTracker.getPartialFragment(o);
      if (p || E)
        return;
      this.moved = !1;
    }
    if (!this.moved && this.stalled !== null) {
      var h;
      if (!(u.len > 0) && !d)
        return;
      const E = Math.max(d, u.start || 0) - o, y = this.hls.levels ? this.hls.levels[this.hls.currentLevel] : null, S = (y == null || (h = y.details) == null ? void 0 : h.live) ? y.details.targetduration * 2 : Os, x = this.fragmentTracker.getPartialFragment(o);
      if (E > 0 && (E <= S || x)) {
        n.paused || this._trySkipBufferHole(x);
        return;
      }
    }
    const m = self.performance.now();
    if (r === null) {
      this.stalled = m;
      return;
    }
    const f = m - r;
    if (!a && f >= J0 && (this._reportStall(u), !this.media))
      return;
    const g = de.bufferInfo(n, o, s.maxBufferHole);
    this._tryFixBufferStall(g, f);
  }
  /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */
  _tryFixBufferStall(e, t) {
    const {
      config: s,
      fragmentTracker: n,
      media: r
    } = this;
    if (r === null)
      return;
    const o = r.currentTime, a = n.getPartialFragment(o);
    a && (this._trySkipBufferHole(a) || !this.media) || (e.len > s.maxBufferHole || e.nextStart && e.nextStart - o < s.maxBufferHole) && t > s.highBufferWatchdogPeriod * 1e3 && (D.warn("Trying to nudge playhead over buffer-hole"), this.stalled = null, this._tryNudgeBuffer());
  }
  /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */
  _reportStall(e) {
    const {
      hls: t,
      media: s,
      stallReported: n
    } = this;
    if (!n && s) {
      this.stallReported = !0;
      const r = new Error(`Playback stalling at @${s.currentTime} due to low buffer (${JSON.stringify(e)})`);
      D.warn(r.message), t.trigger(T.ERROR, {
        type: Z.MEDIA_ERROR,
        details: C.BUFFER_STALLED_ERROR,
        fatal: !1,
        error: r,
        buffer: e.len
      });
    }
  }
  /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param partial - The partial fragment found at the current time (where playback is stalling).
   * @private
   */
  _trySkipBufferHole(e) {
    const {
      config: t,
      hls: s,
      media: n
    } = this;
    if (n === null)
      return 0;
    const r = n.currentTime, o = de.bufferInfo(n, r, 0), a = r < o.start ? o.start : o.nextStart;
    if (a) {
      const l = o.len <= t.maxBufferHole, c = o.len > 0 && o.len < 1 && n.readyState < 3, u = a - r;
      if (u > 0 && (l || c)) {
        if (u > t.maxBufferHole) {
          const {
            fragmentTracker: h
          } = this;
          let m = !1;
          if (r === 0) {
            const f = h.getAppendedFrag(0, Q.MAIN);
            f && a < f.end && (m = !0);
          }
          if (!m) {
            const f = e || h.getAppendedFrag(r, Q.MAIN);
            if (f) {
              let g = !1, p = f.end;
              for (; p < a; ) {
                const E = h.getPartialFragment(p);
                if (E)
                  p += E.duration;
                else {
                  g = !0;
                  break;
                }
              }
              if (g)
                return 0;
            }
          }
        }
        const d = Math.max(a + tp, r + ep);
        if (D.warn(`skipping hole, adjusting currentTime from ${r} to ${d}`), this.moved = !0, this.stalled = null, n.currentTime = d, e && !e.gap) {
          const h = new Error(`fragment loaded with buffer holes, seeking from ${r} to ${d}`);
          s.trigger(T.ERROR, {
            type: Z.MEDIA_ERROR,
            details: C.BUFFER_SEEK_OVER_HOLE,
            fatal: !1,
            error: h,
            reason: h.message,
            frag: e
          });
        }
        return d;
      }
    }
    return 0;
  }
  /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */
  _tryNudgeBuffer() {
    const {
      config: e,
      hls: t,
      media: s,
      nudgeRetry: n
    } = this;
    if (s === null)
      return;
    const r = s.currentTime;
    if (this.nudgeRetry++, n < e.nudgeMaxRetry) {
      const o = r + (n + 1) * e.nudgeOffset, a = new Error(`Nudging 'currentTime' from ${r} to ${o}`);
      D.warn(a.message), s.currentTime = o, t.trigger(T.ERROR, {
        type: Z.MEDIA_ERROR,
        details: C.BUFFER_NUDGE_ON_STALL,
        error: a,
        fatal: !1
      });
    } else {
      const o = new Error(`Playhead still not moving while enough data buffered @${r} after ${e.nudgeMaxRetry} nudges`);
      D.error(o.message), t.trigger(T.ERROR, {
        type: Z.MEDIA_ERROR,
        details: C.BUFFER_STALLED_ERROR,
        error: o,
        fatal: !0
      });
    }
  }
}
const np = 100;
class ip extends ci {
  constructor(e, t, s) {
    super(e, t, s, "[stream-controller]", Q.MAIN), this.audioCodecSwap = !1, this.gapController = null, this.level = -1, this._forceStartLoad = !1, this.altAudio = !1, this.audioOnly = !1, this.fragPlaying = null, this.onvplaying = null, this.onvseeked = null, this.fragLastKbps = 0, this.couldBacktrack = !1, this.backtrackFragment = null, this.audioCodecSwitch = !1, this.videoBuffer = null, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.LEVEL_LOADING, this.onLevelLoading, this), e.on(T.LEVEL_LOADED, this.onLevelLoaded, this), e.on(T.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.on(T.ERROR, this.onError, this), e.on(T.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(T.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.on(T.BUFFER_CREATED, this.onBufferCreated, this), e.on(T.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(T.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.LEVEL_LOADED, this.onLevelLoaded, this), e.off(T.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.off(T.ERROR, this.onError, this), e.off(T.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(T.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.off(T.BUFFER_CREATED, this.onBufferCreated, this), e.off(T.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(T.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  onHandlerDestroying() {
    this._unregisterListeners(), super.onHandlerDestroying();
  }
  startLoad(e) {
    if (this.levels) {
      const {
        lastCurrentTime: t,
        hls: s
      } = this;
      if (this.stopLoad(), this.setInterval(np), this.level = -1, !this.startFragRequested) {
        let n = s.startLevel;
        n === -1 && (s.config.testBandwidth && this.levels.length > 1 ? (n = 0, this.bitrateTest = !0) : n = s.firstAutoLevel), s.nextLoadLevel = n, this.level = s.loadLevel, this.loadedmetadata = !1;
      }
      t > 0 && e === -1 && (this.log(`Override startPosition with lastCurrentTime @${t.toFixed(3)}`), e = t), this.state = k.IDLE, this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
    } else
      this._forceStartLoad = !0, this.state = k.STOPPED;
  }
  stopLoad() {
    this._forceStartLoad = !1, super.stopLoad();
  }
  doTick() {
    switch (this.state) {
      case k.WAITING_LEVEL: {
        const {
          levels: t,
          level: s
        } = this, n = t == null ? void 0 : t[s], r = n == null ? void 0 : n.details;
        if (r && (!r.live || this.levelLastLoaded === n)) {
          if (this.waitForCdnTuneIn(r))
            break;
          this.state = k.IDLE;
          break;
        } else if (this.hls.nextLoadLevel !== this.level) {
          this.state = k.IDLE;
          break;
        }
        break;
      }
      case k.FRAG_LOADING_WAITING_RETRY:
        {
          var e;
          const t = self.performance.now(), s = this.retryDate;
          if (!s || t >= s || (e = this.media) != null && e.seeking) {
            const {
              levels: n,
              level: r
            } = this, o = n == null ? void 0 : n[r];
            this.resetStartWhenNotLoaded(o || null), this.state = k.IDLE;
          }
        }
        break;
    }
    this.state === k.IDLE && this.doTickIdle(), this.onTickEnd();
  }
  onTickEnd() {
    super.onTickEnd(), this.checkBuffer(), this.checkFragmentChanged();
  }
  doTickIdle() {
    const {
      hls: e,
      levelLastLoaded: t,
      levels: s,
      media: n
    } = this;
    if (t === null || !n && (this.startFragRequested || !e.config.startFragPrefetch) || this.altAudio && this.audioOnly)
      return;
    const r = e.nextLoadLevel;
    if (!(s != null && s[r]))
      return;
    const o = s[r], a = this.getMainFwdBufferInfo();
    if (a === null)
      return;
    const l = this.getLevelDetails();
    if (l && this._streamEnded(a, l)) {
      const g = {};
      this.altAudio && (g.type = "video"), this.hls.trigger(T.BUFFER_EOS, g), this.state = k.ENDED;
      return;
    }
    e.loadLevel !== r && e.manualLevel === -1 && this.log(`Adapting to level ${r} from level ${this.level}`), this.level = e.nextLoadLevel = r;
    const c = o.details;
    if (!c || this.state === k.WAITING_LEVEL || c.live && this.levelLastLoaded !== o) {
      this.level = r, this.state = k.WAITING_LEVEL;
      return;
    }
    const u = a.len, d = this.getMaxBufferLength(o.maxBitrate);
    if (u >= d)
      return;
    this.backtrackFragment && this.backtrackFragment.start > a.end && (this.backtrackFragment = null);
    const h = this.backtrackFragment ? this.backtrackFragment.start : a.end;
    let m = this.getNextFragment(h, c);
    if (this.couldBacktrack && !this.fragPrevious && m && m.sn !== "initSegment" && this.fragmentTracker.getState(m) !== Le.OK) {
      var f;
      const p = ((f = this.backtrackFragment) != null ? f : m).sn - c.startSN, E = c.fragments[p - 1];
      E && m.cc === E.cc && (m = E, this.fragmentTracker.removeFragment(E));
    } else this.backtrackFragment && a.len && (this.backtrackFragment = null);
    if (m && this.isLoopLoading(m, h)) {
      if (!m.gap) {
        const p = this.audioOnly && !this.altAudio ? ae.AUDIO : ae.VIDEO, E = (p === ae.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
        E && this.afterBufferFlushed(E, p, Q.MAIN);
      }
      m = this.getNextFragmentLoopLoading(m, c, a, Q.MAIN, d);
    }
    m && (m.initSegment && !m.initSegment.data && !this.bitrateTest && (m = m.initSegment), this.loadFragment(m, o, h));
  }
  loadFragment(e, t, s) {
    const n = this.fragmentTracker.getState(e);
    this.fragCurrent = e, n === Le.NOT_LOADED || n === Le.PARTIAL ? e.sn === "initSegment" ? this._loadInitSegment(e, t) : this.bitrateTest ? (this.log(`Fragment ${e.sn} of level ${e.level} is being downloaded to test bitrate and will not be buffered`), this._loadBitrateTestFrag(e, t)) : (this.startFragRequested = !0, super.loadFragment(e, t, s)) : this.clearTrackerIfNeeded(e);
  }
  getBufferedFrag(e) {
    return this.fragmentTracker.getBufferedFrag(e, Q.MAIN);
  }
  followingBufferedFrag(e) {
    return e ? this.getBufferedFrag(e.end + 0.5) : null;
  }
  /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */
  immediateLevelSwitch() {
    this.abortCurrentFrag(), this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
  }
  /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */
  nextLevelSwitch() {
    const {
      levels: e,
      media: t
    } = this;
    if (t != null && t.readyState) {
      let s;
      const n = this.getAppendedFrag(t.currentTime);
      n && n.start > 1 && this.flushMainBuffer(0, n.start - 1);
      const r = this.getLevelDetails();
      if (r != null && r.live) {
        const a = this.getMainFwdBufferInfo();
        if (!a || a.len < r.targetduration * 2)
          return;
      }
      if (!t.paused && e) {
        const a = this.hls.nextLoadLevel, l = e[a], c = this.fragLastKbps;
        c && this.fragCurrent ? s = this.fragCurrent.duration * l.maxBitrate / (1e3 * c) + 1 : s = 0;
      } else
        s = 0;
      const o = this.getBufferedFrag(t.currentTime + s);
      if (o) {
        const a = this.followingBufferedFrag(o);
        if (a) {
          this.abortCurrentFrag();
          const l = a.maxStartPTS ? a.maxStartPTS : a.start, c = a.duration, u = Math.max(o.end, l + Math.min(Math.max(c - this.config.maxFragLookUpTolerance, c * (this.couldBacktrack ? 0.5 : 0.125)), c * (this.couldBacktrack ? 0.75 : 0.25)));
          this.flushMainBuffer(u, Number.POSITIVE_INFINITY);
        }
      }
    }
  }
  abortCurrentFrag() {
    const e = this.fragCurrent;
    switch (this.fragCurrent = null, this.backtrackFragment = null, e && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.state) {
      case k.KEY_LOADING:
      case k.FRAG_LOADING:
      case k.FRAG_LOADING_WAITING_RETRY:
      case k.PARSING:
      case k.PARSED:
        this.state = k.IDLE;
        break;
    }
    this.nextLoadPosition = this.getLoadPosition();
  }
  flushMainBuffer(e, t) {
    super.flushMainBuffer(e, t, this.altAudio ? "video" : null);
  }
  onMediaAttached(e, t) {
    super.onMediaAttached(e, t);
    const s = t.media;
    this.onvplaying = this.onMediaPlaying.bind(this), this.onvseeked = this.onMediaSeeked.bind(this), s.addEventListener("playing", this.onvplaying), s.addEventListener("seeked", this.onvseeked), this.gapController = new sp(this.config, s, this.fragmentTracker, this.hls);
  }
  onMediaDetaching() {
    const {
      media: e
    } = this;
    e && this.onvplaying && this.onvseeked && (e.removeEventListener("playing", this.onvplaying), e.removeEventListener("seeked", this.onvseeked), this.onvplaying = this.onvseeked = null, this.videoBuffer = null), this.fragPlaying = null, this.gapController && (this.gapController.destroy(), this.gapController = null), super.onMediaDetaching();
  }
  onMediaPlaying() {
    this.tick();
  }
  onMediaSeeked() {
    const e = this.media, t = e ? e.currentTime : null;
    G(t) && this.log(`Media seeked to ${t.toFixed(3)}`);
    const s = this.getMainFwdBufferInfo();
    if (s === null || s.len === 0) {
      this.warn(`Main forward buffer length on "seeked" event ${s ? s.len : "empty"})`);
      return;
    }
    this.tick();
  }
  onManifestLoading() {
    this.log("Trigger BUFFER_RESET"), this.hls.trigger(T.BUFFER_RESET, void 0), this.fragmentTracker.removeAllFragments(), this.couldBacktrack = !1, this.startPosition = this.lastCurrentTime = this.fragLastKbps = 0, this.levels = this.fragPlaying = this.backtrackFragment = this.levelLastLoaded = null, this.altAudio = this.audioOnly = this.startFragRequested = !1;
  }
  onManifestParsed(e, t) {
    let s = !1, n = !1;
    t.levels.forEach((r) => {
      const o = r.audioCodec;
      o && (s = s || o.indexOf("mp4a.40.2") !== -1, n = n || o.indexOf("mp4a.40.5") !== -1);
    }), this.audioCodecSwitch = s && n && !Z0(), this.audioCodecSwitch && this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"), this.levels = t.levels, this.startFragRequested = !1;
  }
  onLevelLoading(e, t) {
    const {
      levels: s
    } = this;
    if (!s || this.state !== k.IDLE)
      return;
    const n = s[t.level];
    (!n.details || n.details.live && this.levelLastLoaded !== n || this.waitForCdnTuneIn(n.details)) && (this.state = k.WAITING_LEVEL);
  }
  onLevelLoaded(e, t) {
    var s;
    const {
      levels: n
    } = this, r = t.level, o = t.details, a = o.totalduration;
    if (!n) {
      this.warn(`Levels were reset while loading level ${r}`);
      return;
    }
    this.log(`Level ${r} loaded [${o.startSN},${o.endSN}]${o.lastPartSn ? `[part-${o.lastPartSn}-${o.lastPartIndex}]` : ""}, cc [${o.startCC}, ${o.endCC}] duration:${a}`);
    const l = n[r], c = this.fragCurrent;
    c && (this.state === k.FRAG_LOADING || this.state === k.FRAG_LOADING_WAITING_RETRY) && c.level !== t.level && c.loader && this.abortCurrentFrag();
    let u = 0;
    if (o.live || (s = l.details) != null && s.live) {
      var d;
      if (this.checkLiveUpdate(o), o.deltaUpdateFailed)
        return;
      u = this.alignPlaylists(o, l.details, (d = this.levelLastLoaded) == null ? void 0 : d.details);
    }
    if (l.details = o, this.levelLastLoaded = l, this.hls.trigger(T.LEVEL_UPDATED, {
      details: o,
      level: r
    }), this.state === k.WAITING_LEVEL) {
      if (this.waitForCdnTuneIn(o))
        return;
      this.state = k.IDLE;
    }
    this.startFragRequested ? o.live && this.synchronizeToLiveEdge(o) : this.setStartPosition(o, u), this.tick();
  }
  _handleFragmentLoadProgress(e) {
    var t;
    const {
      frag: s,
      part: n,
      payload: r
    } = e, {
      levels: o
    } = this;
    if (!o) {
      this.warn(`Levels were reset while fragment load was in progress. Fragment ${s.sn} of level ${s.level} will not be buffered`);
      return;
    }
    const a = o[s.level], l = a.details;
    if (!l) {
      this.warn(`Dropping fragment ${s.sn} of level ${s.level} after level details were reset`), this.fragmentTracker.removeFragment(s);
      return;
    }
    const c = a.videoCodec, u = l.PTSKnown || !l.live, d = (t = s.initSegment) == null ? void 0 : t.data, h = this._getAudioCodec(a), m = this.transmuxer = this.transmuxer || new ha(this.hls, Q.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)), f = n ? n.index : -1, g = f !== -1, p = new ai(s.level, s.sn, s.stats.chunkCount, r.byteLength, f, g), E = this.initPTS[s.cc];
    m.push(r, d, h, c, s, n, l.totalduration, u, p, E);
  }
  onAudioTrackSwitching(e, t) {
    const s = this.altAudio;
    if (!!!t.url) {
      if (this.mediaBuffer !== this.media) {
        this.log("Switching on main audio, use media.buffered to schedule main fragment loading"), this.mediaBuffer = this.media;
        const o = this.fragCurrent;
        o && (this.log("Switching to main audio track, cancel main fragment load"), o.abortRequests(), this.fragmentTracker.removeFragment(o)), this.resetTransmuxer(), this.resetLoadingState();
      } else this.audioOnly && this.resetTransmuxer();
      const r = this.hls;
      s && (r.trigger(T.BUFFER_FLUSHING, {
        startOffset: 0,
        endOffset: Number.POSITIVE_INFINITY,
        type: null
      }), this.fragmentTracker.removeAllFragments()), r.trigger(T.AUDIO_TRACK_SWITCHED, t);
    }
  }
  onAudioTrackSwitched(e, t) {
    const s = t.id, n = !!this.hls.audioTracks[s].url;
    if (n) {
      const r = this.videoBuffer;
      r && this.mediaBuffer !== r && (this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading"), this.mediaBuffer = r);
    }
    this.altAudio = n, this.tick();
  }
  onBufferCreated(e, t) {
    const s = t.tracks;
    let n, r, o = !1;
    for (const a in s) {
      const l = s[a];
      if (l.id === "main") {
        if (r = a, n = l, a === "video") {
          const c = s[a];
          c && (this.videoBuffer = c.buffer);
        }
      } else
        o = !0;
    }
    o && n ? (this.log(`Alternate track found, use ${r}.buffered to schedule main fragment loading`), this.mediaBuffer = n.buffer) : this.mediaBuffer = this.media;
  }
  onFragBuffered(e, t) {
    const {
      frag: s,
      part: n
    } = t;
    if (s && s.type !== Q.MAIN)
      return;
    if (this.fragContextChanged(s)) {
      this.warn(`Fragment ${s.sn}${n ? " p: " + n.index : ""} of level ${s.level} finished buffering, but was aborted. state: ${this.state}`), this.state === k.PARSED && (this.state = k.IDLE);
      return;
    }
    const r = n ? n.stats : s.stats;
    this.fragLastKbps = Math.round(8 * r.total / (r.buffering.end - r.loading.first)), s.sn !== "initSegment" && (this.fragPrevious = s), this.fragBufferedComplete(s, n);
  }
  onError(e, t) {
    var s;
    if (t.fatal) {
      this.state = k.ERROR;
      return;
    }
    switch (t.details) {
      case C.FRAG_GAP:
      case C.FRAG_PARSING_ERROR:
      case C.FRAG_DECRYPT_ERROR:
      case C.FRAG_LOAD_ERROR:
      case C.FRAG_LOAD_TIMEOUT:
      case C.KEY_LOAD_ERROR:
      case C.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(Q.MAIN, t);
        break;
      case C.LEVEL_LOAD_ERROR:
      case C.LEVEL_LOAD_TIMEOUT:
      case C.LEVEL_PARSING_ERROR:
        !t.levelRetry && this.state === k.WAITING_LEVEL && ((s = t.context) == null ? void 0 : s.type) === re.LEVEL && (this.state = k.IDLE);
        break;
      case C.BUFFER_APPEND_ERROR:
      case C.BUFFER_FULL_ERROR:
        if (!t.parent || t.parent !== "main")
          return;
        if (t.details === C.BUFFER_APPEND_ERROR) {
          this.resetLoadingState();
          return;
        }
        this.reduceLengthAndFlushBuffer(t) && this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
        break;
      case C.INTERNAL_EXCEPTION:
        this.recoverWorkerError(t);
        break;
    }
  }
  // Checks the health of the buffer and attempts to resolve playback stalls.
  checkBuffer() {
    const {
      media: e,
      gapController: t
    } = this;
    if (!(!e || !t || !e.readyState)) {
      if (this.loadedmetadata || !de.getBuffered(e).length) {
        const s = this.state !== k.IDLE ? this.fragCurrent : null;
        t.poll(this.lastCurrentTime, s);
      }
      this.lastCurrentTime = e.currentTime;
    }
  }
  onFragLoadEmergencyAborted() {
    this.state = k.IDLE, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.tickImmediate();
  }
  onBufferFlushed(e, {
    type: t
  }) {
    if (t !== ae.AUDIO || this.audioOnly && !this.altAudio) {
      const s = (t === ae.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
      this.afterBufferFlushed(s, t, Q.MAIN), this.tick();
    }
  }
  onLevelsUpdated(e, t) {
    this.level > -1 && this.fragCurrent && (this.level = this.fragCurrent.level), this.levels = t.levels;
  }
  swapAudioCodec() {
    this.audioCodecSwap = !this.audioCodecSwap;
  }
  /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */
  seekToStartPos() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = e.currentTime;
    let s = this.startPosition;
    if (s >= 0 && t < s) {
      if (e.seeking) {
        this.log(`could not seek to ${s}, already seeking at ${t}`);
        return;
      }
      const n = de.getBuffered(e), o = (n.length ? n.start(0) : 0) - s;
      o > 0 && (o < this.config.maxBufferHole || o < this.config.maxFragLookUpTolerance) && (this.log(`adjusting start position by ${o} to match buffer start`), s += o, this.startPosition = s), this.log(`seek to target start position ${s} from current time ${t}`), e.currentTime = s;
    }
  }
  _getAudioCodec(e) {
    let t = this.config.defaultAudioCodec || e.audioCodec;
    return this.audioCodecSwap && t && (this.log("Swapping audio codec"), t.indexOf("mp4a.40.5") !== -1 ? t = "mp4a.40.2" : t = "mp4a.40.5"), t;
  }
  _loadBitrateTestFrag(e, t) {
    e.bitrateTest = !0, this._doFragLoad(e, t).then((s) => {
      const {
        hls: n
      } = this;
      if (!s || this.fragContextChanged(e))
        return;
      t.fragmentError = 0, this.state = k.IDLE, this.startFragRequested = !1, this.bitrateTest = !1;
      const r = e.stats;
      r.parsing.start = r.parsing.end = r.buffering.start = r.buffering.end = self.performance.now(), n.trigger(T.FRAG_LOADED, s), e.bitrateTest = !1;
    });
  }
  _handleTransmuxComplete(e) {
    var t;
    const s = "main", {
      hls: n
    } = this, {
      remuxResult: r,
      chunkMeta: o
    } = e, a = this.getCurrentContext(o);
    if (!a) {
      this.resetWhenMissingContext(o);
      return;
    }
    const {
      frag: l,
      part: c,
      level: u
    } = a, {
      video: d,
      text: h,
      id3: m,
      initSegment: f
    } = r, {
      details: g
    } = u, p = this.altAudio ? void 0 : r.audio;
    if (this.fragContextChanged(l)) {
      this.fragmentTracker.removeFragment(l);
      return;
    }
    if (this.state = k.PARSING, f) {
      if (f != null && f.tracks) {
        const v = l.initSegment || l;
        this._bufferInitSegment(u, f.tracks, v, o), n.trigger(T.FRAG_PARSING_INIT_SEGMENT, {
          frag: v,
          id: s,
          tracks: f.tracks
        });
      }
      const E = f.initPTS, y = f.timescale;
      G(E) && (this.initPTS[l.cc] = {
        baseTime: E,
        timescale: y
      }, n.trigger(T.INIT_PTS_FOUND, {
        frag: l,
        id: s,
        initPTS: E,
        timescale: y
      }));
    }
    if (d && g && l.sn !== "initSegment") {
      const E = g.fragments[l.sn - 1 - g.startSN], y = l.sn === g.startSN, v = !E || l.cc > E.cc;
      if (r.independent !== !1) {
        const {
          startPTS: S,
          endPTS: x,
          startDTS: R,
          endDTS: L
        } = d;
        if (c)
          c.elementaryStreams[d.type] = {
            startPTS: S,
            endPTS: x,
            startDTS: R,
            endDTS: L
          };
        else if (d.firstKeyFrame && d.independent && o.id === 1 && !v && (this.couldBacktrack = !0), d.dropped && d.independent) {
          const _ = this.getMainFwdBufferInfo(), A = (_ ? _.end : this.getLoadPosition()) + this.config.maxBufferHole, I = d.firstKeyFramePTS ? d.firstKeyFramePTS : S;
          if (!y && A < I - this.config.maxBufferHole && !v) {
            this.backtrack(l);
            return;
          } else v && (l.gap = !0);
          l.setElementaryStreamInfo(d.type, l.start, x, l.start, L, !0);
        } else y && S > Os && (l.gap = !0);
        l.setElementaryStreamInfo(d.type, S, x, R, L), this.backtrackFragment && (this.backtrackFragment = l), this.bufferFragmentData(d, l, c, o, y || v);
      } else if (y || v)
        l.gap = !0;
      else {
        this.backtrack(l);
        return;
      }
    }
    if (p) {
      const {
        startPTS: E,
        endPTS: y,
        startDTS: v,
        endDTS: S
      } = p;
      c && (c.elementaryStreams[ae.AUDIO] = {
        startPTS: E,
        endPTS: y,
        startDTS: v,
        endDTS: S
      }), l.setElementaryStreamInfo(ae.AUDIO, E, y, v, S), this.bufferFragmentData(p, l, c, o);
    }
    if (g && m != null && (t = m.samples) != null && t.length) {
      const E = {
        id: s,
        frag: l,
        details: g,
        samples: m.samples
      };
      n.trigger(T.FRAG_PARSING_METADATA, E);
    }
    if (g && h) {
      const E = {
        id: s,
        frag: l,
        details: g,
        samples: h.samples
      };
      n.trigger(T.FRAG_PARSING_USERDATA, E);
    }
  }
  _bufferInitSegment(e, t, s, n) {
    if (this.state !== k.PARSING)
      return;
    this.audioOnly = !!t.audio && !t.video, this.altAudio && !this.audioOnly && delete t.audio;
    const {
      audio: r,
      video: o,
      audiovideo: a
    } = t;
    if (r) {
      let l = e.audioCodec;
      const c = navigator.userAgent.toLowerCase();
      if (this.audioCodecSwitch) {
        l && (l.indexOf("mp4a.40.5") !== -1 ? l = "mp4a.40.2" : l = "mp4a.40.5");
        const u = r.metadata;
        u && "channelCount" in u && (u.channelCount || 1) !== 1 && c.indexOf("firefox") === -1 && (l = "mp4a.40.5");
      }
      l && l.indexOf("mp4a.40.5") !== -1 && c.indexOf("android") !== -1 && r.container !== "audio/mpeg" && (l = "mp4a.40.2", this.log(`Android: force audio codec to ${l}`)), e.audioCodec && e.audioCodec !== l && this.log(`Swapping manifest audio codec "${e.audioCodec}" for "${l}"`), r.levelCodec = l, r.id = "main", this.log(`Init audio buffer, container:${r.container}, codecs[selected/level/parsed]=[${l || ""}/${e.audioCodec || ""}/${r.codec}]`);
    }
    o && (o.levelCodec = e.videoCodec, o.id = "main", this.log(`Init video buffer, container:${o.container}, codecs[level/parsed]=[${e.videoCodec || ""}/${o.codec}]`)), a && this.log(`Init audiovideo buffer, container:${a.container}, codecs[level/parsed]=[${e.codecs}/${a.codec}]`), this.hls.trigger(T.BUFFER_CODECS, t), Object.keys(t).forEach((l) => {
      const u = t[l].initSegment;
      u != null && u.byteLength && this.hls.trigger(T.BUFFER_APPENDING, {
        type: l,
        data: u,
        frag: s,
        part: null,
        chunkMeta: n,
        parent: s.type
      });
    }), this.tickImmediate();
  }
  getMainFwdBufferInfo() {
    return this.getFwdBufferInfo(this.mediaBuffer ? this.mediaBuffer : this.media, Q.MAIN);
  }
  backtrack(e) {
    this.couldBacktrack = !0, this.backtrackFragment = e, this.resetTransmuxer(), this.flushBufferGap(e), this.fragmentTracker.removeFragment(e), this.fragPrevious = null, this.nextLoadPosition = e.start, this.state = k.IDLE;
  }
  checkFragmentChanged() {
    const e = this.media;
    let t = null;
    if (e && e.readyState > 1 && e.seeking === !1) {
      const s = e.currentTime;
      if (de.isBuffered(e, s) ? t = this.getAppendedFrag(s) : de.isBuffered(e, s + 0.1) && (t = this.getAppendedFrag(s + 0.1)), t) {
        this.backtrackFragment = null;
        const n = this.fragPlaying, r = t.level;
        (!n || t.sn !== n.sn || n.level !== r) && (this.fragPlaying = t, this.hls.trigger(T.FRAG_CHANGED, {
          frag: t
        }), (!n || n.level !== r) && this.hls.trigger(T.LEVEL_SWITCHED, {
          level: r
        }));
      }
    }
  }
  get nextLevel() {
    const e = this.nextBufferedFrag;
    return e ? e.level : -1;
  }
  get currentFrag() {
    const e = this.media;
    return e ? this.fragPlaying || this.getAppendedFrag(e.currentTime) : null;
  }
  get currentProgramDateTime() {
    const e = this.media;
    if (e) {
      const t = e.currentTime, s = this.currentFrag;
      if (s && G(t) && G(s.programDateTime)) {
        const n = s.programDateTime + (t - s.start) * 1e3;
        return new Date(n);
      }
    }
    return null;
  }
  get currentLevel() {
    const e = this.currentFrag;
    return e ? e.level : -1;
  }
  get nextBufferedFrag() {
    const e = this.currentFrag;
    return e ? this.followingBufferedFrag(e) : null;
  }
  get forceStartLoad() {
    return this._forceStartLoad;
  }
}
class ye {
  /**
   * Get the video-dev/hls.js package version.
   */
  static get version() {
    return "1.5.13";
  }
  /**
   * Check if the required MediaSource Extensions are available.
   */
  static isMSESupported() {
    return Ma();
  }
  /**
   * Check if MediaSource Extensions are available and isTypeSupported checks pass for any baseline codecs.
   */
  static isSupported() {
    return Q0();
  }
  /**
   * Get the MediaSource global used for MSE playback (ManagedMediaSource, MediaSource, or WebKitMediaSource).
   */
  static getMediaSource() {
    return Lt();
  }
  static get Events() {
    return T;
  }
  static get ErrorTypes() {
    return Z;
  }
  static get ErrorDetails() {
    return C;
  }
  /**
   * Get the default configuration applied to new instances.
   */
  static get DefaultConfig() {
    return ye.defaultConfig ? ye.defaultConfig : Ca;
  }
  /**
   * Replace the default configuration applied to new instances.
   */
  static set DefaultConfig(e) {
    ye.defaultConfig = e;
  }
  /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */
  constructor(e = {}) {
    this.config = void 0, this.userConfig = void 0, this.coreComponents = void 0, this.networkControllers = void 0, this.started = !1, this._emitter = new mi(), this._autoLevelCapping = -1, this._maxHdcpLevel = null, this.abrController = void 0, this.bufferController = void 0, this.capLevelController = void 0, this.latencyController = void 0, this.levelController = void 0, this.streamController = void 0, this.audioTrackController = void 0, this.subtitleTrackController = void 0, this.emeController = void 0, this.cmcdController = void 0, this._media = null, this.url = null, this.triggeringException = void 0, Wh(e.debug || !1, "Hls instance");
    const t = this.config = q0(ye.DefaultConfig, e);
    this.userConfig = e, t.progressive && z0(t);
    const {
      abrController: s,
      bufferController: n,
      capLevelController: r,
      errorController: o,
      fpsController: a
    } = t, l = new o(this), c = this.abrController = new s(this), u = this.bufferController = new n(this), d = this.capLevelController = new r(this), h = new a(this), m = new $f(this), f = new Wf(this), g = t.contentSteeringController, p = g ? new g(this) : null, E = this.levelController = new j0(this, p), y = new xm(this), v = new X0(this.config), S = this.streamController = new ip(this, y, v);
    d.setStreamController(S), h.setStreamController(S);
    const x = [m, E, S];
    p && x.splice(1, 0, p), this.networkControllers = x;
    const R = [c, u, d, h, f, y];
    this.audioTrackController = this.createController(t.audioTrackController, x);
    const L = t.audioStreamController;
    L && x.push(new L(this, y, v)), this.subtitleTrackController = this.createController(t.subtitleTrackController, x);
    const _ = t.subtitleStreamController;
    _ && x.push(new _(this, y, v)), this.createController(t.timelineController, R), v.emeController = this.emeController = this.createController(t.emeController, R), this.cmcdController = this.createController(t.cmcdController, R), this.latencyController = this.createController(Yf, R), this.coreComponents = R, x.push(l);
    const A = l.onErrorOut;
    typeof A == "function" && this.on(T.ERROR, A, l);
  }
  createController(e, t) {
    if (e) {
      const s = new e(this);
      return t && t.push(s), s;
    }
    return null;
  }
  // Delegate the EventEmitter through the public API of Hls.js
  on(e, t, s = this) {
    this._emitter.on(e, t, s);
  }
  once(e, t, s = this) {
    this._emitter.once(e, t, s);
  }
  removeAllListeners(e) {
    this._emitter.removeAllListeners(e);
  }
  off(e, t, s = this, n) {
    this._emitter.off(e, t, s, n);
  }
  listeners(e) {
    return this._emitter.listeners(e);
  }
  emit(e, t, s) {
    return this._emitter.emit(e, t, s);
  }
  trigger(e, t) {
    if (this.config.debug)
      return this.emit(e, e, t);
    try {
      return this.emit(e, e, t);
    } catch (s) {
      if (D.error("An internal error happened while handling event " + e + '. Error message: "' + s.message + '". Here is a stacktrace:', s), !this.triggeringException) {
        this.triggeringException = !0;
        const n = e === T.ERROR;
        this.trigger(T.ERROR, {
          type: Z.OTHER_ERROR,
          details: C.INTERNAL_EXCEPTION,
          fatal: n,
          event: e,
          error: s
        }), this.triggeringException = !1;
      }
    }
    return !1;
  }
  listenerCount(e) {
    return this._emitter.listenerCount(e);
  }
  /**
   * Dispose of the instance
   */
  destroy() {
    D.log("destroy"), this.trigger(T.DESTROYING, void 0), this.detachMedia(), this.removeAllListeners(), this._autoLevelCapping = -1, this.url = null, this.networkControllers.forEach((t) => t.destroy()), this.networkControllers.length = 0, this.coreComponents.forEach((t) => t.destroy()), this.coreComponents.length = 0;
    const e = this.config;
    e.xhrSetup = e.fetchSetup = void 0, this.userConfig = null;
  }
  /**
   * Attaches Hls.js to a media element
   */
  attachMedia(e) {
    D.log("attachMedia"), this._media = e, this.trigger(T.MEDIA_ATTACHING, {
      media: e
    });
  }
  /**
   * Detach Hls.js from the media
   */
  detachMedia() {
    D.log("detachMedia"), this.trigger(T.MEDIA_DETACHING, void 0), this._media = null;
  }
  /**
   * Set the source URL. Can be relative or absolute.
   */
  loadSource(e) {
    this.stopLoad();
    const t = this.media, s = this.url, n = this.url = ti.buildAbsoluteURL(self.location.href, e, {
      alwaysNormalize: !0
    });
    this._autoLevelCapping = -1, this._maxHdcpLevel = null, D.log(`loadSource:${n}`), t && s && (s !== n || this.bufferController.hasSourceTypes()) && (this.detachMedia(), this.attachMedia(t)), this.trigger(T.MANIFEST_LOADING, {
      url: e
    });
  }
  /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */
  startLoad(e = -1) {
    D.log(`startLoad(${e})`), this.started = !0, this.networkControllers.forEach((t) => {
      t.startLoad(e);
    });
  }
  /**
   * Stop loading of any stream data.
   */
  stopLoad() {
    D.log("stopLoad"), this.started = !1, this.networkControllers.forEach((e) => {
      e.stopLoad();
    });
  }
  /**
   * Resumes stream controller segment loading if previously started.
   */
  resumeBuffering() {
    this.started && this.networkControllers.forEach((e) => {
      "fragmentLoader" in e && e.startLoad(-1);
    });
  }
  /**
   * Stops stream controller segment loading without changing 'started' state like stopLoad().
   * This allows for media buffering to be paused without interupting playlist loading.
   */
  pauseBuffering() {
    this.networkControllers.forEach((e) => {
      "fragmentLoader" in e && e.stopLoad();
    });
  }
  /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */
  swapAudioCodec() {
    D.log("swapAudioCodec"), this.streamController.swapAudioCodec();
  }
  /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */
  recoverMediaError() {
    D.log("recoverMediaError");
    const e = this._media;
    this.detachMedia(), e && this.attachMedia(e);
  }
  removeLevel(e) {
    this.levelController.removeLevel(e);
  }
  /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, RESOLUTION (height), FRAME-RATE, CODECS, VIDEO-RANGE, and BANDWIDTH
   */
  get levels() {
    const e = this.levelController.levels;
    return e || [];
  }
  /**
   * Index of quality level (variant) currently played
   */
  get currentLevel() {
    return this.streamController.currentLevel;
  }
  /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */
  set currentLevel(e) {
    D.log(`set currentLevel:${e}`), this.levelController.manualLevel = e, this.streamController.immediateLevelSwitch();
  }
  /**
   * Index of next quality level loaded as scheduled by stream controller.
   */
  get nextLevel() {
    return this.streamController.nextLevel;
  }
  /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */
  set nextLevel(e) {
    D.log(`set nextLevel:${e}`), this.levelController.manualLevel = e, this.streamController.nextLevelSwitch();
  }
  /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */
  get loadLevel() {
    return this.levelController.level;
  }
  /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */
  set loadLevel(e) {
    D.log(`set loadLevel:${e}`), this.levelController.manualLevel = e;
  }
  /**
   * get next quality level loaded
   */
  get nextLoadLevel() {
    return this.levelController.nextLoadLevel;
  }
  /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */
  set nextLoadLevel(e) {
    this.levelController.nextLoadLevel = e;
  }
  /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */
  get firstLevel() {
    return Math.max(this.levelController.firstLevel, this.minAutoLevel);
  }
  /**
   * Sets "first-level", see getter.
   */
  set firstLevel(e) {
    D.log(`set firstLevel:${e}`), this.levelController.firstLevel = e;
  }
  /**
   * Return the desired start level for the first fragment that will be loaded.
   * The default value of -1 indicates automatic start level selection.
   * Setting hls.nextAutoLevel without setting a startLevel will result in
   * the nextAutoLevel value being used for one fragment load.
   */
  get startLevel() {
    const e = this.levelController.startLevel;
    return e === -1 && this.abrController.forcedAutoLevel > -1 ? this.abrController.forcedAutoLevel : e;
  }
  /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */
  set startLevel(e) {
    D.log(`set startLevel:${e}`), e !== -1 && (e = Math.max(e, this.minAutoLevel)), this.levelController.startLevel = e;
  }
  /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */
  get capLevelToPlayerSize() {
    return this.config.capLevelToPlayerSize;
  }
  /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */
  set capLevelToPlayerSize(e) {
    const t = !!e;
    t !== this.config.capLevelToPlayerSize && (t ? this.capLevelController.startCapping() : (this.capLevelController.stopCapping(), this.autoLevelCapping = -1, this.streamController.nextLevelSwitch()), this.config.capLevelToPlayerSize = t);
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  get autoLevelCapping() {
    return this._autoLevelCapping;
  }
  /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */
  get bandwidthEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimate() : NaN;
  }
  set bandwidthEstimate(e) {
    this.abrController.resetEstimator(e);
  }
  /**
   * get time to first byte estimate
   * @type {number}
   */
  get ttfbEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimateTTFB() : NaN;
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  set autoLevelCapping(e) {
    this._autoLevelCapping !== e && (D.log(`set autoLevelCapping:${e}`), this._autoLevelCapping = e, this.levelController.checkMaxAutoUpdated());
  }
  get maxHdcpLevel() {
    return this._maxHdcpLevel;
  }
  set maxHdcpLevel(e) {
    qf(e) && this._maxHdcpLevel !== e && (this._maxHdcpLevel = e, this.levelController.checkMaxAutoUpdated());
  }
  /**
   * True when automatic level selection enabled
   */
  get autoLevelEnabled() {
    return this.levelController.manualLevel === -1;
  }
  /**
   * Level set manually (if any)
   */
  get manualLevel() {
    return this.levelController.manualLevel;
  }
  /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */
  get minAutoLevel() {
    const {
      levels: e,
      config: {
        minAutoBitrate: t
      }
    } = this;
    if (!e) return 0;
    const s = e.length;
    for (let n = 0; n < s; n++)
      if (e[n].maxBitrate >= t)
        return n;
    return 0;
  }
  /**
   * max level selectable in auto mode according to autoLevelCapping
   */
  get maxAutoLevel() {
    const {
      levels: e,
      autoLevelCapping: t,
      maxHdcpLevel: s
    } = this;
    let n;
    if (t === -1 && e != null && e.length ? n = e.length - 1 : n = t, s)
      for (let r = n; r--; ) {
        const o = e[r].attrs["HDCP-LEVEL"];
        if (o && o <= s)
          return r;
      }
    return n;
  }
  get firstAutoLevel() {
    return this.abrController.firstAutoLevel;
  }
  /**
   * next automatically selected quality level
   */
  get nextAutoLevel() {
    return this.abrController.nextAutoLevel;
  }
  /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */
  set nextAutoLevel(e) {
    this.abrController.nextAutoLevel = e;
  }
  /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */
  get playingDate() {
    return this.streamController.currentProgramDateTime;
  }
  get mainForwardBufferInfo() {
    return this.streamController.getMainFwdBufferInfo();
  }
  /**
   * Find and select the best matching audio track, making a level switch when a Group change is necessary.
   * Updates `hls.config.audioPreference`. Returns the selected track, or null when no matching track is found.
   */
  setAudioOption(e) {
    var t;
    return (t = this.audioTrackController) == null ? void 0 : t.setAudioOption(e);
  }
  /**
   * Find and select the best matching subtitle track, making a level switch when a Group change is necessary.
   * Updates `hls.config.subtitlePreference`. Returns the selected track, or null when no matching track is found.
   */
  setSubtitleOption(e) {
    var t;
    return (t = this.subtitleTrackController) == null || t.setSubtitleOption(e), null;
  }
  /**
   * Get the complete list of audio tracks across all media groups
   */
  get allAudioTracks() {
    const e = this.audioTrackController;
    return e ? e.allAudioTracks : [];
  }
  /**
   * Get the list of selectable audio tracks
   */
  get audioTracks() {
    const e = this.audioTrackController;
    return e ? e.audioTracks : [];
  }
  /**
   * index of the selected audio track (index in audio track lists)
   */
  get audioTrack() {
    const e = this.audioTrackController;
    return e ? e.audioTrack : -1;
  }
  /**
   * selects an audio track, based on its index in audio track lists
   */
  set audioTrack(e) {
    const t = this.audioTrackController;
    t && (t.audioTrack = e);
  }
  /**
   * get the complete list of subtitle tracks across all media groups
   */
  get allSubtitleTracks() {
    const e = this.subtitleTrackController;
    return e ? e.allSubtitleTracks : [];
  }
  /**
   * get alternate subtitle tracks list from playlist
   */
  get subtitleTracks() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTracks : [];
  }
  /**
   * index of the selected subtitle track (index in subtitle track lists)
   */
  get subtitleTrack() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTrack : -1;
  }
  get media() {
    return this._media;
  }
  /**
   * select an subtitle track, based on its index in subtitle track lists
   */
  set subtitleTrack(e) {
    const t = this.subtitleTrackController;
    t && (t.subtitleTrack = e);
  }
  /**
   * Whether subtitle display is enabled or not
   */
  get subtitleDisplay() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleDisplay : !1;
  }
  /**
   * Enable/disable subtitle display rendering
   */
  set subtitleDisplay(e) {
    const t = this.subtitleTrackController;
    t && (t.subtitleDisplay = e);
  }
  /**
   * get mode for Low-Latency HLS loading
   */
  get lowLatencyMode() {
    return this.config.lowLatencyMode;
  }
  /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */
  set lowLatencyMode(e) {
    this.config.lowLatencyMode = e;
  }
  /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */
  get liveSyncPosition() {
    return this.latencyController.liveSyncPosition;
  }
  /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */
  get latency() {
    return this.latencyController.latency;
  }
  /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */
  get maxLatency() {
    return this.latencyController.maxLatency;
  }
  /**
   * target distance from the edge as calculated by the latency controller
   */
  get targetLatency() {
    return this.latencyController.targetLatency;
  }
  /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */
  get drift() {
    return this.latencyController.drift;
  }
  /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */
  get forceStartLoad() {
    return this.streamController.forceStartLoad;
  }
}
ye.defaultConfig = void 0;
function ka({
  liveTimeMs: i,
  playbackStartTimeMs: e,
  video: t
}) {
  return !t || !Number.isFinite(t.currentTime) ? null : e == null ? i != null ? i : Date.now() : e + Math.round(t.currentTime * 1e3);
}
function rp({
  playlistDurationSec: i,
  value: e
}) {
  return e == null || !Number.isFinite(e) ? null : Fa({
    playlistDurationSec: i,
    value: e
  });
}
function Fa({
  playlistDurationSec: i,
  value: e
}) {
  return Number.isFinite(e) ? Math.min(Math.max(e, 0), Math.max(i - 1, 0)) : 0;
}
function op(i, e, t) {
  return Number.isFinite(i) ? Math.min(Math.max(i, e), t) : e;
}
const ap = {
  backBufferLength: 2,
  liveBackBufferLength: 2,
  maxBufferLength: 8,
  maxBufferSize: 20 * 1e3 * 1e3,
  maxMaxBufferLength: 12,
  startFragPrefetch: !1,
  testBandwidth: !1
}, lp = /* @__PURE__ */ new Set([
  ye.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
  ye.ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,
  ye.ErrorDetails.BUFFER_ADD_CODEC_ERROR
]);
function cp({
  desiredPlayingRef: i,
  hlsNotSupportedMessageRef: e,
  hlsPlaybackErrorMessageRef: t,
  hlsUrl: s,
  pendingSeekSecRef: n,
  pendingSeekShouldPlayRef: r,
  playbackKey: o,
  playbackMode: a,
  playlistDurationSec: l,
  setError: c,
  setPaused: u,
  sourceBlocked: d,
  sourceReady: h,
  videoRef: m
}) {
  se(() => {
    const f = m.current;
    if (!f)
      return;
    if (c(null), f.controls = !1, f.muted = !0, f.playsInline = !0, !h || d) {
      to(f), u(!0);
      return;
    }
    let g = null, p = null;
    const E = rp({
      playlistDurationSec: l,
      value: n.current
    }), y = a === "archive" && E != null, v = () => {
      !i.current && !r.current || f.play().then(() => {
        r.current = !1, u(!1);
      }).catch(() => {
        u(!0);
      });
    }, S = () => {
      const R = n.current;
      if (R == null || !Number.isFinite(R)) {
        v();
        return;
      }
      try {
        const L = Fa({
          playlistDurationSec: l,
          value: R
        });
        f.currentTime = L, n.current = null, v();
      } catch {
      }
    }, x = (R) => {
      g == null || g.stopLoad(), f.pause(), u(!0), c(R);
    };
    if (ye.isSupported()) {
      g = new ye({
        ...ap,
        autoStartLoad: !y,
        lowLatencyMode: !1,
        startPosition: E != null ? E : -1
      });
      const R = (_, A) => {
        if (Pa(A)) {
          x(wn(A, t.current));
          return;
        }
        if (A.fatal) {
          if (A.type === ye.ErrorTypes.NETWORK_ERROR) {
            g == null || g.startLoad(E != null ? E : -1);
            return;
          }
          if (A.type === ye.ErrorTypes.MEDIA_ERROR) {
            if (up(A)) {
              x(wn(A, t.current));
              return;
            }
            g == null || g.recoverMediaError();
            return;
          }
          x(wn(A, t.current));
        }
      }, L = () => {
        S(), y && (g == null || g.startLoad(E));
      };
      g.on(ye.Events.ERROR, R), g.loadSource(s), g.attachMedia(f), g.on(ye.Events.MANIFEST_PARSED, L), p = () => {
        g == null || g.off(ye.Events.ERROR, R), g == null || g.off(ye.Events.MANIFEST_PARSED, L);
      };
    } else f.canPlayType("application/vnd.apple.mpegurl") ? f.src = s : c({
      kind: "unsupported-browser",
      message: e.current,
      recoverable: !1
    });
    return f.addEventListener("loadedmetadata", S), f.addEventListener("canplay", S), n.current == null && v(), () => {
      f.removeEventListener("loadedmetadata", S), f.removeEventListener("canplay", S), p == null || p(), g == null || g.destroy(), to(f);
    };
  }, [
    i,
    e,
    t,
    s,
    n,
    r,
    o,
    a,
    l,
    c,
    u,
    d,
    h,
    m
  ]);
}
function to(i) {
  i.pause(), i.removeAttribute("src"), i.load();
}
function up(i) {
  return lp.has(i.details);
}
function wn(i, e) {
  var s, n;
  const t = (n = (s = i.error) == null ? void 0 : s.message) != null ? n : i.reason;
  return {
    details: i.details,
    fatal: i.fatal,
    hlsType: i.type,
    kind: dp(i),
    message: e,
    ...t ? { reason: t } : {},
    recoverable: !1
  };
}
function dp(i) {
  return Pa(i) ? "unsupported-codec" : i.type === ye.ErrorTypes.NETWORK_ERROR ? "network" : i.type === ye.ErrorTypes.MEDIA_ERROR ? "media" : "hls";
}
function Pa(i) {
  var e, t, s;
  return i.details !== ye.ErrorDetails.FRAG_PARSING_ERROR ? !1 : /Unsupported .+ in M2TS found/i.test((s = (t = (e = i.error) == null ? void 0 : e.message) != null ? t : i.reason) != null ? s : "");
}
const hp = 300, so = 250, fp = 1e4;
function mp({
  controlledRevision: i,
  controlledTimeMs: e,
  effectiveMissingArchiveTimeMs: t,
  getLivePlaybackTimeMs: s,
  isPlaybackControlled: n,
  onPlaybackBoundsEnd: r,
  onPlaybackTimeChange: o,
  paused: a,
  playbackBounds: l,
  playbackMode: c,
  playbackStartTimeMs: u,
  playbackStartTimeMsRef: d,
  setCurrentTimeMs: h,
  setLiveEdgeMs: m,
  streamUnavailable: f,
  videoRef: g
}) {
  const p = oe(i), E = oe(null);
  se(() => {
    d.current = u;
  }, [u, d]), se(() => {
    const v = p.current;
    n && i != null && v != null && i !== v && (E.current = null), (!n || e == null) && (E.current = null), p.current = i;
  }, [i, e, n]);
  const y = Y(() => {
    if (f || t != null)
      return;
    const v = g.current, S = ka({
      liveTimeMs: s(),
      playbackStartTimeMs: d.current,
      video: v
    });
    if (S == null)
      return;
    if (n && e != null) {
      let R = E.current;
      if ((R == null ? void 0 : R.revision) !== i) {
        const I = S - e;
        if (I < -so || I > fp)
          return;
        R = {
          rawTimeMs: S,
          revision: i,
          targetTimeMs: e
        }, E.current = R;
      }
      const L = R.targetTimeMs + Math.max(0, S - R.rawTimeMs), _ = L - e;
      if (_ < 0)
        return;
      if (_ < so) {
        h(e);
        return;
      }
      const A = no({
        playbackBounds: l,
        playbackMode: c,
        timeMs: L
      });
      if (A != null) {
        h(A), o == null || o(A, c), r == null || r(A);
        return;
      }
      h(L), o == null || o(L, c);
      return;
    }
    const x = no({
      playbackBounds: l,
      playbackMode: c,
      timeMs: S
    });
    if (x != null) {
      h(x), o == null || o(x, c), r == null || r(x);
      return;
    }
    h(S), o == null || o(S, c), d.current == null && m(
      (R) => R == null ? S : Math.max(R, S)
    );
  }, [
    e,
    i,
    t,
    s,
    n,
    r,
    o,
    l,
    c,
    d,
    h,
    m,
    f,
    g
  ]);
  return se(() => {
    if (a || f || t != null)
      return;
    const v = setInterval(y, hp);
    return () => {
      clearInterval(v);
    };
  }, [t, a, f, y]), {
    updateCurrentTime: y
  };
}
function no({
  playbackBounds: i,
  playbackMode: e,
  timeMs: t
}) {
  return e === "archive" && (i == null ? void 0 : i.locked) === !0 && t >= i.endMs ? i.endMs : null;
}
function gp({
  desiredPlayingRef: i,
  initialPlaybackState: e,
  pendingSeekSecRef: t,
  pendingSeekShouldPlayRef: s,
  playbackState: n,
  setCurrentTimeMs: r
}) {
  var d;
  const o = oe(null), a = oe(n != null), l = (d = n == null ? void 0 : n.timeMs) != null ? d : null, [c, u] = ie(
    () => io({
      initialPlaybackState: e,
      playbackState: n
    })
  );
  return lo(() => {
    var m, f;
    if (!n) {
      const g = a.current;
      if (a.current = !1, o.current = null, g) {
        const p = io({
          initialPlaybackState: e,
          playbackState: void 0
        });
        t.current = p.mode === "archive" ? 0 : null, s.current = i.current, r(
          p.mode === "archive" ? p.playbackStartTimeMs : (m = e == null ? void 0 : e.timeMs) != null ? m : Date.now()
        ), u((E) => pp(p, E.key + 1));
      }
      return;
    }
    if (a.current = !0, o.current === n.revision)
      return;
    o.current = n.revision;
    const h = Oa(n);
    t.current = h.mode === "archive" ? 0 : null, s.current = i.current, r(
      h.mode === "archive" ? h.playbackStartTimeMs : (f = n.timeMs) != null ? f : Date.now()
    ), u(h);
  }, [
    i,
    e,
    t,
    s,
    n,
    r
  ]), se(() => {
    l != null && r(l);
  }, [l, r]), {
    isPlaybackControlled: n != null,
    localPlaybackState: c,
    playbackKey: c.key,
    playbackMode: c.mode,
    playbackStartTimeMs: c.playbackStartTimeMs,
    setLocalPlaybackState: u
  };
}
function pp(i, e) {
  return {
    ...i,
    key: e
  };
}
function Oa(i) {
  var e;
  return (i == null ? void 0 : i.mode) === "archive" && i.timeMs != null ? {
    mode: "archive",
    playbackStartTimeMs: i.timeMs,
    key: i.revision
  } : {
    mode: "live",
    playbackStartTimeMs: null,
    key: (e = i == null ? void 0 : i.revision) != null ? e : 0
  };
}
function io({
  initialPlaybackState: i,
  playbackState: e
}) {
  return e ? Oa(e) : (i == null ? void 0 : i.mode) === "archive" && i.timeMs != null ? {
    mode: "archive",
    playbackStartTimeMs: i.timeMs,
    key: 0
  } : {
    mode: "live",
    playbackStartTimeMs: null,
    key: 0
  };
}
function Tp({
  controlsMode: i,
  error: e,
  missingArchiveTimeMs: t,
  onControlsModeChange: s,
  paused: n,
  playerRootRef: r,
  streamUnavailable: o
}) {
  const [a, l] = ie(!1), [c, u] = ie(!1), [d, h] = ie(i != null ? i : "auto"), m = i != null ? i : d, f = Y(
    (_) => {
      h((A) => {
        const I = i != null ? i : A, w = typeof _ == "function" ? _(I) : _;
        return s == null || s(w), w;
      });
    },
    [s, i]
  ), g = Te(
    () => !o && (m === "pinned" || m === "auto" && (a || c || n || e != null || t != null)),
    [c, a, m, e, t, n, o]
  ), p = Y(() => {
    var A;
    u(!1);
    const _ = document.activeElement;
    _ instanceof HTMLElement && ((A = r.current) != null && A.contains(_)) && _.blur();
  }, [r]), E = Y(() => {
    p(), f("hidden");
  }, [p, f]), y = Y(() => {
    p(), f("auto");
  }, [p, f]), v = Y(() => {
    f((_) => _ === "pinned" ? (p(), "auto") : "pinned");
  }, [p, f]), S = Y((_) => {
    _.currentTarget.contains(_.relatedTarget) || u(!1);
  }, []), x = Y(() => {
    u(!0);
  }, []), R = Y((_) => {
    l(!0);
  }, []), L = Y((_) => {
    l(!1);
  }, []);
  return {
    clearControlsFocus: p,
    controlsMode: m,
    controlsVisible: g,
    handleBlurCapture: S,
    handleFocusCapture: x,
    handlePointerEnter: R,
    handlePointerLeave: L,
    hideControls: E,
    showControls: y,
    togglePinControls: v
  };
}
function Ep({
  archiveRanges: i,
  archiveRangesLoading: e,
  canSeekArchive: t,
  desiredPlayingRef: s,
  dvrWindow: n,
  isPlaybackControlled: r,
  liveAvailable: o,
  onLiveModeRequest: a,
  onPlaybackTimeChange: l,
  onTimelineSeek: c,
  pendingSeekSecRef: u,
  pendingSeekShouldPlayRef: d,
  playbackMode: h,
  playbackStartTimeMsRef: m,
  playlistDurationSec: f,
  getLivePlaybackTimeMs: g,
  setCurrentTimeMs: p,
  setLocalPlaybackState: E,
  setMissingArchiveTimeMs: y,
  setPaused: v,
  timelineWindow: S,
  videoRef: x
}) {
  se(() => {
    if (r || o || h !== "live")
      return;
    const _ = jd({
      archiveRanges: i,
      dvrWindow: n
    });
    _ != null && (y(null), u.current = 0, d.current = s.current, p(_), E((A) => ({
      mode: "archive",
      playbackStartTimeMs: _,
      key: A.key + 1
    })));
  }, [
    i,
    s,
    n,
    r,
    o,
    h,
    u,
    d,
    p,
    E,
    y
  ]);
  const R = Y(
    (_) => {
      if (!t || !S)
        return;
      const A = op(_, S.startMs, S.endMs), I = e || os(i, A), w = x.current;
      if (r || c) {
        p(A), I ? (w == null || w.pause(), s.current = !0, d.current = !0, v(!1), y(null)) : (w == null || w.pause(), y(A), u.current = null, d.current = !1), c == null || c(A);
        return;
      }
      if (!I) {
        w == null || w.pause(), p(A), y(A), u.current = null, d.current = !1, E((U) => ({
          mode: "archive",
          playbackStartTimeMs: A,
          key: U.key
        })), l == null || l(A, "archive");
        return;
      }
      y(null);
      const $ = m.current, M = $ == null ? null : (A - $) / 1e3;
      if (p(A), l == null || l(A, "archive"), w && M != null && M >= 0 && M <= f) {
        try {
          w.currentTime = M, s.current && w.play().catch(() => {
            v(!0);
          });
        } catch {
          u.current = M;
        }
        return;
      }
      u.current = 0, d.current = s.current, E((U) => ({
        mode: "archive",
        playbackStartTimeMs: A,
        key: U.key + 1
      }));
    },
    [
      i,
      e,
      t,
      s,
      r,
      c,
      l,
      u,
      d,
      m,
      f,
      p,
      E,
      y,
      v,
      S,
      x
    ]
  );
  return {
    handleLiveMode: Y(() => {
      if (!o)
        return;
      if (r || a) {
        a == null || a();
        return;
      }
      y(null), u.current = null, d.current = !1;
      const _ = g();
      p(_), l == null || l(_, "live"), E((A) => ({
        mode: "live",
        playbackStartTimeMs: null,
        key: A.key + 1
      }));
    }, [
      r,
      o,
      g,
      a,
      l,
      u,
      d,
      p,
      E,
      y
    ]),
    handleTimelineSeek: R
  };
}
function yp({
  desiredPlayingRef: i,
  pendingSeekSecRef: e,
  pendingSeekShouldPlayRef: t,
  playbackMode: s,
  playbackStartTimeMsRef: n,
  selectedVideoTrackId: r,
  onSelectedVideoTrackIdChange: o,
  sourceUrl: a,
  videoRef: l,
  videoTracks: c,
  videoTracksLoading: u
}) {
  var I, w, $;
  const [d, h] = ie(() => ({
    sourceUrl: a,
    trackId: r != null ? r : null
  })), m = d.sourceUrl === a ? d.trackId : null, f = r === void 0 ? m : r, g = c.length === 0 ? null : xp({
    playbackMode: s,
    videoTracks: c
  }), p = f == null ? null : (I = c.find((M) => M.id === f)) != null ? I : null, E = p != null && (ei({
    playbackMode: s,
    track: p
  }) || p.id === (g == null ? void 0 : g.id)), y = c.length === 0 || E ? f : (w = g == null ? void 0 : g.id) != null ? w : null, v = Y(
    (M) => {
      h({
        sourceUrl: a,
        trackId: M
      }), o == null || o(M);
    },
    [o, a]
  );
  se(() => {
    f === y || y == null || o == null || o(y);
  }, [o, f, y]);
  const S = Y(() => {
    const M = n.current, U = ka({
      playbackStartTimeMs: M,
      video: l.current
    });
    M == null || U == null || (e.current = Math.max((U - M) / 1e3, 0), t.current = i.current);
  }, [i, e, t, n, l]), x = Y(
    (M) => {
      M !== y && (S(), v(M));
    },
    [S, y, v]
  ), R = y == null ? null : ($ = c.find((M) => M.id === y)) != null ? $ : null, L = s === "live" && c.length > 0 && !c.some((M) => ei({ playbackMode: s, track: M })) ? R != null ? R : c[0] : null, A = u && y != null || !u && (c.length === 0 || R != null);
  return {
    handleVideoTrackChange: x,
    selectedVideoTrackId: y,
    trackSelectionReady: A,
    unsupportedLiveTrack: L
  };
}
function xp({
  playbackMode: i,
  videoTracks: e
}) {
  var t;
  return (t = e.find((s) => ei({ playbackMode: i, track: s }))) != null ? t : e[0];
}
function ei({
  playbackMode: i,
  track: e
}) {
  return i !== "live" ? !0 : !vp(e);
}
function vp(i) {
  var t, s;
  const e = (s = (t = i.codec) == null ? void 0 : t.toLowerCase()) != null ? s : "";
  return e.includes("h265") || e.includes("h.265") || e.includes("hevc") || e.includes("hev1") || e.includes("hvc1");
}
function Sp({
  archiveRanges: i,
  archiveRangesLoading: e,
  currentTimeMs: t,
  playbackMode: s,
  playbackStartTimeMs: n,
  resetKey: r
}) {
  const [o, a] = ie(null), [l, c] = ie(
    null
  ), u = Te(
    () => Ap({
      archiveRanges: i,
      archiveRangesLoading: e,
      currentTimeMs: t,
      playbackMode: s,
      playbackStartTimeMs: n
    }),
    [i, e, t, s, n]
  ), d = u === void 0 ? o : u, h = l != null && d == null && s === "archive" && t != null && !e && os(i, t) ? t : null;
  return se(() => {
    l !== d && c(d);
  }, [d, l]), se(() => {
    u !== null || o == null || a(null);
  }, [u, o]), se(() => {
    a(null);
  }, [r]), {
    archiveResumeTimeMs: h,
    effectiveMissingArchiveTimeMs: d,
    missingArchiveTimeMs: o,
    setMissingArchiveTimeMs: a
  };
}
function Ap({
  archiveRanges: i,
  archiveRangesLoading: e,
  currentTimeMs: t,
  playbackMode: s,
  playbackStartTimeMs: n
}) {
  if (s !== "archive")
    return null;
  const r = t != null ? t : n;
  if (r == null)
    return null;
  if (!e)
    return os(i, r) ? null : r;
}
const Zt = 3600;
function Lp({
  archiveResumeTimeMs: i,
  displayedPlaybackMode: e,
  effectiveMissingArchiveTimeMs: t,
  error: s,
  streamLiveAvailable: n,
  streamUnavailable: r,
  unsupportedLiveTrackError: o
}) {
  const a = e === "live" && n === !1 && !r, l = r || o != null || i != null || t != null || a, c = o != null ? o : s;
  return {
    liveUnavailableInLiveMode: a,
    playbackUnavailable: l,
    visibleError: c
  };
}
function Rp(i) {
  return i == null || !Number.isFinite(i.startMs) || !Number.isFinite(i.endMs) || i.startMs >= i.endMs ? null : i;
}
function Dp({
  activePlaybackBounds: i,
  activePlaybackRate: e,
  archiveRanges: t,
  archiveRangesError: s,
  archiveRangesLoading: n,
  canSeekArchive: r,
  controlsMode: o,
  currentTimeMs: a,
  displayedPlaybackMode: l,
  fullscreen: c,
  handleArchiveCalendarDaySelect: u,
  handlePlaybackRateChange: d,
  handleTimelineZoomIn: h,
  handleTimelineZoomOut: m,
  handleVideoTrackChange: f,
  hideControls: g,
  paused: p,
  selectedVideoTrackId: E,
  timelineZoomDisabled: y,
  toggleFullscreen: v,
  togglePinControls: S,
  togglePlay: x,
  videoTracks: R
}) {
  return {
    archiveCalendarDisabled: (i == null ? void 0 : i.locked) === !0 || !r,
    archiveRanges: t,
    archiveRangesError: s,
    archiveRangesLoading: n,
    controlsMode: o,
    currentTimeMs: a,
    fullscreen: c,
    onArchiveCalendarDaySelect: u,
    onFullscreenToggle: v,
    onHideControls: g,
    onPlaybackRateChange: d,
    onPinToggle: S,
    onPlayToggle: x,
    onTimelineZoomIn: h,
    onTimelineZoomOut: m,
    onVideoTrackChange: f,
    paused: p,
    playbackRate: e,
    playbackRateDisabled: l !== "archive",
    selectedVideoTrackId: E,
    timelineZoomDisabled: y,
    videoTracks: R
  };
}
function Ip(i) {
  return On.includes(i) ? i : 1;
}
function bp(i, e) {
  i && (i.defaultPlaybackRate !== e && (i.defaultPlaybackRate = e), i.playbackRate !== e && (i.playbackRate = e));
}
function ro(i) {
  return i != null && i.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA;
}
function _p({
  hlsUrl: i,
  playbackKey: e,
  playbackUnavailable: t,
  videoRef: s,
  visibleError: n
}) {
  const [r, o] = ie(!0), [a, l] = ie(!1);
  se(() => {
    const h = s.current, m = ro(h);
    l(m), o(!m);
  }, [i, e, s]), se(() => {
    if (t || n != null) {
      o(!1);
      return;
    }
    a || o(!0);
  }, [a, t, n]);
  const c = Y(() => {
    !a && !ro(s.current) && o(!0);
  }, [a, s]), u = Y(() => {
    l(!0), o(!1);
  }, []);
  return {
    markMediaError: Y(() => {
      l(!1), o(!1);
    }, []),
    markMediaLoading: c,
    markMediaReady: u,
    showMediaLoader: r && !a && !t && n == null
  };
}
function Cp() {
  const [i, e] = ie(null);
  return {
    liveEdgeMs: i,
    setLiveEdgeMs: e
  };
}
function wp({
  dvrWindow: i,
  liveAvailable: e,
  onLiveStatusChange: t,
  setLiveEdgeMs: s,
  streamLiveAvailable: n,
  streamLiveEdgeMs: r
}) {
  se(() => {
    if (!i) {
      s(null);
      return;
    }
    s(
      (o) => o == null ? i.endMs : Math.max(o, i.endMs)
    );
  }, [i, s]), se(() => {
    t == null || t({
      liveAvailable: n,
      liveEdgeMs: r
    });
  }, [t, n, r]), se(() => {
    !e || r == null || s(
      (o) => o == null ? r : Math.max(o, r)
    );
  }, [e, s, r]);
}
function Mp({
  playbackMode: i,
  timelineViewport: e,
  timelineWindowLoaded: t
}) {
  return e == null || e.mode === "fixed" && !t || e.mode === "live-follow" && i !== "live" ? null : e;
}
function kp({
  activePlaybackBounds: i,
  displayedPlaybackMode: e,
  onPlayerSettingsChange: t,
  playerSettings: s,
  timelineWindowLoaded: n
}) {
  var E;
  const [r, o] = ie(null), [a, l] = ie(1), c = Ip((E = s == null ? void 0 : s.playbackRate) != null ? E : a), u = e === "archive" ? c : 1, d = Te(() => {
    var v;
    const y = (i == null ? void 0 : i.locked) === !0 ? {
      mode: "fixed",
      startMs: i.startMs,
      endMs: i.endMs
    } : (v = s == null ? void 0 : s.timelineViewport) != null ? v : r;
    return Mp({
      playbackMode: e,
      timelineViewport: y,
      timelineWindowLoaded: n
    });
  }, [
    i,
    e,
    r,
    s == null ? void 0 : s.timelineViewport,
    n
  ]), h = Y(
    (y) => {
      t == null || t({ selectedVideoTrackId: y }, { immediate: !0 });
    },
    [t]
  ), m = Y(
    (y) => {
      t == null || t({ controlsMode: y }, { immediate: !0 });
    },
    [t]
  ), f = Y(
    (y) => {
      t == null && l(y), t == null || t({ playbackRate: y }, { immediate: !0 });
    },
    [t]
  ), g = Y(
    (y) => {
      i != null && i.locked || (t == null && o(y), t == null || t({ timelineViewport: y }, { immediate: !0 }));
    },
    [i == null ? void 0 : i.locked, t]
  ), p = Y(() => {
    o(null);
  }, []);
  return {
    activePlaybackRate: u,
    clearLocalTimelineViewport: p,
    effectiveTimelineViewport: d,
    handleControlsModeChange: m,
    handlePlaybackRateChange: f,
    handleSelectedVideoTrackIdChange: h,
    handleTimelineViewportChange: g
  };
}
function Fp(i, e) {
  const [t, s] = ie(i);
  return se(() => {
    const n = window.setTimeout(() => {
      s(i);
    }, e);
    return () => {
      window.clearTimeout(n);
    };
  }, [e, i]), t;
}
const bs = /* @__PURE__ */ new Map(), Na = "preview-image", Pp = 180, oo = 1e3;
function Op({
  authToken: i,
  archiveRanges: e,
  enabled: t,
  previewTimeMs: s,
  sourceUrl: n
}) {
  const r = s == null ? null : Math.floor(s / oo) * oo, o = Fp(r, Pp), a = r != null && o === r ? o : null, l = `${n}:${i != null ? i : ""}`, c = Y(
    (d) => {
      const h = bs.get(l);
      h == null || h.delete(d.endpoint);
    },
    [l]
  ), u = Y(
    (d) => {
      var m;
      const h = (m = bs.get(l)) != null ? m : /* @__PURE__ */ new Set();
      h.add(d.endpoint), bs.set(l, h);
    },
    [l]
  );
  return Te(() => {
    var p;
    const d = {
      available: void 0,
      media: [],
      rememberFailedMedia: u,
      rememberLoadedMedia: c,
      timeMs: null
    };
    if (!t || a == null)
      return d;
    const h = os(e, a);
    if (!h)
      return {
        available: h,
        media: [],
        rememberFailedMedia: u,
        rememberLoadedMedia: c,
        timeMs: a
      };
    const m = Dt(n), g = ((p = bs.get(l)) != null ? p : /* @__PURE__ */ new Set()).has(Na) ? [] : [
      Np({
        authToken: i,
        config: m,
        timeMs: a
      })
    ];
    return {
      available: h,
      media: g,
      rememberFailedMedia: u,
      rememberLoadedMedia: c,
      timeMs: a
    };
  }, [
    e,
    i,
    t,
    l,
    u,
    c,
    n,
    a
  ]);
}
function Np({
  authToken: i,
  config: e,
  timeMs: t
}) {
  return {
    endpoint: Na,
    type: "image",
    url: kd({
      authToken: i,
      config: e,
      timeMs: t
    })
  };
}
function Up({
  activePlaybackBounds: i,
  archiveRanges: e,
  canSeekArchive: t,
  currentTimeMs: s,
  displayedPlaybackMode: n,
  displayedPlaybackStartTimeMs: r,
  effectiveTimelineViewport: o,
  handleLiveMode: a,
  handleTimelineSeek: l,
  handleTimelineViewportChange: c,
  sourceUrl: u,
  streamAuthToken: d,
  timelineDisplayWindow: h,
  timelineLiveAvailable: m
}) {
  var L, _;
  const [f, g] = ie(null), [p, E] = ie(null), y = Op({
    archiveRanges: e,
    authToken: d,
    enabled: t,
    previewTimeMs: f,
    sourceUrl: u
  }), v = Y(
    (A) => {
      i != null && i.locked || !t || (c({
        mode: "fixed",
        startMs: A.dayStartMs,
        endMs: A.dayEndMs
      }), l(A.firstArchiveTimeMs));
    },
    [i == null ? void 0 : i.locked, t, l, c]
  ), S = Y(() => {
    E((A) => {
      var I;
      return {
        direction: "in",
        revision: ((I = A == null ? void 0 : A.revision) != null ? I : 0) + 1
      };
    });
  }, []), x = Y(() => {
    E((A) => {
      var I;
      return {
        direction: "out",
        revision: ((I = A == null ? void 0 : A.revision) != null ? I : 0) + 1
      };
    });
  }, []), R = {
    archiveRanges: e,
    currentTimeMs: s,
    durationSec: Zt,
    liveAvailable: m,
    mode: n,
    onLive: a,
    onPreviewTimeChange: g,
    onSeek: l,
    onThumbnailMediaError: y.rememberFailedMedia,
    onThumbnailMediaLoad: y.rememberLoadedMedia,
    onTimelineViewportChange: c,
    playbackStartTimeMs: r,
    seekable: t,
    thumbnailAvailable: y.available,
    thumbnailMedia: y.media,
    thumbnailTimeMs: y.timeMs,
    timelineViewport: o,
    timelineZoomCommand: p,
    viewportLocked: (i == null ? void 0 : i.locked) === !0,
    windowEndMs: (L = h == null ? void 0 : h.endMs) != null ? L : null,
    windowStartMs: (_ = h == null ? void 0 : h.startMs) != null ? _ : null
  };
  return {
    handleArchiveCalendarDaySelect: v,
    handleTimelineZoomIn: S,
    handleTimelineZoomOut: x,
    timelineProps: R,
    timelineZoomDisabled: (i == null ? void 0 : i.locked) === !0 || !t
  };
}
function Bp({
  activePlaybackBounds: i,
  applyActivePlaybackRate: e,
  handleLiveMode: t,
  markMediaError: s,
  markMediaLoading: n,
  markMediaReady: r,
  playbackMode: o,
  setPaused: a,
  timelineLiveAvailable: l,
  updateCurrentTime: c
}) {
  return {
    onCanPlay: () => {
      e(), r();
    },
    onEnded: () => {
      o === "archive" && l && !(i != null && i.locked) && t();
    },
    onError: () => {
      s();
    },
    onLoadedData: () => {
      e(), r();
    },
    onLoadedMetadata: () => {
      e(), r();
    },
    onLoadStart: () => {
      n();
    },
    onPause: () => a(!0),
    onPlay: () => {
      e(), a(!1);
    },
    onPlaying: () => {
      e(), r();
    },
    onRateChange: e,
    onSeeked: () => {
      e(), r();
    },
    onSeeking: () => {
      n();
    },
    onTimeUpdate: c,
    onWaiting: () => {
      n();
    }
  };
}
function $p({
  sourceUrl: i,
  autoplay: e = !0,
  initialPlaybackState: t,
  playbackBounds: s,
  playbackState: n,
  playerSettings: r,
  onLiveStatusChange: o,
  onLiveModeRequest: a,
  onArchiveUnavailable: l,
  onPlayerSettingsChange: c,
  onPlaybackTimeChange: u,
  onTimelineSeek: d
}) {
  var vi, Si, Ai, Li, Ri, Di;
  const { t: h } = ht("hlsFlussonicVideoPlayer"), m = oe(null), f = oe(null), g = oe(i), p = oe(h("errors.hlsPlayback")), E = oe(h("errors.hlsNotSupported")), y = oe(e), v = oe(null), S = oe(null), x = oe(!1), [R, L] = ie(!e), [_, A] = ie(null), [I, w] = ie(null), { liveEdgeMs: $, setLiveEdgeMs: M } = Cp(), U = Te(() => Dt(i), [i]), { isPlaybackControlled: N, playbackKey: H, playbackMode: q, playbackStartTimeMs: B, setLocalPlaybackState: O } = gp({
    desiredPlayingRef: y,
    initialPlaybackState: t,
    pendingSeekSecRef: S,
    pendingSeekShouldPlayRef: x,
    playbackState: n,
    setCurrentTimeMs: A
  }), P = N && n != null && n.revision !== H ? n : null, W = (vi = P == null ? void 0 : P.mode) != null ? vi : q, K = (P == null ? void 0 : P.mode) === "archive" ? (Si = P.timeMs) != null ? Si : B : (P == null ? void 0 : P.mode) === "live" ? null : B, J = (Ai = P == null ? void 0 : P.revision) != null ? Ai : H, j = N && (n == null ? void 0 : n.timeMs) != null ? n.timeMs : _, z = Te(() => Rp(s), [s]), {
    archiveRanges: ne,
    canSeekArchive: he,
    dvrWindow: Fe,
    liveAvailable: we,
    streamUnavailable: tt,
    streamAuthToken: st,
    streamLiveAvailable: ft,
    streamLiveEdgeMs: Et,
    timelineWindow: Pe,
    videoTracks: nt
  } = Mh({
    liveEdgeMs: $,
    playbackMode: q,
    playbackStartTimeMs: B,
    playlistDurationSec: Zt,
    sourceUrl: i
  }), { getLivePlaybackTimeMs: it } = Oh({
    liveAvailable: we,
    streamLiveEdgeMs: Et
  });
  wp({
    dvrWindow: Fe,
    liveAvailable: we,
    onLiveStatusChange: o,
    setLiveEdgeMs: M,
    streamLiveAvailable: ft,
    streamLiveEdgeMs: Et
  });
  const rt = z != null && z.locked ? !1 : we, te = z != null && z.locked ? {
    endMs: z.endMs,
    startMs: z.startMs
  } : Pe, {
    activePlaybackRate: Ge,
    clearLocalTimelineViewport: Ne,
    effectiveTimelineViewport: It,
    handleControlsModeChange: bt,
    handlePlaybackRateChange: _t,
    handleSelectedVideoTrackIdChange: sn,
    handleTimelineViewportChange: nn
  } = kp({
    activePlaybackBounds: z,
    displayedPlaybackMode: W,
    onPlayerSettingsChange: c,
    playerSettings: r,
    timelineWindowLoaded: Pe != null
  }), { handleVideoTrackChange: Ct, selectedVideoTrackId: He, trackSelectionReady: rn, unsupportedLiveTrack: ls } = yp({
    desiredPlayingRef: y,
    onSelectedVideoTrackIdChange: sn,
    pendingSeekSecRef: S,
    pendingSeekShouldPlayRef: x,
    playbackMode: q,
    playbackStartTimeMsRef: v,
    selectedVideoTrackId: r == null ? void 0 : r.selectedVideoTrackId,
    sourceUrl: i,
    videoRef: f,
    videoTracks: nt.data,
    videoTracksLoading: nt.loading
  }), cs = `${i}:${He != null ? He : "auto"}:${H}`, Wt = Y(() => {
    bp(f.current, Ge);
  }, [Ge]), on = Te(
    () => ls == null ? null : {
      kind: "unsupported-codec",
      message: h("errors.liveCodecUnsupported"),
      recoverable: !1
    },
    [h, ls]
  ), us = Te(
    () => Dd({
      config: U,
      playbackMode: q,
      playbackStartTimeMs: B,
      playlistDurationSec: Zt,
      videoTrackId: He
    }),
    [U, q, B, He]
  ), Yt = He != null ? He : (Li = nt.data[0]) == null ? void 0 : Li.id, an = Fh({
    archiveRanges: ne.data,
    archiveRangesError: ne.error,
    archiveRangesLoading: ne.loading,
    authToken: st,
    config: U,
    playbackBounds: z,
    videoTrackId: Yt != null ? Yt : null
  }), { archiveResumeTimeMs: mt, effectiveMissingArchiveTimeMs: Ye, setMissingArchiveTimeMs: pe } = Sp({
    archiveRanges: ne.data,
    archiveRangesLoading: ne.loading,
    currentTimeMs: j,
    playbackMode: W,
    playbackStartTimeMs: K,
    resetKey: J
  }), { liveUnavailableInLiveMode: Oe, playbackUnavailable: _e, visibleError: ot } = Lp({
    archiveResumeTimeMs: mt,
    displayedPlaybackMode: W,
    effectiveMissingArchiveTimeMs: Ye,
    error: I,
    streamLiveAvailable: ft,
    streamUnavailable: tt,
    unsupportedLiveTrackError: on
  }), { markMediaError: Ua, markMediaLoading: Ba, markMediaReady: $a, showMediaLoader: Ga } = _p({
    hlsUrl: us,
    playbackKey: H,
    playbackUnavailable: _e,
    videoRef: f,
    visibleError: ot
  }), { fullscreen: Ha, toggleFullscreen: Ka } = Od({
    elementRef: m
  }), {
    clearControlsFocus: Va,
    controlsMode: yi,
    controlsVisible: Wa,
    handleBlurCapture: Ya,
    handleFocusCapture: qa,
    handlePointerEnter: za,
    handlePointerLeave: ja,
    hideControls: Xa,
    showControls: Qa,
    togglePinControls: Za
  } = Tp({
    controlsMode: r == null ? void 0 : r.controlsMode,
    error: ot,
    missingArchiveTimeMs: Ye,
    onControlsModeChange: bt,
    paused: R,
    playerRootRef: m,
    streamUnavailable: tt
  }), { handleLiveMode: xi, handleTimelineSeek: Ja } = Ep({
    archiveRanges: ne.data,
    archiveRangesLoading: ne.loading,
    canSeekArchive: he,
    desiredPlayingRef: y,
    dvrWindow: Fe,
    isPlaybackControlled: N,
    liveAvailable: rt,
    onLiveModeRequest: a,
    onPlaybackTimeChange: u,
    onTimelineSeek: d,
    pendingSeekSecRef: S,
    pendingSeekShouldPlayRef: x,
    playbackMode: q,
    playbackStartTimeMsRef: v,
    playlistDurationSec: Zt,
    getLivePlaybackTimeMs: it,
    setCurrentTimeMs: A,
    setLocalPlaybackState: O,
    setMissingArchiveTimeMs: pe,
    setPaused: L,
    timelineWindow: Pe,
    videoRef: f
  }), {
    handleArchiveCalendarDaySelect: el,
    handleTimelineZoomIn: tl,
    handleTimelineZoomOut: sl,
    timelineProps: nl,
    timelineZoomDisabled: il
  } = Up({
    activePlaybackBounds: z,
    archiveRanges: ne.data,
    canSeekArchive: he,
    currentTimeMs: j,
    displayedPlaybackMode: W,
    displayedPlaybackStartTimeMs: K,
    effectiveTimelineViewport: It,
    handleLiveMode: xi,
    handleTimelineSeek: Ja,
    handleTimelineViewportChange: nn,
    sourceUrl: i,
    streamAuthToken: st,
    timelineDisplayWindow: te,
    timelineLiveAvailable: rt
  });
  se(() => {
    !N || Ye == null || l == null || l(Ye);
  }, [Ye, N, l]), se(() => {
    if (mt == null || (A(mt), pe(null), N))
      return;
    const Ee = f.current;
    Ee == null || Ee.pause(), S.current = 0, x.current = y.current, L(!y.current), O((qt) => ({
      mode: "archive",
      playbackStartTimeMs: mt,
      key: qt.key + 1
    }));
  }, [
    mt,
    y,
    N,
    S,
    x,
    A,
    O,
    pe,
    L,
    f
  ]), cp({
    desiredPlayingRef: y,
    hlsNotSupportedMessageRef: E,
    hlsPlaybackErrorMessageRef: p,
    hlsUrl: us,
    pendingSeekSecRef: S,
    pendingSeekShouldPlayRef: x,
    playbackKey: H,
    playbackMode: q,
    playlistDurationSec: Zt,
    setError: w,
    setPaused: L,
    sourceBlocked: _e,
    sourceReady: rn,
    videoRef: f
  }), se(() => {
    Wt();
  }, [Wt, cs]);
  const rl = Y(
    (Ee) => {
      if (!(z != null && z.locked))
        return;
      const qt = f.current;
      if (y.current = !1, x.current = !1, qt) {
        const Ii = v.current, ds = Ii == null ? null : (Ee - Ii) / 1e3;
        ds != null && Number.isFinite(ds) && ds >= 0 && (qt.currentTime = ds), qt.pause();
      }
      A(Ee), L(!0);
    },
    [z == null ? void 0 : z.locked]
  ), { updateCurrentTime: ol } = mp({
    controlledRevision: (Ri = n == null ? void 0 : n.revision) != null ? Ri : null,
    controlledTimeMs: (Di = n == null ? void 0 : n.timeMs) != null ? Di : null,
    effectiveMissingArchiveTimeMs: Ye,
    getLivePlaybackTimeMs: it,
    isPlaybackControlled: N,
    onPlaybackBoundsEnd: rl,
    onPlaybackTimeChange: u,
    paused: R,
    playbackBounds: z,
    playbackMode: q,
    playbackStartTimeMs: B,
    playbackStartTimeMsRef: v,
    setCurrentTimeMs: A,
    setLiveEdgeMs: M,
    streamUnavailable: _e,
    videoRef: f
  });
  se(() => {
    p.current = h("errors.hlsPlayback"), E.current = h("errors.hlsNotSupported");
  }, [h]), se(() => {
    const Ee = S.current;
    A(
      q === "archive" ? B != null ? B + Math.round((Ee != null ? Ee : 0) * 1e3) : null : it()
    );
  }, [it, q, B, H]), se(() => {
    y.current = e;
    const Ee = f.current;
    Ee && (e ? Ee.play().catch(() => {
      L(!0);
    }) : Ee.pause());
  }, [e]), se(() => {
    g.current !== i && (g.current = i, pe(null), Ne(), S.current = null, x.current = !1, N || O((Ee) => ({
      mode: "live",
      playbackStartTimeMs: null,
      key: Ee.key + 1
    })));
  }, [Ne, N, O, pe, i]);
  const al = () => {
    const Ee = f.current;
    if (Ee)
      if (Ee.paused) {
        if (Va(), z != null && z.locked && j != null && j >= z.endMs) {
          y.current = !0, x.current = !0, L(!1), d == null || d(z.startMs);
          return;
        }
        y.current = !0, Ee.play().catch(() => {
        });
      } else
        y.current = !1, Ee.pause();
  }, ll = Dp({
    activePlaybackBounds: z,
    activePlaybackRate: Ge,
    archiveRanges: ne.data,
    archiveRangesError: ne.error,
    archiveRangesLoading: ne.loading,
    canSeekArchive: he,
    controlsMode: yi,
    currentTimeMs: j,
    displayedPlaybackMode: W,
    fullscreen: Ha,
    handleArchiveCalendarDaySelect: el,
    handlePlaybackRateChange: _t,
    handleTimelineZoomIn: tl,
    handleTimelineZoomOut: sl,
    handleVideoTrackChange: Ct,
    hideControls: Xa,
    paused: R,
    selectedVideoTrackId: He,
    timelineZoomDisabled: il,
    toggleFullscreen: Ka,
    togglePinControls: Za,
    togglePlay: al,
    videoTracks: nt.data
  }), cl = Bp({
    activePlaybackBounds: z,
    applyActivePlaybackRate: Wt,
    handleLiveMode: xi,
    markMediaError: Ua,
    markMediaLoading: Ba,
    markMediaReady: $a,
    playbackMode: q,
    setPaused: L,
    timelineLiveAvailable: rt,
    updateCurrentTime: ol
  });
  return {
    controlsOverlayVisible: Wa,
    controlsProps: ll,
    dvrExportState: an,
    playerRootRef: m,
    restoreControlsButton: {
      onClick: Qa,
      title: h("controls.showPanel"),
      visible: yi === "hidden" && !tt
    },
    rootHandlers: {
      onBlurCapture: Ya,
      onFocusCapture: qa,
      onPointerEnter: za,
      onPointerLeave: ja
    },
    status: {
      effectiveMissingArchiveTimeMs: Ye,
      liveUnavailableInLiveMode: Oe,
      showMediaLoader: Ga,
      streamUnavailable: tt,
      visibleError: ot
    },
    timelineProps: nl,
    videoElementKey: cs,
    videoHandlers: cl,
    videoRef: f
  };
}
const Gp = "Play", Hp = "Pause", Kp = "Video quality", Vp = "Playback speed", Wp = "Player settings", Yp = { title: "Archive calendar", open: "Open archive calendar", previousMonth: "Previous month", nextMonth: "Next month", loading: "Checking archive calendar", error: "Failed to load archive calendar", empty: "No recorded days", recordedDay: "Day with recording", openDay: "Open recording for day" }, qp = { zoomIn: "Zoom timeline in", zoomOut: "Zoom timeline out", seek: "Seek video timeline" }, zp = { unpinPanel: "Unpin panel", pinPanel: "Pin panel", hidePanel: "Hide panel", showPanel: "Show panel" }, jp = { interval: "Download interval", availableFragment: "Download available fragment", starting: "Starting download", checking: "Checking archive", noTrack: "Video quality is unavailable", noArchive: "No recording in selected interval", archiveError: "Failed to check archive", multiple: "Select fragment to download", error: "Failed to download interval" }, Xp = { enter: "Enter fullscreen", exit: "Exit fullscreen", toggle: "Fullscreen" }, Qp = { hlsPlayback: "Video playback error", hlsNotSupported: "HLS playback is not supported in this browser", liveCodecUnsupported: "Live stream uses an unsupported HEVC codec", liveUnavailable: "Live stream is unavailable", streamUnavailable: "No live stream or recording available", noArchive: "No video for the selected time" }, Zp = {
  play: Gp,
  pause: Hp,
  videoQuality: Kp,
  playbackRate: Vp,
  settings: Wp,
  calendar: Yp,
  timeline: qp,
  controls: zp,
  download: jp,
  fullscreen: Xp,
  errors: Qp
}, Jp = { hlsFlussonicVideoPlayer: Zp }, eT = "Reproducir", tT = "Pausa", sT = "Calidad de video", nT = "Velocidad de reproduccion", iT = "Configuracion del reproductor", rT = { title: "Calendario del archivo", open: "Abrir calendario del archivo", previousMonth: "Mes anterior", nextMonth: "Mes siguiente", loading: "Comprobando calendario del archivo", error: "No se pudo cargar el calendario del archivo", empty: "No hay dias con grabacion", recordedDay: "Dia con grabacion", openDay: "Abrir grabacion del dia" }, oT = { zoomIn: "Acercar linea de tiempo", zoomOut: "Alejar linea de tiempo", seek: "Buscar en la linea de tiempo del video" }, aT = { unpinPanel: "Desanclar panel", pinPanel: "Anclar panel", hidePanel: "Ocultar panel", showPanel: "Mostrar panel" }, lT = { interval: "Descargar intervalo", availableFragment: "Descargar fragmento disponible", starting: "Iniciando descarga", checking: "Comprobando archivo", noTrack: "La calidad de video no esta disponible", noArchive: "No hay grabacion en el intervalo seleccionado", archiveError: "No se pudo comprobar el archivo", multiple: "Seleccionar fragmento para descargar", error: "No se pudo descargar el intervalo" }, cT = { enter: "Abrir pantalla completa", exit: "Salir de pantalla completa", toggle: "Pantalla completa" }, uT = { hlsPlayback: "Error de reproduccion de video", hlsNotSupported: "La reproduccion HLS no es compatible con este navegador", liveCodecUnsupported: "La transmision en vivo usa un codec HEVC no compatible", liveUnavailable: "La transmision en vivo no esta disponible", streamUnavailable: "No hay transmision en vivo ni grabacion disponible", noArchive: "No hay video para la hora seleccionada" }, dT = {
  play: eT,
  pause: tT,
  videoQuality: sT,
  playbackRate: nT,
  settings: iT,
  calendar: rT,
  timeline: oT,
  controls: aT,
  download: lT,
  fullscreen: cT,
  errors: uT
}, hT = { hlsFlussonicVideoPlayer: dT }, fT = "Воспроизвести", mT = "Пауза", gT = "Качество видео", pT = "Скорость воспроизведения", TT = "Настройки плеера", ET = { title: "Календарь архива", open: "Открыть календарь архива", previousMonth: "Предыдущий месяц", nextMonth: "Следующий месяц", loading: "Проверка календаря архива", error: "Не удалось загрузить календарь архива", empty: "Нет дней с записью", recordedDay: "День с записью", openDay: "Открыть запись за день" }, yT = { zoomIn: "Приблизить таймлайн", zoomOut: "Отдалить таймлайн", seek: "Перемотка видео по таймлайну" }, xT = { unpinPanel: "Открепить панель", pinPanel: "Закрепить панель", hidePanel: "Скрыть панель", showPanel: "Показать панель" }, vT = { interval: "Скачать интервал", availableFragment: "Скачать доступный фрагмент", starting: "Запуск скачивания", checking: "Проверка архива", noTrack: "Качество видео недоступно", noArchive: "В выбранном интервале нет записи", archiveError: "Не удалось проверить архив", multiple: "Выберите фрагмент для скачивания", error: "Не удалось скачать интервал" }, ST = { enter: "Открыть полноэкранный режим", exit: "Выйти из полноэкранного режима", toggle: "Полноэкранный режим" }, AT = { hlsPlayback: "Ошибка воспроизведения видео", hlsNotSupported: "Воспроизведение HLS не поддерживается в этом браузере", liveCodecUnsupported: "Live-трансляция использует неподдерживаемый кодек HEVC", liveUnavailable: "Live-трансляция недоступна", streamUnavailable: "Нет трансляции и записи", noArchive: "Видео за выбранное время отсутствует" }, LT = {
  play: fT,
  pause: mT,
  videoQuality: gT,
  playbackRate: pT,
  settings: TT,
  calendar: ET,
  timeline: yT,
  controls: xT,
  download: vT,
  fullscreen: ST,
  errors: AT
}, RT = { hlsFlussonicVideoPlayer: LT }, DT = { ru: RT, en: Jp, es: hT }, IT = {
  caches: ["localStorage", "cookie"],
  lookupCookie: "i18next",
  lookupLocalStorage: "i18nextLng",
  lookupQuerystring: "lng",
  order: ["localStorage", "cookie", "querystring", "path"]
}, Ns = bl.createInstance();
Ns.use(_l).use(Dl).init({
  detection: IT,
  fallbackLng: "en",
  interpolation: {
    escapeValue: !1
  },
  react: {
    useSuspense: !1
  },
  resources: DT
});
function bT(i) {
  var R;
  const { title: e = "video", style: t, camNameAvailable: s, additionalInfoElement: n, displayTimeOffsetMs: r } = i, {
    controlsOverlayVisible: o,
    controlsProps: a,
    dvrExportState: l,
    playerRootRef: c,
    restoreControlsButton: u,
    rootHandlers: d,
    status: h,
    timelineProps: m,
    videoElementKey: f,
    videoHandlers: g,
    videoRef: p
  } = $p(i), { effectiveMissingArchiveTimeMs: E, liveUnavailableInLiveMode: y, showMediaLoader: v, streamUnavailable: S, visibleError: x } = h;
  return /* @__PURE__ */ ue(
    "div",
    {
      className: at.root,
      "data-hls-video-player-root": !0,
      ref: c,
      style: {
        ...t,
        position: (R = t == null ? void 0 : t.position) != null ? R : "relative"
      },
      ...d,
      children: [
        /* @__PURE__ */ F("video", { className: at.video, ref: p, ...g }, f),
        v && /* @__PURE__ */ F("div", { className: at.loadingOverlay, children: /* @__PURE__ */ F(ao, { size: "l" }) }),
        E != null && /* @__PURE__ */ F(gd, { displayTimeOffsetMs: r, timeMs: E }),
        y && /* @__PURE__ */ F(md, {}),
        S && /* @__PURE__ */ F(pd, {}),
        s && /* @__PURE__ */ F("div", { className: at.cameraNameBadge, children: e }),
        n,
        /* @__PURE__ */ F(Hl, { displayTimeOffsetMs: r, exportState: l, title: e }),
        /* @__PURE__ */ ue(
          "div",
          {
            className: ce(at.controlsOverlay, o && at.controlsOverlayVisible),
            "data-carousel-drag-disabled": !0,
            children: [
              /* @__PURE__ */ F(Qc, { ...m, displayTimeOffsetMs: r }),
              /* @__PURE__ */ F(cd, { ...a, displayTimeOffsetMs: r })
            ]
          }
        ),
        u.visible && /* @__PURE__ */ F(
          "button",
          {
            className: at.restoreControlsButton,
            "data-carousel-drag-disabled": !0,
            onClick: u.onClick,
            title: u.title,
            type: "button",
            children: /* @__PURE__ */ F(Ll, {})
          }
        ),
        x && /* @__PURE__ */ F("div", { className: at.errorOverlay, children: /* @__PURE__ */ F("span", { className: at.errorOverlayMessage, children: x.message }) })
      ]
    }
  );
}
function BT({ locale: i, ...e }) {
  return se(() => {
    !i || Ns.language === i || Ns.changeLanguage(i);
  }, [i]), /* @__PURE__ */ F(Il, { i18n: Ns, children: /* @__PURE__ */ F(bT, { ...e }) });
}
export {
  BT as FlussonicHlsVideoPlayer,
  On as HLS_PLAYBACK_RATE_OPTIONS
};
//# sourceMappingURL=hls-flussonic-video-player.es.js.map
